import BILLING_FLOW from './billingFlow';
import WORKSPACE_EXTRA from './workspaceExtra';
import SELF_HOSTED from './selfHosted';
import SELF_HOSTED_GUIDE from './selfHostedGuide';
import UX_EXTRA from './uxExtra';
import INSTANCE_LICENCE from './instanceLicence';
import DESIGN_EXTRA from './designExtra';
import ERROR_REPORTS from './errorReports';
import CLOAKING_TOOLS from './cloakingTools';
import INTEGRATION_CATALOGUE from './integrationCatalogue';
import BILLING_STOP from './billingStop';
import TRIAL_FUNNEL from './trialFunnel';
import FIRST_DAY from './firstDay';
import CONVERSION_CHECK from './conversionCheck';
import POSTBACK_JOURNAL from './postbackJournal';
import DOMAIN_CHECK from './domainCheck';
import LIVE_TRACE_AUTO from './liveTraceAuto';
import TRIAL_BANNER from './trialBanner';
import NOTIFICATION_CHANNELS from './notificationChannels';
import DOWNGRADE_IMPACT from './downgradeImpact';
import PRESET_HINTS from './presetHints';
import CLICK_ISSUES from './clickIssues';
import CLICK_WARNINGS from './clickWarnings';
import ERROR_TEXTS from './errorTexts';
import QUICK_SETUP from './quickSetup';
import METRIC_NAMES from './metricNames';
import CONVERSION_STATUSES from './conversionStatuses';
import SETTINGS_PLACES from './settingsPlaces';
import PROTECTION_WARNINGS from './protectionWarnings';
import AI_OPTIMIZER_SAFE from './aiOptimizerSafe';
import PER_EVENT_POSTBACKS from './perEventPostbacks';
import MENU_GROUPS from './menuGroups';
import CAMPAIGN_FORM from './campaignForm';
import STREAM_FORM from './streamForm';
import OFFER_FORM from './offerForm';
import BUNDLE_ACTIONS from './bundleActions';
import AUTOMATION_HISTORY from './automationHistory';
import PLAN_LIMITS from './planLimits';
import POOL_LINKS from './poolLinks';
import SAVED_REPORT_VIEW from './savedReportView';
import EDIT_DIALOGS from './editDialogs';
import TLS_TOOLS from './tlsTools';
import CONVERSION_IMPORT from './conversionImport';
import DE from './locales/de';
import FR from './locales/fr';
import IT from './locales/it';
import PL from './locales/pl';
import TR from './locales/tr';
import UK from './locales/uk';
import { brandText } from '../brand';
import React from 'react';

/*
  Simple i18n: English is the canonical source. Keys ARE the English strings.
  Locale-specific maps live below (`ru`, `es`, `pt`). If a key is missing in
  the active locale's map, the lookup falls back to the English source —
  half-translated locales are better than crashes, and the fallback is
  obvious enough that operators notice and report it.

  Wave 23: LATAM coverage added (Spanish + Brazilian Portuguese). Coverage
  starts with Navbar / Dashboard / common buttons / auth / common toasts;
  long-tail strings continue to fall back to English until requested.
*/

const ru = {
  // White pages (cloaking) — hosted same-origin compliant pages
  'White pages': 'Белые страницы',
  'Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)':
    'Статические страницы для ботов/модерации — хостятся здесь, отдаются с того же домена (Google-safe клоака)',
  'White pages (hosted, same-origin)': 'Белые страницы (хостинг, тот же домен)',
  'Safe page URL (external)': 'URL безопасной страницы (внешняя)',
  'External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.':
    'Внешняя безопасная страница — трекер отдаёт её с того же домена через прокси (identity-теги срезаются). Используется, если не выбрана белая страница. Должен быть абсолютный http(s)-URL. Этот способ и сам по себе проходит модерацию Google; белая страница — просто более надёжная альтернатива, полностью отдаваемая с вашего домена.',
  'Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.':
    'Необязательно — самый надёжный вариант для Google/Facebook: отдаётся с домена вашей кампании (/wp/…), поэтому финальный URL остаётся на домене. Выберите несколько — на каждый запрос будет случайная, чтобы одна белая не крутилась на сотни объявлений. Управление — в разделе «Белые страницы».',
  'selected — rotated per request': 'выбрано — ротация на каждый запрос',
  'No white pages yet. Upload some under White pages, then pick them here.':
    'Пока нет белых страниц. Загрузите их в разделе «Белые страницы», затем выберите здесь.',
  'Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Select several to rotate a random one per request — so one white isn’t reused across hundreds of ads. Manage under White pages.':
    'Рекомендуется для Google/Facebook: отдаётся с домена вашей кампании (/wp/…), поэтому финальный URL объявления остаётся на домене и проходит модерацию. Выберите несколько — на каждый запрос будет случайная из них, чтобы одна белая не крутилась на сотни объявлений. Управление — в разделе «Белые страницы».',
  'Static pages for bots & ad review': 'Статические страницы для ботов и модерации',
  'Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.':
    'Безопасные статические страницы для ботов и модераторов рекламы — отдаются с того же домена, что и кампания.',
  'These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.':
    'Эти страницы хостятся здесь и отдаются с того же домена по пути /wp/<slug>/ на любом вашем проверенном домене. Выберите одну в настройках клоакинга кампании — боты и модераторы Google/Facebook увидят её, реальные пользователи попадут на оффер.',
  'Upload white page': 'Загрузить белую страницу',
  'Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.':
    'Загрузите статический ZIP (index.html + ресурсы). PHP запрещён. Максимум 50 МБ.',
  'My white page': 'Моя белая страница',
  'What this white page is for': 'Для чего эта белая страница',
  'Static files only (.html/.css/.js/images). No .php.':
    'Только статические файлы (.html/.css/.js/картинки). Без .php.',
  'Please enter a name for the white page': 'Введите название белой страницы',
  'White page uploaded successfully': 'Белая страница успешно загружена',
  'Error uploading white page': 'Ошибка загрузки белой страницы',
  'Error loading white pages': 'Ошибка загрузки белых страниц',
  'Error deleting white page': 'Ошибка удаления белой страницы',
  'White page deleted': 'Белая страница удалена',
  'No white pages': 'Нет белых страниц',
  'Upload a static white page to use for campaign cloaking':
    'Загрузите статическую белую страницу для клоакинга кампаний',
  'Search white pages…': 'Поиск белых страниц…',
  'Same-origin path': 'Путь на том же домене',
  'Delete white page': 'Удалить белую страницу',
  'This permanently deletes "{name}" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).':
    'Это навсегда удалит «{name}» и её файлы. Кампании, всё ещё ссылающиеся на неё, откатятся на URL безопасной страницы (или на оффер, если его нет).',
  'Multiple HTML pages detected. Select the main page bots will land on.':
    'Обнаружено несколько HTML-страниц. Выберите главную, на которую попадут боты.',
  'White page (hosted, same-origin)': 'Белая страница (хостинг, тот же домен)',
  'None — use Safe page URL below': 'Нет — использовать URL безопасной страницы ниже',
  'Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Manage these under White pages.':
    'Рекомендуется для Google/Facebook: отдаётся с домена вашей кампании (/wp/…), поэтому финальный URL объявления остаётся на домене и проходит модерацию. Управление — в разделе «Белые страницы».',
  'Safe page URL (external fallback)': 'URL безопасной страницы (внешний запасной вариант)',
  'Optional fallback, used only when no white page is selected above. Must be an absolute http(s) URL. Note: an external URL lives on another domain — exactly what triggers Google’s “destination mismatch”, so prefer a white page for paid search.':
    'Необязательный запасной вариант — используется, только если выше не выбрана белая страница. Должен быть абсолютным http(s)-URL. Учтите: внешний URL живёт на другом домене — именно это вызывает у Google «несоответствие целевой страницы», поэтому для платного поиска лучше выбрать белую страницу.',
  'Select a white page or enter a valid http(s) Safe page URL for cloaking':
    'Выберите белую страницу или введите корректный http(s) URL безопасной страницы для клоакинга',
  // Campaign settings tooltips (preview link, postback token, status mapping, S2S)
  'The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.': 'Готовая к копированию tracking-ссылка кампании. Поменяйте домен на любой ваш проверенный домен воркспейса, чтобы гонять несколько доменов на одной кампании; плейсхолдеры подставляет рекламная сеть в момент клика.',
  'Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.': 'Секрет, которым аутентифицируются входящие постбэки этой кампании. Вставляется как &token=… в URL постбэков, которые вы отдаёте сети. Держите в секрете: с ним можно регистрировать конверсии.',
  'Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.': 'Переводит сырые статусные слова сети в наши категории. Приоритет: инлайн-параметр в URL > эта карта кампании > пресет партнёрской сети > кастомные типы > встроенные значения.',
  'Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.': 'Исходящие вызовы, уведомляющие другую систему (ваш источник трафика, другой трекер, Telegram) при получении конверсии. Для CAPI рекламных платформ (Facebook/Google/TikTok) используйте раздел Conversion forwarders — там хэш PII и ретраи.',
  // Campaign params URL-key hint + cloaking per-class hints + gtag hint
  'The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.': 'Имя query-параметра в вашей tracking-ссылке — держите его URL-безопасным: латиница, цифры и _ (без пробелов). Пробелы автоматически заменяются на _, чтобы в ссылке не появлялось %20.',
  'UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.': 'Боты по UA-паттернам и UA, подделывающие поискового краулера (не прошли DNS-проверку), получают белую страницу.',
  'DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.': 'DNS-подтверждённые поисковые краулеры (Googlebot/Bingbot/…) получают белую страницу. Выключите, чтобы они индексировали реальный оффер.',
  'Visitors from datacenter or Tor-exit IPs get the safe page.': 'Посетители с датацентровых или Tor-exit IP получают белую страницу.',
  'Visitors behind a proxy/VPN get the safe page.': 'Посетители за прокси/VPN получают белую страницу.',
  'Works only when an active Google Ads forwarder exists (simple mode or with a conversion tag). The AW-…/label can be passed per click via the tm parameter, so one campaign credits conversions to different accounts.': 'Работает только при активной интеграции Google Ads (режим simple или с conversion-тегом). Тег AW-…/label можно передавать per-click в параметре tm — так одна кампания корректно зачитывает конверсии в разные кабинеты.',
  'Fire Google Ads gtag on redirect (click-time conversion)': 'Слать gtag Google Ads на редиректе (конверсия на клике)',
  'Fires a Google Ads conversion at the click moment (on /r/, before the offer) from the AW-…/label in the {tm} parameter — no forwarder needed. This optimizes Google on CLICKS, not on registrations/deposits.': 'Шлёт конверсию Google Ads в момент клика (на /r/, до оффера) из AW-…/label в параметре {tm} — форвардер не нужен. Это оптимизирует Google на КЛИКИ, а не на реги/депозиты.',
  'Click-time signal: the conversion fires for every clean click, so Google optimizes on clicks. To optimize on real registrations/deposits keep this OFF and use the "Google Ads" button under Forwarding — S2S postbacks (fires on the broker postback by {gclid}). Leaving both on double-counts.': 'Сигнал на клике: конверсия срабатывает на каждом чистом клике, поэтому Google оптимизируется на клики. Чтобы оптимизироваться на реальные реги/депозиты — держите ВЫКЛ и используйте кнопку «Google Ads» в разделе «Пересылка — S2S-постбэки» (срабатывает по постбэку брокера через {gclid}). Если включить оба — двойной счёт.',
  'Bot model': 'Модель ботов',
  // C5/A2/C4 UI screens + doc TOC labels (member access, click traces, bot model)
  'Member access': 'Доступ участников',
  'Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.': 'Настройте, что каждый участник команды может видеть и редактировать — по каждой сущности, а также какие метрики отчётов ему доступны. Владельцы и администраторы не ограничиваются никогда.',
  'Member': 'Участник',
  'Choose a member…': 'Выберите участника…',
  'Failed to load members': 'Не удалось загрузить участников',
  'Retry': 'Повторить',
  'No team members yet': 'Участников пока нет',
  'Invite teammates from the Workspace page, then configure their access here.': 'Пригласите коллег на странице Workspace, затем настройте их доступ здесь.',
  'Pick a member to configure': 'Выберите участника для настройки',
  'Their entity access and allowed report metrics will show up here.': 'Здесь появятся его доступ к сущностям и разрешённые метрики отчётов.',
  'Failed to load member access': 'Не удалось загрузить доступ участника',
  'Owners and admins have full, unrestricted access': 'Владельцы и администраторы имеют полный, неограниченный доступ',
  'You can still save these rules, but they stay inert unless the role changes to manager or viewer.': 'Правила можно сохранить, но они не действуют, пока роль не сменится на manager или viewer.',
  'Entity access': 'Доступ к сущностям',
  'Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.': 'Полный — режим по умолчанию: без ограничений. Только чтение запрещает изменения. К выбранным ограничивает участника перечисленными ID. Созданные и выбранные добавляет всё, что участник создал сам.',
  'Entity': 'Сущность',
  'Access mode': 'Режим доступа',
  'Allowed IDs': 'Разрешённые ID',
  'Full': 'Полный',
  'Read-only': 'Только чтение',
  'To selected': 'К выбранным',
  'Created and selected': 'Созданные и выбранные',
  'IDs, comma or space separated': 'ID через запятую или пробел',
  'IDs of the specific items this member may access': 'ID конкретных элементов, к которым у участника есть доступ',
  'No IDs yet — the member will only see items they created themselves.': 'ID не указаны — участник увидит только элементы, созданные им самим.',
  'No IDs yet — the member will not see any items of this type.': 'ID не указаны — участник не увидит ни одного элемента этого типа.',
  'All items': 'Все элементы',
  'Allowed report metrics': 'Разрешённые метрики отчётов',
  'Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.': 'Переключайте метрики, которые участник может видеть в отчётах и дашбордах. Если не выбрана ни одна метрика — ограничений нет.',
  'All metrics (no restriction)': 'Все метрики (без ограничений)',
  'metrics allowed': 'метрик разрешено',
  'Clear (allow all)': 'Сбросить (разрешить все)',
  'Save access': 'Сохранить доступ',
  'Member access saved': 'Доступ участника сохранён',
  'Failed to save member access': 'Не удалось сохранить доступ участника',
  'Click traces': 'Трассировки кликов',
  'Diagnostics': 'Диагностика',
  'Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.': 'Сэмплированные реальные клики с полным решением о маршрутизации по каждому — какие потоки проверялись и почему совпал победитель.',
  'Pick a campaign above to inspect where its real clicks were routed and why.': 'Выберите кампанию выше, чтобы увидеть, куда были направлены её реальные клики и почему.',
  'Live-click tracing': 'Трассировка живых кликов',
  'Enable live-click tracing': 'Включить трассировку живых кликов',
  'Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.': 'По умолчанию выключено. При включении сэмплированная доля реальных кликов записывает полную трассировку маршрутизации. Безопасно для приватности: IP-адреса и user-agent не сохраняются, а трассировки автоматически удаляются.',
  'Sample rate (%)': 'Доля сэмплирования (%)',
  'Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.': 'Доля кликов для трассировки, от 0 до 100%. Пример: 10% — трассируется примерно каждый десятый клик.',
  'Sample rate must be between 0 and 100': 'Доля сэмплирования должна быть от 0 до 100',
  'Trace settings saved': 'Настройки трассировки сохранены',
  'Error loading click traces': 'Ошибка загрузки трассировок кликов',
  'Could not load traces': 'Не удалось загрузить трассировки',
  'Something went wrong while loading click traces for this campaign.': 'Что-то пошло не так при загрузке трассировок кликов этой кампании.',
  'No traces yet': 'Трассировок пока нет',
  'Enable tracing above; traces of sampled real clicks will appear here.': 'Включите трассировку выше — здесь появятся трассировки сэмплированных реальных кликов.',
  'Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.': 'Трассировка включена — трассировки сэмплированных реальных кликов появятся здесь по мере поступления трафика. Если ничего нет, проверьте долю сэмплирования.',
  'Flags': 'Метки',
  'Show routing trace': 'Показать трассировку маршрутизации',
  'Hide routing trace': 'Скрыть трассировку маршрутизации',
  'Per-stream verdicts': 'Вердикты по потокам',
  'No per-stream verdicts were recorded for this click.': 'Для этого клика не записаны вердикты по потокам.',
  'Not matched': 'Не сопоставлено',
  'Filters evaluated': 'Проверено фильтров',
  'Relation': 'Отношение',
  'Page': 'Страница',
  'entries': 'записей',
  'just now': 'только что',
  '{n}m ago': '{n} мин назад',
  '{n}h ago': '{n} ч назад',
  'ML bot model': 'ML-модель ботов',
  'Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.': 'Классификатор ботов со слабой разметкой: обучайте его на последних кликах, смотрите метрики и оценивайте произвольные payload\'ы. Только shadow-режим — на живую маршрутизацию не влияет.',
  'Admin access required': 'Требуется доступ администратора',
  'The ML bot-model panel is only available to workspace admins.': 'Панель ML-модели ботов доступна только администраторам воркспейса.',
  'Error loading bot-model status': 'Не удалось загрузить статус ML-модели',
  'Model status': 'Статус модели',
  'Trained': 'Обучена',
  'Not trained': 'Не обучена',
  'Inference': 'Инференс',
  'Degenerate': 'Вырожденная',
  'Trained on a single class or too few samples — metrics are not meaningful.': 'Обучена на одном классе или слишком малой выборке — метрики не показательны.',
  'Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.': 'Инференс по умолчанию выключен и работает только в shadow-режиме — даже включённый, он лишь записывает скоры на кликах для анализа и никогда не влияет на маршрутизацию.',
  'Accuracy': 'Точность',
  'Positive rate': 'Доля позитивных',
  'Log loss': 'Log loss',
  'AUC': 'AUC',
  'Training samples': 'Обучающие сэмплы',
  'Trained at': 'Обучена в',
  'No bot model trained yet. Train one on recent clicks below.': 'Модель ботов ещё не обучена. Обучите её на последних кликах ниже.',
  'Train model': 'Обучить модель',
  'Training…': 'Обучение…',
  'Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.': 'Обучение берёт до 5 000 последних кликов, слабо размечает их существующими бот-эвристиками (user agent, уникальность, поведенческий скор) и обучает небольшую логистическую регрессию. Повторное обучение заменяет сохранённую модель.',
  'Model trained on {n} clicks — accuracy {acc}': 'Модель обучена на {n} кликах — точность {acc}',
  'Model trained on {n} clicks': 'Модель обучена на {n} кликах',
  'No click data to train on yet.': 'Пока нет кликов для обучения.',
  'Training finished': 'Обучение завершено',
  'Training failed': 'Не удалось обучить модель',
  'Score a sample': 'Оценить сэмпл',
  'Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.': 'Инструмент разработчика: вставьте JSON-payload в форме клика и прогоните его через обученную модель. Ничего не сохраняется, живой трафик не затрагивается.',
  'Click payload (JSON)': 'Payload клика (JSON)',
  'Score': 'Оценка',
  'Scoring…': 'Оценка…',
  'Reset example': 'Вернуть пример',
  'Invalid JSON — check the payload and try again.': 'Некорректный JSON — проверьте payload и попробуйте снова.',
  'Payload must be a JSON object.': 'Payload должен быть JSON-объектом.',
  'No trained model — train one first.': 'Нет обученной модели — сначала обучите её.',
  'Scoring failed': 'Не удалось оценить payload',
  'Likely bot': 'Похоже на бота',
  'Likely human': 'Похоже на человека',
  'Threshold 0.5 — scores above are flagged as bots.': 'Порог 0.5 — скоры выше помечаются как боты.',
  'Heuristic weak label': 'Эвристическая слабая метка',
  'Human': 'Человек',
  'Feature': 'Признак',
  '{n} min ago': '{n} мин назад',
  '{n} h ago': '{n} ч назад',
  '{n} d ago': '{n} дн назад',
  'Archive & restore': 'Архив и восстановление',
  'Access control': 'Контроль доступа',

  "Offer rotation on daily cap": "Ротация офферов при дневном лимите",
  "No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.": "Порог не нужен. Правило срабатывает, когда любой оффер кампании достигает дневного лимита, и уведомляет, что трафик уходит на запасной / остальные офферы. Лимит и запасной оффер задаются на каждом оффере.",
  "Connection types": "Типы соединения",
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Фильтр по типу сетевого соединения. 'hosting' (датацентр/облако) работает сразу; другие значения (напр. cellular, wifi) требуют, чтобы edge-прокси присылал заголовок X-Connection-Type.",
  "Status mapping": "Маппинг статусов",
  "Add status": "Добавить статус",
  "No status mappings added": "Маппинги статусов не добавлены",
  "Network status (e.g. ftd)": "Статус сети (напр. ftd)",
  "Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.": "Сопоставьте сырой статус, который присылает сеть, с каноническим статусом. Применяется к входящим постбэкам, когда маппинг статусов кампании не совпал.",
  "Lead": "Лид",
  "Sale": "Продажа",
  "Reject": "Отказ",
  "Upsell": "Апселл",
  "Ignore": "Игнор",
  "Split testing": "Сплит-тест",
  "Parameter filters": "Фильтры по параметрам",
  "Params": "Параметры",
  "Split testing enabled": "Сплит-тест включён",
  "Split testing disabled": "Сплит-тест выключен",
  "Failed to update campaign": "Не удалось обновить кампанию",
  "Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.": "Ротация потоков. Вкл: обычные потоки ротируются по весу, позиция не учитывается. Выкл: потоки проверяются сверху вниз по позиции, весь трафик забирает первый подходящий. Перехватывающие потоки всегда проверяются первыми и не ротируются по весу.",
  "Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.": "Маршрутизация по суб-параметрам URL. Одно правило на строку: имя=значение1, значение2 — пропускает перечисленные значения; имя!=значение1, значение2 — блокирует их (отсутствующий параметр проходит блок-правило). Правило без значений не накладывает ограничений.",
  "Regions": "Регионы",
  "GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.": "Названия регионов/штатов/областей по GeoIP (напр. California, Bavaria). Поддерживаются маски, /regex/ и @empty.",
  "IP addresses": "IP-адреса",
  "Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.": "Точные IP, CIDR-блоки (10.0.0.0/8) или маски (192.168.*). Удобно для белого списка своих тестовых IP или блокировки диапазона датацентра.",
  "User agents": "User-Agent",
  "Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.": "Подстроки, маски или /regex/ по сырой строке User-Agent — напр. *Chrome/12* таргетирует Chrome 120+, HeadlessChrome ловит headless-браузеры.",
  "Clicks per hour": "Кликов в час",
  "Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.": "Лимит в скользящем окне: после стольких кликов за последний час поток перестаёт принимать НОВЫЕ клики, трафик уходит в следующий поток. Пусто = без лимита.",
  "Clicks per 24h": "Кликов за 24 часа",
  "Rolling-window limit over the last 24 hours. Empty = no limit.": "Лимит в скользящем окне за последние 24 часа. Пусто = без лимита.",
  "Filter relation": "Отношение фильтров",
  "AND: the click must pass every configured filter. OR: any single passing filter admits the click.": "И: клик должен пройти все настроенные фильтры. ИЛИ: достаточно одного совпавшего фильтра.",
  "AND (all)": "И (все)",
  "OR (any)": "ИЛИ (любой)",
  "Is": "Совпадает",
  "Is not": "Не совпадает",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Дни недели и часы, когда поток активен. Время — в таймзоне владельца кампании. «Не совпадает» инвертирует расписание: поток принимает клики КРОМЕ указанного времени.",
  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Просто текстовая метка сети для заметок и фильтров — ни на что не влияет. Для реальной привязки используйте «Партнёрская сеть» или блок Affiliate routing ниже.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Переиспользуемая партнёрская сеть из раздела Affiliate networks: постбэк-шаблон и параметры оффера, отчёты по сетям. Необязательно.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "Куда уходит клик для обычного redirect-оффера. Работают макросы: {click_id}, {country_code}, {gclid} и др. Для форм-офферов (лид в CRM) URL может быть любым.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Максимум конверсий на оффер в сутки. При достижении лимита трафик уходит на запасной оффер (Fallback). Пусто = без лимита.",
  "Time zone in which the daily cap is counted and the counter resets.": "Часовой пояс, в котором считается суточный лимит и сбрасывается счётчик.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Запасной оффер: сюда пойдёт трафик, когда достигнут дневной лимит основного.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "Партнёрка/CRM, куда отправляется лид. Заводится один раз в разделе Integrations (TrackBox или Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "Box/Goal ID оффера у партнёрки — какой продукт/бокс принимает лид. Значение выдаёт партнёрка (напр. 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Доля лидов на эту партнёрку при нескольких (сплит/ротация). Напр. 70 и 30 = 70% и 30%.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Выкл = партнёрка временно пропускается (напр. пока не согласован запуск), настройки при этом сохраняются.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Точечный адрес формы для ИМЕННО этого оффера. Обычно НЕ нужен — ставь общий /api/lead (см. документацию). Нужен только для жёсткой привязки формы к одному офферу.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Уведомление в Telegram на КАЖДУЮ отправку формы (принят/отклонён/тест). Это отдельно от Telegram-постбэка в кампании (тот — на подтверждённую конверсию). Bot token — от @BotFather, Chat ID группы — с префиксом -100…",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "URL по умолчанию, если ни один поток не подошёл. Обычно маршрут задают потоки (Streams) — это поле как страховка.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "Рекламная площадка (Google Ads, Facebook…). Задаёт набор макросов/сабов, которые добавятся к трекинг-ссылке для передачи данных клика.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Как считать расход: CPC — за клик, CPM — за 1000 показов, CPA — за конверсию. Влияет на Расход / ROI / CPC / CPA в отчётах.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "Имя GET-параметра, под которым трекер допишет click_id к URL оффера (напр. click_id → ?click_id=…). Нужно, чтобы партнёрка вернула этот click_id в постбэке. Сниппеты форм читают и click_id, и clickid.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "Не ставить cookie xpnsr_vid (для сетей, где cookie запрещены). Уникальность тогда считается по IP+User Agent, а click_id передавай через URL — поле «Click ID forward parameter» выше.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "Хэшировать IP перед сохранением (для GDPR). ГЕО определяется ДО хэширования, поэтому таргетинг по стране/городу не страдает.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Как перенаправлять: 302 — обычный быстрый редирект; Meta refresh / JS — когда сеть не идёт по 302 или нужен gtag; Cloaked (iframe) — спрятать URL оффера в адресной строке.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — обычный поток с фильтрами; Catch — ловит трафик, не подошедший ни под один Normal; Default — замыкающий, если не подошёл ни один поток.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Приоритет проверки. Чем меньше число, тем раньше проверяется поток. Трафик уходит в первый подходящий.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "При нескольких потоках одного типа — доля трафика между ними (сплит). Напр. 70 и 30 = 70% и 30%.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Максимум кликов на этот поток. После достижения поток перестаёт принимать трафик. Пусто = без лимита.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — вести на лендинг/оффер потока; Action — спец. ответ (напр. 404 / пустой ответ для анти-фрода); Split test — сплит между вариантами.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Фильтр по уникальности визита: только уникальные / только повторные / не фильтровать.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Как поступать с ботами (детект по User-Agent): не фильтровать / только боты / исключить ботов. Удобно для анти-фрод потока.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Фильтр прокси/VPN (datacenter/Tor): не фильтровать / только прокси / исключить прокси.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Пускать только IPv4 или только IPv6, либо не фильтровать.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Дни недели и часы, когда поток активен. Время считается в таймзоне владельца кампании.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Готовый пресет площадки (Google Ads, Facebook…) — подставит название, стандартные макросы/сабы и S2S-постбэк для этого источника.",
  // Traffic-source template catalog picker
  'Search templates…': 'Поиск шаблонов…',
  'All categories': 'Все категории',
  'Templates in catalog': 'Шаблонов в каталоге',
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "Необязательно. Исходящий постбэк В рекламную сеть при конверсии — чтобы площадка оптимизировала кампании на своей стороне (напр. Facebook CAPI по-старому).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Параметры, которые площадка передаёт в клик (sub1…subN, gclid, tm и т.д.). Они станут макросами, попадут в отчёты и добавятся к трекинг-ссылке.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — типовой адаптер под их API. Custom API — под любую другую CRM: запрос (URL, заголовки, тело, где брать redirect) настраиваешь сам.",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "Секретный ключ Push/Registration от партнёрки. Берётся в ЛК партнёрки (раздел API / API Testing) или у аффилейт-менеджера.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Ваш Affiliate ID у партнёрки. Выдаёт партнёрка.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Campaign ID у партнёрки. Обычно 1, если не сказано иное.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "Сырые статусы сети, которые считать ЛИДОМ (регистрация). Через запятую. Напр. new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "Сырые статусы, которые считать ПРОДАЖЕЙ/депозитом. Напр. ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Статусы отказа/брака. Напр. bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Эти статусы молча отбрасываются — не пишутся в конверсии. Напр. spam, junk, test.",
  // Navbar
  'Dashboard': 'Дашборд',
  'Campaigns': 'Кампании',
  'Landing pages': 'Лендинги',
  'Offers': 'Офферы',
  'Sources': 'Источники',
  'Report': 'Отчёт',
  'Group clicks and conversions by any dimension with full metrics.': 'Группируйте клики и конверсии по любому измерению с полным набором метрик.',
  'Grouped by': 'Группировка по',
  'No data for this period.': 'Нет данных за период.',
  'Empty ref.': 'Пустой реф.',
  'Group': 'Группа',
  '— no level —': '— без уровня —',
  'Click a row to drill in': 'Нажмите на строку, чтобы раскрыть',
  'Expand': 'Раскрыть',
  'Collapse': 'Свернуть',
  'Open in clicks log': 'Открыть в логе кликов',
  'Failed to load': 'Не удалось загрузить',
  'Card view': 'Карточки',
  'Table view': 'Таблица',
  'Save view': 'Сохранить вид',
  'Save current view': 'Сохранить текущий вид',
  'Saved views': 'Сохранённые виды',
  'Delete view': 'Удалить вид',
  'View saved': 'Вид сохранён',
  'View name': 'Название вида',
  'Remember the current filters, sort and layout under a name for one-click recall.': 'Запомнить текущие фильтры, сортировку и раскладку под именем для вызова в один клик.',
  'e.g. Tier-1 by revenue': 'напр. Tier-1 по выручке',
  'Upload pre-landing (ZIP)': 'Загрузить прелендинг (ZIP)',
  'Upload a ZIP with your warm-up page. index.html is auto-detected.': 'Загрузите ZIP с прогревочной страницей. index.html определится автоматически.',
  'ZIP file': 'ZIP-файл',
  'Pre-landing uploaded': 'Прелендинг загружен',
  'Upload failed': 'Ошибка загрузки',
  'Choose a ZIP file': 'Выберите ZIP-файл',
  'Uploaded': 'Загружен',
  'Uploading…': 'Загрузка…',
  'Columns': 'Колонки',
  'Receiving conversions (incoming postback)': 'Приём конверсий (входящий постбэк)',
  'Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.': 'Ссылки для вставки в кабинет партнёрки (напр. TrackBox), чтобы она сообщала кампании о конверсиях. Передайте click_id в параметр сети — он вернётся сюда.',
  'Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.': 'Сопоставьте сырые статусы партнёрки с нашими (через запятую). Применяется ко всем входящим постбэкам кампании. Инлайн-параметры в URL имеют приоритет.',
  'Forwarding — S2S postbacks': 'Пересылка — S2S-постбэки',
  'Landing click': 'Клик по ленду',
  'Time on landing': 'Время на ленде',
  'sec': 'с',
  'OS': 'ОС',
  'ISP / provider': 'Провайдер (ISP)',
  'Proxy': 'Прокси',
  'Empty referrer': 'Пустой реферер',
  'Bots': 'Боты',
  'Only bots': 'Только боты',
  'Exclude bots': 'Исключить ботов',
  'Proxy / VPN': 'Прокси / VPN',
  'Only proxy': 'Только прокси',
  'Exclude proxy': 'Исключить прокси',
  'IP version': 'Версия IP',
  'Show 404': 'Показать 404',
  'Do nothing': 'Ничего не делать',
  'Schedule': 'Расписание',
  'Add interval': 'Добавить интервал',
  'Every day, all day': 'Каждый день, круглосуточно',
  'Every day': 'Каждый день',
  'Error loading affiliate networks': 'Ошибка загрузки партнёрских сетей',
  'Quick start from preset': 'Быстрый старт из пресета',
  'Affiliate network name': 'Название партнёрской сети',
  'Vertical': 'Вертикаль',
  'Postback URL template': 'Шаблон postback-URL',
  'Outbound postback the tracker calls to notify this network.': 'Исходящий постбэк, которым трекер уведомляет сеть о конверсии.',
  'Offer parameters': 'Параметры оффера',
  'Key': 'Ключ',
  'Notes': 'Заметки',
  'Internal notes': 'Внутренние заметки',
  'Affiliate networks': 'Партнёрские сети',
  'Reusable partner networks: postback template, offer params and inbound URL.': 'Переиспользуемые партнёрские сети: шаблон постбэка, параметры оффера и входящий URL.',
  'Create network': 'Создать сеть',
  'Create affiliate network': 'Создать партнёрскую сеть',
  'Pick a preset or configure a partner network from scratch.': 'Выберите пресет или настройте сеть вручную.',
  'Search networks': 'Поиск сетей',
  'No affiliate networks yet': 'Партнёрских сетей пока нет',
  'Create one from a preset like TrackBox or Adcombo.': 'Создайте сеть из пресета, например TrackBox или Adcombo.',
  'Postback copied': 'Постбэк скопирован',
  'Inbound postback URL (paste in the network)': 'Входящий postback-URL (вставьте в кабинет сети)',
  'Inbound URL copied': 'Входящий URL скопирован',
  'conv.': 'конв.',
  'offer parameter(s)': 'параметр(ы) оффера',
  'Edit affiliate network': 'Редактировать партнёрскую сеть',
  'Update partner network settings': 'Обновите настройки партнёрской сети',
  'Delete affiliate network': 'Удалить партнёрскую сеть',
  'This permanently deletes the network. Offers linked to it keep their other settings.': 'Сеть будет удалена без возможности восстановления. Привязанные офферы сохранят остальные настройки.',
  'Affiliate network created': 'Партнёрская сеть создана',
  'Error creating affiliate network': 'Ошибка создания партнёрской сети',
  'Affiliate network updated': 'Партнёрская сеть обновлена',
  'Error updating affiliate network': 'Ошибка обновления партнёрской сети',
  'Affiliate network deleted': 'Партнёрская сеть удалена',
  'Cannot delete: network is linked to offers': 'Нельзя удалить: сеть привязана к офферам',
  'Error deleting affiliate network': 'Ошибка удаления партнёрской сети',
  'Copy failed': 'Не удалось скопировать',
  'Network (text label)': 'Сеть (текстовая метка)',
  'Traffic': 'Трафик',
  'A/B Tests': 'A/B Тесты',
  'Anti-fraud': 'Анти-фрод',
  'Analytics': 'Аналитика',
  'Automation': 'Автоматизация',
  'Integrations': 'Интеграции',
  'Settings': 'Настройки',
  'Account': 'Аккаунт',
  'My account': 'Мой аккаунт',
  'Profile': 'Профиль',
  'Sign out': 'Выйти',
  'User': 'Пользователь',

  // Dashboard
  'Welcome, {name}.': 'Добро пожаловать, {name}.',
  'Welcome,': 'Добро пожаловать,',
  'Real-time overview of your campaigns and stats': 'Обзор ваших кампаний и статистики в реальном времени',
  'Create campaign': 'Создать кампанию',
  'Clicks': 'Клики',
  'Unique visitors': 'Уникальные посетители',
  'Conversions': 'Конверсии',
  'Total active campaigns': 'Всего активных кампаний',
  'Total clicks': 'Общее количество кликов',
  'Unique clicks': 'Уникальные клики',
  '{rate}% conversion': '{rate}% конверсия',
  'Recent campaigns': 'Последние кампании',
  'Your latest campaigns': 'Ваши недавно созданные кампании',
  'You have no campaigns yet': 'У вас пока нет кампаний',
  'Create your first campaign': 'Создать первую кампанию',
  'Quick actions': 'Быстрые действия',
  'Commonly used features': 'Часто используемые функции',
  'Add a new ad campaign': 'Добавьте новую рекламную кампанию',
  'View detailed statistics': 'Просмотрите детальную статистику',
  'Manage campaigns': 'Управление кампаниями',
  'Edit existing campaigns': 'Редактируйте существующие кампании',
  'Show all campaigns': 'Показать все кампании',
  'More details': 'Подробнее',
  'Active': 'Активна',
  'Paused': 'Остановлена',
  'No description': 'Без описания',
  '{n} clicks': '{n} кликов',
  '{n} unique': '{n} уникальных',
  '{n} conversions': '{n} конверсий',

  // Loading
  'Loading workspace': 'Загрузка рабочего пространства',
  'Loading your data…': 'Загружаем ваши данные…',

  // Auth
  'Sign in': 'Войти',
  'Sign up': 'Регистрация',
  'Email': 'Email',
  'Work email': 'Рабочая почта',
  'Password': 'Пароль',
  'Full name': 'Полное имя',
  'Jane Doe': 'Иван Иванов',
  'Create account': 'Создать аккаунт',
  'Create new account': 'Создать новый аккаунт',
  'Already have an account?': 'Уже есть аккаунт?',
  "Don't have an account?": 'Нет аккаунта?',
  'Welcome back': 'С возвращением',
  'Sign in to your xpnsr account': 'Войдите в свой аккаунт xpnsr',
  'Attribution,': 'Атрибуция,',
  'honest': 'честно',
  'Create': 'Создать',
  'account': 'аккаунт',
  'S2S postback · bot shield': 'S2S постбэки · защита от ботов',
  'Remember this device': 'Запомнить устройство',
  'Reset': 'Сбросить',
  'Access tracker': 'Войти в трекер',
  'Hide password': 'Скрыть пароль',
  'Show password': 'Показать пароль',
  'At least 6 characters': 'Минимум 6 символов',
  'Signing in…': 'Входим…',
  'Creating account…': 'Создаём аккаунт…',
  'Invalid email or password': 'Неверный email или пароль',
  'Registration failed. Please try again.': 'Регистрация не удалась. Попробуйте ещё раз.',
  'New registrations are disabled. Contact your workspace admin for an invitation.':
    'Регистрация новых пользователей отключена. Запросите приглашение у администратора рабочего пространства.',

  // Sidebar (xpnsr shared)
  'Home': 'Главная',
  'Auth': 'Авторизация',
  'Book Demo': 'Забронировать демо',
  'Search campaigns, streams…': 'Поиск кампаний, потоков…',
  'One visual language for the xpnsr.tech family.':
    'Единый визуальный язык для всей линейки xpnsr.tech.',
  'Control': 'Контроль',
  'Operations': 'Управление',
  'Precise tracking': 'Точное отслеживание',
  'KPIs, sources and leads in one panel.': 'KPI, источники и лиды в одной панели.',
  'Readable reports': 'Понятные отчёты',
  'Data visualization for fast decisions.': 'Визуализация данных для быстрых решений.',
  'Scale your team': 'Масштабируйте команду',
  'Organize teams, campaigns and sources without friction.':
    'Организуйте команды, кампании и источники без лишней сложности.',
  'Enter your credentials to continue.': 'Введите данные для входа.',
  'Create a new xpnsr.tech account.': 'Создайте новую учётную запись xpnsr.tech.',

  // Campaigns
  'Campaign management': 'Управление кампаниями',
  'Create, edit and track your ad campaigns in real time':
    'Создавайте, редактируйте и отслеживайте ваши рекламные кампании в реальном времени',
  'Search campaigns…': 'Поиск кампаний...',
  'Create new campaign': 'Создать новую кампанию',
  'Edit campaign': 'Редактировать кампанию',
  'Fill in the details of your new ad campaign': 'Заполните информацию о новой рекламной кампании',
  'Update campaign details': 'Внесите изменения в кампанию',
  'Campaign name': 'Название кампании',
  'Description (optional)': 'Описание (необязательно)',
  'Target URL': 'Целевая ссылка',
  'Traffic source': 'Источник трафика',
  'Cost model': 'Модель оплаты',
  'Select a traffic source (optional)': 'Выберите источник трафика (необязательно)',
  'CPC (per click)': 'CPC (за клик)',
  'CPM (per impression)': 'CPM (за показы)',
  'CPA (per action)': 'CPA (за действие)',
  'Cancel': 'Отмена',
  'Save changes': 'Сохранить изменения',
  'Edit': 'Редактировать',
  'Copy link': 'Копировать ссылку',
  'Delete': 'Удалить',
  'Are you sure you want to delete this campaign?':
    'Вы действительно хотите удалить эту кампанию?',
  'Campaign created successfully!': 'Кампания создана успешно!',
  'Campaign updated successfully!': 'Кампания обновлена успешно!',
  'Campaign deleted successfully!': 'Кампания удалена успешно!',
  'No campaigns': 'Нет кампаний',
  'Campaigns not found': 'Кампании не найдены',
  'Create your first campaign to start tracking traffic':
    'Создайте вашу первую кампанию для начала отслеживания трафика',
  'Try adjusting search criteria': 'Попробуйте изменить критерии поиска',
  'Tracking ID': 'Трекинговый ID',
  'Link copied to clipboard!': 'Ссылка скопирована в буфер обмена!',
  'Failed to copy link': 'Не удалось скопировать ссылку',
  'Error loading campaigns': 'Ошибка при загрузке кампаний',
  'Error creating campaign': 'Ошибка при создании кампании',
  'Error updating campaign': 'Ошибка при обновлении кампании',
  'Error deleting campaign': 'Ошибка при удалении кампании',
  'For example: Product A ad': 'Например: Реклама товара А',
  'Short campaign description': 'Краткое описание кампании',

  // Landing pages
  'New landing page': 'Новый лендинг',
  'Add landing page': 'Добавить лендинг',
  'Add a landing page for use in campaigns and A/B tests':
    'Добавьте лендинг для использования в кампаниях и A/B тестах',
  'Edit landing page': 'Редактировать лендинг',
  'Edit landing page settings': 'Измените настройки лендинга',
  'Search landing pages…': 'Поиск лендингов…',
  'Create landing pages for use in campaigns':
    'Создавайте лендинги для использования в кампаниях',
  'No landing pages': 'Нет лендингов',
  'Nothing found': 'Ничего не найдено',
  'Landing page created': 'Лендинг создан',
  'Landing page updated': 'Лендинг обновлён',
  'Landing page deleted': 'Лендинг удалён',
  'Delete this landing page?': 'Удалить этот лендинг?',
  'Error loading landing pages': 'Ошибка загрузки лендингов',
  'Error creating landing page': 'Ошибка создания лендинга',
  'Error updating landing page': 'Ошибка обновления лендинга',
  'Error deleting landing page': 'Ошибка удаления лендинга',
  'Please fill in name and URL': 'Заполните название и URL',
  'URL copied': 'URL скопирован',
  'My landing': 'Мой лендинг',
  'Landing page description': 'Описание лендинга',
  'Lead generation': 'Лидогенерация',
  'Subscription': 'Подписка',
  'Download': 'Загрузка',
  'Other': 'Другое',
  'Category': 'Категория',
  'Select category': 'Выберите категорию',
  'Description': 'Описание',
  'Tags': 'Теги',
  'Add tag': 'Добавить тег',
  'Status': 'Статус',
  'Inactive': 'Неактивен',
  'Visits': 'Посещения',
  'CR': 'CR',
  'Actions': 'Действия',
  'Name': 'Название',
  'URL': 'URL',
  'Save': 'Сохранить',
  'Unique': 'Уникальные',

  // Offers
  'Add offer': 'Добавить оффер',
  'New offer': 'Новый оффер',
  'Edit offer': 'Редактировать оффер',
  'Add an offer to use in campaigns': 'Добавьте оффер для использования в кампаниях',
  'Change offer parameters': 'Измените параметры оффера',
  'Search offers…': 'Поиск офферов…',
  'No offers': 'Нет офферов',
  'Create offers to monetize your traffic': 'Создайте офферы для монетизации трафика',
  'Offer created': 'Оффер создан',
  'Offer updated': 'Оффер обновлён',
  'Offer deleted': 'Оффер удалён',
  'Delete this offer?': 'Удалить этот оффер?',
  'Error loading offers': 'Ошибка загрузки офферов',
  'Error creating offer': 'Ошибка создания оффера',
  'Error updating offer': 'Ошибка обновления оффера',
  'Error deleting offer': 'Ошибка удаления оффера',
  'My offer': 'Мой оффер',
  'Offer URL': 'URL оффера',
  'Offer description': 'Описание оффера',
  'Affiliate network': 'Партнёрская сеть',
  'Network': 'Сеть',
  'Payout': 'Выплата',
  'Currency': 'Валюта',
  'Geo': 'Гео',
  'Countries (ISO codes, e.g. US, RU)': 'Страны (ISO коды, напр. US, RU)',
  'Nutra': 'Нутра',
  'Gambling': 'Гемблинг',
  'Dating': 'Дейтинг',
  'Finance': 'Финансы',
  'Crypto': 'Крипто',
  'Sweepstakes': 'Свипстейки',

  // Campaign detail
  'Back': 'Назад',
  'Streams': 'Потоки',
  'Open target URL': 'Открыть целевую ссылку',
  'Copy tracking link': 'Скопировать трекинговую ссылку',
  'Tracking link copied!': 'Трекинговая ссылка скопирована!',
  'Campaign not found': 'Кампания не найдена',
  'Successful conversions': 'Успешные конверсии',
  'Conversion rate': 'Конверсия',
  'Conversion percentage': 'Процент конверсии',
  'Campaign info': 'Информация о кампании',
  'Tracking link': 'Трекинговая ссылка',
  'Created': 'Создано',
  'Updated': 'Обновлено',
  'Recent clicks': 'Последние клики',
  'Recent activity for this campaign': 'Недавняя активность по этой кампании',
  'No clicks for this campaign yet': 'Пока нет кликов по этой кампании',
  'Showing latest 10 clicks': 'Показаны последние 10 кликов',
  'Device breakdown': 'Статистика по устройствам',
  'Browser breakdown': 'Статистика по браузерам',
  'No data to display': 'Нет данных для отображения',
  'Unknown': 'Неизвестно',

  // Traffic sources
  'Traffic sources': 'Источники трафика',
  'Create source': 'Создать источник',
  'Create traffic source': 'Создать источник трафика',
  'Edit traffic source': 'Редактировать источник трафика',
  'Update traffic source settings': 'Измените настройки источника трафика',
  'Configure a traffic source for UTM tags and conversion postbacks':
    'Настройте источник трафика для получения UTM-меток и отправки конверсий',
  'Source template': 'Шаблон источника',
  'Pick a template or create your own': 'Выберите шаблон или создайте свой',
  'Traffic source name': 'Название источника трафика',
  'Traffic source description': 'Описание источника трафика',
  'Postback URL': 'Postback URL',
  'Postback URL copied': 'Postback URL скопирован',
  'UTM parameters': 'Параметры UTM-меток',
  'Add parameter': 'Добавить параметр',
  'Enter parameter name:': 'Введите название параметра:',
  'Parameter': 'Параметр',
  'Alias': 'Псевдоним',
  'Placeholder': 'Плейсхолдер',
  'Action': 'Действие',
  'Source macro': 'Макрос источника',
  'No parameters added': 'Параметры не добавлены',
  'Search traffic sources…': 'Поиск источников трафика…',
  'Sources not found': 'Источники не найдены',
  'No traffic sources': 'Нет источников трафика',
  'Create sources to integrate with ad networks':
    'Создайте источники для интеграции с рекламными площадками',
  'Spend': 'Расходы',
  'Parameters configured:': 'Параметров настроено:',
  'Traffic source created': 'Источник трафика создан',
  'Traffic source updated': 'Источник трафика обновлён',
  'Traffic source deleted': 'Источник трафика удалён',
  'Are you sure you want to delete this traffic source?':
    'Вы действительно хотите удалить этот источник трафика?',
  'Cannot delete: source is in use by campaigns':
    'Невозможно удалить: источник используется в кампаниях',
  'Error loading traffic sources': 'Ошибка загрузки источников трафика',
  'Error creating traffic source': 'Ошибка создания источника трафика',
  'Error updating traffic source': 'Ошибка обновления источника трафика',
  'Error deleting traffic source': 'Ошибка удаления источника трафика',

  // Settings
  'Preferences': 'Предпочтения',
  'Notifications': 'Уведомления',
  'System': 'Система',
  'Profile information': 'Информация профиля',
  'Manage your basic account information': 'Управляйте основной информацией вашего аккаунта',
  'Enter your full name': 'Введите ваше полное имя',
  'Enter your email': 'Введите ваш email',
  'Save profile': 'Сохранить профиль',
  'Change password': 'Сменить пароль',
  'Update your password to keep your account secure':
    'Обновите пароль для обеспечения безопасности',
  'Current password': 'Текущий пароль',
  'New password': 'Новый пароль',
  'Confirm new password': 'Подтвердите новый пароль',
  'Enter current password': 'Введите текущий пароль',
  'Enter new password': 'Введите новый пароль',
  'New passwords do not match': 'Новые пароли не совпадают',
  'New password must be at least 6 characters':
    'Новый пароль должен содержать минимум 6 символов',
  'Password changed successfully': 'Пароль успешно изменён',
  'Profile updated successfully': 'Профиль успешно обновлён',
  'Error updating profile': 'Ошибка обновления профиля',
  'Error changing password': 'Ошибка смены пароля',
  'Error loading settings': 'Ошибка загрузки настроек',
  'Error saving settings': 'Ошибка сохранения настроек',
  'Error saving system settings': 'Ошибка сохранения системных настроек',
  'User settings saved': 'Настройки пользователя сохранены',
  'System settings saved': 'Системные настройки сохранены',
  'Interface preferences': 'Предпочтения интерфейса',
  'Customize the look and behavior of the app':
    'Настройте внешний вид и поведение приложения',
  'Timezone': 'Временная зона',
  'Moscow (UTC+3)': 'Москва (UTC+3)',
  'Kyiv (UTC+2)': 'Киев (UTC+2)',
  'New York (UTC-5)': 'Нью-Йорк (UTC-5)',
  'Language': 'Язык',
  'Date format': 'Формат даты',
  'Dashboard refresh rate (sec)': 'Частота обновления дашборда (сек)',
  'Save settings': 'Сохранить настройки',
  'Configure how you receive notifications': 'Настройте способы получения уведомлений',
  'Email notifications': 'Email уведомления',
  'SMS notifications': 'SMS уведомления',
  'Get email notifications about important events':
    'Получайте уведомления на email о важных событиях',
  'Get SMS for critical events': 'Получайте SMS о критических событиях',
  'Save notification settings': 'Сохранить настройки уведомлений',
  'Tracking domains': 'Домены трекинга',
  'Configure domains for campaign tracking': 'Настройте домены для трекинга кампаний',
  'Primary tracking domain': 'Основной домен трекинга',
  'Additional domains': 'Дополнительные домены',
  'Add domain': 'Добавить домен',
  'Add': 'Добавить',
  'Save domain settings': 'Сохранить настройки доменов',
  'Security': 'Безопасность',
  'Security and access settings': 'Настройки безопасности и доступа',
  'Security settings': 'Настройки безопасности',
  'Coming in upcoming releases': 'Будут реализованы в следующих обновлениях',

  // Analytics
  'Active campaigns': 'Активные кампании',
  'Clicks today': 'Клики сегодня',
  'For the current day': 'За текущий день',
  'Confirmed': 'Подтверждённые',
  'Refresh': 'Обновить',
  'Export': 'Экспорт',
  'Report exported': 'Отчёт экспортирован',
  'Period:': 'Период:',
  'Today': 'Сегодня',
  '7 days': '7 дней',
  '14 days': '14 дней',
  '30 days': '30 дней',
  '90 days': '90 дней',
  'Campaign:': 'Кампания:',
  'All campaigns': 'Все кампании',
  'Overview': 'Обзор',
  'Devices': 'Устройства',
  'Clicks and conversions': 'Клики и конверсии',
  'No data for the selected period': 'Нет данных за выбранный период',
  'No data': 'Нет данных',
  'Hourly activity': 'Почасовая активность',
  'CR% by day': 'CR% по дням',
  'Campaign stats': 'Статистика по кампаниям',
  'Revenue': 'Доход',
  'No campaign data': 'Нет данных о кампаниях',
  'Total revenue': 'Общий доход',
  'Total spend': 'Общие расходы',
  'Profit': 'Прибыль',
  'Net positive': 'Чистая прибыль',
  'Net loss': 'Чистый убыток',
  'Advanced notification preferences': 'Расширенные настройки уведомлений',
  'Push notifications, webhook URL, alert categories': 'Push-уведомления, Webhook URL, категории оповещений',
  'Configure': 'Настроить',
  'All values shown in': 'Все значения показаны в',
  'FX rates unavailable — non-USD revenue is excluded from the totals.':
    'Курсы валют недоступны — доход не в USD исключён из итогов.',
  'ROI by campaigns': 'ROI по кампаниям',
  'No ROI data': 'Нет данных для ROI',
  'Clicks by country': 'Клики по странам',
  'Geo table': 'Таблица по ГЕО',
  'No geo data': 'Нет гео-данных',
  'Country': 'Страна',
  'Devices table': 'Таблица устройств',
  'Device type': 'Тип устройства',
  'Share': 'Доля',
  'No device data': 'Нет данных об устройствах',

  // Streams
  'Failed to load campaign': 'Ошибка загрузки кампании',
  'Failed to load streams': 'Ошибка загрузки потоков',
  'Stream created': 'Поток создан',
  'Failed to create stream': 'Ошибка создания потока',
  'Stream updated': 'Поток обновлён',
  'Failed to update stream': 'Ошибка обновления потока',
  'Delete this stream?': 'Вы действительно хотите удалить этот поток?',
  'Stream deleted': 'Поток удалён',
  'Failed to delete stream': 'Ошибка удаления потока',
  'Catch': 'Перехватывающий',
  'Fallback': 'Замыкающий',
  'Normal': 'Обычный',
  'Stream name': 'Название потока',
  'Stream type': 'Тип потока',
  'Position': 'Позиция',
  'Weight (%)': 'Вес (%)',
  'Click limit': 'Лимит кликов',
  'No limit': 'Без ограничений',
  'Stream action': 'Действие потока',
  'Action type': 'Тип действия',
  'Redirect': 'Редирект',
  'Split test': 'Сплит-тест',
  'Redirect URL': 'URL редиректа',
  'Landings and offers': 'Лендинги и Офферы',
  'Landings': 'Лендинги',
  'No landings available': 'Нет доступных лендингов',
  'No offers available': 'Нет доступных офферов',
  'Traffic filters': 'Фильтры трафика',
  'Countries (ISO codes)': 'Страны (коды ISO)',
  'Cities': 'Города',
  'Browsers': 'Браузеры',
  'Operating systems': 'Операционные системы',
  'Languages': 'Языки',
  "Don't filter": 'Не фильтровать',
  'Accept only unique': 'Принимать только уникальные',
  'Filter unique': 'Фильтровать уникальные',
  'Campaign streams': 'Потоки кампании',
  'Create stream': 'Создать поток',
  'Configure stream for traffic distribution by conditions':
    'Настройте поток для распределения трафика по условиям',
  'No streams': 'Нет потоков',
  'Create streams to distribute traffic by conditions':
    'Создайте потоки для распределения трафика по условиям',
  'Weight': 'Вес',
  'Bots filtered': 'Боты отфильтровано',
  'Countries': 'Страны',
  'Limit': 'Лимит',
  'Edit stream': 'Редактировать поток',
  'Modify stream settings': 'Измените настройки потока',

  // Traffic Management
  'Failed to load data': 'Ошибка загрузки данных',
  'Failed to load traffic rules': 'Ошибка загрузки правил трафика',
  'Select a campaign': 'Выберите кампанию',
  'Traffic rule created': 'Правило трафика создано',
  'Failed to create rule': 'Ошибка создания правила',
  'Rule updated': 'Правило обновлено',
  'Failed to update rule': 'Ошибка обновления правила',
  'Rule deleted': 'Правило удалено',
  'Failed to delete rule': 'Ошибка удаления правила',
  'Landing created': 'Лендинг создан',
  'Failed to create landing': 'Ошибка создания лендинга',
  'Failed to create offer': 'Ошибка создания оффера',
  'Traffic management': 'Управление трафиком',
  'Select campaign': 'Выберите кампанию',
  'Traffic rules': 'Правила трафика',
  'Traffic distribution rules': 'Правила распределения трафика',
  'Create rule': 'Создать правило',
  'Create traffic rule': 'Создать правило трафика',
  'Edit rule': 'Редактировать правило',
  'Configure conditions and actions for traffic distribution':
    'Настройте условия и действия для распределения трафика',
  'Rule name': 'Название правила',
  'Priority': 'Приоритет',
  'Rule description': 'Описание правила',
  'Conditions (leave empty for any value)': 'Условия (оставьте пустым для любых значений)',
  'Update': 'Обновить',
  'No traffic rules': 'Нет правил трафика',
  'Create rules to distribute traffic by conditions':
    'Создайте правила для распределения трафика по условиям',
  'Stopped': 'Остановлено',
  'Any': 'Любые',
  'Redirects': 'Редиректов',
  'Select a campaign to manage traffic rules': 'Выберите кампанию для управления правилами трафика',
  'Add landing': 'Добавить лендинг',
  'Add a new landing to the library': 'Добавьте новый лендинг в библиотеку',
  'Landing name': 'Название лендинга',
  'Landing description': 'Описание лендинга',
  'No landings': 'Нет лендингов',
  'Add landings to use in traffic rules': 'Добавьте лендинги для использования в правилах трафика',
  'Add a new offer to monetize traffic': 'Добавьте новый оффер для монетизации трафика',
  'Offer name': 'Название оффера',
  'Add offers to monetize traffic': 'Добавьте офферы для монетизации трафика',
  // A/B Testing
  'A/B Testing': 'A/B тестирование',
  'Create A/B test': 'Создать A/B тест',
  'Set up split testing to optimize conversions': 'Настройте сплит-тестирование для оптимизации конверсий',
  'Test name': 'Название теста',
  'Landing page test': 'Тест лендингов',
  'Test description': 'Описание теста',
  'Test type': 'Тип теста',
  'Traffic paths': 'Пути трафика',
  'Confidence level (%)': 'Уровень доверия (%)',
  'Minimum sample size': 'Минимальный размер выборки',
  'Test variants': 'Варианты теста',
  'Add variant': 'Добавить вариант',
  'Variant {n}': 'Вариант {n}',
  'Variant name': 'Название варианта',
  'URL (or pick below)': 'URL (или выберите ниже)',
  'Pick landing page': 'Выбрать лендинг',
  'Pick offer': 'Выбрать оффер',
  'Traffic weight (%)': 'Вес трафика (%)',
  'Total weight': 'Общий вес',
  'Create test': 'Создать тест',
  'No A/B tests': 'Нет A/B тестов',
  'Create split tests to optimize conversions': 'Создайте сплит-тесты для оптимизации конверсий',
  'Visitors': 'Посетители',
  'Significance': 'Значимость',
  'Variants': 'Вариантов',
  'Progress to minimum sample': 'Прогресс до минимальной выборки',
  'A/B test results': 'Результаты A/B теста',
  'Variant performance analysis': 'Анализ производительности вариантов',
  'Conversion': 'Конверсия',
  'Confidence interval': 'Доверительный интервал',
  'Not enough data for analysis': 'Недостаточно данных для анализа',
  'Close': 'Закрыть',
  'Running': 'Запущен',
  'Completed': 'Завершен',
  'Draft': 'Черновик',
  'Delete this A/B test?': 'Удалить этот A/B тест?',
  'A/B test deleted': 'A/B тест удален',
  'Failed to delete test': 'Ошибка удаления теста',
  'A/B test created': 'A/B тест создан',
  'Failed to create A/B test': 'Ошибка создания A/B теста',
  'A/B test started': 'A/B тест запущен',
  'Failed to start test': 'Ошибка запуска теста',
  'A/B test paused': 'A/B тест остановлен',
  'Failed to pause test': 'Ошибка остановки теста',
  'Failed to load results': 'Ошибка загрузки результатов',
  'Failed to load A/B tests': 'Ошибка загрузки A/B тестов',
  'At least 2 variants required': 'Нужно минимум 2 варианта',
  // Integrations
  'Webhooks': 'Вебхуки',
  'Import costs and conversions': 'Импорт затрат и конверсий',
  'Sync campaigns and conversions': 'Синхронизация кампаний и конверсий',
  'Import ad statistics': 'Импорт статистики рекламы',
  'VKontakte integration': 'Интеграция с ВКонтакте',
  'Automatic traffic import': 'Автоматический импорт трафика',
  'Server-to-server postbacks': 'Server-to-server постбеки',
  'Custom API integration': 'Пользовательская API интеграция',
  'Telegram notifications': 'Уведомления в Telegram',
  'Click': 'Клик',
  'Campaign paused': 'Кампания на паузе',
  'Campaign started': 'Кампания запущена',
  'Fraud detected': 'Фрод обнаружен',
  'Threshold reached': 'Порог достигнут',
  'Fill in type and name': 'Заполните тип и название',
  'Integration created': 'Интеграция создана',
  'Error creating': 'Ошибка создания',
  'Integration updated': 'Интеграция обновлена',
  'Error updating': 'Ошибка обновления',
  'Delete integration?': 'Удалить интеграцию?',
  'Integration deleted': 'Интеграция удалена',
  'Error deleting': 'Ошибка удаления',
  'Fill in name and URL': 'Заполните название и URL',
  'Webhook created': 'Вебхук создан',
  'Error creating webhook': 'Ошибка создания вебхука',
  'Webhook updated': 'Вебхук обновлен',
  'Delete webhook?': 'Удалить вебхук?',
  'Webhook deleted': 'Вебхук удален',
  'Test succeeded (HTTP {code})': 'Тест успешен (HTTP {code})',
  'Test error: {detail}': 'Ошибка теста: {detail}',
  'Error testing webhook': 'Ошибка тестирования вебхука',
  'Integration type': 'Тип интеграции',
  'Select type': 'Выберите тип',
  'Configuration (key-value)': 'Конфигурация (ключ-значение)',
  'Key (e.g. api_key)': 'Ключ (напр. api_key)',
  'Value': 'Значение',
  'My webhook': 'Мой вебхук',
  'Secret (optional)': 'Секрет (опционально)',
  'Events': 'События',
  'Retry attempts': 'Попытки повтора',
  'Timeout (sec)': 'Таймаут (сек)',
  'Add integration': 'Добавить интеграцию',
  'New integration': 'Новая интеграция',
  'Configure connection to an external service': 'Настройте подключение к внешнему сервису',
  'No integrations': 'Нет интеграций',
  'Connect external services to automate workflows': 'Подключите внешние сервисы для автоматизации',
  'Connected': 'Подключено',
  'Disconnected': 'Отключено',
  'Last sync': 'Последняя синхронизация',
  'Add webhook': 'Добавить вебхук',
  'New webhook': 'Новый вебхук',
  'Configure a webhook to receive notifications': 'Настройте вебхук для получения уведомлений',
  'No webhooks': 'Нет вебхуков',
  'Create webhooks to send events to external systems': 'Создайте вебхуки для отправки событий во внешние системы',
  'Success': 'Успешно',
  'Errors': 'Ошибки',
  'Test': 'Тест',
  'Edit integration': 'Редактировать интеграцию',
  'Edit webhook': 'Редактировать вебхук',

  // Anti-Fraud
  'Anti-fraud system': 'Анти-фрод система',
  'Filter created': 'Фильтр создан',
  'Failed to create filter': 'Ошибка создания фильтра',
  'Filter updated': 'Фильтр обновлен',
  'Failed to update filter': 'Ошибка обновления фильтра',
  'Filter deleted': 'Фильтр удален',
  'Failed to delete filter': 'Ошибка удаления фильтра',
  'IP added to blacklist': 'IP добавлен в черный список',
  'IP added to whitelist': 'IP добавлен в белый список',
  'Failed to add IP': 'Ошибка добавления IP',
  'IP removed from blacklist': 'IP удален из черного списка',
  'IP removed from whitelist': 'IP удален из белого списка',
  'Failed to remove IP': 'Ошибка удаления IP',
  'Activity marked as resolved': 'Активность отмечена как решенная',
  'Failed to update activity': 'Ошибка обновления активности',
  'Filters': 'Фильтры',
  'IP lists': 'IP списки',
  'Suspicious activity': 'Подозрительная активность',
  'Statistics': 'Статистика',
  'Fraud filters': 'Фильтры фрода',
  'Create filter': 'Создать фильтр',
  'Edit filter': 'Редактировать фильтр',
  'Create fraud filter': 'Создать фильтр фрода',
  'Configure automatic filters to block suspicious traffic': 'Настройте автоматические фильтры для блокировки подозрительного трафика',
  'Filter name': 'Название фильтра',
  'Filter type': 'Тип фильтра',
  'Bot detection': 'Детекция ботов',
  'Click frequency': 'Частота кликов',
  'Country block': 'Блокировка стран',
  'ASN block': 'Блокировка по ASN',
  'Datacenter / hosting block': 'Блокировка дата-центров и хостинга',
  'Proxy / VPN / Tor block': 'Блокировка прокси / VPN / Tor',
  'External risk score': 'Внешняя оценка риска',
  'Filter description': 'Описание фильтра',
  'Max clicks per minute': 'Максимум кликов в минуту',
  'Blocked countries (ISO codes)': 'Заблокированные страны (коды ISO)',
  'ASN numbers': 'Номера ASN',
  'ASN name substrings': 'Подстроки имени ASN',
  'Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).': 'AS-номера через запятую (например 16509 = AWS, 24940 = Hetzner).',
  'Case-insensitive substring match against the ASN label.': 'Поиск без учёта регистра по имени ASN.',
  'Allowed ASNs (whitelist)': 'Разрешённые ASN (белый список)',
  'Optional. Datacenter IPs that match these ASNs / labels are not blocked.': 'Опционально. IP дата-центров с этими ASN не будут заблокированы.',
  'Block Tor exit nodes': 'Блокировать выходные узлы Tor',
  'Block proxies (requires API key)': 'Блокировать прокси (требуется API-ключ)',
  'Block VPNs (requires API key)': 'Блокировать VPN (требуется API-ключ)',
  'External provider': 'Внешний провайдер',
  'Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.': 'Задайте IPQS_API_KEY или FRAUDSCORE_API_KEY в окружении бэкенда.',
  'Risk score threshold (0-100)': 'Порог оценки риска (0-100)',
  'Block when the provider returns a score >= this threshold (default 85).': 'Блокировать, когда провайдер возвращает оценку >= этого порога (по умолчанию 85).',
  'Block': 'Заблокировать',
  'Log only': 'Только логировать',
  'No active filters': 'Нет активных фильтров',
  'Create filters for automatic fraud protection': 'Создайте фильтры для автоматической защиты от фрода',
  'Blocked': 'Заблокировано',
  'False positives': 'Ложные срабатывания',
  'IP blacklist': 'Черный список IP',
  'IP whitelist': 'Белый список IP',
  'Blacklist is empty': 'Черный список пуст',
  'Whitelist is empty': 'Белый список пуст',
  'Blocked: {n} times': 'Заблокировано: {n} раз',
  // Wave 25d — bot-detection blocked-samples drill-down.
  'View blocked samples': 'Посмотреть заблокированные сэмплы',
  'Blocked samples': 'Заблокированные сэмплы',
  'Blocked samples: {name}': 'Заблокированные сэмплы: {name}',
  'Most recent traffic caught by this filter. Use it to spot false positives.':
    'Последний трафик, пойманный фильтром. Помогает заметить ложные срабатывания.',
  'No blocked samples yet': 'Пока нет заблокированных сэмплов',
  'Failed to load blocked samples': 'Не удалось загрузить заблокированные сэмплы',
  '(empty UA)': '(пустой UA)',
  'Add IP to blacklist': 'Добавить IP в черный список',
  'Add IP to whitelist': 'Добавить IP в белый список',
  'IP address': 'IP адрес',
  'Reason': 'Причина',
  'Reason for adding': 'Причина добавления',
  'Notes (optional)': 'Заметки (необязательно)',
  'Additional information': 'Дополнительная информация',
  'No suspicious activity detected': 'Подозрительной активности не обнаружено',
  'The system automatically tracks suspicious actions': 'Система автоматически отслеживает подозрительные действия',
  'Resolved': 'Решено',
  'Mark as resolved': 'Отметить как решенное',
  'User Agent': 'User Agent',
  'Time': 'Время',
  'Details': 'Детали',
  'Active filters': 'Активные фильтры',
  'Blocked IPs': 'Заблокированные IP',

  // Automation
  'Failed to load automation rules': 'Ошибка загрузки правил автоматизации',
  'Automation rule created': 'Правило автоматизации создано',
  'Failed to create automation rule': 'Ошибка создания правила автоматизации',
  'Automation rule updated': 'Правило автоматизации обновлено',
  'Failed to update automation rule': 'Ошибка обновления правила автоматизации',
  'Are you sure you want to delete this rule?': 'Вы действительно хотите удалить это правило?',
  'Automation rule deleted': 'Правило автоматизации удалено',
  'Failed to delete automation rule': 'Ошибка удаления правила автоматизации',
  'Rule activated': 'Правило активировано',
  'Rule deactivated': 'Правило деактивировано',
  'Failed to change rule status': 'Ошибка изменения статуса правила',
  'Notification settings saved': 'Настройки уведомлений сохранены',
  'Failed to save notification settings': 'Ошибка сохранения настроек уведомлений',
  'Pause campaign': 'Пауза кампании',
  'Budget alert': 'Оповещение о бюджете',
  'Performance alert': 'Оповещение о производительности',
  'Rules': 'Правила',
  'Automation rules': 'Правила автоматизации',
  'Create automation rule': 'Создать правило автоматизации',
  'Configure automatic actions based on conditions': 'Настройте автоматические действия на основе условий',
  'Rule type': 'Тип правила',
  'Trigger conditions': 'Условия срабатывания',
  'Maximum cost per click': 'Максимальная стоимость клика',
  'Minimum CR (%)': 'Минимальный CR (%)',
  'Budget percentage for alert': 'Процент от бюджета для оповещения',
  'Execution settings': 'Настройки выполнения',
  'Interval between executions (min)': 'Интервал между срабатываниями (мин)',
  'Maximum executions per day': 'Максимум выполнений в день',
  'No automation rules': 'Нет правил автоматизации',
  'Create rules to automatically manage campaigns': 'Создайте правила для автоматического управления кампаниями',
  'Executions': 'Выполнений',
  'Interval': 'Интервал',
  '{n} min': '{n} мин',
  'Daily limit': 'Лимит в день',
  'Last execution': 'Последнее выполнение',
  'Notification channels': 'Каналы уведомлений',
  'Receive notifications by email': 'Получать уведомления на email',
  'Receive SMS for critical events': 'Получать SMS о критических событиях',
  'Push notifications': 'Push уведомления',
  'Browser notifications': 'Уведомления в браузере',
  'Webhook URL': 'Webhook URL',
  'Manage how and when you receive alerts': 'Управляйте как и когда вы получаете оповещения',
  'Save preferences': 'Сохранить настройки',
  'Saving…': 'Сохранение…',
  'Delivery channels': 'Каналы доставки',
  'Choose how to receive notifications': 'Выберите как получать уведомления',
  'Receive alerts via email': 'Получать оповещения по email',
  'Critical alerts via SMS': 'Критические оповещения по SMS',
  'In-app and browser push': 'В приложении и в браузере',
  'POST JSON payloads to your endpoint': 'POST JSON на ваш эндпоинт',
  'Alert categories': 'Категории оповещений',
  'Choose which types of events trigger notifications': 'Выберите какие события вызывают уведомления',
  'Campaign alerts': 'Оповещения о кампаниях',
  'Paused, resumed, daily cap reached': 'Пауза, возобновление, достижение лимита',
  'Performance alerts': 'Оповещения о производительности',
  'ROI drop, conversion rate change, EPC decline': 'Падение ROI, изменение CR, снижение EPC',
  'Fraud alerts': 'Оповещения о фроде',
  'Suspicious clicks, bot traffic, IP blacklist hits': 'Подозрительные клики, бот-трафик, IP в блэклисте',
  'System alerts': 'Системные оповещения',
  'Domain verification, TLS expiry, billing': 'Верификация домена, TLS, биллинг',
  'Notification preferences saved': 'Настройки уведомлений сохранены',
  'Failed to load notification settings': 'Ошибка загрузки настроек уведомлений',
  'CSV exported': 'CSV экспортирован',
  'Export campaigns to CSV': 'Экспорт кампаний в CSV',
  'Export offers to CSV': 'Экспорт офферов в CSV',
  'No domains yet': 'Пока нет доменов',
  'Add a custom domain to serve tracking links from your own branded URL.': 'Добавьте кастомный домен для трекинг-ссылок с вашего брендового URL.',
  'Create streams to split traffic by geo, device, OS, or custom conditions.': 'Создайте стримы для распределения трафика по гео, устройствам, ОС или условиям.',
  'Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.': 'Создайте правила для автоматической паузы, возобновления или настройки кампаний.',
  'No members yet': 'Пока нет участников',
  'Invite teammates above to collaborate.': 'Пригласите коллег для совместной работы.',
  'URL for receiving notifications in JSON format': 'URL для получения уведомлений в формате JSON',
  'Alert types': 'Типы оповещений',
  'Campaign start, pause, completion': 'Старт, пауза, завершение кампаний',
  'Changes in CR, ROI, cost': 'Изменения CR, ROI, стоимости',
  'Suspicious traffic detection': 'Обнаружение подозрительного трафика',
  'Updates and technical information': 'Обновления, техническая информация',
  'Execution history': 'История выполнений',
  'Execution history is empty': 'История выполнений пуста',
  'Records of automatic rule executions will appear here': 'Здесь будут отображаться записи о выполнении автоматических правил',
  'Edit automation rule': 'Редактировать правило автоматизации',
  'Change automation rule settings': 'Измените настройки правила автоматизации',

  // GeoMap
  'Geographic statistics': 'Географическая статистика',
  'Loading geographic data...': 'Загрузка географических данных...',
  'By country': 'По странам',
  'By city': 'По городам',
  'No country data': 'Нет данных о странах',
  'No city data': 'Нет данных о городах',
  'Click map': 'Карта кликов',
  'No data to display on map': 'Нет данных для отображения на карте',
  'Geographic data will appear after the first clicks with resolvable coordinates':
    'Географические данные появятся после первых кликов с определяемыми координатами',

  // Auth (App.js)
  'Signed in successfully!': 'Вход выполнен успешно!',
  'Sign in failed': 'Ошибка входа',
  'Registration successful!': 'Регистрация прошла успешно!',
  'Registration failed': 'Ошибка регистрации',
  'Signed out': 'Выход выполнен',
  'One moment…': 'Минутку…',

  // Documentation
  'Documentation': 'Документация',
  'Help': 'Помощь',
  'Step-by-step guide for every feature': 'Пошаговая инструкция для каждой функции',
  'Search sections...': 'Поиск разделов...',
  'Loading documentation...': 'Загрузка документации...',
  'Back to top': 'Наверх',

  // Domains
  'Domains': 'Домены',
  'Tracker domains': 'Домены трекера',
  'Custom domains': 'Свои домены',
  'Bind your own domain to mask tracking links. Point a CNAME to our edge and verify ownership via TXT record.':
    'Привяжите свой домен, чтобы маскировать трекинговые ссылки. Создайте CNAME на наш edge и подтвердите владение через TXT-запись.',
  'After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.':
    'После добавления настройте DNS для домена (TXT-запись для проверки и CNAME/A-запись для маршрутизации), затем нажмите «Проверить».',
  'Verified': 'Подтверждён',
  'Failed': 'Ошибка',
  'Pending': 'Ожидание',
  'Default': 'По умолчанию',
  'Set default': 'Сделать основным',
  'Verify': 'Проверить',
  'TXT verification record': 'TXT-запись для проверки',
  'Routing record (CNAME)': 'Запись маршрутизации (CNAME)',
  'Copy value': 'Скопировать значение',
  'Copied': 'Скопировано',
  'Tracking links will use': 'Трекинговые ссылки будут использовать',
  'Domain added': 'Домен добавлен',
  'Failed to add domain': 'Не удалось добавить домен',
  'Domain verified': 'Домен подтверждён',
  'Verification failed': 'Подтверждение не удалось',
  'Default domain updated': 'Домен по умолчанию обновлён',
  'Domain deleted': 'Домен удалён',
  'Delete this domain?': 'Удалить этот домен?',
  'Enable HTTPS': 'Включить HTTPS',
  'HTTPS active': 'HTTPS активен',
  'Check TLS': 'Проверить TLS',
  'TLS validation records': 'Записи валидации TLS',
  'TLS provisioning started': 'Выпуск TLS сертификата запущен',
  'TLS provisioning failed': 'Не удалось запустить выпуск TLS',
  'Action failed': 'Действие не удалось',
  'Loading…': 'Загрузка…',

  // Conversion API / CAPI forwarders
  'Conversion API': 'API Конверсий',
  'Conversion forwarders': 'Конверсии → рекл. сети',
  'Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.':
    'Отправка конверсий S2S в рекламные сети (FB CAPI, Google Ads, TikTok). Срабатывает автоматически на каждый постбэк.',
  'New forwarder': 'Новый форвардер',
  'Edit forwarder': 'Редактировать форвардер',
  'No forwarders yet': 'Пока нет форвардеров',
  'Forwarder created': 'Форвардер создан',
  'Forwarder updated': 'Форвардер обновлён',
  'Forwarder deleted': 'Форвардер удалён',
  'Delete forwarder?': 'Удалить форвардер?',
  'Send test': 'Тестовая отправка',
  'Test event sent': 'Тестовое событие отправлено',
  'Test failed': 'Тест не прошёл',
  'No events yet': 'Событий пока нет',
  'Provider': 'Провайдер',
  'Event name': 'Название события',
  'Name is required': 'Нужно указать имя',
  'Missing fields': 'Не заполнены поля',
  'Sent': 'Отправлено',
  'Event': 'Событие',
  'Last sent': 'Последняя отправка',

  // Public API / keys
  'Public API': 'Публичное API',
  'API keys': 'API-ключи',
  'New key': 'Новый ключ',
  'New API key': 'Новый API-ключ',
  'Use API keys to call the public /v1 REST API. Pass the key as':
    'API-ключи для вызова публичного /v1 REST API. Передавайте ключ как',
  'or': 'или',
  'Copy your key now — it will not be shown again': 'Скопируйте ключ сейчас — он больше не будет показан',
  'Copy': 'Копировать',
  'Dismiss': 'Скрыть',
  'Quick start': 'Быстрый старт',
  'Docs': 'Документация',
  'No API keys yet': 'Пока нет ключей',
  'Scopes': 'Права',
  'Delete this key?': 'Удалить этот ключ?',
  'Key deleted': 'Ключ удалён',
  'last used': 'последнее использование',
  'never used': 'не использовался',

  // Workspace / team
  'Team': 'Команда',
  'Workspace': 'Воркспейс',
  'Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.':
    'Приглашайте участников с ролями. Владелец видит всё; менеджер/админ могут редактировать; viewer — только чтение.',
  'Invite member': 'Пригласить участника',
  'Invite': 'Пригласить',
  'Invite sent': 'Приглашение создано',
  'Share this link with the invitee:': 'Отправьте эту ссылку приглашённому:',
  'Role': 'Роль',
  'Members': 'Участники',
  'Revoke access?': 'Отозвать доступ?',
  'Revoke access': 'Отозвать доступ',
  'Access revoked': 'Доступ отозван',
  'Reset 2FA': 'Сбросить 2FA',
  "Reset this member's 2FA?": 'Сбросить 2FA этого участника?',
  '2FA reset — member can re-enrol': '2FA сброшено — участник может настроить заново',
  'Member had no 2FA configured': 'У участника не было настроенного 2FA',
  '2FA reset failed': 'Не удалось сбросить 2FA',
  'Workspace currency': 'Валюта рабочего пространства',
  'Display currency': 'Валюта отображения',
  'Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.':
    'Отчёты и дашборды будут приведены к этой валюте. Курсы обновляются раз в час.',
  'Workspace currency saved': 'Валюта рабочего пространства сохранена',
  'Could not save currency': 'Не удалось сохранить валюту',
  'Invited': 'Приглашён',
  'Shared with me': 'Поделились со мной',
  'No shared workspaces': 'Нет общих воркспейсов',

  // Audit log (Wave 17)
  'Audit log': 'Журнал аудита',
  'Workspace-scoped trail of privileged actions. Retained for 90 days.':
    'Журнал привилегированных действий по воркспейсу. Хранится 90 дней.',
  'Target type': 'Тип объекта',
  'Actor ID': 'ID актора',
  'Since': 'С',
  'Until': 'По',
  'Apply': 'Применить',
  'Actor': 'Актор',
  'Target': 'Объект',
  'Payload': 'Данные',
  'IP': 'IP',
  'Load more': 'Загрузить ещё',
  'No audit entries match the current filters.':
    'Нет записей аудита под текущие фильтры.',
  'Failed to load audit log': 'Не удалось загрузить журнал аудита',

  // CAPI DLQ (Wave 19)
  'CAPI DLQ': 'CAPI DLQ',
  'CAPI dead-letter queue': 'Очередь недоставленных CAPI',
  'Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.':
    'Конверсии, которые исчерпали лимит повторов. Replay — повторная попытка отправки; Discard — удалить навсегда.',
  'Forwarder ID': 'ID форвардера',
  'Conversion ID': 'ID конверсии',
  'Since (ISO)': 'С (ISO)',
  'Until (ISO)': 'По (ISO)',
  'Apply filters': 'Применить фильтры',
  'No DLQ entries match these filters.':
    'Записи DLQ под текущие фильтры не найдены.',
  'Forwarder': 'Форвардер',
  'Attempts': 'Попыток',
  'Last error': 'Последняя ошибка',
  'Replay': 'Повторить',
  'Discard': 'Удалить',
  'CAPI replay succeeded': 'CAPI replay успешен',
  'Replay failed:': 'Ошибка replay:',
  'Replay failed': 'Ошибка replay',
  'DLQ entry discarded': 'Запись DLQ удалена',
  'Discard failed': 'Ошибка удаления',
  'Permanently discard this DLQ entry?':
    'Удалить эту запись DLQ навсегда?',
  'Failed to load CAPI DLQ': 'Не удалось загрузить CAPI DLQ',

  // Bulk campaign operations (Wave 20)
  'Activated {n}': 'Активировано: {n}',
  'Paused {n}': 'Остановлено: {n}',
  'Deleted {n}': 'Удалено: {n}',
  'Skipped {n} (no access or not found)':
    'Пропущено: {n} (нет доступа или не найдено)',
  'Bulk update failed': 'Ошибка массового обновления',
  'Bulk delete failed': 'Ошибка массового удаления',

  // Admin health (Wave 21)
  'System health': 'Состояние системы',
  // Nav labels added after the !99 coverage fill (parity !105/!108 wired
  // these screens without translation keys, so they leaked raw English).
  'System status': 'Статус системы',
  'S2S log': 'Лог S2S',
  'TLS fingerprints': 'Отпечатки TLS',
  'Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.':
    'Сводка по CAPI / postback / FX / синхронизации затрат по доступным воркспейсам.',
  'CAPI delivery': 'Доставка CAPI',
  'Conversion API dispatches in the last window.':
    'Отправки Conversion API за выбранный период.',
  'Total': 'Всего',
  'Success rate': 'Доля успехов',
  'No CAPI events in window.': 'CAPI-событий за период нет.',
  'Retry queue': 'Очередь повторов',
  'Pending CAPI re-attempts.': 'Ожидающие повторы CAPI.',
  'Due now': 'К отправке сейчас',
  'Oldest': 'Самое старое',
  'Dead-letter queue': 'Очередь недоставленных',
  'Conversions that exhausted the retry budget.':
    'Конверсии, исчерпавшие бюджет повторов.',
  'Postback delivery': 'Доставка постбэков',
  'S2S postback callouts in the last window.':
    'S2S-постбэки за выбранный период.',
  'FX cache': 'FX-кэш',
  'Per-base exchange-rate snapshot freshness.':
    'Свежесть курсов по валютам базиса.',
  'Base': 'Базис',
  'Refreshed': 'Обновлено',
  'FX cache is empty.': 'FX-кэш пуст.',
  'stale': 'устарел',
  'fresh': 'актуален',
  'Ad cost sync': 'Синхронизация затрат',
  'Active connections, last sync time, and recent errors.':
    'Активные подключения, время последней синхронизации, ошибки.',
  'No active ad-cost connections.': 'Нет активных подключений к рекламным расходам.',
  'error': 'ошибка',
  'ok': 'ok',
  'Generated at': 'Сгенерировано',
  'Window': 'Период',
  'Failed to load admin health':
    'Не удалось загрузить дашборд состояния',

  // Audit log CSV export (Wave 22)
  'Export CSV': 'Экспорт CSV',
  'Audit log exported': 'Audit log выгружен',
  'Audit export failed': 'Ошибка экспорта audit log',

  // Billing
  'Billing': 'Биллинг',
  'Plans & usage': 'Тарифы и использование',
  'Current plan': 'Текущий тариф',
  'Current': 'Текущий',
  'Clicks this month': 'Клики в этом месяце',
  // Billing — tiered editions (launch)
  'Plans & billing': 'Тарифы и оплата',
  'Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.': 'Пять редакций: каждый тариф включает весь трекер — выбирайте размер команды, масштаб доменов и набор автоматизации. Клики никогда не ограничиваются.',
  'Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.': 'Биллинг на этом сервере ещё не активирован — все функции открыты. Тарифы ниже показывают, что вступит в силу после запуска оплаты.',
  'Trial': 'Пробный период',
  'day(s) left': 'дн. осталось',
  'choose a plan to keep your traffic flowing without interruption.': 'выберите тариф, чтобы трафик шёл без перерыва.',
  'Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.': 'Подписка неактивна: обработка кликов и создание сущностей приостановлены. Выберите тариф, чтобы мгновенно возобновить.',
  'Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.': 'Последний платёж не прошёл — трекер продолжает работать, пока Stripe повторяет попытку. Обновите карту в разделе «Управление оплатой».',
  'cancels at period end': 'отменится в конце периода',
  'unlimited': 'безлимит',
  'months': 'мес.',
  'month': 'мес.',
  'billed every': 'списание каждые',
  'user(s)': 'польз.',
  'domain(s)': 'домен(ов)',
  'Choose plan': 'Выбрать тариф',
  'Full tracker core': 'Весь функционал трекера',
  'Unlimited clicks': 'Безлимитные клики',
  'Landing page editor': 'Редактор лендингов',
  'Online support': 'Онлайн-поддержка',
  'Click API + API keys': 'Click API + API-ключи',
  'Facebook CAPI': 'Facebook CAPI',
  'All 8 CAPI providers': 'Все 8 провайдеров CAPI',
  'Report by conversion date': 'Отчёт по дате конверсии',
  'White label branding': 'White label брендинг',
  'Personal manager': 'Персональный менеджер',
  'Priority support': 'Приоритетная поддержка',
  'Onboarding call': 'Онбординг-звонок',
  'trialing': 'пробный период',
  'active': 'активна',
  'past_due': 'просрочен платёж',
  'expired': 'истёк',
  'canceled': 'отменена',
  'exempt': 'без оплаты',
  'Manage billing': 'Управление подпиской',
  'Manage': 'Управлять',
  'Upgrade': 'Перейти',
  'Free forever': 'Бесплатно навсегда',
  'clicks/mo': 'кликов/мес',
  'campaigns': 'кампаний',
  'team members': 'участников команды',

  // Campaign params / postbacks / simplified Google Ads forwarder
  'Campaign parameters': 'Параметры кампании',
  'Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.':
    'Опишите параметры, которые вы передаёте в URL из рекламных сетей. Каждая строка становится макросом вида {key}, доступным в постбэках и CAPI.',
  'URL key': 'Ключ URL',
  'Placeholder / default': 'Значение по умолчанию',
  'Google Ads tag': 'Google Ads tag',
  'No parameters yet': 'Пока нет параметров',
  'Parameters have unsaved changes — clicks keep using the saved set until you save.':
    'Есть несохранённые изменения параметров — пока вы не сохраните, клики пишутся по сохранённому набору.',
  'Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.':
    'Значение, которое подставляется в tracking-ссылку для этого ключа: макрос рекламной сети, например {campaignid}, или фиксированное значение, например MCLV. Фиксированное значение также записывается в клики, пришедшие без этого ключа; макрос в фигурных скобках — нет. Для ключей, которые задаёт сам рекламный аккаунт (tm и tml), оставьте поле пустым.',
  'Macro: filled by the ad network, not stored on clicks without this key':
    'Макрос: подставляет рекламная сеть; в клики без этого ключа не записывается',
  'Google Ads conversion keys': 'Ключи конверсий Google Ads',
  'Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign':
    'Разбивка кликов и конверсий по sub1–sub30 или по любому параметру, объявленному в кампании',
  'Sub slot': 'Слот sub',
  'Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.':
    'Необязательно: значение дополнительно записывается в sub1…sub30 или в именованное поле (external_id, creative_id…). Привяжите одно и то же к одному слоту во всех кампаниях (например, team → sub8) — тогда одна колонка отчёта и макрос {sub_id_8} покроют всех баеров; external_id подставляется в {external_id} постбэка источника.',
  'Source postback': 'Постбэк источника',
  'This source postback is already added': 'Постбэк источника уже добавлен',
  'Source postback added — check its placeholders (REPLACE, XXXX…) and press Save':
    'Постбэк источника добавлен — замените заглушки (REPLACE, XXXX…) и нажмите «Сохранить»',
  'Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.':
    '«Продажа» срабатывает и на депозиты (ftd, dep, deposit), а «Лид» — и на регистрации (reg, signup), как бы их ни называл брокер.',
  'Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.':
    'Ключи без значения по умолчанию (tm, tml, a…) в ссылку не попадают: передавайте их в объявлении, например в Final URL suffix Google Ads.',
  '= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.':
    '= метка Submit Lead Form — эту конверсию сделайте основной (Primary). Отправляется из браузера посетителя после успешного лида.',
  '= Purchase / deposit label — set this conversion as Secondary. Sent by the "Deposit → Purchase" S2S rule; do not add an S2S rule for lead.':
    '= метка Purchase / депозит — эту конверсию сделайте дополнительной (Secondary). Отправляется S2S-правилом «Депозит → Purchase»; S2S-правило для лида не добавляйте.',
  'Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.':
    'Передавайте оба ключа в Final URL suffix каждого аккаунта Google Ads (tml=AW-…/метка-лида&tm=AW-…/метка-purchase), а значение по умолчанию для них здесь оставьте пустым.',
  'Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.':
    'Ключи чувствительны к регистру. Любой ключ (a, b, s, c…) сохраняется в клике, работает как макрос {key} и выбирается для группировки в «Отчётах» и отчёте Sub-ID — наравне с sub1…sub30. Привяжите его к слоту sub, чтобы он совпадал во всех кампаниях.',
  'Use lowercase keys — the tracker does not read:': 'Пишите ключи строчными — трекер не читает:',
  'Tracking URL preview': 'Предпросмотр tracking-ссылки',
  'Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.':
    'Вставьте как Final URL (Google Ads) или tracking-ссылку (Facebook). При необходимости замените плейсхолдеры {key} на макросы рекламной сети.',
  'Fire Google Ads gtag on redirect': 'Fire Google Ads gtag при редиректе',
  'When on, /r/ returns a tiny HTML page that calls gtag("event","conversion", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.':
    'Когда включено, /r/ отдаёт HTML-страничку, которая вызывает gtag("event","conversion", …) с вашим тегом и потом редиректит. Нужно, если вы не настраиваете Final URL suffix в Google Ads.',
  'S2S postbacks': 'S2S постбэки',
  'Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.':
    'Исходящие HTTP-запросы, которые отправляются при получении постбэка. Поддерживают макросы {click_id}, {payout} и все параметры кампании выше.',
  'No postbacks yet': 'Пока нет постбэков',
  'Method': 'Метод',
  'Statuses': 'Статусы',
  'Add postback': 'Добавить постбэк',
  'Show recent log': 'Показать лог',
  'Available macros': 'Доступные макросы',
  'Campaign saved': 'Кампания сохранена',
  'Postback fired': 'Постбэк отправлен',

  // Conversion Forwarder simple/advanced
  'Mode': 'Режим',
  'Simple': 'Простой',
  'Advanced': 'Продвинутый',
  'Conversion tag': 'Conversion tag',
  'Conversion tag is required': 'Укажите conversion tag',
  'Paste the "send_to" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.':
    'Вставьте значение send_to из сниппета конверсии Google Ads (например AW-123456789/AbCdEf). OAuth не нужен — трекер отстрелит событие через Final URL suffix или gtag на редиректе.',
  'OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.':
    'Click Conversions Upload через OAuth — нужны developer token, customer ID и refresh token. Использовать только если нужна серверная отправка по gclid.',

  // Auto-added missing keys
  'Campaign': 'Кампания',
  'Create a new xpnsr.tech account': 'Создать аккаунт xpnsr.tech',
  'Already have an account? Sign in': 'Уже есть аккаунт? Войти',
  'Only ZIP files are supported': 'Поддерживаются только ZIP файлы',
  'Please enter a name for the landing page': 'Введите название лендинга',
  'Please select a ZIP file': 'Выберите ZIP файл',
  'Landing page uploaded successfully': 'Лендинг успешно загружен',
  'Error uploading landing page': 'Ошибка загрузки лендинга',
  'Upload ZIP': 'Загрузить ZIP',
  'Upload Landing Page': 'Загрузить лендинг',
  'Upload a ZIP file containing your landing page files (max 50MB)': 'Загрузите ZIP архив с файлами лендинга (макс. 50MB)',
  'My landing page': 'Мой лендинг',
  'tag1, tag2, tag3': 'тег1, тег2, тег3',
  'Separate tags with commas': 'Разделяйте теги запятыми',
  'ZIP File': 'ZIP файл',
  'Drag & drop or click to select': 'Перетащите или нажмите для выбора',
  'Select ZIP File': 'Выбрать ZIP файл',
  'Uploading...': 'Загрузка...',
  'Upload': 'Загрузить',
  'History': 'История',
  'Notification settings': 'Настройки уведомлений',
  'Please fill in name and select ZIP file': 'Заполните название и выберите ZIP файл',
  'Offer uploaded successfully': 'Оффер успешно загружен',
  'Error uploading offer': 'Ошибка загрузки оффера',
  'Upload Offer ZIP': 'Загрузить ZIP оффера',
  'Upload a ZIP file containing offer files': 'Загрузите ZIP с файлами оффера',
  'Countries (comma-separated ISO codes, e.g. US,RU,DE)': 'Страны (ISO коды через запятую, напр. US,RU,DE)',
  'ZIP File (max 100MB)': 'ZIP файл (макс. 100MB)',
  'Change': 'Изменить',
  'Select ZIP file': 'Выбрать ZIP файл',
  'Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.': 'Загрузите ZIP с HTML страницами и ресурсами. Поддерживаются _preview.png для превью и PHP-скрипты для обработки.',
  'Upload Offer': 'Загрузить оффер',

  // Multi-page upload & file editor
  'pages': 'стр.',
  'Choose entry point': 'Выбрать точку входа',
  'Multiple HTML pages detected. Select the main page visitors will land on.': 'Обнаружено несколько HTML-страниц. Выберите главную, на которую попадёт посетитель.',
  'Skip (use auto-detected)': 'Пропустить (авто)',
  'Confirm': 'Подтвердить',
  'Edit files': 'Редактировать файлы',
  'File editor': 'Редактор файлов',
  'Edit HTML, CSS, JS and other text files inside the uploaded archive': 'Редактируйте HTML, CSS, JS и другие текстовые файлы внутри загруженного архива',
  'Files': 'Файлы',
  'Select a file from the sidebar to edit': 'Выберите файл из списка слева для редактирования',
  'Binary file — not editable': 'Бинарный файл — не редактируется',
  'File saved': 'Файл сохранён',
  'Error loading files': 'Ошибка загрузки файлов',
  'Error loading file': 'Ошибка загрузки файла',
  'Error saving file': 'Ошибка сохранения файла',
  'Discard unsaved changes?': 'Отменить несохранённые изменения?',
  'Saving...': 'Сохранение...',

  // Forwarder ↔ campaign binding & bulk create
  'Bulk create': 'Массовое создание',
  'Bulk create Google Ads forwarders': 'Массовое создание форвардеров Google Ads',
  'Conversion tags (one per line)': 'Конверсионные теги (по одному на строку)',
  'Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.': 'Вставьте теги AW-XXX/YYY, по одному на строку. Каждый создаст отдельный форвардер.',
  'Bind to campaigns': 'Привязать к кампаниям',
  'Leave empty to fire on all campaigns': 'Оставьте пустым для срабатывания на все кампании',
  'Add campaign…': 'Добавить кампанию…',
  'Create all': 'Создать все',
  'Creating…': 'Создание…',
  '{count} forwarders created': '{count} форвардеров создано',
  'campaign': 'кампания',
  'Linked forwarders': 'Привязанные форвардеры',
  'Conversion forwarders that fire for this campaign': 'Форвардеры конверсий, которые срабатывают для этой кампании',

  // Analytics — Heatmap & Funnel (Phase 2 #9/#10)
  'Heatmap': 'Тепловая карта',
  'Funnel': 'Воронка',
  'Activity heatmap': 'Тепловая карта активности',
  'Day-of-week x hour-of-day breakdown': 'Разбивка по дням недели и часам',
  'Less': 'Меньше',
  'More': 'Больше',
  'Peak': 'Пик',
  'No heatmap data': 'Нет данных для тепловой карты',
  'Conversion funnel': 'Воронка конверсий',
  'Click-to-conversion pipeline with status breakdown': 'Пайплайн клик → конверсия с разбивкой по статусам',
  'Status breakdown': 'Разбивка по статусам',
  'No funnel data': 'Нет данных воронки',
  'Mon': 'Пн',
  'Tue': 'Вт',
  'Wed': 'Ср',
  'Thu': 'Чт',
  'Fri': 'Пт',
  'Sat': 'Сб',
  'Sun': 'Вс',

  // Ad-Account OAuth
  'Ad-Account Connections': 'Подключения рекламных кабинетов',
  'Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.': 'Подключите аккаунты FB / Google Ads для автоматического импорта расходов в кампании.',
  'Connect with Facebook': 'Подключить через Facebook',
  'Connect with Google Ads': 'Подключить через Google Ads',
  'Ad account connected via OAuth': 'Рекламный аккаунт подключён через OAuth',
  'OAuth error: ': 'Ошибка OAuth: ',
  'Failed to start OAuth': 'Не удалось начать OAuth',
  'Token refreshed': 'Токен обновлён',
  'Refresh failed': 'Ошибка обновления токена',
  'Refresh token': 'Обновить токен',
  'Connect ad account': 'Подключить рекламный аккаунт',
  'Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.': 'Токены шифруются при хранении. Используйте кнопки OAuth выше для FB / Google или введите токены вручную ниже.',
  'Sync now': 'Синхронизировать',
  'Connect': 'Подключить',
  'Failed to load connections': 'Не удалось загрузить подключения',
  'Connection created': 'Подключение создано',
  'Connection deleted': 'Подключение удалено',
  'Delete this connection?': 'Удалить это подключение?',
  'Delete failed': 'Ошибка удаления',
  'Sync complete': 'Синхронизация завершена',
  'Sync failed': 'Ошибка синхронизации',
  'No connections yet. Connect FB or Google Ads to start importing cost.': 'Нет подключений. Подключите FB или Google Ads для импорта расходов.',
  'Refresh token (optional)': 'Refresh-токен (опционально)',
  'Display name': 'Отображаемое имя',
  'Account ID': 'ID аккаунта',
  'Access token': 'Access-токен',
  'Save failed': 'Ошибка сохранения',
  // Wave 33 — granular RBAC matrix
  'Permissions': 'Права доступа',
  'Permission matrix': 'Матрица прав доступа',
  'Permission matrix saved': 'Матрица прав сохранена',
  'Failed to load permission matrix': 'Не удалось загрузить матрицу прав',
  'Failed to save permission matrix': 'Не удалось сохранить матрицу прав',
  'Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.': 'Переопределите минимальную роль для каждого действия в этом воркспейсе. Сохраняются только ячейки, отличающиеся от значения по умолчанию.',
  'overrides': 'переопределений',
  'Read-only — only the workspace owner can edit the matrix.': 'Только для чтения — изменять матрицу может только владелец воркспейса.',
  'Reset all to defaults': 'Сбросить всё к значениям по умолчанию',
  'Custom': 'Изменено',
  'Reset to default': 'Сбросить к значению по умолчанию',
  'owner': 'владелец',
  'admin': 'админ',
  'manager': 'менеджер',
  'viewer': 'наблюдатель',
  'Landings & offers': 'Лендинги и офферы',
  'Reports': 'Отчёты',
  'Audit': 'Аудит',

  // Navigation hints (sidebar tooltips)
  'Toggle navigation hints': 'Вкл/выкл подсказки навигации',
  'Show hints': 'Показать подсказки',
  'Hide hints': 'Скрыть подсказки',

  // Sidebar nav group labels
  'Tools': 'Инструменты',
  'Admin': 'Админ',
  'Resources': 'Документация',
  'Pre-landings': 'Пре-лендинги',
  'Book demo': 'Забронировать демо',
  'Overview of clicks, conversions and active campaigns': 'Главный экран: сводка кликов, конверсий и активных кампаний',
  'Create ad campaigns and get tracking links': 'Создайте рекламные кампании и получите трекинговые ссылки',
  'Upload landing pages (ZIP) or set a URL for split-tests': 'Загрузите лендинги (ZIP) или укажите URL для сплит-тестов',
  'Warm-up pages shown before the offer': 'Промежуточные страницы перед оффером для прогрева трафика',
  'Connect Facebook, Google, TikTok ad accounts': 'Подключите рекламные кабинеты Facebook, Google, TikTok',
  'Two-factor auth, sessions and password': 'Двухфакторная аутентификация, сессии и пароль',
  'Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms': 'Офферы/воронки: загрузка, роутинг на партнёрки по API (веса, фолбэк), лид-формы',
  'Traffic sources with presets (Google Ads with tm & macros, etc.)': 'Источники трафика с пресетами (Google Ads с макросами и tm и др.)',
  'Manage flows and traffic distribution rules': 'Управление потоками и правилами распределения трафика',
  'Split-test landings and offers with auto-distribution': 'Сплит-тесты лендингов и офферов с автоматическим распределением',
  'Block bots, fraud and suspicious clicks': 'Защита от ботов, фрода и подозрительных кликов',
  'Detailed reports: charts, geo, devices, ROI': 'Подробные отчёты: графики, гео, устройства, ROI',
  'Full click log with IP, UserAgent, GEO and time': 'Полный лог кликов с IP, UserAgent, GEO и временем',
  'Auto-rules: pause campaigns on low ROI, etc.': 'Автоправила: пауза кампаний при низком ROI и др.',
  'Partner CRMs (TrackBox, Custom API) for API lead injection + notifications': 'CRM партнёрок (TrackBox, Custom API) для приёма лидов по API + уведомления',
  'Add your own domains for tracking links': 'Добавьте свои домены для трекинговых ссылок',
  'Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth': 'Онлайн-конверсии в Google/FB/TikTok (S2S). Google — режим simple, без OAuth',
  'Keys to access the tracker REST API': 'Ключи для доступа к REST API трекера',
  'Invite your team, assign roles and permissions': 'Пригласите команду, назначьте роли и права доступа',
  'Action log of all users for 90 days': 'Журнал действий всех пользователей за 90 дней',
  'Cookie consent banner for GDPR compliance': 'Баннер согласия на cookies для GDPR',
  'Ready-made templates and integrations': 'Готовые шаблоны и интеграции от сообщества',
  'Swagger REST API docs (opens in new tab)': 'Swagger-документация REST API (откроется в новой вкладке)',
  'Failed conversion dispatches — can be retried': 'Ошибки отправки конверсий — можно повторить',
  'Server, queue and database status': 'Состояние серверов, очередей и баз данных',
  'Plan, payment and usage limits': 'Тарифный план, оплата и лимиты',
  'Profile, language, timezone and notifications': 'Профиль, язык, часовой пояс и уведомления',


  // Wave 24: full Russian coverage across the dashboard, A/B testing,
  // Anti-fraud, Auth, Branding, Campaigns, Marketplace, Onboarding,
  // Public dashboards, Security, Settings and other long-tail strings
  // that were previously falling back to English.
  '(no label)': '(без названия)',
  '180 days': '180 дней',
  '2FA disabled': '2FA отключено',
  '2FA enabled': '2FA включено',
  '2FA is currently enabled': '2FA сейчас включено',
  '302 redirect (default)': '302 редирект (по умолчанию)',
  '365 days': '365 дней',
  'A campaign groups your traffic sources and tracking links under one name.':
    'Кампания объединяет ваши источники трафика и трекинговые ссылки под одним названием.',
  'AI Optimizer': 'AI Оптимизатор',
  'Accept button label': 'Текст кнопки «Принять»',
  'Accepted': 'Принято',
  'Accepting invitation…': 'Принимаем приглашение…',
  'Action on trigger': 'Действие при срабатывании',
  'Activate': 'Активировать',
  'Activate 2FA': 'Активировать 2FA',
  'Add a forwarder to push conversions to ad networks automatically.':
    'Добавьте форвардер, чтобы автоматически отправлять конверсии в рекламные сети.',
  'Add forwarder': 'Добавить форвардер',
  'Add the CNAME record shown on the Domains page, then click verify.':
    'Добавьте CNAME-запись, показанную на странице «Домены», затем нажмите «Проверить».',
  'Add vendor': 'Добавить вендора',
  'Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.':
    'Агрессивный режим: блокирует любые клики без JA3/JA4 или ещё не классифицированные. Сначала пометьте хеши корпоративных прокси в «Переопределения воркспейса».',
  'Alert if ROI drops below this %': 'Оповещать, если ROI опустится ниже этого %',
  'Algorithm': 'Алгоритм',
  'All groups': 'Все группы',
  'All statuses': 'Все статусы',
  'Allowed metrics': 'Доступные метрики',
  'Always block these JA3 / JA4 hashes regardless of classification.':
    'Всегда блокировать эти хеши JA3 / JA4 независимо от классификации.',
  'Anonymous': 'Аноним',
  'Any type': 'Любой тип',
  'Anyone with this link will lose access to the shared dashboard immediately.':
    'Все, у кого есть эта ссылка, мгновенно потеряют доступ к публичной панели.',
  'Applied {n} weight changes': 'Применено изменений весов: {n}',
  'Archive': 'Архивировать',
  'Archived': 'В архиве',
  'Auto': 'Авто',
  'Auto-refresh every 30s': 'Автообновление каждые 30 сек',
  'Available on enterprise plans. Hides the "Powered by xpnsr" footer.':
    'Доступно на корпоративных тарифах. Скрывает футер «Powered by xpnsr».',
  'Back to sign-in': 'Назад ко входу',
  'Backup codes (save now)': 'Резервные коды (сохраните сейчас)',
  'Bangkok (UTC+7)': 'Бангкок (UTC+7)',
  'Banned': 'Забанен',
  'Banner copy': 'Текст баннера',
  'Banner status': 'Статус баннера',
  'Berlin (UTC+1)': 'Берлин (UTC+1)',
  'Best cohort': 'Лучшая когорта',
  'Block classification': 'Блокировка по классификации',
  'Block fingerprints classified as bad': 'Блокировать отпечатки с плохой классификацией',
  'Block unknown fingerprints': 'Блокировать неизвестные отпечатки',
  'Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.':
    'Блокировать, когда совокупный риск-скор TLS+UA+IP превышает порог. По умолчанию 0.7.',
  'Body': 'Тело',
  'Body (JSON)': 'Тело (JSON)',
  'Body copied to clipboard.': 'Тело скопировано в буфер обмена.',
  'Body must be valid JSON.': 'Тело должно быть валидным JSON.',
  'Branding': 'Брендинг',
  'Branding cleared': 'Брендинг сброшен',
  'Branding saved': 'Брендинг сохранён',
  'Break down clicks and conversions by sub-ID parameters (sub1–sub15)':
    'Разбивка кликов и конверсий по параметрам sub-ID (sub1–sub15)',
  'Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.':
    'Просматривайте и устанавливайте шаблоны от сообщества для постбэков, макросов, антифрод-правил и пре-лендингов. Заявки публикуются автоматически — сообщество модерирует через удаление.',
  'Browser': 'Браузер',
  'Build traffic rules, rotate landings and split-test offers for any campaign.':
    'Создавайте правила трафика, ротируйте лендинги и сплит-тестируйте офферы в любой кампании.',
  'Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.':
    'Объединяйте проверенные домены в пул и ротируйте трекинговые ссылки между ними. Вытащите забаненный домен из ротации одним кликом, без переразвёртывания креативов.',
  'By browser': 'По браузерам',
  'By device': 'По устройствам',
  'By {author}': 'Автор: {author}',
  'CR %': 'CR %',
  'CR%': 'CR%',
  'Campaign ID': 'ID кампании',
  'Campaign activated': 'Кампания активирована',
  'Campaign archived': 'Кампания заархивирована',
  'Campaign cloned successfully!': 'Кампания успешно склонирована!',
  'Campaign comparison': 'Сравнение кампаний',
  'Campaign created': 'Кампания создана',
  'Campaign dashboard': 'Панель кампании',
  'Campaign restored': 'Кампания восстановлена',
  'Cap': 'Кап',
  'Cap timezone': 'Часовой пояс капа',
  'Catalog': 'Каталог',
  'Chicago (UTC-6)': 'Чикаго (UTC-6)',
  'Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).':
    'Выберите пресет и при необходимости дополните его кодами стран ISO-3166 (через запятую, например BR, MX, AR).',
  'Clear': 'Очистить',
  'Click ID forward parameter': 'Параметр передачи Click ID',
  'Click detail': 'Детали клика',
  'Click to activate': 'Нажмите, чтобы активировать',
  'Click to pause': 'Нажмите, чтобы поставить на паузу',
  'Clicks log': 'Лог кликов',
  'Clipboard unavailable — copy the URL manually': 'Буфер обмена недоступен — скопируйте URL вручную',
  'Cloaked (iframe)': 'Маскировка (iframe)',
  'Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.':
    'Маскированный iframe оставляет домен трекера в адресной строке — работает только для целевых сайтов, разрешающих фрейминг.',
  'Clone': 'Клонировать',
  'Close navigation': 'Закрыть навигацию',
  'Cohort': 'Когорта',
  'Cohort retention': 'Удержание по когортам',
  'Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.':
    'Список IP через запятую, которым разрешено отправлять постбэки. Оставьте пустым, чтобы разрешить все.',
  'Compare': 'Сравнить',
  'Compare current to proposed weights. Apply persists the proposed column to the streams.':
    'Сравните текущие и предложенные веса. «Применить» сохранит предложенные веса в потоки.',
  'Comparing…': 'Сравнение…',
  'Compliance': 'Соответствие требованиям',
  'Configure UTM templates and conversion postbacks for every ad network you run.':
    'Настройте UTM-шаблоны и постбэки конверсий для каждой рекламной сети.',
  'Configure offers, payouts and target geos. Upload ZIPs or link external networks.':
    'Настройте офферы, выплаты и таргет-гео. Загружайте ZIP-архивы или подключайте внешние сети.',
  'Configure stream': 'Настроить поток',
  'Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.':
    'Настройте баннер GDPR / CCPA, который показывается на лендингах трекера. Баннер учитывает регион — посетители вне выбранных регионов его не увидят.',
  'Confirm action': 'Подтвердите действие',
  'Connect external services and webhooks': 'Подключайте внешние сервисы и вебхуки',
  'Connect external services and webhooks to automate workflows.':
    'Подключайте внешние сервисы и вебхуки, чтобы автоматизировать рабочие процессы.',
  'Connection restored': 'Соединение восстановлено',
  'Connections': 'Подключения',
  'Consent banner': 'Баннер согласия',
  'Consent banner saved': 'Баннер согласия сохранён',
  'Conv': 'Конв.',
  'Conv.': 'Конв.',
  'Conversion rate comparison': 'Сравнение конверсии',
  'Cookieless mode (skip xpnsr_vid first-party cookie)':
    'Режим без cookies (без first-party cookie xpnsr_vid)',
  'Copied to clipboard.': 'Скопировано в буфер обмена.',
  'Copy link (/r/)': 'Копировать ссылку (/r/)',
  'Copy link (/{alias}/)': 'Копировать ссылку (/{alias}/)',
  'Cost': 'Стоимость',
  'Cost value': 'Значение стоимости',
  'Could not accept invitation': 'Не удалось принять приглашение',
  'Could not copy — please copy the link manually.': 'Не удалось скопировать — скопируйте ссылку вручную.',
  'Could not create public link': 'Не удалось создать публичную ссылку',
  'Could not load branding': 'Не удалось загрузить настройки брендинга',
  'Could not load marketplace templates.': 'Не удалось загрузить шаблоны маркетплейса.',
  'Could not load template detail.': 'Не удалось загрузить детали шаблона.',
  'Could not load the shared dashboard.': 'Не удалось загрузить публичную панель.',
  'Could not reset branding': 'Не удалось сбросить брендинг',
  'Could not save branding': 'Не удалось сохранить брендинг',
  'Country (ISO-2)': 'Страна (ISO-2)',
  'Create a campaign first': 'Сначала создайте кампанию',
  'Create key': 'Создать ключ',
  'Create landing page': 'Создать лендинг',
  'Create link': 'Создать ссылку',
  'Create new landing page': 'Создать новый лендинг',
  'Create new offer': 'Создать новый оффер',
  'Create offer': 'Создать оффер',
  'Create pool': 'Создать пул',
  'Custom domain': 'Кастомный домен',
  'Custom range': 'Произвольный период',
  'Customise the dashboard for your agency or sub-account':
    'Настройте панель под ваше агентство или субаккаунт',
  'Daily cap': 'Дневной кап',
  'Dashboard hostname': 'Хост дашборда',
  'Decision': 'Решение',
  'Default offer URL': 'URL оффера по умолчанию',
  'Defense': 'Защита',
  'Delete A/B test': 'Удалить A/B тест',
  'Delete API key': 'Удалить API-ключ',
  'Delete automation rule': 'Удалить правило автоматизации',
  'Delete campaign': 'Удалить кампанию',
  'Delete campaigns': 'Удалить кампании',
  'Delete connection': 'Удалить подключение',
  'Delete domain': 'Удалить домен',
  'Delete domain pool': 'Удалить пул доменов',
  'Delete failed.': 'Не удалось удалить.',
  'Delete forwarder': 'Удалить форвардер',
  'Delete integration': 'Удалить интеграцию',
  'Delete landing page': 'Удалить лендинг',
  'Delete offer': 'Удалить оффер',
  'Delete pre-landing': 'Удалить пре-лендинг',
  'Delete stream': 'Удалить поток',
  'Delete traffic source': 'Удалить источник трафика',
  'Delete webhook': 'Удалить вебхук',
  'Delete {n} selected campaign(s)? This cannot be undone.':
    'Удалить выбранные кампании ({n})? Это действие нельзя отменить.',
  'Denver (UTC-7)': 'Денвер (UTC-7)',
  'Deselect all': 'Снять выделение',
  'Device': 'Устройство',
  'Disable 2FA': 'Отключить 2FA',
  'Disable 2FA — enter a current code': 'Отключение 2FA — введите текущий код',
  'Disable auto-refresh': 'Отключить автообновление',
  'Disable failed': 'Не удалось отключить',
  'Disabled': 'Отключено',
  'Discard DLQ entry': 'Удалить запись DLQ',
  'Dismissed': 'Закрыто',
  'Do not block by classification': 'Не блокировать по классификации',
  'Domain marked healthy': 'Домен помечен здоровым',
  'Domain not verified yet — check the DNS record.': 'Домен ещё не подтверждён — проверьте DNS-запись.',
  'Domain pool created': 'Пул доменов создан',
  'Domain pool deleted': 'Пул доменов удалён',
  'Domain pools': 'Пулы доменов',
  'Domain pulled from rotation': 'Домен выведен из ротации',
  'Domain registered. Add the DNS record, then verify.':
    'Домен зарегистрирован. Добавьте DNS-запись и подтвердите.',
  'Done': 'Готово',
  'Dubai (UTC+4)': 'Дубай (UTC+4)',
  'EPC': 'EPC',
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.":
    'Каждая строка — посетители, пришедшие впервые в этот день. Столбцы показывают накопительную конверсию по дням после первого визита.',
  'Earnings per click': 'Доход с клика',
  'Edit pre-landing': 'Редактировать пре-лендинг',
  'Enable 2FA': 'Включить 2FA',
  'Enabled': 'Включено',
  'Enter a code from the app to confirm': 'Введите код из приложения для подтверждения',
  'Enter a hostname': 'Введите хост',
  'Enter an offer URL': 'Введите URL оффера',
  'Enter the 6-digit code from your authenticator app, or one of your backup codes.':
    'Введите 6-значный код из приложения-аутентификатора или один из резервных кодов.',
  'Epsilon (ε)': 'Эпсилон (ε)',
  'Error archiving campaign': 'Ошибка архивирования кампании',
  'Error cloning campaign': 'Ошибка клонирования кампании',
  'Expires': 'Истекает',
  'Expires after (days)': 'Срок действия (дней)',
  'Explicit blocked fingerprints (comma-separated)': 'Явно заблокированные отпечатки (через запятую)',
  'Export JSON': 'Экспорт JSON',
  'Export XLSX': 'Экспорт XLSX',
  'Extra countries (ISO-3166 alpha-2)': 'Дополнительные страны (ISO-3166 alpha-2)',
  'Failed to accept invite': 'Не удалось принять приглашение',
  'Failed to apply optimization': 'Не удалось применить оптимизацию',
  'Failed to compare': 'Не удалось выполнить сравнение',
  'Failed to copy tracking link': 'Не удалось скопировать трекинговую ссылку',
  'Failed to create campaign': 'Не удалось создать кампанию',
  'Failed to create pool': 'Не удалось создать пул',
  'Failed to delete key': 'Не удалось удалить ключ',
  'Failed to load campaigns': 'Не удалось загрузить кампании',
  'Failed to load clicks log': 'Не удалось загрузить лог кликов',
  'Failed to load consent config': 'Не удалось загрузить настройки согласия',
  'Failed to load conversions': 'Не удалось загрузить конверсии',
  'Failed to load pre-landings': 'Не удалось загрузить пре-лендинги',
  'Failed to load profile': 'Не удалось загрузить профиль',
  'Failed to load sub-ID report': 'Не удалось загрузить отчёт по sub-ID',
  'Failed to preview optimization': 'Не удалось получить предпросмотр оптимизации',
  'Failed to register domain': 'Не удалось зарегистрировать домен',
  'Failed to revoke access': 'Не удалось отозвать доступ',
  'Failed to save': 'Не удалось сохранить',
  'Failed to update status': 'Не удалось обновить статус',
  'Fallback offer': 'Оффер на случай отказа',
  'Filter junk traffic, block malicious IPs and review suspicious activity in one place.':
    'Фильтруйте мусорный трафик, блокируйте вредоносные IP и анализируйте подозрительную активность в одном месте.',
  'From (ISO-8601)': 'С (ISO-8601)',
  'GDPR: pseudonymize visitor IPs (hash before storage)':
    'GDPR: псевдонимизировать IP посетителей (хешировать перед сохранением)',
  'Generate a key to call the public REST API.': 'Сгенерируйте ключ для вызова публичного REST API.',
  'Go back': 'Назад',
  'Go to Workspace': 'Перейти в воркспейс',
  'Group (optional)': 'Группа (необязательно)',
  'Group by:': 'Группировать по:',
  'Healthy': 'Здоровый',
  'Hide xpnsr branding': 'Скрыть брендинг xpnsr',
  'Hosted pages and uploads': 'Хостинг страниц и загрузки',
  'Hostname': 'Хост',
  'Install': 'Установить',
  'Install failed.': 'Не удалось установить.',
  'Invalid 2FA code': 'Неверный код 2FA',
  'Invalid SSO session': 'Недействительная SSO-сессия',
  'Invitation accepted!': 'Приглашение принято!',
  'JS redirect (location.replace)': 'JS-редирект (location.replace)',
  'Keyboard shortcuts': 'Горячие клавиши',
  'Keyboard shortcuts (?)': 'Горячие клавиши (?)',
  'Keyword exclude': 'Исключаемые ключевые слова',
  'Keyword include': 'Включаемые ключевые слова',
  'Label (operator-only)': 'Метка (только для оператора)',
  'Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.':
    'Последние 200 записей согласия в этом воркспейсе. Используются как аудит-трейл для DSAR-запросов и регуляторов.',
  'Last viewed': 'Последний просмотр',
  'Layout': 'Раскладка',
  'Layout & retention': 'Раскладка и срок хранения',
  'Live': 'В реальном времени',
  'Live KPIs and breakdowns across campaigns, geos, devices.':
    'KPI и разбивки по кампаниям, гео и устройствам в реальном времени.',
  'Loading marketplace…': 'Загружаем маркетплейс…',
  'Loading...': 'Загрузка...',
  'Login page subtitle': 'Подзаголовок страницы входа',
  'Logo URL': 'URL логотипа',
  'London (UTC+0)': 'Лондон (UTC+0)',
  'Lookback (days)': 'Глубина анализа (дни)',
  'Los Angeles (UTC-8)': 'Лос-Анджелес (UTC-8)',
  'Make sure your tracking URLs include {key}=... parameter':
    'Убедитесь, что в трекинговых URL присутствует параметр {key}=...',
  'Manage profile, preferences, notifications and system configuration.':
    'Управление профилем, настройками, уведомлениями и конфигурацией системы.',
  'Manage your offers and creatives': 'Управление офферами и креативами',
  'Manual entry secret': 'Секрет для ручного ввода',
  'Mark all read': 'Отметить все прочитанными',
  'Mark read': 'Отметить прочитанным',
  'Marketplace': 'Маркетплейс',
  'Match if referrer/params contain a keyword':
    'Срабатывает, если реферер или параметры содержат ключевое слово',
  'Meta refresh': 'Meta refresh',
  'Metric': 'Метрика',
  'Min clicks per stream': 'Мин. кликов на поток',
  'Minimum ROI (%)': 'Минимальный ROI (%)',
  'Missing SSO session token': 'Отсутствует токен SSO-сессии',
  'Missing invite token': 'Отсутствует токен приглашения',
  'Most clicks': 'Больше всего кликов',
  'Most revenue': 'Больше всего дохода',
  'Mumbai (UTC+5:30)': 'Мумбаи (UTC+5:30)',
  'Must be an https:// URL. Leave blank to fall back to the xpnsr logo.':
    'Должен быть HTTPS URL. Оставьте пустым, чтобы использовать логотип xpnsr.',
  'Name A→Z': 'Название А→Я',
  'Name Z→A': 'Название Я→А',
  'Name and target URL are required': 'Название и целевой URL обязательны',
  'Name is required.': 'Название обязательно.',
  'New': 'Новый',
  'New pre-landing': 'Новый пре-лендинг',
  'New public dashboard link': 'Новая публичная ссылка на панель',
  'Newest first': 'Сначала новые',
  'Next': 'Далее',
  'No active streams to optimize.': 'Нет активных потоков для оптимизации.',
  'No clicks match these filters.': 'Под фильтры не подходит ни один клик.',
  'No cohort data': 'Нет данных по когортам',
  'No consent records yet.': 'Записей о согласии пока нет.',
  'No conversions yet': 'Конверсий пока нет',
  'No data found for {key}': 'Нет данных для {key}',
  'No data yet.': 'Данных пока нет.',
  'No description provided.': 'Описание не указано.',
  'No internet connection': 'Нет подключения к интернету',
  'No notifications yet': 'Уведомлений пока нет',
  'No performance data yet': 'Данных по эффективности пока нет',
  'No pre-landings yet. Create one to start chaining traffic.':
    'Пре-лендингов пока нет. Создайте, чтобы выстроить цепочку трафика.',
  'No public links yet. Create one to share read-only stats with advertisers.':
    'Публичных ссылок пока нет. Создайте, чтобы делиться статистикой с рекламодателями в режиме только-чтение.',
  'No results.': 'Ничего не найдено.',
  'No templates match these filters.': 'Под фильтры не подходит ни один шаблон.',
  'No vendors disclosed.': 'Вендоры не указаны.',
  'No verified custom domains. Add one in Domains → Settings.':
    'Нет подтверждённых кастомных доменов. Добавьте в «Домены → Настройки».',
  'None': 'Нет',
  'Notify only': 'Только уведомлять',
  'Oldest first': 'Сначала старые',
  'Onboarding complete!': 'Онбординг завершён!',
  'Only match if referrer contains one of these':
    'Срабатывает, только если реферер содержит одно из этих значений',
  'Open Campaigns': 'Открыть «Кампании»',
  'Open Domains page': 'Открыть страницу «Домены»',
  'Open command palette': 'Открыть командную палитру',
  'Open landing pages': 'Открыть лендинги',
  'Open my tracking link': 'Открыть мою трекинговую ссылку',
  'Operators host the static page; the tracker just routes clicks here first.':
    'Операторы хостят статическую страницу — трекер просто направляет клики сюда в первую очередь.',
  'Optimization': 'Оптимизация',
  'Optional': 'Необязательно',
  'Pages library': 'Библиотека страниц',
  'Parameter name, e.g. sub1': 'Имя параметра, например sub1',
  'Pause': 'Пауза',
  'Performance': 'Эффективность',
  'Performance overview': 'Обзор эффективности',
  'Permanently discard this dead-letter entry? This cannot be undone.':
    'Окончательно удалить эту dead-letter запись? Действие нельзя отменить.',
  'Please sign in first, then open the invite link again.':
    'Сначала войдите, затем откройте ссылку приглашения снова.',
  'Please wait…': 'Пожалуйста, подождите…',
  'Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.':
    'Направьте этот хост на трекер через DNS. Посетители увидят ваш брендинг ещё до входа.',
  'Pool name': 'Название пула',
  'Postback IP whitelist': 'Белый список IP для постбэков',
  'Pre-Landings': 'Пре-лендинги',
  'Pre-landing created': 'Пре-лендинг создан',
  'Pre-landing deleted': 'Пре-лендинг удалён',
  'Pre-landing updated': 'Пре-лендинг обновлён',
  'Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.':
    'Пре-лендинги дают более быструю и комплаенс-дружелюбную точку входа перед отправкой посетителя на оффер. Их можно добавить в любой момент.',
  'Preview': 'Предпросмотр',
  'Previous': 'Назад',
  'Primary colour': 'Основной цвет',
  'Privacy policy URL': 'URL политики конфиденциальности',
  'Products': 'Продукты',
  'Proposed': 'Предложено',
  'Proposed drift': 'Дрейф предложенных',
  'Proposed weights': 'Предложенные веса',
  'Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.':
    'Защитите аккаунт TOTP-кодом из приложения-аутентификатора. Резервные коды позволят войти, если потеряете устройство.',
  "Public link created — copy it now, it won't be shown again.":
    'Публичная ссылка создана — скопируйте её сейчас, повторно она не покажется.',
  'Public link revoked.': 'Публичная ссылка отозвана.',
  'Public read-only links': 'Публичные ссылки только-чтение',
  'Publish': 'Опубликовать',
  'Publishing…': 'Публикуем…',
  'Pull out of rotation': 'Вывести из ротации',
  'Purpose (e.g. Analytics)': 'Назначение (например, Аналитика)',
  'Quick start from template': 'Быстрый старт по шаблону',
  'Quiz / review / bonus pages that intercept the click before the final landing or offer.':
    'Страницы с квизами / обзорами / бонусами, которые перехватывают клик до основного лендинга или оффера.',
  'ROI': 'ROI',
  'ROI alert': 'Оповещение по ROI',
  'Random seed (optional)': 'Случайный seed (необязательно)',
  'Read-only public view — generated by xpnsr-tracker.':
    'Публичный просмотр только-чтение — сгенерировано xpnsr-tracker.',
  'Rebalance stream weights based on historical conversion rate using a multi-armed bandit.':
    'Перебалансируйте веса потоков на основе исторической конверсии с помощью многорукого бандита.',
  'Recent decisions': 'Последние решения',
  'Record retention (days)': 'Срок хранения записей (дней)',
  'Redirect method': 'Метод редиректа',
  'Redirect mode': 'Режим редиректа',
  'Referrer / Keyword filters': 'Фильтры по реферерам и ключевым словам',
  'Referrer exclude': 'Исключаемые рефереры',
  'Referrer include': 'Включаемые рефереры',
  'Region preset': 'Пресет регионов',
  'Region scope': 'Область регионов',
  'Register a custom hostname so your tracking links resolve under your own brand.':
    'Зарегистрируйте кастомный хост, чтобы трекинговые ссылки шли под вашим брендом.',
  'Register hostname': 'Зарегистрировать хост',
  'Reject button label': 'Текст кнопки «Отклонить»',
  'Rejected': 'Отклонено',
  'Remove': 'Удалить',
  'Remove template': 'Удалить шаблон',
  'Remove this template? This cannot be undone.': 'Удалить этот шаблон? Действие нельзя отменить.',
  'Reset branding': 'Сбросить брендинг',
  'Reset to defaults': 'Сбросить к настройкам по умолчанию',
  'Resetting…': 'Сбрасываем…',
  'Restore': 'Восстановить',
  'Restore to rotation': 'Вернуть в ротацию',
  'Return on investment': 'Возврат инвестиций (ROI)',
  'Rev.': 'Доход',
  'Revenue comparison': 'Сравнение дохода',
  'Revoke': 'Отозвать',
  'Revoke failed': 'Не удалось отозвать',
  'Revoke public link': 'Отозвать публичную ссылку',
  'Risk score threshold (0.0 – 1.0)': 'Порог риск-скора (0.0 – 1.0)',
  'Round robin': 'Round robin',
  'Routing': 'Маршрутизация',
  'Row-level drill-down into incoming clicks: country, device, stream, and variant.':
    'Детализация входящих кликов: страна, устройство, поток, вариант.',
  'Run a preview to see proposed weights.': 'Запустите предпросмотр, чтобы увидеть предложенные веса.',
  'SSO failed': 'SSO-вход не удался',
  'SSO is not configured': 'SSO не настроен',
  'SSO sign-in failed': 'Не удалось войти через SSO',
  'Save branding': 'Сохранить брендинг',
  'Scan the QR code with your authenticator app': 'Отсканируйте QR-код в приложении-аутентификаторе',
  'Search': 'Поиск',
  'Search by name, description, or slug. Filter by type or tag.':
    'Поиск по названию, описанию или slug. Фильтрация по типу или тегу.',
  'Search…': 'Поиск…',
  'Secondary colour': 'Дополнительный цвет',
  'Select all': 'Выбрать всё',
  'Select at least 2 campaigns': 'Выберите минимум 2 кампании',
  'Select campaigns (2–10)': 'Выберите кампании (2–10)',
  'Sending…': 'Отправка…',
  'Set up rules, notifications and triggered actions for your campaigns.':
    'Настройте правила, уведомления и триггеры для своих кампаний.',
  'Set up your tracker': 'Настройте трекер',
  'Setup failed': 'Не удалось выполнить настройку',
  'Share a token-gated dashboard URL with advertisers without giving them an account.':
    'Поделитесь дашбордом с рекламодателями через токенизированный URL — без создания им аккаунта.',
  'Shareable URL': 'Ссылка для шаринга',
  'Shared dashboard': 'Публичная панель',
  'Side-by-side metrics for selected campaigns': 'Метрики выбранных кампаний рядом',
  'Sign in with Google': 'Войти через Google',
  'Sign in with Microsoft': 'Войти через Microsoft',
  'Singapore (UTC+8)': 'Сингапур (UTC+8)',
  'Size': 'Размер',
  'Skip for now': 'Пропустить пока',
  'Skip if referrer contains one of these': 'Пропускать, если реферер содержит одно из этих значений',
  'Skip if referrer/params contain a keyword':
    'Пропускать, если реферер или параметры содержат ключевое слово',
  'Skip this step until you have a campaign — you can finish setup from the Campaigns page.':
    'Пропустите этот шаг, пока нет кампании — настройку можно завершить со страницы «Кампании».',
  'Skipped (below min_clicks_per_stream)': 'Пропущено (ниже min_clicks_per_stream)',
  'Smoothed CR': 'Сглаженный CR',
  'Sort by': 'Сортировка',
  'Split traffic across variants to find what converts best.':
    'Распределяйте трафик между вариантами, чтобы найти лучший по конверсии.',
  'Step {step} of {total}': 'Шаг {step} из {total}',
  'Sticky (per-visitor)': 'Sticky (на посетителя)',
  'Stream': 'Поток',
  'Stream ID': 'ID потока',
  'Stream configured': 'Поток настроен',
  "Streams decide which offer each visitor lands on. Configure your default stream and you\\'ll have a working tracking link.":
    'Потоки определяют, на какой оффер попадёт посетитель. Настройте поток по умолчанию — и у вас будет рабочая трекинговая ссылка.',
  'Sub-ID drill-down': 'Детализация по sub-ID',
  'Submission failed.': 'Не удалось отправить заявку.',
  'Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.':
    'Заявки публикуются автоматически. Slug формируется из названия — при коллизии добавляется числовой суффикс.',
  'Submit a template': 'Отправить шаблон',
  'Submit template': 'Отправить шаблон',
  'Sydney (UTC+11)': 'Сидней (UTC+11)',
  'São Paulo (UTC-3)': 'Сан-Паулу (UTC-3)',
  'TLS fingerprint (JA3 / JA4)': 'TLS-отпечаток (JA3 / JA4)',
  'Tags (comma-separated)': 'Теги (через запятую)',
  'Tags:': 'Теги:',
  'Template': 'Шаблон',
  'Template body copied to clipboard.': 'Тело шаблона скопировано в буфер обмена.',
  'Template installed. Body shown in detail dialog.': 'Шаблон установлен. Тело показано в окне с деталями.',
  'Template marketplace': 'Маркетплейс шаблонов',
  'Template published as {slug}.': 'Шаблон опубликован как {slug}.',
  'Template removed.': 'Шаблон удалён.',
  'The token will only be shown once after creation — copy it immediately.':
    'Токен показывается только один раз после создания — скопируйте его сразу.',
  'Third-party processors disclosed to the visitor (max 50).':
    'Сторонние обработчики, раскрываемые посетителю (макс. 50).',
  'This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.':
    'Эта ссылка не требует авторизации. Все, у кого она есть, могут видеть выбранные метрики до истечения срока или отзыва.',
  'This member will lose access to this workspace immediately.':
    'Этот участник мгновенно потеряет доступ к воркспейсу.',
  'This shared link has expired or been revoked.': 'Эта публичная ссылка истекла или была отозвана.',
  'This shared link is not valid.': 'Эта публичная ссылка недействительна.',
  'This will permanently delete "{name}" and all associated clicks, conversions and postback events. This cannot be undone.':
    'Это окончательно удалит «{name}» вместе со всеми связанными кликами, конверсиями и постбэк-событиями. Действие нельзя отменить.',
  'This will permanently delete "{name}" and all its variants.':
    'Это окончательно удалит «{name}» вместе со всеми вариантами.',
  'This will permanently delete "{name}" and remove it from all campaigns.':
    'Это окончательно удалит «{name}» и уберёт его из всех кампаний.',
  'This will permanently delete "{name}".': 'Это окончательно удалит «{name}».',
  'This will permanently delete "{name}". Campaigns using this domain will fall back to the default domain.':
    'Это окончательно удалит «{name}». Кампании, использующие этот домен, переключатся на домен по умолчанию.',
  'This will permanently delete "{name}". Campaigns using this source will lose their tracking parameters.':
    'Это окончательно удалит «{name}». Кампании с этим источником потеряют трекинговые параметры.',
  'This will permanently delete pool "{name}".': 'Это окончательно удалит пул «{name}».',
  'This will permanently delete rule "{name}".': 'Это окончательно удалит правило «{name}».',
  'This will permanently delete stream "{name}".': 'Это окончательно удалит поток «{name}».',
  'This will permanently delete this ad account connection. Cost syncing will stop.':
    'Это окончательно удалит подключение рекламного аккаунта. Синхронизация затрат остановится.',
  'This will permanently delete this conversion forwarder.':
    'Это окончательно удалит этот форвардер конверсий.',
  'This will permanently delete webhook "{name}". Events will no longer be forwarded.':
    'Это окончательно удалит вебхук «{name}». События больше не будут пересылаться.',
  'This will permanently revoke this API key. Any integrations using it will stop working.':
    'Это окончательно отзовёт API-ключ. Все интеграции, использующие его, перестанут работать.',
  'This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.':
    'Это сбросит все настройки брендинга к значениям по умолчанию. Логотип, цвета и кастомный домен будут удалены.',
  'This will reset two-factor authentication for this member. They will need to re-enrol.':
    'Это сбросит двухфакторную аутентификацию участника. Ему потребуется заново пройти настройку.',
  'Title': 'Заголовок',
  'Title, body, and button labels shown to the visitor.':
    'Заголовок, текст и подписи кнопок, которые видит посетитель.',
  'To (ISO-8601)': 'По (ISO-8601)',
  'Toggle navigation': 'Переключить навигацию',
  'Tokyo (UTC+9)': 'Токио (UTC+9)',
  'Too many requests — please retry in a moment.': 'Слишком много запросов — повторите чуть позже.',
  'Track click usage and switch plans. Billing renews monthly.':
    'Отслеживайте использование кликов и переключайте тарифы. Оплата продлевается ежемесячно.',
  'Tracking domain': 'Трекинговый домен',
  'Tracking link copied to clipboard': 'Трекинговая ссылка скопирована в буфер обмена',
  'Tune the bandit before running a preview. Apply only writes weights to active streams.':
    'Настройте бандит перед запуском предпросмотра. «Применить» записывает веса только в активные потоки.',
  'Two-factor authentication': 'Двухфакторная аутентификация',
  'Two-factor code': 'Код двухфакторной аутентификации',
  'Type': 'Тип',
  'Type a command or search…': 'Введите команду или поиск…',
  'Ungrouped': 'Без группы',
  'Unlimited': 'Без лимита',
  'Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.':
    'Загрузите архив лендинга (.zip) или выберите хостинговый пре-лендинг из библиотеки.',
  'Upload, organize and reuse landing pages across your campaigns.':
    'Загружайте, упорядочивайте и используйте лендинги повторно в кампаниях.',
  'Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.':
    'Использует базовый список (Python requests, Go net/http, curl, headless Chrome) плюс переопределения вашего воркспейса.',
  'Vendor list': 'Список вендоров',
  'Vendor name (e.g. Google Analytics)': 'Имя вендора (например, Google Analytics)',
  'Verify now': 'Проверить сейчас',
  'Verifying…': 'Проверка…',
  'View': 'Просмотр',
  'Views': 'Просмотры',
  'Visible metrics': 'Видимые метрики',
  'Visitor': 'Посетитель',
  'Visual identity': 'Визуальная идентичность',
  'Weight floor (%)': 'Минимальный вес (%)',
  'Weighted': 'С весами',
  'Welcome to ACME Tracker — sign in to continue':
    'Добро пожаловать в ACME Tracker — войдите, чтобы продолжить',
  'When disabled, the public widget responds with required:false so landing pages skip rendering entirely.':
    'В отключённом состоянии публичный виджет отвечает required:false, и лендинги вообще не рендерят баннер.',
  'When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.':
    'При установке трекер автоматически добавляет ?<param>=<click_id> к URL редиректа. Оставьте пустым, чтобы отключить. Используйте {click_id} в целевом URL для полного контроля.',
  'Workflows': 'Рабочие процессы',
  'Workspace default domain': 'Домен воркспейса по умолчанию',
  'Your tracking link': 'Ваша трекинговая ссылка',
  'clear tag': 'очистить тег',
  'clicks': 'кликов',
  'connections': 'подключений',
  'domains': 'домены',
  'e.g. 185.45.12.1, 91.108.0.0': 'например, 185.45.12.1, 91.108.0.0',
  'e.g. Facebook, Google, Tier 1': 'например, Facebook, Google, Tier 1',
  'e.g. MaxBounty CPA': 'например, MaxBounty CPA',
  'e.g. adcombo, cpa, status': 'например, adcombo, cpa, status',
  'group.<key>': 'group.<key>',
  'installs': 'установок',
  'live': 'live',
  'logo': 'лого',
  'max change': 'макс. изменение',
  'no': 'нет',
  'or continue with': 'или войти через',
  'revoked': 'отозвано',
  'rows': 'строк',
  'to close': 'чтобы закрыть',
  'to navigate': 'для навигации',
  'to select': 'чтобы выбрать',
  'weight units': 'ед. веса',
  'yes': 'да',
  '{count} conversions': '{count} конверсий',
  '{key} breakdown': 'Разбивка по {key}',
  '{n} selected': 'выбрано: {n}',
  'Δ': 'Δ',

  // Sidebar nav labels + tooltips that were falling back to EN
  'Sub-ID reports': 'Отчёты по Sub-ID',
  'Ad accounts': 'Рекламные аккаунты',
  'API docs': 'API-документация',
  'Drill-down by sub1–sub15: clicks, conversions, CR':
    'Детализация по sub1–sub15: клики, конверсии, CR',
  'Side-by-side metrics for multiple campaigns':
    'Метрики нескольких кампаний рядом',
  'Step-by-step user guide for every feature':
    'Пошаговое руководство по каждой функции',

  // Theme toggle aria-labels (ThemeToggle.jsx)
  'Switch to dark theme': 'Переключиться на тёмную тему',
  'Switch to light theme': 'Переключиться на светлую тему',

  // Generic error pages (ErrorPage.jsx) — 403 / 404 / 500
  'Page not found': 'Страница не найдена',
  'The page you are looking for does not exist or has been moved.':
    'Страница, которую вы ищете, не существует или была перемещена.',
  'Access denied': 'Доступ запрещён',
  'You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.':
    'У вас нет прав на просмотр этой страницы. Обратитесь к администратору воркспейса, если считаете это ошибкой.',
  'Server error': 'Ошибка сервера',
  'Something went wrong on our end. Please try again later or contact support.':
    'Что-то пошло не так на нашей стороне. Попробуйте позже или обратитесь в поддержку.',

  // Permission matrix labels (Settings → Права доступа), sourced from
  // backend/permissions.py _CATALOG. Role names + category headings were
  // already translated; the action labels + descriptions were falling back
  // to EN.
  'View campaigns': 'Просмотр кампаний',
  'List and open campaigns and their stats.':
    'Просмотр списка и открытие кампаний с их статистикой.',
  'Create campaigns': 'Создание кампаний',
  'Add new campaigns and their default streams.':
    'Добавление новых кампаний и их потоков по умолчанию.',
  'Edit campaigns': 'Редактирование кампаний',
  'Change campaign settings, target URL, status.':
    'Изменение настроек, целевого URL и статуса кампаний.',
  'Permanently remove a campaign and its history.':
    'Безвозвратное удаление кампании и её истории.',
  'View landings': 'Просмотр лендингов',
  'Browse the landing-page library.': 'Просмотр библиотеки лендингов.',
  'Edit landings': 'Редактирование лендингов',
  'Upload, edit, and delete landings.':
    'Загрузка, редактирование и удаление лендингов.',
  'View offers': 'Просмотр офферов',
  'Browse the offer library.': 'Просмотр библиотеки офферов.',
  'Edit offers': 'Редактирование офферов',
  'Create, edit, and delete offers.':
    'Создание, редактирование и удаление офферов.',
  'View anti-fraud': 'Просмотр анти-фрода',
  'Read filter list, blocked samples, audit feed.':
    'Просмотр списка фильтров, заблокированных образцов и журнала аудита.',
  'Edit anti-fraud filters': 'Редактирование анти-фрод фильтров',
  'Create / update / delete fraud filters and IP lists.':
    'Создание / изменение / удаление фрод-фильтров и IP-списков.',
  'Manage TLS fingerprint overrides':
    'Управление переопределениями TLS-отпечатков',
  'Pin JA3 / JA4 hashes per-workspace (overrides the seed list).':
    'Закрепление JA3 / JA4 хэшей для воркспейса (переопределяет seed-список).',
  'View reports': 'Просмотр отчётов',
  'Open the analytics dashboard and saved reports.':
    'Открытие аналитического дашборда и сохранённых отчётов.',
  'Export reports': 'Экспорт отчётов',
  'Download CSV / JSON report exports.':
    'Скачивание CSV / JSON экспортов отчётов.',
  'View automation rules': 'Просмотр правил автоматизации',
  'Read the rules engine and execution history.':
    'Просмотр движка правил и истории выполнения.',
  'Edit automation rules': 'Редактирование правил автоматизации',
  'Create / update / delete automation rules.':
    'Создание / изменение / удаление правил автоматизации.',
  'View integrations': 'Просмотр интеграций',
  'Browse integration configurations.': 'Просмотр настроек интеграций.',
  'Edit integrations': 'Редактирование интеграций',
  'Connect / disconnect ad accounts and webhooks.':
    'Подключение и отключение рекламных аккаунтов и вебхуков.',
  'View postbacks': 'Просмотр постбэков',
  'Browse postbacks and the CAPI dead-letter queue.':
    'Просмотр постбэков и очереди недоставленных CAPI.',
  'Edit postbacks': 'Редактирование постбэков',
  'Configure postbacks, replay / discard CAPI DLQ entries.':
    'Настройка постбэков, повтор и удаление записей CAPI DLQ.',
  'Invite members': 'Приглашение участников',
  'Send invite links to new teammates.':
    'Отправка ссылок-приглашений новым участникам команды.',
  'Change member role': 'Изменение роли участника',
  'Promote / demote existing members.':
    'Повышение и понижение ролей существующих участников.',
  'Remove members': 'Удаление участников',
  "Revoke a teammate's access.": 'Отзыв доступа участника команды.',
  'Edit workspace settings': 'Редактирование настроек воркспейса',
  'Change workspace currency, timezone, branding.':
    'Изменение валюты, часового пояса и брендинга воркспейса.',
  'Edit permission matrix': 'Редактирование матрицы прав',
  'Override the default permission matrix for this workspace.':
    'Переопределение матрицы прав по умолчанию для этого воркспейса.',
  'View billing': 'Просмотр биллинга',
  'See plan, invoices, payment method.':
    'Просмотр тарифа, счетов и способа оплаты.',
  'Change plan, update payment method.':
    'Смена тарифа и обновление способа оплаты.',
  'View audit log': 'Просмотр журнала аудита',
  'Read the workspace audit feed.': 'Чтение журнала аудита воркспейса.',
  'View tracking domains': 'Просмотр доменов трекинга',
  'Browse the tracking-domain list.': 'Просмотр списка доменов трекинга.',
  'Edit tracking domains': 'Редактирование доменов трекинга',
  'Add / remove tracking domains.': 'Добавление и удаление доменов трекинга.',
  'View API keys': 'Просмотр API-ключей',
  'List existing API keys (does not reveal the secret).':
    'Просмотр существующих API-ключей (без раскрытия секрета).',
  'Manage API keys': 'Управление API-ключами',
  'Create / revoke API keys.': 'Создание и отзыв API-ключей.',
  // Cloaking (self-hosted white/money-page split)
  'Cloaking — send bots to a safe page': 'Клоакинг — уводить ботов на белую страницу',
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.":
    'Собственный клоакинг. Боты, модераторы рекламных сетей, датацентр/прокси-IP и поисковые краулеры видят белую (safe) страницу; живые люди идут на реальный оффер. Классификация — на своих проверках бот/IP/DNS-краулеров, без сторонних платных сервисов.',
  'Safe page URL': 'URL белой страницы',
  'The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.':
    'Безопасная страница для ботов/краулеров. Должна быть абсолютным http(s) URL. В SEO-режиме её индексируют верифицированные краулеры.',
  'Bots & spoofed crawlers': 'Боты и поддельные краулеры',
  'Verified search crawlers': 'Верифицированные краулеры',
  'Datacenter / Tor IPs': 'Датацентр / Tor IP',
  'Proxy / VPN IPs': 'Прокси / VPN IP',
  'Enter a valid http(s) Safe page URL for cloaking': 'Укажите корректный http(s) URL белой страницы для клоакинга',
  // ClicksLog cloaked column + filter
  'Cloaked': 'Клоакинг',
  'All traffic': 'Весь трафик',
  'Cloaked only': 'Только клоак',
  'Real only': 'Только реальный',
  // CampaignDetail cloaking panel
  'Cloaking': 'Клоакинг',
  'Bots and crawlers sent to the safe page vs humans to the offer':
    'Боты и краулеры уходят на белую страницу, люди — на оффер',
  'last {n} days': 'за {n} дн.',
  'Cloaked → safe page': 'Клоак → белая',
  'Real → offer': 'Реальные → оффер',
  'Cloak rate': 'Доля клоака',
  'Spoofed crawlers': 'Поддельные краулеры',
  'Verified crawlers': 'Верифиц. краулеры',
  'Datacenter / Tor': 'Датацентр / Tor',
  // SEO crawler split (domain root)
  'SEO split (crawlers → index, humans → funnel)':
    'SEO-сплит (краулеры → индекс, люди → воронка)',
  'SEO crawler split on: verified crawlers index the page, humans go to the funnel':
    'SEO-сплит включён: верифицированные краулеры индексируют страницу, люди идут в воронку',
  'SEO crawler split off': 'SEO-сплит выключен',
  'When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.':
    'Когда включено, DNS-верифицированные поисковые краулеры получают index-страницу (для ранжирования), а люди — воронку привязанной кампании. Нужны index-страница и кампания, привязанная к домену.',
  // Fallback robots/sitemap (opt-in)
  'Fallback robots/sitemap': 'Fallback robots/sitemap',
  'Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.':
    'Отдавать сгенерированные robots.txt / sitemap.xml на корне домена ТОЛЬКО если в вашем загруженном бандле их нет. Ваши SEO-файлы всегда в приоритете.',
  'Fallback robots.txt/sitemap.xml on (only when your bundle has none)':
    'Fallback robots.txt/sitemap.xml включён (только если в бандле их нет)',
  'Fallback robots.txt/sitemap.xml off': 'Fallback robots.txt/sitemap.xml выключен',
  // SEO domains dashboard badges
  'Root: stable index': 'Корень: стабильный индекс',
  'Root: SEO split': 'Корень: SEO-сплит',
  'Root: funnel': 'Корень: воронка',
  'Root: 404': 'Корень: 404',
  'own': 'свой',
  'fallback': 'fallback',
  'none': 'нет',
  'indexable': 'индексируется',
  'no-index': 'no-index',

  // De-russification wave: strings converted from hardcoded RU/bilingual
  // literals in components to English keys (Campaign params & postbacks,
  // Documentation TOC, Domains, Integrations, Offers, Leads, misc).
  'Registration': 'Регистрация',
  'Deposit': 'Депозит',
  'Trash': 'Треш',
  'Hide': 'Скрыть',
  'Show': 'Показать',
  'Import from source': 'Импорт из источника',
  'Postback token': 'Токен постбека',
  'Require postback token': 'Требовать токен постбэка',
  'Network macros': 'Макросы сети',
  'FTD · Deposit (sale)': 'FTD · Депозит (sale)',
  'Chargeback (reject)': 'Возврат (reject)',
  'This campaign has no source with parameters': 'У кампании не выбран источник с параметрами',
  'Macros imported from the source — click Save': 'Макросы импортированы из источника — нажмите Save',
  'Save the campaign once to generate the token.': 'Токен появится после первого сохранения кампании.',
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.":
    'Когда ВКЛ — входящий постбэк обязан нести токен именно этой кампании, иначе отклоняется (401). Выключите, если партнёрка (напр. TrackBox) шлёт ОДИН общий постбэк на все кампании: тогда уберите &token=… из этого URL, и конверсии будут сопоставляться по click_id.',
  'Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).':
    'Проверка токена отключена — постбэк принимается по click_id без токена (убери &token=… из URL в партнёрке).',
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.":
    'TrackBox: передайте ваш click_id в параметр Affclickid ссылки оффера, чтобы {affclickid} вернулся в эту кампанию. Метод GET.',
  'Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.':
    'Generic: передайте ваш click_id в ссылку оффера, чтобы он вернулся в эту кампанию как {click_id}. Метод GET.',
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.":
    'Subid: передайте ваш click_id в параметр subid ссылки оффера, чтобы {subid} вернулся в эту кампанию. Метод GET.',
  'Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.':
    'Впишите токен бота и chat_id — добавим постбеки на Лид и Депозит с готовым текстом (Campaign, Sub1..4, Source, Payout). Потом нажмите «Сохранить».',
  // Documentation TOC
  'What is XPNSR Tracker': 'Что такое XPNSR Tracker',
  'Links & aliases': 'Ссылки и алиасы',
  'Postbacks': 'Постбэки',
  'Macros': 'Макросы',
  'Redirect modes': 'Режимы редиректа',
  'A/B tests': 'A/B тесты',
  'Glossary': 'Глоссарий',
  'Partners & lead forms': 'Партнёрки и лид-формы',
  'Google Ads & conversions': 'Google Ads и конверсии',
  'Reports (Report Builder)': 'Отчёты (Report Builder)',
  // Domains
  'Failed to copy': 'Не удалось скопировать',
  'Domain opened for indexing': 'Домен открыт для индексации',
  'Domain closed from indexing': 'Домен закрыт от индексации',
  'Index page set': 'Index-страница задана',
  'Index page cleared': 'Index-страница убрана',
  'Server migration (admin only)': 'Смена сервера (только для админа)',
  'Current server IP:': 'Текущий IP сервера:',
  'Step 1. Provision a new server': 'Шаг 1. Поднять новый сервер',
  'Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.':
    'В AWS создать EC2-инстанс (Ubuntu, открыть порты 80 и 443), зайти в него по SSH и вставить эту команду целиком. В конце она напишет IP нового сервера.',
  'Step 2. Enter the new IP': 'Шаг 2. Вписать новый IP',
  'Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.':
    'Вставить IP из Шага 1 и нажать «Сохранить». У всех клиентов сразу обновится IP для A-записи — без перезапуска.',
  'Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.':
    'Совет: если в AWS переназначить прежний Elastic IP на новый сервер, здесь менять ничего не нужно — и клиентам тоже.',
  'Open for search engines — click to close': 'Открыт для поисковиков — нажмите, чтобы закрыть',
  'Closed from search engines — click to open': 'Закрыт для поисковиков — нажмите, чтобы открыть',
  'Indexable': 'Индексируется',
  'No-index': 'Закрыт',
  'Index page (SEO, served at the root with 200):': 'Index-страница (SEO, отдаётся на корне 200):',
  '— none (root opens the funnel) —': '— нет (корень открывает воронку) —',
  // Integrations
  'Custom API (any CRM)': 'Custom API (любая CRM)',
  'TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.':
    'Реквизиты TrackBox (ЛК → API Testing). Один раз на аккаунт — офферы будут ссылаться на эту партнёрку.',
  'Username': 'Имя пользователя',
  'Signup path': 'Путь регистрации',
  'Pull path': 'Путь Pull-запроса',
  'Pull type': 'Тип Pull-запроса',
  'Auto pull-sync': 'Авто Pull-синхронизация',
  'Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.':
    'Универсальная интеграция под любую CRM партнёрки. Опишите её API-запрос регистрации лида — трекер будет слать сюда данные формы и редиректить по ссылке из ответа.',
  'API URL (base)': 'API URL (база)',
  'Body format': 'Формат тела',
  'Headers': 'Заголовки',
  '(one "Key: value" per line, macros allowed)': '(по строке «Ключ: значение», можно макросы)',
  'Body template (JSON)': 'Тело запроса (JSON)',
  '(values are macros in curly braces)': '(значения — макросы в фигурных скобках)',
  'Redirect field': 'Redirect-поле',
  'Success field (optional)': 'Success-поле (опц.)',
  'Success value (optional)': 'Success-значение (опц.)',
  'plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.':
    'плюс любые поля формы и параметры оффера. Redirect-поле — путь в JSON-ответе (напр. data.url); если пусто — берём первую http(s)-ссылку из ответа.',
  'Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.':
    'Партнёрка/CRM заводится здесь один раз, а потом оффер ссылается на неё. TrackBox / Tigloo — типовой адаптер; Custom API — под любую другую CRM. Лид с формы оффера уходит в выбранную партнёрку.',
  // Offers
  'Affiliate routing (form offers)': 'Партнёрки (форм-офферы)',
  'Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.':
    'Оффер можно лить на несколько партнёрок с весами (сплит/ротация). Неактивные пропускаются (напр. пока не договорился). Лид уходит по весу; при отказе — фолбэк на следующую.',
  'Telegram lead alerts': 'Telegram о лидах',
  '(sent on EVERY submit — even test/error)': '(шлётся на КАЖДЫЙ сабмит — даже тест/ошибка)',
  // Leads
  'Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.':
    'Сюда попадает каждый лид с форм-офферов — принятый, отклонённый и тестовый. Фильтруй, выгружай в CSV и перепродавай. Статусы обновляются постбэками и Pull-синхронизацией.',
  // Misc components
  'Hint': 'Подсказка',
  'Cycle language': 'Переключить язык',
  'Switch to {lang}': 'Переключить на {lang}',
  'Current language: {lang}': 'Текущий язык: {lang}',
  'Scroll to top': 'Наверх',
  'Something went wrong': 'Что-то пошло не так',
  'An unexpected error occurred.': 'Произошла непредвиденная ошибка.',
  'Reload page': 'Перезагрузить страницу',
  // Placeholder examples (only those where a localized example makes sense;
  // value-like lists such as country codes / city / device names stay English
  // because the filters match English data values)
  'My first campaign': 'Моя первая кампания',
  'CPA Network': 'CPA-сеть',
  'Main FB pixel': 'Основной пиксель FB',
  'zapier integration': 'интеграция с zapier',
  'Bot token': 'Токен бота',
  'Chat ID': 'ID чата',
  // --- Coverage fill (auto-added): remaining UI strings ---
  '(no match)': '(нет совпадений)',
  '+ Upload': '+ Загрузить',
  'A custom conversion type with its own reporting rules and status transitions.': 'Пользовательский тип конверсии с собственными правилами отчётности и переходами статусов.',
  'A formula over base metrics rendered as a report column.': 'Формула над базовыми метриками, отображаемая как столбец отчёта.',
  'A/B testing': 'A/B-тестирование',
  'Add a manual cost, or connect an ad account to sync spend automatically.': 'Добавьте расход вручную или подключите рекламный аккаунт, чтобы синхронизировать расходы автоматически.',
  'Add cost': 'Добавить расход',
  'Add from preset': 'Добавить из пресета',
  'Add manual cost': 'Добавить расход вручную',
  'Add partner route': 'Добавить партнёрский маршрут',
  'Add range': 'Добавить диапазон',
  'Add value': 'Добавить значение',
  'Added to blacklist': 'Добавлено в чёрный список',
  'Added to whitelist': 'Добавлено в белый список',
  'Adjust the period or campaign filter.': 'Измените период или фильтр по кампаниям.',
  'Affiliate CRM — push leads via API': 'Партнёрская CRM — отправка лидов через API',
  'Affiliate network postback': 'Постбэк партнёрской сети',
  'All offers': 'Все офферы',
  'All rows': 'Все строки',
  'Allowed next statuses': 'Допустимые следующие статусы',
  'Amount': 'Сумма',
  'Any date': 'Любая дата',
  'Any status': 'Любой статус',
  'Arithmetic over base metrics. Supported: + - * / ( ) and numbers.': 'Арифметика над базовыми метриками. Поддерживаются: + - * / ( ) и числа.',
  'Back to streams': 'Назад к потокам',
  'Base metrics': 'Базовые метрики',
  'Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.': 'Привяжите собственный домен, чтобы маскировать трекинговые ссылки. Направьте A-запись на ваш трекинг-сервер и подтвердите владение доменом через TXT-запись.',
  'Black': 'Чёрный',
  'Black / white lists': 'Чёрные / белые списки',
  'Blacklist': 'Чёрный список',
  'Blacklisted': 'В чёрном списке',
  'Blank referrer (JS)': 'Пустой реферер (JS)',
  'Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.': 'Зафиксируйте расход по кампании. Он включается в расход кампании, используемый в ROI и на дашбордах.',
  'Bot': 'Бот',
  'Bot IP addresses': 'IP-адреса ботов',
  'Bot User-Agent signatures': 'Сигнатуры User-Agent ботов',
  'Bot lists': 'Списки ботов',
  'Bot lists saved': 'Списки ботов сохранены',
  'Breakdown': 'Разбивка',
  'Bucket': 'Бакет',
  'Built-in statuses': 'Встроенные статусы',
  'By destination': 'По назначению',
  'By stream': 'По потоку',
  'CPS (per sale)': 'CPS (за продажу)',
  'CPuC (per unique click)': 'CPuC (за уникальный клик)',
  'CRM': 'CRM',
  'CRM response': 'Ответ CRM',
  'Cadence': 'Периодичность',
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": 'Календарные даты, когда поток активен (часовой пояс владельца). Оставьте начало или конец пустым для открытой границы. «Не является» инвертирует диапазон.',
  'California, Bavaria, Moscow Oblast': 'Калифорния, Бавария, Московская область',
  'Canonical status stored on each conversion. Auto-generated from the name if left blank.': 'Канонический статус, сохраняемый у каждой конверсии. Автоматически генерируется из названия, если поле оставить пустым.',
  'Click API (server-to-server)': 'Click API (сервер-сервер)',
  'Code (slug)': 'Код (slug)',
  'Column key in reports. Auto-generated from the name if left blank.': 'Ключ столбца в отчётах. Автоматически генерируется из названия, если поле оставить пустым.',
  'Comma-separated email addresses.': 'Email-адреса через запятую.',
  'Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).': 'Компенсирует расход за трафик, потерянный между источником и трекером: реальный расход = базовый / (1 − потери%/100).',
  'Configure any partner CRM lead API': 'Настройте API лидов любой партнёрской CRM',
  'Conversion date': 'Дата конверсии',
  'Conversion statuses': 'Статусы конверсий',
  'Conversion type created': 'Тип конверсии создан',
  'Conversion type deleted': 'Тип конверсии удалён',
  'Conversion type updated': 'Тип конверсии обновлён',
  'Conversion types': 'Типы конверсий',
  'Cookie (default)': 'Cookie (по умолчанию)',
  'Copy blacklist': 'Копировать чёрный список',
  'Copy list': 'Копировать список',
  'Copy whitelist': 'Копировать белый список',
  'Cost entries': 'Записи расходов',
  'Cost entry added': 'Запись расхода добавлена',
  'Cost entry deleted': 'Запись расхода удалена',
  'Count conversions of this type toward the offer daily cap.': 'Учитывать конверсии этого типа в дневном капе оффера.',
  'Counts against offer cap': 'Учитывается в капе оффера',
  'Counts in conversions': 'Учитывается в конверсиях',
  'Counts in revenue': 'Учитывается в доходе',
  'Counts vs cap': 'Учёт в капе',
  'Create conversion type': 'Создать тип конверсии',
  'Create custom metric': 'Создать пользовательскую метрику',
  'Create metric': 'Создать метрику',
  'Create one like uCR = conversions / unique_clicks * 100.': 'Создайте метрику вида uCR = conversions / unique_clicks * 100.',
  'Create one to export campaign performance on demand.': 'Создайте отчёт, чтобы экспортировать статистику кампаний по запросу.',
  'Create one to map partner statuses like FTD or second deposit.': 'Создайте тип, чтобы сопоставлять статусы партнёра, такие как FTD или второй депозит.',
  'Create one to receive recurring reports by email.': 'Создайте расписание, чтобы получать регулярные отчёты по email.',
  'Create type': 'Создать тип',
  'Custom bot IPs/CIDRs and UA signatures for the bot-detection filter': 'Собственные IP/CIDR ботов и сигнатуры UA для фильтра обнаружения ботов',
  'Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.': 'Собственные IP/CIDR ботов и сигнатуры User-Agent, используемые антифрод-фильтром обнаружения ботов.',
  'Custom conversion types: map network statuses, reporting flags and transition rules': 'Пользовательские типы конверсий: сопоставление статусов сетей, флаги отчётности и правила переходов',
  'Custom metric created': 'Пользовательская метрика создана',
  'Custom metric deleted': 'Пользовательская метрика удалена',
  'Custom metric updated': 'Пользовательская метрика обновлена',
  'Custom metrics': 'Пользовательские метрики',
  'DSAR erasure completed': 'Стирание данных по DSAR завершено',
  'DSAR export ready': 'Экспорт данных по DSAR готов',
  'Daily': 'Ежедневно',
  'Data subject': 'Субъект данных',
  'Data-subject access (Article 15) and erasure (Article 17) by identifier.': 'Доступ субъекта данных (статья 15) и стирание (статья 17) по идентификатору.',
  'Data-subject export (Art. 15) and erasure (Art. 17) by identifier': 'Экспорт данных субъекта (ст. 15) и стирание (ст. 17) по идентификатору',
  'Date': 'Дата',
  'Date range': 'Диапазон дат',
  'Day': 'День',
  'Day of month (1-31)': 'День месяца (1-31)',
  'Day of week': 'День недели',
  'Decimals': 'Десятичные знаки',
  'Define a reusable report and its grouping/metrics.': 'Определите переиспользуемый отчёт, его группировку и метрики.',
  'Define custom conversion types, map network statuses and control reporting semantics.': 'Определяйте пользовательские типы конверсий, сопоставляйте статусы сетей и управляйте семантикой отчётности.',
  'Define formula-based report columns over base metrics (CR, EPC, ROI variants).': 'Определяйте формульные столбцы отчётов на основе базовых метрик (варианты CR, EPC, ROI).',
  'Delete conversion type': 'Удалить тип конверсии',
  'Delete cost entry': 'Удалить запись расхода',
  'Delete custom metric': 'Удалить пользовательскую метрику',
  'Delete file': 'Удалить файл',
  'Delete report': 'Удалить отчёт',
  'Delete schedule': 'Удалить расписание',
  'Delete this file?': 'Удалить этот файл?',
  'Desktop, Mobile, Tablet': 'Desktop, Mobile, Tablet',
  'Destination': 'Назначение',
  'Distribution': 'Распределение',
  'Double meta (hide referrer)': 'Двойной meta (скрыть реферер)',
  'Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.': 'Пропустите тестовые клики через эту кампанию, чтобы проверить логику потоков и фильтры — реальный трафик не записывается.',
  'EPC (sensitive)': 'EPC (чувствительная метрика)',
  'Edge server updated': 'Edge-сервер обновлён',
  'Edit conversion type': 'Редактировать тип конверсии',
  'Edit custom metric': 'Редактировать пользовательскую метрику',
  'Enter a valid amount': 'Введите корректную сумму',
  'Enter at least one identifier': 'Введите хотя бы один идентификатор',
  'Enter bot token and chat id': 'Введите токен бота и chat id',
  'Enter the text to find': 'Введите текст для поиска',
  'Equalize weights': 'Выровнять веса',
  'Erase': 'Стереть',
  'Erase data': 'Стереть данные',
  'Erase subject data?': 'Стереть данные субъекта?',
  'Erased': 'Стёрто',
  'Erasure is a hard delete and cannot be undone. It requires an admin role.': 'Стирание — это безвозвратное удаление, его нельзя отменить. Требуется роль администратора.',
  'Error creating conversion type': 'Ошибка создания типа конверсии',
  'Error creating cost entry': 'Ошибка создания записи расхода',
  'Error creating custom metric': 'Ошибка создания пользовательской метрики',
  'Error creating report': 'Ошибка создания отчёта',
  'Error creating schedule': 'Ошибка создания расписания',
  'Error deleting conversion type': 'Ошибка удаления типа конверсии',
  'Error deleting cost entry': 'Ошибка удаления записи расхода',
  'Error deleting custom metric': 'Ошибка удаления пользовательской метрики',
  'Error deleting file': 'Ошибка удаления файла',
  'Error deleting report': 'Ошибка удаления отчёта',
  'Error deleting schedule': 'Ошибка удаления расписания',
  'Error loading bot lists': 'Ошибка загрузки списков ботов',
  'Error loading conversion types': 'Ошибка загрузки типов конверсий',
  'Error loading cost entries': 'Ошибка загрузки записей расходов',
  'Error loading custom metrics': 'Ошибка загрузки пользовательских метрик',
  'Error loading reports': 'Ошибка загрузки отчётов',
  'Error loading scheduled reports': 'Ошибка загрузки отчётов по расписанию',
  'Error saving bot lists': 'Ошибка сохранения списков ботов',
  'Error updating conversion type': 'Ошибка обновления типа конверсии',
  'Error updating custom metric': 'Ошибка обновления пользовательской метрики',
  'Error uploading file': 'Ошибка загрузки файла',
  'Every submitted lead is stored here: filter, export (CSV) and resell': 'Каждый отправленный лид сохраняется здесь: фильтруйте, экспортируйте (CSV) и перепродавайте',
  'Export data': 'Экспорт данных',
  'Export flows': 'Экспорт потоков',
  'Exported': 'Экспортировано',
  'Failed to clone stream': 'Не удалось клонировать поток',
  'Failed to equalize weights': 'Не удалось выровнять веса',
  'Failed to erase DSAR': 'Не удалось стереть данные по DSAR',
  'Failed to export DSAR': 'Не удалось экспортировать данные по DSAR',
  'Failed to export flows': 'Не удалось экспортировать потоки',
  'Failed to export list': 'Не удалось экспортировать список',
  'Failed to export report': 'Не удалось экспортировать отчёт',
  'Failed to import flows': 'Не удалось импортировать потоки',
  'Failed to insert flow': 'Не удалось вставить поток',
  'Failed to load leads': 'Не удалось загрузить лиды',
  'Failed to remove': 'Не удалось удалить',
  'Failed to replace URLs': 'Не удалось заменить URL',
  'Failed to run report': 'Не удалось сформировать отчёт',
  'Failed to update': 'Не удалось обновить',
  'Failed to update list': 'Не удалось обновить список',
  'Failed to update schedule': 'Не удалось обновить расписание',
  'Favourite': 'Избранный',
  'Favourite flows': 'Избранные потоки',
  'Favourites': 'Избранное',
  'Fetched': 'Получено',
  'File deleted': 'Файл удалён',
  'File uploaded': 'Файл загружен',
  'Filter rule': 'Правило фильтра',
  'Find': 'Найти',
  'Find and replace a substring in flow redirect URLs (never landing/offer URLs).': 'Найти и заменить подстроку в URL редиректов потоков (но не в URL лендингов/офферов).',
  'Fire on statuses': 'Срабатывать при статусах',
  'First 25 simulated clicks and how each was routed.': 'Первые 25 симулированных кликов и то, как был направлен каждый из них.',
  'Flag clicks that arrive with no User-Agent header.': 'Помечать клики, приходящие без заголовка User-Agent.',
  'Flow tools': 'Инструменты потоков',
  'Form submit (POST)': 'Отправка формы (POST)',
  'Format': 'Формат',
  'Formula': 'Формула',
  'Formula is required': 'Формула обязательна',
  'Formula-based report columns over base metrics (CR, EPC, ROI variants)': 'Формульные столбцы отчётов на основе базовых метрик (варианты CR, EPC, ROI)',
  'Friday': 'Пятница',
  'From': 'От',
  'GDPR / DSAR': 'GDPR / DSAR',
  'Group by': 'Группировать по',
  'Has label': 'Есть метка',
  'Headless click registration and the JS adapter for landing pages.': 'Серверная (headless) регистрация кликов и JS-адаптер для лендингов.',
  'Hour': 'Час',
  'Hour (0-23)': 'Час (0-23)',
  'How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.': 'Как идентифицируются вернувшиеся посетители для определения уникальных кликов: Cookie (по умолчанию), IP, IP+UA или Параметр — идентификация по GET-параметру (например, external_id), чтобы один и тот же пользователь распознавался при смене IP/cookie.',
  'IP + User-Agent': 'IP + User-Agent',
  'IP of your tracking server': 'IP вашего трекинг-сервера',
  'IPs': 'IP-адреса',
  'ISP / carrier': 'Провайдер / оператор',
  'Import flows': 'Импорт потоков',
  'Imported': 'Импортировано',
  'In conversions': 'В конверсиях',
  'In revenue': 'В доходе',
  'Include this type in the conversions column.': 'Учитывать этот тип в колонке конверсий.',
  'Include this type in the revenue column.': 'Учитывать этот тип в колонке дохода.',
  'Insert': 'Вставить',
  'Integration': 'Интеграция',
  'JS adapter snippet': 'Сниппет JS-адаптера',
  'Key (e.g. price)': 'Ключ (например, price)',
  'Key metrics over time buckets. Toggle to attribute conversions to their arrival date.': 'Ключевые метрики по временным интервалам. Включите переключатель, чтобы относить конверсии к дате их поступления.',
  'Keys': 'Ключи',
  'Label color': 'Цвет метки',
  'Last run': 'Последний запуск',
  'Lead export failed': 'Не удалось экспортировать лиды',
  'Lead storage': 'Хранилище лидов',
  'Leads': 'Лиды',
  'Leads exported': 'Лиды экспортированы',
  'Leave empty to count every conversion.': 'Оставьте пустым, чтобы учитывать каждую конверсию.',
  'Leave the period blank to record spend as of now.': 'Оставьте период пустым, чтобы записать расход на текущий момент.',
  'Lists': 'Списки',
  'Manager': 'Менеджер',
  'Manual': 'Вручную',
  'Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.': 'Вручную записывайте расход кампании, который не видит синхронизация с рекламным аккаунтом: фиксированные платежи, офлайн-медиа, корректировки.',
  'Manually record campaign spend — flat fees, offline media, corrections': 'Ручной учёт расхода кампании — фиксированные платежи, офлайн-медиа, корректировки',
  'Marked values are reusable as report filters and copyable for ad networks.': 'Отмеченные значения можно повторно использовать как фильтры отчётов и копировать для рекламных сетей.',
  'Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.': 'Проверка заголовка X-Requested-With для определения webview / встроенных браузеров приложений. Совпадение по подстроке — например, com.android охватывает Android-webview, а @empty — клики без заголовка.',
  'Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.': 'Сопоставление поисковой системы, определённой по параметрам se / se_referrer или хосту реферера, — например, google, bing, yandex.',
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": 'Сопоставление названия организации ISP / ASN посетителя (из офлайн-таблицы IP-данных). Поддерживаются маски, /regex/ и @empty — например, AMAZON*, *Comcast*.',
  'Matched': 'Сопоставлено',
  'Metrics': 'Метрики',
  'Metrics over time buckets (hour/day/weekday/month) + conversion-date view': 'Метрики по временным интервалам (час/день/день недели/месяц) + режим по дате конверсии',
  'Monday': 'Понедельник',
  'Monthly': 'Ежемесячно',
  'Moscow, New York': 'Москва, Нью-Йорк',
  'Moscow, New York, London': 'Москва, Нью-Йорк, Лондон',
  'Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.': 'Именованные пары ключ/значение, подставляемые в URL лендинга/оффера/постбэка через макрос {offer_value:NAME}.',
  'Network preset…': 'Пресет сети…',
  'Network status values': 'Значения статусов сети',
  'New report': 'Новый отчёт',
  'New saved report': 'Новый сохранённый отчёт',
  'New schedule': 'Новое расписание',
  'New scheduled report': 'Новый отчёт по расписанию',
  'No cost entries yet': 'Записей о расходах пока нет',
  'No custom conversion types yet': 'Пользовательских типов конверсий пока нет',
  'No custom metrics yet': 'Пользовательских метрик пока нет',
  'No data for this period': 'Нет данных за этот период',
  'No favourite flows yet. Star a flow to reuse it here.': 'Избранных потоков пока нет. Отметьте поток звёздочкой, чтобы переиспользовать его здесь.',
  'No label': 'Без метки',
  'No leads yet': 'Лидов пока нет',
  'No list entries yet. Use the thumbs buttons on report rows.': 'Записей в списках пока нет. Используйте кнопки «палец вверх/вниз» в строках отчёта.',
  'No match': 'Нет совпадения',
  'No offer values. Add a key like price, then use {offer_value:price} in URLs.': 'Нет значений оффера. Добавьте ключ, например price, затем используйте {offer_value:price} в URL.',
  'No partner routes — this is a plain redirect/upload offer.': 'Партнёрских маршрутов нет — это обычный оффер с редиректом/загрузкой.',
  'No recipients set': 'Получатели не заданы',
  'No saved reports yet': 'Сохранённых отчётов пока нет',
  'No scheduled reports yet': 'Отчётов по расписанию пока нет',
  'No status values added': 'Значения статусов не добавлены',
  'Not accepted': 'Не принят',
  'Note': 'Примечание',
  'Offer': 'Оффер',
  'Offer values': 'Значения оффера',
  'One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).': 'По одному точному IP или CIDR-блоку в строке (например, 203.0.113.7 или 10.0.0.0/8).',
  'One per line: substring, mask (*) or /regex/.': 'По одному в строке: подстрока, маска (*) или /regex/.',
  'One value per line (or comma-separated). Each simulated query samples one value from each list.': 'По одному значению в строке (или через запятую). Каждый симулируемый запрос берёт по одному значению из каждого списка.',
  'Only these conversion statuses are sent to the ad platform. Default: sale.': 'На рекламную платформу отправляются только эти статусы конверсий. По умолчанию: sale.',
  'Open Domains': 'Открыть «Домены»',
  'Overrides': 'Переопределения',
  'Owner': 'Владелец',
  'POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.': 'POST /v1/click с API-ключом (скоуп write). Возвращает решение о маршрутизации без браузерного редиректа.',
  'Parameter name, e.g. external_id': 'Имя параметра, например external_id',
  'Parameters': 'Параметры',
  'Paste on a landing page to auto-append the click id and forward the visitor.': 'Вставьте на лендинг, чтобы автоматически подставлять ID клика и перенаправлять посетителя.',
  'Per-query trace': 'Трассировка по запросам',
  'Period': 'Период',
  'Period end': 'Конец периода',
  'Period start': 'Начало периода',
  'Phone': 'Телефон',
  'Pick a report, cadence and recipients.': 'Выберите отчёт, периодичность и получателей.',
  'Postback added from preset': 'Постбэк добавлен из пресета',
  'Postback macro': 'Макрос постбэка',
  'Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.': 'Укажите хотя бы один идентификатор. Будут затронуты совпадающие клики и конверсии во всех доступных вам воркспейсах.',
  'Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.': 'Забирает статусы лидов и депозиты из TrackBox (за последние 7 дней) и обновляет сохранённые лиды. Сначала укажите Pull x-api-key в настройках интеграции.',
  'Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.': 'Забирает статусы лидов из OpenAFF за число дней, указанное в интеграции, и обновляет сохранённые лиды. Сначала укажите в интеграции токен API статусов.',
  'Pull sync': 'Pull-синхронизация',
  'Pull sync (statuses/deposits)': 'Pull-синхронизация (статусы/депозиты)',
  'Pull sync done': 'Pull-синхронизация завершена',
  'Queries': 'Запросы',
  'ROI %': 'ROI %',
  'ROI (sensitive)': 'ROI (конфиденциально)',
  'Raw status strings partner networks send that should map to this type (case-insensitive).': 'Сырые строки статусов, которые присылают партнёрские сети и которые должны сопоставляться с этим типом (без учёта регистра).',
  'Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.': 'Сырые статусы, которые считать TRASH (записываются, но исключаются из выплат). Например, trash, invalid.',
  'Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.': 'Сырые статусы, которые считать DEPOSIT (полноценный тип конверсии). Например, dep, ftd, deposit.',
  'Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.': 'Сырые статусы, которые считать REGISTRATION (полноценный тип конверсии). Например, reg, signup.',
  'Read-only — only the workspace owner can edit the matrix': 'Только чтение — редактировать матрицу может только владелец воркспейса',
  'Recipients': 'Получатели',
  'Recurring reports emailed on a daily/weekly/monthly cadence': 'Регулярные отчёты на почту ежедневно, еженедельно или ежемесячно',
  'Recurring reports emailed to recipients on a daily/weekly/monthly cadence.': 'Регулярные отчёты, отправляемые получателям на почту ежедневно, еженедельно или ежемесячно.',
  'Removed': 'Удалено',
  'Replace': 'Заменить',
  'Replace URL': 'Заменить URL',
  'Replace with': 'Заменить на',
  'Report deleted': 'Отчёт удалён',
  'Report queued': 'Отчёт поставлен в очередь',
  'Report saved': 'Отчёт сохранён',
  'Report type': 'Тип отчёта',
  'Request': 'Запрос',
  'Response sample': 'Пример ответа',
  'Reusable partner networks: postback, offer params, inbound URL': 'Переиспользуемые партнёрские сети: постбэк, параметры оффера, входящий URL',
  'Reusable report definitions you can export to CSV or XLSX on demand.': 'Переиспользуемые шаблоны отчётов, которые можно экспортировать в CSV или XLSX по требованию.',
  'Reusable report definitions, exportable to CSV/XLSX on demand': 'Переиспользуемые шаблоны отчётов с экспортом в CSV/XLSX по требованию',
  'RevShare (% of payout)': 'RevShare (% от выплаты)',
  'Revenue (sensitive)': 'Доход (конфиденциально)',
  'Routing record (A record)': 'Запись маршрутизации (A-запись)',
  'Run now': 'Запустить сейчас',
  'Run pull sync': 'Запустить pull-синхронизацию',
  'Run simulation': 'Запустить симуляцию',
  'Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.': 'Запускает скользящую синхронизацию за последние 7 дней. Используйте, чтобы проверить ответ перед включением автоматической pull-синхронизации.',
  'Sample datasets': 'Примеры наборов данных',
  'Saturday': 'Суббота',
  'Saved reports': 'Сохранённые отчёты',
  'Schedule created': 'Расписание создано',
  'Schedule deleted': 'Расписание удалено',
  'Scheduled reports': 'Отчёты по расписанию',
  'Search conversion types': 'Поиск типов конверсий',
  'Search custom metrics': 'Поиск пользовательских метрик',
  'Search engines': 'Поисковые системы',
  'Search presets': 'Поиск пресетов',
  'Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.': 'Отправьте синтетический лид в CRM и проверьте ответ. Если не переопределить значения ниже, будут использованы одноразовые email/телефон.',
  'Send test lead': 'Отправить тестовый лид',
  'Set another entry page first': 'Сначала назначьте другую входную страницу',
  'Show shortcuts': 'Показать горячие клавиши',
  'Simulate': 'Симулировать',
  'Simulating…': 'Симуляция…',
  'Simulation failed': 'Симуляция не удалась',
  'Source': 'Источник',
  'Starred flows from any campaign. Insert a copy into this campaign.': 'Избранные потоки из любых кампаний. Вставьте копию в эту кампанию.',
  'Stored form leads: name/email/phone/geo/status, filter + CSV export for resale': 'Сохранённые лиды из форм: имя/email/телефон/гео/статус, фильтрация + экспорт в CSV для перепродажи',
  'Stream cloned': 'Поток клонирован',
  'Streams changed': 'Потоки изменены',
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": 'Потоки определяют, на какой оффер попадёт каждый посетитель. Настройте поток по умолчанию — и у вас будет рабочая трекинг-ссылка.',
  'Submitted leads from your offer forms will appear here.': 'Здесь появятся лиды, отправленные через формы ваших офферов.',
  'Sunday': 'Воскресенье',
  'Synced': 'Синхронизировано',
  'Telegram postbacks added — press Save to apply': 'Постбэки Telegram добавлены — нажмите «Сохранить», чтобы применить',
  'Google Ads postbacks added — press Save to apply': 'Постбэки Google Ads добавлены — нажмите «Сохранить», чтобы применить',
  'Google Ads preset applied — press Save to apply': 'Пресет Google Ads применён — нажмите «Сохранить», чтобы применить',
  'Also add the standard Google Ads parameters (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) as defaults': 'Также добавить стандартные параметры Google Ads (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) как значения по умолчанию',
  'Google Ads postbacks added + click-time gtag turned off — press Save to apply': 'Постбэки Google Ads добавлены + клик-тайм gtag выключен — нажмите «Сохранить», чтобы применить',
  'Adding these also turns OFF the click-time gtag (fire on redirect) for this campaign, so the same Google conversion is not counted twice.': 'Это также ВЫКЛЮЧАЕТ клик-тайм gtag (fire on redirect) для этой кампании, чтобы одна и та же конверсия Google не считалась дважды.',
  'Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use "Import from source" to add them to a campaign.': 'Параметры (campaignid, adgroupid, keyword, tm, tml, sub1–3) задаются один раз в источнике трафика Google Ads — используйте «Импорт из источника», чтобы добавить их в кампанию.',
  'Google Ads conversions': 'Конверсии Google Ads',
  'Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.': 'Только исходящая пересылка: эти HTTP-запросы уведомляют другую систему после записи конверсии в XPNSR. Пресеты партнёрских сетей и входящие URL настраиваются на странице «Партнёрские сети» и вставляются в кабинет партнёра — это не правила пересылки.',
  'Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.': 'Настройка входящих событий партнёра: параметры передачи click ID в оффер, маппинг статусов и postback URL для кабинета партнёра. Этот раздел не отправляет лиды в CRM и не является S2S-пересылкой кампании.',
  'Inbound postback URL template': 'Шаблон входящего postback URL',
  'Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.': 'Входящий URL, который вызывает партнёрская сеть при отправке статуса lead, sale, reject или другого события. Скопируйте его в кабинет партнёра; XPNSR не вызывает этот URL как исходящий postback кампании.',
  'Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.': 'Выберите пресет входящего postback или настройте контракт партнёра вручную. Для отправки формы в CRM создайте «Интеграцию» и привяжите её к офферу.',
  'Google Ads deposit postback added + click-time gtag kept off — press Save to apply': 'Постбэк депозита Google Ads добавлен, клик-тайм gtag оставлен выключенным — нажмите «Сохранить», чтобы применить',
  'Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.': 'Устаревшая конверсия по клику: срабатывает на /r/ до регистрации или депозита. Держите её выключенной для оптимизации по лидам и депозитам. Реальные лиды отправляются автоматически с размещённых лендингов после успешного ответа /api/lead.',
  'Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.': 'Держите этот параметр ВЫКЛЮЧЕННЫМ для оптимизации по реальным конверсиям. Лиды отправляются онлайн с размещённого лендинга только после успешного /api/lead; депозиты можно пересылать ниже по S2S после postback sale от брокера. Включение заставит Google оптимизироваться по кликам и может задвоить конверсии.',
  'Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.': 'Добавляет только S2S-постбэк депозита/Purchase. Он срабатывает на postback sale от брокера и сопоставляет клик Google по {gclid}. ID аккаунта и метка депозита берутся из per-click тега {tm} (AW-<account>/<deposit-label>) в Final URL suffix объявления.',
  'Deposit → Purchase (with payout value) — fires on sale': 'Депозит → Purchase (с суммой выплаты) — срабатывает на sale',
  'Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.': 'S2S для лида намеренно не добавляется: размещённый лендинг уже отправляет конверсию Lead онлайн через client-side gtag после принятия /api/lead системой CRM. Добавление S2S-правила для лида создаст риск двойного учёта одного лида.',
  'For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep "Fire Google Ads gtag on redirect" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.': 'Для онлайн-лидов передавайте tml=AW-<account>/<lead-label> в Final URL suffix каждого рекламного аккаунта. Держите «Отправлять Google Ads gtag при редиректе» ВЫКЛЮЧЕННЫМ: трекер инжектит отдельный lead gtag в размещённые лендинги и запускает его только после успешной отправки лида. Назначьте Lead основной (Primary) при оптимизации по лидам; Purchase держите дополнительной (Secondary), пока отправка депозитов не проверена, затем настройте цели под свою стратегию ставок.',
  'Sends the Google Ads conversion server-side on the broker postback, matched by {gclid} — no gtag on the landing and no API. Account id and label are read from the {tm} tag (AW-<account>/<label>) you already put in the ad Final URL suffix.': 'Отправляет конверсию Google Ads серверно по постбэку брокера, сопоставляя по {gclid} — без gtag на лендинге и без API. Идентификатор аккаунта и метка берутся из тега {tm} (AW-<account>/<label>), который вы и так вставляете в Final URL suffix объявления.',
  'Deposit → Purchase (primary, with value) — fires on sale': 'Депозит → Purchase (основная, с суммой) — срабатывает на sale',
  'Registration → Lead (secondary) — fires on lead': 'Регистрация → Lead (вторичная) — срабатывает на lead',
  'For the Lead tag add its label to the ad Final URL suffix as tml=<label> (same AW account). If tml is empty the Lead beacon is skipped automatically. Keep Lead as Secondary in Google so optimization stays on deposits.': 'Для лид-метки добавьте её label в Final URL suffix объявления как tml=<label> (тот же AW-аккаунт). Если tml пуст, лид-бикон пропускается автоматически. Держите Lead вторичной (Secondary) в Google, чтобы оптимизация оставалась на депозитах.',
  'Test integration': 'Проверить интеграцию',
  'Test lead accepted': 'Тестовый лид принят',
  'Test lead not accepted': 'Тестовый лид не принят',
  'This permanently deletes all matching clicks and conversions. This cannot be undone.': 'Все совпадающие клики и конверсии будут безвозвратно удалены. Это действие нельзя отменить.',
  'This permanently deletes the conversion type. Existing conversions keep their stored status.': 'Тип конверсии будет безвозвратно удалён. Существующие конверсии сохранят записанный статус.',
  'This permanently deletes the metric column from reports.': 'Колонка метрики будет безвозвратно удалена из отчётов.',
  'This permanently deletes the saved report definition.': 'Сохранённый шаблон отчёта будет безвозвратно удалён.',
  'This permanently deletes the scheduled report.': 'Отчёт по расписанию будет безвозвратно удалён.',
  'This removes the manual cost and reverses its contribution to the campaign spend.': 'Ручной расход будет удалён, а его вклад в расход кампании — отменён.',
  'Thursday': 'Четверг',
  'To': 'По',
  'Total leads': 'Всего лидов',
  'Tracking domains are managed on the Domains page — add and verify a custom domain there.': 'Трекинг-домены управляются на странице «Домены» — добавьте и подтвердите там собственный домен.',
  'Traffic Simulation': 'Симуляция трафика',
  'Traffic loss %': 'Потери трафика, %',
  'Traffic trends': 'Тренды трафика',
  'Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.': 'Правила переходов: в какие статусы может переходить конверсия этого типа. Оставьте все флажки снятыми, чтобы разрешить любые переходы.',
  'Treat empty User-Agent as bot': 'Считать пустой User-Agent ботом',
  'Trends': 'Тренды',
  'Tuesday': 'Вторник',
  'US, CA, GB': 'US, CA, GB',
  'US, CA, GB, RU': 'US, CA, GB, RU',
  'US, GB, DE': 'US, GB, DE',
  'US,RU,DE': 'US,RU,DE',
  'Uniqueness method': 'Метод определения уникальности',
  'Update reporting semantics and status transitions.': 'Обновите семантику отчётности и переходы статусов.',
  'Update the formula, format or decimals.': 'Обновите формулу, формат или количество знаков после запятой.',
  'Use a negative amount to book a correction.': 'Используйте отрицательную сумму, чтобы записать корректировку.',
  'Viewer': 'Наблюдатель',
  'Visitor ID': 'ID посетителя',
  'Wednesday': 'Среда',
  'Weekly': 'Еженедельно',
  'Weights equalized': 'Веса выровнены',
  'White': 'Белый',
  'Whitelist': 'Белый список',
  'Whitelisted': 'В белом списке',
  'X-Requested-With': 'X-Requested-With',
  'analyst': 'аналитик',
  'box/goal id': 'ID бокса/цели',
  'buy, cheap, discount': 'купить, дёшево, скидка',
  'cpa, nutra, en': 'cpa, nutra, en',
  'day': 'день',
  'days': 'дней',
  'e.g. Q3 influencer flat fee': 'например, фиксированная оплата инфлюенсера за Q3',
  'e.g. Second deposit': 'например, Второй депозит',
  'e.g. Unique CR': 'например, Уникальный CR',
  'e.g. Weekly digest': 'например, Еженедельный дайджест',
  'e.g. Weekly performance': 'например, Еженедельные показатели',
  'email / phone / name': 'email / телефон / имя',
  'free, demo': 'бесплатно, демо',
  'redirect': 'редирект',
  'statuses on schedule': 'статусы по расписанию',
  // A11y icon-button labels
  'Remove variant': 'Удалить вариант',
  'Start test': 'Запустить тест',
  'Pause test': 'Приостановить тест',
  'View test results': 'Посмотреть результаты теста',
  'Remove parameter': 'Удалить параметр',
  'Remove status mapping': 'Удалить маппинг статуса',
  'Copy postback URL template': 'Скопировать шаблон postback-URL',
  'Copy inbound postback URL': 'Скопировать входящий postback-URL',
  'Remove IP from blacklist': 'Удалить IP из чёрного списка',
  'Remove IP from whitelist': 'Удалить IP из белого списка',
  'Copy curl command': 'Скопировать команду curl',
  'Copy JS snippet': 'Скопировать JS-сниппет',
  'Copy snippet': 'Скопировать сниппет',
  'Remove postback': 'Удалить постбэк',
  'Campaign actions': 'Действия с кампанией',
  'Remove vendor': 'Удалить вендора',
  'Remove campaign': 'Убрать кампанию',
  'Remove value': 'Удалить значение',
  'Remove field': 'Удалить поле',
  'Copy webhook URL': 'Скопировать URL вебхука',
  'Copy landing page URL': 'Скопировать URL лендинга',
  'Open landing page': 'Открыть лендинг',
  'Remove partner route': 'Удалить партнёрский маршрут',
  'Copy lead-form URL': 'Скопировать URL лид-формы',
  'Copy offer URL': 'Скопировать URL оффера',
  'Delete list entry': 'Удалить запись списка',
  'Copy secret': 'Скопировать секрет',
  'Remove time range': 'Удалить диапазон времени',
  'Remove date range': 'Удалить диапазон дат',
  'Pause stream': 'Приостановить поток',
  'Resume stream': 'Возобновить поток',
  'Open redirect URL': 'Открыть URL редиректа',
  'Open offer URL': 'Открыть URL оффера',
  'Copy postback URL': 'Скопировать postback-URL',
  'Delete rule': 'Удалить правило',
  'Delete filter': 'Удалить фильтр',
  // i18n backfill: pre-existing untranslated keys in screens touched by the a11y pass
  'Delete traffic rule': 'Удалить правило трафика',
  'This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.': 'Правило трафика будет удалено навсегда. Трафик пойдёт по оставшимся правилам или в дефолт кампании.',
  'Delete fraud filter': 'Удалить антифрод-фильтр',
  'This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.': 'Антифрод-фильтр будет удалён навсегда. Трафик, который он сейчас блокирует или оценивает, больше не будет проверяться этим правилом.',
  'Action (no page — hand off to the offer)': 'Action (без страницы — сразу передать офферу)',
  'After click (at redirect)': 'После клика (при редиректе)',
  'Before click (at landing — enables offer macros)': 'До клика (на лендинге — включает макросы оффера)',
  'Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.': 'Мобильный оператор из заголовка X-Carrier от edge-прокси. Маски, /regex/ и @empty поддерживаются — напр. Vodafone*, /^T-Mobile/.',
  'Mobile operator / carrier': 'Мобильный оператор',
  'Offer selection moment': 'Момент выбора оффера',
  'Preload (serve the page from the tracker domain)': 'Preload (отдавать страницу с домена трекера)',
  'Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.': 'Preload загружает страницу на сервере и отдаёт её под вашим доменом трекера; Action ничего не показывает и позволяет потоку выбрать оффер.',
  'QR code': 'QR-код',
  'Redirect (send visitor to the URL)': 'Redirect (отправить посетителя на URL)',
  'Remote rotator (fetch target)': 'Удалённый ротатор (цель по запросу)',
  'Scan to open the tracking link on a device.': 'Отсканируйте, чтобы открыть трекинговую ссылку на устройстве.',
  'Transparent (server-side fetch)': 'Прозрачный (загрузка на стороне сервера)',
  'When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.': 'Когда выбирать оффер для этого потока. После (по умолчанию): в момент редиректа. До: при отдаче лендинга, чтобы макросы {offer_name} / {offer_value:*} отрисовались на лендинге.',
  'Added to favourites': 'Добавлено в избранное',
  'Credentials and settings for this partner. Fields marked * are required.': 'Учётные данные и настройки этого партнёра. Поля, отмеченные *, обязательны.',
  'Key created': 'Ключ создан',
  'Removed from favourites': 'Удалено из избранного',
  'Affiliate network archived': 'Партнёрская сеть архивирована',
  'Archive affiliate network': 'Архивировать партнёрскую сеть',
  'Archive landing page': 'Архивировать лендинг',
  'Archive offer': 'Архивировать оффер',
  'Archive stream': 'Архивировать поток',
  'Archive traffic source': 'Архивировать источник трафика',
  'Archived at': 'В архиве с',
  'Archived items are hidden from your lists. Restore them or delete them permanently.': 'Архивные элементы скрыты из списков. Восстановите их или удалите навсегда.',
  'Delete permanently': 'Удалить навсегда',
  'Deleted permanently': 'Удалено навсегда',
  'Error loading archive': 'Ошибка загрузки архива',
  'Error restoring': 'Ошибка восстановления',
  'Landing page archived': 'Лендинг архивирован',
  'No archived items': 'Архивных элементов нет',
  'Offer archived': 'Оффер архивирован',
  'Restored': 'Восстановлено',
  'Stream archived': 'Поток архивирован',
  'This will move "{name}" to the archive. You can restore it or delete it permanently from the Archive page.': 'Это переместит «{name}» в архив. Восстановить или удалить навсегда можно на странице «Архив».',
  'This will permanently delete "{name}". This action cannot be undone.': 'Это окончательно удалит «{name}». Действие нельзя отменить.',
  'Traffic source archived': 'Источник трафика архивирован',
  'View archived': 'Показать архивные',
  // Backfill: post-!99 UI-wiring components (SystemStatus / CampaignMaintenance / TlsFingerprints / S2SLogs, etc.)
  'Start date is required': 'Укажите дату начала',
  'Enter a valid cost': 'Введите корректную стоимость',
  'Updated {n} clicks': 'Обновлено {n} кликов',
  'Failed to update costs': 'Не удалось обновить стоимость',
  'Statistics deleted': 'Статистика удалена',
  'Failed to delete statistics': 'Не удалось удалить статистику',
  'Maintenance & costs': 'Обслуживание и стоимость',
  'Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.': 'Задним числом перезапишите стоимость кликов, сбросьте статистику или получите альтернативную трекинговую ссылку.',
  'Update costs': 'Обновить стоимость',
  'Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.': 'Задним числом (пере)запишите стоимость за клик для кликов в заданном диапазоне времени. Режим «Общая» распределяет сумму по совпавшим кликам; «За клик» применяет её к каждому.',
  'Start date': 'Дата начала',
  'End date': 'Дата окончания',
  'Total (spread across clicks)': 'Общая (распределить по кликам)',
  'Per click': 'За клик',
  'Only unique clicks': 'Только уникальные клики',
  'Skip bot clicks': 'Пропускать клики ботов',
  'Clean statistics': 'Очистить статистику',
  'Alternative link prefixes': 'Альтернативные префиксы ссылок',
  'Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.': 'Любой из этих префиксов пути ведёт на один и тот же tracking id — ротируйте их между источниками, чтобы обходить блок-листы.',
  'Delete statistics': 'Удалить статистику',
  'This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.': 'Все клики и конверсии этой кампании будут безвозвратно удалены. Настройки кампании сохранятся. Это действие нельзя отменить.',
  'Error loading S2S log': 'Ошибка загрузки S2S-лога',
  'S2S postback log': 'Лог S2S-постбэков',
  'Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.': 'Каждый исходящий постбэк конверсии, отправленный по вашим кампаниям — фильтруйте по кампании, статусу или результату.',
  'Any result': 'Любой результат',
  'Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.': 'Исходящие постбэки конверсий появятся здесь, как только ваши кампании начнут пересылать конверсии.',
  'Result': 'Результат',
  'HTTP': 'HTTP',
  'Error loading system status': 'Ошибка загрузки состояния системы',
  'Paste the Tor exit list first': 'Сначала вставьте список выходных узлов Tor',
  'Tor exit list updated': 'Список выходных узлов Tor обновлён',
  'Failed to update Tor exit list': 'Не удалось обновить список выходных узлов Tor',
  'Process uptime, database size, data-processing queue and host metrics.': 'Время работы процесса, размер базы данных, очередь обработки данных и метрики хоста.',
  'Process': 'Процесс',
  'Uptime': 'Время работы',
  'Started': 'Запущен',
  'Python': 'Python',
  'Platform': 'Платформа',
  'Database': 'База данных',
  'Total documents': 'Всего документов',
  'Data processing': 'Обработка данных',
  'Analytics backend': 'Бэкенд аналитики',
  'Ingest mode': 'Режим приёма',
  'Queue depth': 'Глубина очереди',
  'Click uniqueness': 'Уникальность кликов',
  'Redis ping': 'Пинг Redis',
  'Host': 'Хост',
  'Load average': 'Средняя нагрузка',
  'Disk used': 'Диск занят',
  'Disk free': 'Диск свободно',
  'Cron': 'Cron',
  'Last cost sync': 'Последняя синхронизация стоимости',
  'FX rates': 'Курсы валют',
  'No FX rates cached.': 'Курсы валют не закешированы.',
  'Tor exit list': 'Список выходных узлов Tor',
  'Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.': 'Вставьте дамп выходных узлов Tor, по одному в строке (напр. из torbulkexitlist), чтобы обновить блок-лист в памяти.',
  'Replace list': 'Заменить список',
  'Error loading fingerprints': 'Ошибка загрузки отпечатков',
  'Fingerprint updated': 'Отпечаток обновлён',
  'Failed to update fingerprint': 'Не удалось обновить отпечаток',
  'JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.': 'Переопределения отпечатков JA3 / JA4 — пометьте отпечаток как хороший или плохой, чтобы управлять детекцией ботов.',
  'All classifications': 'Все классификации',
  'All kinds': 'Все типы',
  'No fingerprint overrides yet': 'Переопределений отпечатков пока нет',
  'As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.': 'По мере поступления трафика отпечатки JA3/JA4 появляются здесь, чтобы вы могли отмечать заведомо хороших или плохих клиентов.',
  'Fingerprint': 'Отпечаток',
  'Kind': 'Тип',
  'Label': 'Метка',
  'Hits': 'Попадания',
  'Last seen': 'Последний раз',
  'Classification': 'Классификация',
  // Ops panel (monitoring & backups, operator console)
  'Telegram alerts': 'Telegram-оповещения',
  'Deploy + server-error notifications for the operator.':
    'Уведомления оператору о деплоях и ошибках сервера.',
  'Configured': 'Настроено',
  'Not configured': 'Не настроено',
  'Topic': 'Тема',
  'Topic ID (optional)': 'ID темы (необязательно)',
  'Leave the token empty to keep the saved one.':
    'Оставьте поле токена пустым, чтобы не менять сохранённый.',
  'Save & send test': 'Сохранить и отправить тест',
  'Test message delivered': 'Тестовое сообщение доставлено',
  'Send failed': 'Отправка не удалась',
  'Chat ID is required': 'Нужно указать ID чата',
  'Nightly DB backups': 'Ночные бэкапы базы',
  'A full copy of the database every night, kept on the persistent volume.':
    'Полная копия базы каждую ночь, хранится на постоянном диске.',
  'Daily at': 'Ежедневно в',
  'Copies kept': 'Хранится копий',
  'Stored': 'Сейчас на диске',
  'Latest': 'Последняя',
  'No backups yet': 'Бэкапов пока нет',
  'Run backup now': 'Сделать бэкап сейчас',
  'Backup started — the result will arrive in the monitoring topic.':
    'Бэкап запущен — результат придёт в тему мониторинга.',
  // Platform back-office (operator console)
  'Platform admin': 'Админ платформы',
  'Operator': 'Оператор',
  'Cross-tenant back-office: accounts, access and platform health.':
    'Бэк-офис платформы: аккаунты, доступы и состояние системы.',
  'Accounts': 'Аккаунты',
  'New sign-ups': 'Новые регистрации',
  'Last 30 days': 'За 30 дней',
  'Clicks (24h)': 'Клики (24ч)',
  'Clicks (30d)': 'Клики (30д)',
  'Conversions (30d)': 'Конверсии (30д)',
  'Platform state': 'Состояние платформы',
  'Self-signup': 'Саморегистрация',
  'Open': 'Открыта',
  'Closed': 'Закрыта',
  'Controlled by the DISABLE_REGISTRATION variable on Railway.':
    'Управляется переменной DISABLE_REGISTRATION на Railway.',
  'Root admins': 'Root-админы',
  'From PLATFORM_ADMIN_EMAILS — manage the list on Railway.':
    'Из PLATFORM_ADMIN_EMAILS — список меняется на Railway.',
  'Granted admins': 'Выданные админки',
  'Every registered account. Block access or grant platform admin.':
    'Все зарегистрированные аккаунты. Блокируйте доступ или выдавайте админку платформы.',
  'Search by email or name…': 'Поиск по email или имени…',
  'Plan': 'Тариф',
  'Last click': 'Последний клик',
  'No accounts found': 'Аккаунты не найдены',
  'Root admin': 'Root-админ',
  'Client': 'Клиент',
  'Managed on Railway': 'Управляется на Railway',
  'Grant platform admin': 'Выдать админку платформы',
  'Grant platform admin?': 'Выдать админку платформы?',
  'Make admin': 'Сделать админом',
  'Revoke platform admin': 'Забрать админку платформы',
  'Revoke platform admin?': 'Забрать админку платформы?',
  'Revoke admin': 'Забрать админку',
  'Block account': 'Заблокировать аккаунт',
  'Block this account?': 'Заблокировать этот аккаунт?',
  'The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.':
    'Пользователь сразу теряет доступ — все сессии отклоняются, пока вы его не разблокируете. Его кампании и трекинг-ссылки продолжают принимать трафик.',
  'Reason (optional)': 'Причина (необязательно)',
  'Visible to admins only': 'Видно только админам',
  'Unblock': 'Разблокировать',
  'Unblock account': 'Разблокировать аккаунт',
  'Unblock this account?': 'Разблокировать этот аккаунт?',
  'The user will be able to sign in again immediately.':
    'Пользователь сразу же сможет войти снова.',
  'This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.':
    'Пользователь получит операторский доступ: бэк-офис платформы, все аккаунты и настройки платформы. Выдача фиксируется в аудит-логе.',
  'The user keeps their account but loses operator access.':
    'Аккаунт сохранится, но операторский доступ пропадёт.',
  'Account blocked': 'Аккаунт заблокирован',
  'Account unblocked': 'Аккаунт разблокирован',
  'Platform admin granted': 'Админка платформы выдана',
  'Platform admin revoked': 'Админка платформы отозвана',
  'Failed to load platform overview': 'Не удалось загрузить обзор платформы',
  'Failed to load users': 'Не удалось загрузить пользователей',
  '{count} accounts': '{count} аккаунтов',
  'Page {page} of {total}': 'Страница {page} из {total}',
  'Change plan': 'Сменить тариф',
  'Plan updated': 'Тариф обновлён',
  'Sets the edition directly (status "active", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.':
    'Устанавливает тариф напрямую (статус «active», без триала) — для ручных и комп-аккаунтов. Аккаунты с живой подпиской Stripe меняют тариф через Stripe.',
  'Account deleted': 'Аккаунт удалён',
  'Delete account': 'Удалить аккаунт',
  'Delete this account permanently?': 'Удалить этот аккаунт навсегда?',
  'This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.':
    'Будут стёрты аккаунт и ВСЕ его данные — кампании, клики, конверсии, офферы, лендинги, домены, отчёты. Действие необратимо.',
  // Signup email verification
  'We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.':
    'Мы отправили ссылку-подтверждение на {email}. Откройте её, чтобы активировать аккаунт — ссылка действует 24 часа.',
  "Check your spam folder if it doesn't arrive within a minute.":
    'Если письмо не пришло за минуту — проверьте папку «Спам».',
  'Resend the email': 'Отправить письмо ещё раз',
  'Sent — check your inbox': 'Отправлено — проверьте почту',
  'Could not resend the email — try again.': 'Не удалось отправить письмо — попробуйте ещё раз.',
  'Back to sign in': 'Назад ко входу',
  'Confirming your email…': 'Подтверждаем ваш email…',
  'This takes a second.': 'Это займёт секунду.',
  'Email confirmed — welcome aboard!': 'Email подтверждён — добро пожаловать!',
  'Taking you to your dashboard…': 'Переходим в ваш дашборд…',
  'Verification failed — the link may have expired.':
    'Подтверждение не удалось — возможно, ссылка устарела.',
  'The verification link is incomplete — open the link from the email again.':
    'Ссылка подтверждения неполная — откройте ссылку из письма ещё раз.',
  // Settings, Ops, platform admin, white pages, campaign params (completed 2026-10-11)
  "Use 8–128 characters; long passphrases are recommended": "От 8 до 128 символов; рекомендуется длинная парольная фраза",
  "Users": "Пользователи",
  "Error": "Ошибка",
  "Failed to load documentation.": "Не удалось загрузить документацию.",
  "Production readiness": "Готовность к продакшену",
  "Ready": "Готово",
  "Attention required": "Требуется внимание",
  "Secret-free checks for runtime configuration and isolation controls.": "Проверки конфигурации и изоляции без раскрытия секретов.",
  "Environment": "Окружение",
  "production": "продакшен",
  "development": "разработка",
  "Rate limiter": "Ограничение частоты",
  "Access token TTL": "Срок жизни токена доступа",
  "Backend root": "Бэкенд от root",
  "Blocking checks": "Блокирующие проверки",
  "Failed to load integrity status": "Не удалось загрузить статус целостности",
  "Traffic suspended": "Трафик приостановлен",
  "Traffic resumed": "Трафик возобновлён",
  "Data integrity": "Целостность данных",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Обязательные уникальные индексы защищают атрибуцию кликов, конверсии и идемпотентность биллинга.",
  "All mandatory indexes are present and unique.": "Все обязательные индексы на месте и уникальны.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "Не игнорируйте это предупреждение. Перед изменением индексов проверьте логи запуска бэкенда.",
  "Missing": "Отсутствует",
  "Not unique": "Не уникальный",
  "Resume campaign traffic": "Возобновить трафик кампаний",
  "Resume traffic": "Возобновить трафик",
  "Suspend campaign traffic": "Приостановить трафик кампаний",
  "Suspend traffic": "Приостановить трафик",
  "Suspend all campaign traffic for this account?": "Приостановить весь трафик кампаний этого аккаунта?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "Публичные трекинговые ссылки будут отвечать как неактивная кампания. Настройки кампаний не меняются, трафик можно возобновить мгновенно.",
  "Resume campaign traffic for this account?": "Возобновить трафик кампаний этого аккаунта?",
  "Existing active campaigns and tracking links will start serving again.": "Активные кампании и трекинговые ссылки снова начнут работать.",
  "Password changed — other devices have been signed out": "Пароль изменён — на других устройствах выполнен выход",
  "Sign out of every device, including this one? You will need to sign in again.": "Выйти на всех устройствах, включая это? Потребуется войти снова.",
  "All sessions signed out": "Все сеансы завершены",
  "Error signing out sessions": "Не удалось завершить сеансы",
  "Changing your password also signs out every other device.": "Смена пароля также завершает сеансы на всех других устройствах.",
  "Active sessions": "Активные сеансы",
  "Lost a laptop, or think someone else has your password? End every session at once.": "Потеряли ноутбук или подозреваете, что пароль знает кто-то ещё? Завершите все сеансы сразу.",
  "This signs out every device, including this one. Signing back in takes one password.": "Будет выполнен выход на всех устройствах, включая это. Чтобы войти снова, нужен только пароль.",
  "Sign out everywhere": "Выйти везде",
  "Pages": "Страницы",
  "Copy path": "Копировать путь",
};

// Spanish (es) — focused coverage of Navbar, Dashboard, auth, and the
// most-touched UI controls. Long-tail strings fall back to English.
const es = {
  'Bot model': 'Modelo de bots',
  // C5/A2/C4 UI screens + doc TOC labels (member access, click traces, bot model)
  'Member access': 'Acceso de miembros',
  'Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.': 'Define qué puede ver y editar cada miembro del equipo — por entidad, y qué métricas de informes puede leer. Los propietarios y administradores nunca se restringen.',
  'Member': 'Miembro',
  'Choose a member…': 'Elige un miembro…',
  'Failed to load members': 'No se pudieron cargar los miembros',
  'Retry': 'Reintentar',
  'No team members yet': 'Aún no hay miembros en el equipo',
  'Invite teammates from the Workspace page, then configure their access here.': 'Invita a compañeros desde la página Workspace y luego configura su acceso aquí.',
  'Pick a member to configure': 'Elige un miembro para configurar',
  'Their entity access and allowed report metrics will show up here.': 'Aquí aparecerán su acceso a entidades y las métricas de informes permitidas.',
  'Failed to load member access': 'No se pudo cargar el acceso del miembro',
  'Owners and admins have full, unrestricted access': 'Los propietarios y administradores tienen acceso completo y sin restricciones',
  'You can still save these rules, but they stay inert unless the role changes to manager or viewer.': 'Puedes guardar estas reglas igualmente, pero permanecen inactivas hasta que el rol cambie a manager o viewer.',
  'Entity access': 'Acceso a entidades',
  'Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.': 'Completo es el valor por defecto: sin restricción. Solo lectura bloquea las ediciones. A seleccionados limita al miembro a los IDs listados. Creados y seleccionados añade todo lo que el miembro creó por sí mismo.',
  'Entity': 'Entidad',
  'Access mode': 'Modo de acceso',
  'Allowed IDs': 'IDs permitidos',
  'Full': 'Completo',
  'Read-only': 'Solo lectura',
  'To selected': 'A seleccionados',
  'Created and selected': 'Creados y seleccionados',
  'IDs, comma or space separated': 'IDs separados por coma o espacio',
  'IDs of the specific items this member may access': 'IDs de los elementos concretos a los que este miembro puede acceder',
  'No IDs yet — the member will only see items they created themselves.': 'Aún no hay IDs: el miembro solo verá los elementos que creó él mismo.',
  'No IDs yet — the member will not see any items of this type.': 'Aún no hay IDs: el miembro no verá ningún elemento de este tipo.',
  'All items': 'Todos los elementos',
  'Allowed report metrics': 'Métricas de informes permitidas',
  'Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.': 'Activa o desactiva las métricas que este miembro puede ver en informes y paneles. Si no seleccionas ninguna, no hay restricción.',
  'All metrics (no restriction)': 'Todas las métricas (sin restricción)',
  'metrics allowed': 'métricas permitidas',
  'Clear (allow all)': 'Limpiar (permitir todas)',
  'Save access': 'Guardar acceso',
  'Member access saved': 'Acceso del miembro guardado',
  'Failed to save member access': 'No se pudo guardar el acceso del miembro',
  'Click traces': 'Trazas de clics',
  'Diagnostics': 'Diagnóstico',
  'Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.': 'Clics reales muestreados con la decisión de enrutamiento completa de cada uno: qué streams se evaluaron y por qué coincidió el ganador.',
  'Pick a campaign above to inspect where its real clicks were routed and why.': 'Elige una campaña arriba para ver adónde se enrutaron sus clics reales y por qué.',
  'Live-click tracing': 'Trazado de clics en vivo',
  'Enable live-click tracing': 'Activar el trazado de clics en vivo',
  'Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.': 'Desactivado por defecto. Al activarlo, una parte muestreada de los clics reales registra su traza completa de enrutamiento. Respetuoso con la privacidad: no se almacenan direcciones IP ni user agents, y las trazas caducan automáticamente.',
  'Sample rate (%)': 'Tasa de muestreo (%)',
  'Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.': 'Porcentaje de clics a trazar, de 0 a 100%. Ejemplo: 10% traza aproximadamente uno de cada diez clics.',
  'Sample rate must be between 0 and 100': 'La tasa de muestreo debe estar entre 0 y 100',
  'Trace settings saved': 'Configuración de trazado guardada',
  'Error loading click traces': 'Error al cargar las trazas de clics',
  'Could not load traces': 'No se pudieron cargar las trazas',
  'Something went wrong while loading click traces for this campaign.': 'Algo salió mal al cargar las trazas de clics de esta campaña.',
  'No traces yet': 'Aún no hay trazas',
  'Enable tracing above; traces of sampled real clicks will appear here.': 'Activa el trazado arriba; aquí aparecerán las trazas de clics reales muestreados.',
  'Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.': 'El trazado está activado: las trazas de clics reales muestreados aparecerán aquí a medida que llegue tráfico. Si no aparece nada, revisa la tasa de muestreo.',
  'Flags': 'Indicadores',
  'Show routing trace': 'Mostrar la traza de enrutamiento',
  'Hide routing trace': 'Ocultar la traza de enrutamiento',
  'Per-stream verdicts': 'Veredictos por stream',
  'No per-stream verdicts were recorded for this click.': 'No se registraron veredictos por stream para este clic.',
  'Not matched': 'Sin coincidencia',
  'Filters evaluated': 'Filtros evaluados',
  'Relation': 'Relación',
  'Page': 'Página',
  'entries': 'entradas',
  'just now': 'ahora mismo',
  '{n}m ago': 'hace {n} min',
  '{n}h ago': 'hace {n} h',
  'ML bot model': 'Modelo ML de bots',
  'Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.': 'Clasificador de bots con supervisión débil: entrénalo con clics recientes, revisa métricas y puntúa payloads ad hoc. Solo en modo sombra: nunca afecta al enrutamiento en vivo.',
  'Admin access required': 'Se requiere acceso de administrador',
  'The ML bot-model panel is only available to workspace admins.': 'El panel del modelo ML de bots solo está disponible para administradores del workspace.',
  'Error loading bot-model status': 'Error al cargar el estado del modelo de bots',
  'Model status': 'Estado del modelo',
  'Trained': 'Entrenado',
  'Not trained': 'Sin entrenar',
  'Inference': 'Inferencia',
  'Degenerate': 'Degenerado',
  'Trained on a single class or too few samples — metrics are not meaningful.': 'Entrenado con una sola clase o muy pocas muestras: las métricas no son significativas.',
  'Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.': 'La inferencia está desactivada por defecto y es solo en modo sombra: incluso activada, las puntuaciones solo se guardan en los clics para análisis y nunca afectan al enrutamiento.',
  'Accuracy': 'Precisión',
  'Positive rate': 'Tasa de positivos',
  'Log loss': 'Log loss',
  'AUC': 'AUC',
  'Training samples': 'Muestras de entrenamiento',
  'Trained at': 'Entrenado el',
  'No bot model trained yet. Train one on recent clicks below.': 'Aún no hay un modelo de bots entrenado. Entrena uno con los clics recientes abajo.',
  'Train model': 'Entrenar modelo',
  'Training…': 'Entrenando…',
  'Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.': 'El entrenamiento toma hasta 5.000 clics recientes, los etiqueta débilmente con las heurísticas de bots existentes (user agent, unicidad, puntuación de comportamiento) y ajusta un pequeño modelo de regresión logística. Reentrenar reemplaza el modelo guardado.',
  'Model trained on {n} clicks — accuracy {acc}': 'Modelo entrenado con {n} clics — precisión {acc}',
  'Model trained on {n} clicks': 'Modelo entrenado con {n} clics',
  'No click data to train on yet.': 'Aún no hay datos de clics para entrenar.',
  'Training finished': 'Entrenamiento finalizado',
  'Training failed': 'Error al entrenar el modelo',
  'Score a sample': 'Puntuar una muestra',
  'Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.': 'Herramienta para desarrolladores: pega un payload JSON con forma de clic y pásalo por el modelo entrenado. No se guarda nada y el tráfico en vivo no se ve afectado.',
  'Click payload (JSON)': 'Payload del clic (JSON)',
  'Score': 'Puntuar',
  'Scoring…': 'Puntuando…',
  'Reset example': 'Restaurar ejemplo',
  'Invalid JSON — check the payload and try again.': 'JSON no válido: revisa el payload e inténtalo de nuevo.',
  'Payload must be a JSON object.': 'El payload debe ser un objeto JSON.',
  'No trained model — train one first.': 'No hay modelo entrenado: entrena uno primero.',
  'Scoring failed': 'Error al puntuar',
  'Likely bot': 'Probable bot',
  'Likely human': 'Probable humano',
  'Threshold 0.5 — scores above are flagged as bots.': 'Umbral 0.5: las puntuaciones superiores se marcan como bots.',
  'Heuristic weak label': 'Etiqueta débil heurística',
  'Human': 'Humano',
  'Feature': 'Característica',
  '{n} min ago': 'hace {n} min',
  '{n} h ago': 'hace {n} h',
  '{n} d ago': 'hace {n} d',
  'Archive & restore': 'Archivar y restaurar',
  'Access control': 'Control de acceso',

  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Etiqueta de texto libre de la red, solo para notas y filtros — no afecta nada. Para un vínculo real usa el campo Red de afiliados o el bloque Affiliate routing de abajo.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Red de socios reutilizable de la sección Affiliate networks: plantilla de postback, parámetros de oferta e informes por red. Opcional.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "A dónde va el clic en una oferta de redirección simple. Funcionan macros: {click_id}, {country_code}, {gclid} y más. Para ofertas con formulario (lead a CRM) la URL puede ser cualquiera.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Máximo de conversiones por oferta al día. Al alcanzar el límite, el tráfico va a la oferta de respaldo (Fallback). Vacío = sin límite.",
  "Time zone in which the daily cap is counted and the counter resets.": "Zona horaria en la que se cuenta el límite diario y se reinicia el contador.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Oferta de respaldo: el tráfico va aquí cuando la oferta principal alcanza su límite diario.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "El socio/CRM al que se envía el lead. Se configura una vez en la sección Integrations (TrackBox o Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "El Box/Goal ID de la oferta en el socio — qué producto/box recibe el lead. El socio da el valor (p. ej. 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Proporción de leads a este socio cuando hay varios (split/rotación). P. ej. 70 y 30 = 70% y 30%.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Apagado = el socio se omite temporalmente (p. ej. hasta acordar el lanzamiento); sus ajustes se conservan.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Endpoint de formulario específico para SOLO esta oferta. Normalmente NO se necesita — usa el /api/lead compartido (ver docs). Solo para atar un formulario a una oferta concreta.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Notificación en Telegram en CADA envío del formulario (aceptado/rechazado/prueba). Aparte del postback de Telegram en la campaña (ese salta con una conversión confirmada). Bot token de @BotFather; el Chat ID del grupo empieza con -100…",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "URL por defecto cuando ningún flujo coincide. El enrutamiento lo suelen definir los Streams — este campo es una red de seguridad.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "La plataforma de anuncios (Google Ads, Facebook…). Define el conjunto de macros/subs que se añaden al enlace de tracking para pasar datos del clic.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Cómo se cuenta el costo: CPC — por clic, CPM — por 1000 impresiones, CPA — por conversión. Afecta Costo / ROI / CPC / CPA en los informes.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "El nombre del parámetro GET con el que el tracker añade el click_id a la URL de la oferta (p. ej. click_id → ?click_id=…). Necesario para que el socio devuelva este click_id en el postback. Los snippets de formulario leen click_id y clickid.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "No establecer la cookie xpnsr_vid (para redes que prohíben cookies). La unicidad se calcula por IP+User Agent, y el click_id se pasa por URL — el campo Click ID forward parameter de arriba.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "Hashear la IP antes de guardarla (para GDPR). El GEO se resuelve ANTES del hasheo, así que el targeting por país/ciudad no se ve afectado.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Cómo redirigir: 302 — redirección rápida normal; Meta refresh / JS — cuando la red no sigue 302 o se necesita gtag; Cloaked (iframe) — ocultar la URL de la oferta en la barra de direcciones.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — flujo normal con filtros; Catch — captura el tráfico que no coincidió con ningún Normal; Default — flujo de último recurso cuando nada coincide.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Prioridad de verificación. Cuanto menor el número, antes se comprueba el flujo. El tráfico va al primero que coincide.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "Cuando varios flujos comparten tipo — el reparto de tráfico entre ellos (split). P. ej. 70 y 30 = 70% y 30%.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Máximo de clics para este flujo. Al alcanzarlo, el flujo deja de recibir tráfico. Vacío = sin límite.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — enviar al landing/oferta del flujo; Action — respuesta especial (p. ej. 404 / respuesta vacía para anti-fraude); Split test — reparto entre variantes.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Filtrar por unicidad de la visita: solo únicas / solo repetidas / no filtrar.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Cómo tratar los bots (detectados por User-Agent): no filtrar / solo bots / excluir bots. Útil para un flujo anti-fraude.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Filtro de proxy/VPN (datacenter/Tor): no filtrar / solo proxy / excluir proxy.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Permitir solo IPv4 o solo IPv6, o no filtrar.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Días de la semana y horas en que el flujo está activo. La hora es en la zona horaria del dueño de la campaña.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Un preset de plataforma listo (Google Ads, Facebook…) — rellena el nombre, los macros/subs estándar y el postback S2S de esta fuente.",
  // Traffic-source template catalog picker
  'Search templates…': 'Buscar plantillas…',
  'All categories': 'Todas las categorías',
  'Templates in catalog': 'Plantillas en el catálogo',
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "Opcional. Un postback saliente HACIA la red publicitaria en la conversión — para que la plataforma optimice campañas de su lado (p. ej. Facebook CAPI clásico).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Parámetros que la plataforma pasa al clic (sub1…subN, gclid, tm, etc.). Se convierten en macros, aparecen en informes y se añaden al enlace de tracking.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — adaptador tipado para su API. Custom API — para cualquier otra CRM: configuras tú la solicitud (URL, cabeceras, cuerpo, de dónde leer el redirect).",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "La clave secreta Push/Registration del socio. Obtenla en el panel del socio (sección API / API Testing) o con tu affiliate manager.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Tu Affiliate ID en el socio. Lo da el socio.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Campaign ID en el socio. Normalmente 1 salvo que indiquen lo contrario.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "Estados crudos de la red que contar como LEAD (registro). Separados por comas. P. ej. new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "Estados crudos que contar como VENTA/depósito. P. ej. ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Estados de rechazo/mala calidad. P. ej. bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Estos estados se descartan en silencio — no se registran como conversiones. P. ej. spam, junk, test.",
  '(empty UA)': '(UA vacío)',
  '14 days': '14 días',
  '2FA reset failed': 'Error al restablecer 2FA',
  '2FA reset — member can re-enrol': '2FA restablecido — el miembro puede volver a inscribirse',
  '30 days': '30 días',
  '7 days': '7 días',
  '90 days': '90 días',
  'A/B Testing': 'Pruebas A/B',
  'A/B Tests': 'Pruebas A/B',
  'A/B test created': 'Prueba A/B creada',
  'A/B test deleted': 'Prueba A/B eliminada',
  'A/B test paused': 'Prueba A/B pausada',
  'A/B test results': 'Resultados de la prueba A/B',
  'A/B test started': 'Prueba A/B iniciada',
  'API keys': 'Claves API',
  'ASN block': 'Bloqueo por ASN',
  'ASN name substrings': 'Subcadenas del nombre ASN',
  'ASN numbers': 'Números ASN',
  'Accept only unique': 'Aceptar solo únicos',
  'Access revoked': 'Acceso revocado',
  'Access token': 'Token de acceso',
  'Access tracker': 'Acceder al tracker',
  'Account': 'Cuenta',
  'Account ID': 'ID de cuenta',
  'Action': 'Acción',
  'Action failed': 'Acción fallida',
  'Action type': 'Tipo de acción',
  'Actions': 'Acciones',
  'Activated {n}': 'Activadas: {n}',
  'Active': 'Activa',
  'Active campaigns': 'Campañas activas',
  'Active connections, last sync time, and recent errors.': 'Conexiones activas, última sincronización y errores recientes.',
  'Active filters': 'Filtros activos',
  'Activity heatmap': 'Mapa de calor de actividad',
  'Activity marked as resolved': 'Actividad marcada como resuelta',
  'Actor': 'Actor',
  'Actor ID': 'ID del actor',
  'Ad account connected via OAuth': 'Cuenta publicitaria conectada via OAuth',
  'Ad cost sync': 'Sincronización de costos publicitarios',
  'Ad-Account Connections': 'Conexiones de cuentas publicitarias',
  'Add': 'Agregar',
  'Add IP to blacklist': 'Agregar IP a la lista negra',
  'Add IP to whitelist': 'Agregar IP a la lista blanca',
  'Add a landing page for use in campaigns and A/B tests': 'Agrega una landing page para usar en campañas y pruebas A/B',
  'Add a new ad campaign': 'Añadir una nueva campaña',
  'Add a new landing to the library': 'Agregar una nueva landing a la biblioteca',
  'Add a new offer to monetize traffic': 'Agregar una nueva oferta para monetizar tráfico',
  'Add an offer to use in campaigns': 'Agregar una oferta para usar en campañas',
  'Add domain': 'Agregar dominio',
  'Add integration': 'Agregar integración',
  'Add landing': 'Agregar landing',
  'Add landing page': 'Agregar landing page',
  'Add landings to use in traffic rules': 'Agregar landings para usar en reglas de tráfico',
  'Add offer': 'Agregar oferta',
  'Add offers to monetize traffic': 'Agregar ofertas para monetizar tráfico',
  'Add parameter': 'Agregar parámetro',
  'Add postback': 'Agregar postback',
  'Add tag': 'Agregar etiqueta',
  'Add variant': 'Agregar variante',
  'Add webhook': 'Agregar webhook',
  'Additional domains': 'Dominios adicionales',
  'Additional information': 'Información adicional',
  'Admin': 'Administrador',
  'Admin reset 2FA': 'Admin restableció 2FA',
  'Admin tools': 'Herramientas de administrador',
  'After completing payment, your subscription will be activated automatically.': 'Después de completar el pago, tu suscripción se activará automáticamente.',
  'Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.': 'Agresivo: bloquea cualquier clic cuyo JA3/JA4 falte o no esté clasificado. Etiqueta primero los hashes de proxy corporativos con las anulaciones del espacio de trabajo.',
  'Alert': 'Alerta',
  'Alert sent': 'Alerta enviada',
  'Alerts': 'Alertas',
  'All': 'Todo',
  'All campaigns': 'Todas las campañas',
  'All clear': 'Todo en orden',
  'All clicks': 'Todos los clics',
  'All conversions': 'Todas las conversiones',
  'All countries': 'Todos los países',
  'All devices': 'Todos los dispositivos',
  'All sources': 'Todas las fuentes',
  'All status': 'Todos los estados',
  'All systems normal': 'Todos los sistemas normales',
  'All time': 'Todo el tiempo',
  'All types': 'Todos los tipos',
  'Allow custom domains for tracking links and pre-landings.': 'Permitir dominios personalizados para enlaces de tracking y pre-landings.',
  'Allowed ASN numbers': 'Números ASN permitidos',
  'Allowed countries (ISO codes)': 'Países permitidos (códigos ISO)',
  'Already have an account?': '¿Ya tienes una cuenta?',
  'Always block these JA3 / JA4 hashes regardless of classification.': 'Siempre bloquear estos hashes JA3 / JA4 sin importar la clasificación.',
  'An admin will be notified — keep your authenticator app handy in case the issue is on your end.': 'Se notificará a un administrador — mantén tu aplicación autenticadora a mano por si el problema es de tu lado.',
  'Analytics': 'Analítica',
  'Analytics view': 'Vista de analítica',
  'Anti-fraud': 'Anti-fraude',
  'Anti-fraud filters and detection rules will appear here': 'Aquí aparecerán los filtros antifraude y reglas de detección',
  'Anti-fraud rules engine': 'Motor de reglas antifraude',
  'Anti-fraud system': 'Sistema antifraude',
  'Any role except Owner': 'Cualquier rol excepto Propietario',
  'Apply': 'Aplicar',
  'Approve': 'Aprobar',
  'Are you sure?': '¿Estás seguro?',
  'Are you sure? This action cannot be undone.': '¿Estás seguro? Esta acción no se puede deshacer.',
  'Audit export failed': 'Falló la exportación de auditoría',
  'Audit log': 'Registro de auditoría',
  'Audit log exported': 'Registro de auditoría exportado',
  'Authentication': 'Autenticación',
  'Auto-pause': 'Pausa automática',
  'Auto-pause when fraud rate exceeds': 'Pausa automática cuando la tasa de fraude supere',
  'Auto-redirect': 'Redirección automática',
  'Auto-renews monthly. Cancel anytime.': 'Se renueva automáticamente cada mes. Cancela cuando quieras.',
  'Automate': 'Automatizar',
  'Automated decisions': 'Decisiones automáticas',
  'Automation': 'Automatización',
  'Automation rule created': 'Regla de automatización creada',
  'Automation rule deleted': 'Regla de automatización eliminada',
  'Automation rule failed': 'Regla de automatización fallida',
  'Automation rule updated': 'Regla de automatización actualizada',
  'Available': 'Disponible',
  'Average CR': 'CR promedio',
  'Average CR (%)': 'CR promedio (%)',
  'Average ROI': 'ROI promedio',
  'Average revenue per conversion': 'Ingreso promedio por conversión',
  'Avg time on landing': 'Tiempo promedio en landing',
  'Back': 'Atrás',
  'Back to landings': 'Volver a landings',
  'Back to login': 'Volver al inicio de sesión',
  'Back to offers': 'Volver a ofertas',
  'Backup codes': 'Códigos de respaldo',
  'Bad classification list': 'Lista de clasificación negativa',
  'Bad fingerprint': 'Huella maliciosa',
  'Banking-grade security': 'Seguridad de nivel bancario',
  'Base': 'Base',
  'Basic information': 'Información básica',
  'Be careful with these powerful tools': 'Ten cuidado con estas herramientas potentes',
  'Best practices': 'Mejores prácticas',
  'Beta': 'Beta',
  'Billing': 'Facturación',
  'Block': 'Bloquear',
  'Block by classification': 'Bloquear por clasificación',
  'Block classification': 'Clasificación a bloquear',
  'Block fingerprints classified as bad': 'Bloquear huellas clasificadas como maliciosas',
  'Block known fraud': 'Bloquear fraude conocido',
  'Block selected': 'Bloquear seleccionados',
  'Block tor': 'Bloquear Tor',
  'Block unknown fingerprints': 'Bloquear huellas desconocidas',
  'Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.': 'Bloquear cuando la puntuación de riesgo combinada TLS+UA+IP supere este umbral. Por defecto 0.7.',
  'Block when the provider returns a score >= this threshold (default 85).': 'Bloquear cuando el proveedor devuelva una puntuación >= este umbral (por defecto 85).',
  'Blocked': 'Bloqueado',
  'Blocked IPs': 'IPs bloqueadas',
  'Blocked countries (ISO codes)': 'Países bloqueados (códigos ISO)',
  'Blocked samples': 'Muestras bloqueadas',
  'Blocked samples: {name}': 'Muestras bloqueadas: {name}',
  'Blocked: {n} times': 'Bloqueado: {n} veces',
  'Book Demo': 'Reservar demo',
  'Bot detection': 'Detección de bots',
  'Bots filtered': 'Bots filtrados',
  'Browser breakdown': 'Desglose por navegador',
  'Browser notifications': 'Notificaciones del navegador',
  'Browsers': 'Navegadores',
  'Budget alert': 'Alerta de presupuesto',
  'Budget percentage for alert': 'Porcentaje de presupuesto para alerta',
  'Bulk delete failed': 'Falló la eliminación masiva',
  'Bulk update failed': 'Falló la actualización masiva',
  'By city': 'Por ciudad',
  'By country': 'Por país',
  'CAPI DLQ': 'CAPI DLQ',
  'CAPI dead-letter queue': 'Cola de mensajes muertos CAPI',
  'CAPI delivery': 'Entrega CAPI',
  'CAPI replay succeeded': 'Reintento CAPI exitoso',
  'CPA (per action)': 'CPA (por acción)',
  'CPC (per click)': 'CPC (por clic)',
  'CPM (per impression)': 'CPM (por impresión)',
  'CR': 'CR',
  'CR% by day': 'CR% por día',
  'Campaign': 'Campaña',
  'Campaign alerts': 'Alertas de campaña',
  'Campaign created successfully!': '¡Campaña creada con éxito!',
  'Campaign deleted successfully!': '¡Campaña eliminada con éxito!',
  'Campaign info': 'Información de campaña',
  'Campaign management': 'Gestión de campañas',
  'Campaign name': 'Nombre de campaña',
  'Campaign not found': 'Campaña no encontrada',
  'Campaign parameters': 'Parámetros de campaña',
  'Campaign paused': 'Campaña pausada',
  'Campaign saved': 'Campaña guardada',
  'Campaign start, pause, completion': 'Inicio, pausa y finalización de campaña',
  'Campaign started': 'Campaña iniciada',
  'Campaign stats': 'Estadísticas de campaña',
  'Campaign streams': 'Streams de campaña',
  'Campaign updated successfully!': '¡Campaña actualizada con éxito!',
  'Campaign:': 'Campaña:',
  'Campaigns': 'Campañas',
  'Campaigns not found': 'Campañas no encontradas',
  'Cancel': 'Cancelar',
  'Cannot delete: source is in use by campaigns': 'No se puede eliminar: la fuente está en uso por campañas',
  'Case-insensitive substring match against the ASN label.': 'Coincidencia de subcadena sin distinción de mayúsculas contra la etiqueta ASN.',
  'Catch': 'Capturar',
  'Category': 'Categoría',
  'Change': 'Cambiar',
  'Change automation rule settings': 'Cambiar configuración de regla de automatización',
  'Change offer parameters': 'Cambiar parámetros de oferta',
  'Change password': 'Cambiar contraseña',
  'Changes in CR, ROI, cost': 'Cambios en CR, ROI, costo',
  'Check TLS': 'Verificar TLS',
  'Cities': 'Ciudades',
  'Click': 'Clic',
  'Click frequency': 'Frecuencia de clics',
  'Click limit': 'Límite de clics',
  'Click map': 'Mapa de clics',
  'Click-to-conversion pipeline with status breakdown': 'Pipeline clic a conversión con desglose por estado',
  'Clicks': 'Clics',
  'Clicks and conversions': 'Clics y conversiones',
  'Clicks by country': 'Clics por país',
  'Clicks this month': 'Clics este mes',
  // Billing — tiered editions (launch)
  'Plans & billing': 'Planes y facturación',
  'Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.': 'Cinco ediciones: cada plan incluye el tracker completo — elige el tamaño de tu equipo, la escala de dominios y el nivel de automatización. Los clics nunca se limitan.',
  'Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.': 'La facturación aún no está activada en este servidor — todas las funciones están abiertas. Los planes de abajo muestran lo que aplicará cuando los pagos estén activos.',
  'Trial': 'Prueba',
  'day(s) left': 'día(s) restante(s)',
  'choose a plan to keep your traffic flowing without interruption.': 'elige un plan para que tu tráfico siga sin interrupciones.',
  'Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.': 'Tu suscripción está inactiva: el procesamiento de clics y la creación de entidades están en pausa. Elige un plan para reanudar al instante.',
  'Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.': 'El último pago falló — el tracker sigue funcionando mientras Stripe reintenta. Actualiza tu tarjeta en Gestionar facturación.',
  'cancels at period end': 'se cancela al final del período',
  'unlimited': 'ilimitado',
  'months': 'meses',
  'month': 'mes',
  'billed every': 'cobro cada',
  'user(s)': 'usuario(s)',
  'domain(s)': 'dominio(s)',
  'Choose plan': 'Elegir plan',
  'Full tracker core': 'Núcleo completo del tracker',
  'Unlimited clicks': 'Clics ilimitados',
  'Landing page editor': 'Editor de landing pages',
  'Online support': 'Soporte en línea',
  'Click API + API keys': 'Click API + claves API',
  'Facebook CAPI': 'Facebook CAPI',
  'All 8 CAPI providers': 'Los 8 proveedores CAPI',
  'Report by conversion date': 'Informe por fecha de conversión',
  'White label branding': 'Marca white label',
  'Personal manager': 'Gerente personal',
  'Priority support': 'Soporte prioritario',
  'Onboarding call': 'Llamada de incorporación',
  'trialing': 'en prueba',
  'active': 'activa',
  'past_due': 'pago vencido',
  'expired': 'expirada',
  'canceled': 'cancelada',
  'exempt': 'exenta',
  'Clicks today': 'Clics hoy',
  'Close': 'Cerrar',
  'Coming in upcoming releases': 'Próximamente en futuras versiones',
  'Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).': 'Números AS separados por comas (ej. 16509 = AWS, 24940 = Hetzner).',
  'Commonly used features': 'Funciones más usadas',
  'Completed': 'Completado',
  'Conditions (leave empty for any value)': 'Condiciones (déjalo vacío para cualquier valor)',
  'Confidence interval': 'Intervalo de confianza',
  'Confidence level (%)': 'Nivel de confianza (%)',
  'Configuration (key-value)': 'Configuración (clave-valor)',
  'Configure a traffic source for UTM tags and conversion postbacks': 'Configura una fuente de tráfico para etiquetas UTM y postbacks de conversión',
  'Configure a webhook to receive notifications': 'Configura un webhook para recibir notificaciones',
  'Configure automatic actions based on conditions': 'Configura acciones automáticas basadas en condiciones',
  'Configure automatic filters to block suspicious traffic': 'Configura filtros automáticos para bloquear tráfico sospechoso',
  'Configure conditions and actions for traffic distribution': 'Configura condiciones y acciones para la distribución de tráfico',
  'Configure connection to an external service': 'Configura la conexión a un servicio externo',
  'Configure domains for campaign tracking': 'Configura dominios para tracking de campañas',
  'Configure how you receive notifications': 'Configura cómo recibes notificaciones',
  'Configure stream for traffic distribution by conditions': 'Configura stream para distribución de tráfico por condiciones',
  'Confirm': 'Confirmar',
  'Confirm new password': 'Confirmar nueva contraseña',
  'Confirm password': 'Confirmar contraseña',
  'Confirmed': 'Confirmado',
  'Connect': 'Conectar',
  'Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.': 'Conecta cuentas de FB / Google Ads para que los datos de costos se importen automáticamente a las campañas.',
  'Connect ad account': 'Conectar cuenta publicitaria',
  'Connect external services to automate workflows': 'Conecta servicios externos para automatizar flujos de trabajo',
  'Connect with Facebook': 'Conectar con Facebook',
  'Connect with Google Ads': 'Conectar con Google Ads',
  'Connected': 'Conectado',
  'Connection created': 'Conexión creada',
  'Connection deleted': 'Conexión eliminada',
  'Control': 'Control',
  'Conversion': 'Conversión',
  'Conversion API': 'API de conversión',
  'Conversion API dispatches in the last window.': 'Envíos de Conversion API en la última ventana.',
  'Conversion ID': 'ID de conversión',
  'Conversion forwarders': 'Reenviadores de conversiones',
  'Conversion funnel': 'Embudo de conversión',
  'Conversion percentage': 'Porcentaje de conversión',
  'Conversion rate': 'Tasa de conversión',
  'Conversion tag': 'Etiqueta de conversión',
  'Conversion tag is required': 'Se requiere etiqueta de conversión',
  'Conversions': 'Conversiones',
  'Conversions that exhausted the retry budget.': 'Conversiones que agotaron el presupuesto de reintentos.',
  'Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.': 'Conversiones que agotaron el presupuesto de reintentos. Reintentar vuelve a intentar el reenviador; descartar elimina la entrada permanentemente.',
  'Copied': 'Copiado',
  'Copy': 'Copiar',
  'Copy link': 'Copiar enlace',
  'Copy tracking link': 'Copiar enlace de tracking',
  'Copy value': 'Copiar valor',
  'Copy your key now — it will not be shown again': 'Copia tu clave ahora — no se mostrará de nuevo',
  'Cost model': 'Modelo de costo',
  'Could not save currency': 'No se pudo guardar la moneda',
  'Countries': 'Países',
  'Countries (ISO codes)': 'Países (códigos ISO)',
  'Countries (ISO codes, e.g. US, RU)': 'Países (códigos ISO, ej. US, RU)',
  'Countries (comma-separated ISO codes, e.g. US,RU,DE)': 'Países (códigos ISO separados por comas, ej. US,RU,DE)',
  'Country': 'País',
  'Country block': 'Bloqueo por país',
  'Create': 'Crear',
  'Create A/B test': 'Crear prueba A/B',
  'Create a new xpnsr.tech account': 'Crear una nueva cuenta xpnsr.tech',
  'Create a new xpnsr.tech account.': 'Crear una nueva cuenta xpnsr.tech.',
  'Create account': 'Crear cuenta',
  'Create automation rule': 'Crear regla de automatización',
  'Create campaign': 'Crear campaña',
  'Create filter': 'Crear filtro',
  'Create filters for automatic fraud protection': 'Crear filtros para protección antifraude automática',
  'Create fraud filter': 'Crear filtro antifraude',
  'Create landing pages for use in campaigns': 'Crear landings para usar en campañas',
  'Create new account': 'Crear nueva cuenta',
  'Create new campaign': 'Crear nueva campaña',
  'Create offers to monetize your traffic': 'Crear ofertas para monetizar tu tráfico',
  'Create rule': 'Crear regla',
  'Create rules to automatically manage campaigns': 'Crear reglas para gestionar campañas automáticamente',
  'Create rules to distribute traffic by conditions': 'Crear reglas para distribuir tráfico por condiciones',
  'Create source': 'Crear fuente',
  'Create sources to integrate with ad networks': 'Crear fuentes para integrar con redes publicitarias',
  'Create split tests to optimize conversions': 'Crear split tests para optimizar conversiones',
  'Create stream': 'Crear stream',
  'Create streams to distribute traffic by conditions': 'Crear streams para distribuir tráfico por condiciones',
  'Create test': 'Crear prueba',
  'Create traffic rule': 'Crear regla de tráfico',
  'Create traffic source': 'Crear fuente de tráfico',
  'Create webhooks to send events to external systems': 'Crear webhooks para enviar eventos a sistemas externos',
  'Create your first campaign': 'Crea tu primera campaña',
  'Create your first campaign to start tracking traffic': 'Crea tu primera campaña para empezar a trackear tráfico',
  'Create, edit and track your ad campaigns in real time': 'Crea, edita y trackea tus campañas publicitarias en tiempo real',
  'Created': 'Creado',
  'Creating account…': 'Creando cuenta…',
  'Crypto': 'Cripto',
  'Currency': 'Moneda',
  'Current': 'Actual',
  'Current password': 'Contraseña actual',
  'Current plan': 'Plan actual',
  'Custom API integration': 'Integración API personalizada',
  'Custom domains': 'Dominios personalizados',
  'Customize the look and behavior of the app': 'Personaliza la apariencia y el comportamiento de la app',
  'DLQ entry discarded': 'Entrada DLQ descartada',
  'Daily limit': 'Límite diario',
  'Dashboard': 'Panel',
  'Dashboard refresh rate (sec)': 'Frecuencia de actualización del dashboard (seg)',
  'Data visualization for fast decisions.': 'Visualización de datos para decisiones rápidas.',
  'Datacenter / hosting block': 'Bloqueo por datacenter / hosting',
  'Date format': 'Formato de fecha',
  'Dating': 'Dating',
  'Day-of-week x hour-of-day breakdown': 'Desglose por día de la semana y hora',
  'Dead-letter queue': 'Cola de mensajes muertos',
  'Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.': 'Declara los parámetros URL que pasas a través de redes publicitarias. Cada fila se convierte en una macro como {key} disponible en postbacks y payloads CAPI.',
  'Default': 'Predeterminado',
  'Default domain updated': 'Dominio predeterminado actualizado',
  'Delete': 'Eliminar',
  'Delete failed': 'Error al eliminar',
  'Delete forwarder?': '¿Eliminar reenviador?',
  'Delete integration?': '¿Eliminar integración?',
  'Delete this A/B test?': '¿Eliminar esta prueba A/B?',
  'Delete this connection?': '¿Eliminar esta conexión?',
  'Delete this domain?': '¿Eliminar este dominio?',
  'Delete this key?': '¿Eliminar esta clave?',
  'Delete this landing page?': '¿Eliminar esta landing?',
  'Delete this offer?': '¿Eliminar esta oferta?',
  'Delete this stream?': '¿Eliminar este stream?',
  'Delete webhook?': '¿Eliminar webhook?',
  'Deleted': 'Eliminado',
  'Deleted {n}': 'Eliminadas: {n}',
  'Description': 'Descripción',
  'Description (optional)': 'Descripción (opcional)',
  'Details': 'Detalles',
  'Device breakdown': 'Desglose por dispositivo',
  'Device type': 'Tipo de dispositivo',
  'Devices': 'Dispositivos',
  'Devices table': 'Tabla de dispositivos',
  'Discard': 'Descartar',
  'Discard failed': 'Error al descartar',
  'Disconnected': 'Desconectado',
  'Dismiss': 'Descartar',
  'Display currency': 'Moneda a mostrar',
  'Display name': 'Nombre para mostrar',
  'Docs': 'Documentación',
  'Domain added': 'Dominio agregado',
  'Domain deleted': 'Dominio eliminado',
  'Domain verified': 'Dominio verificado',
  'Domains': 'Dominios',
  'Download': 'Descargar',
  'Draft': 'Borrador',
  'Drag & drop or click to select': 'Arrastra y suelta o haz clic para seleccionar',
  'Due now': 'Pendientes ahora',
  'Edit': 'Editar',
  'Edit automation rule': 'Editar regla de automatización',
  'Edit campaign': 'Editar campaña',
  'Edit existing campaigns': 'Editar campañas existentes',
  'Edit filter': 'Editar filtro',
  'Edit forwarder': 'Editar reenviador',
  'Edit integration': 'Editar integración',
  'Edit landing page': 'Editar landing',
  'Edit landing page settings': 'Editar configuración de landing',
  'Edit offer': 'Editar oferta',
  'Edit rule': 'Editar regla',
  'Edit stream': 'Editar stream',
  'Edit traffic source': 'Editar fuente de tráfico',
  'Edit webhook': 'Editar webhook',
  'Email': 'Correo electrónico',
  'Email notifications': 'Notificaciones por email',
  'Enable HTTPS': 'Habilitar HTTPS',
  'Enter current password': 'Ingresa la contraseña actual',
  'Enter new password': 'Ingresa la nueva contraseña',
  'Enter parameter name:': 'Ingresa el nombre del parámetro:',
  'Enter your credentials to continue.': 'Ingresa tus credenciales para continuar.',
  'Enter your email': 'Ingresa tu email',
  'Enter your full name': 'Ingresa tu nombre completo',
  'Error changing password': 'Error al cambiar la contraseña',
  'Error creating': 'Error al crear',
  'Error creating campaign': 'Error al crear campaña',
  'Error creating landing page': 'Error al crear landing',
  'Error creating offer': 'Error al crear oferta',
  'Error creating traffic source': 'Error al crear fuente de tráfico',
  'Error creating webhook': 'Error al crear webhook',
  'Error deleting': 'Error al eliminar',
  'Error deleting campaign': 'Error al eliminar campaña',
  'Error deleting landing page': 'Error al eliminar landing',
  'Error deleting offer': 'Error al eliminar oferta',
  'Error deleting traffic source': 'Error al eliminar fuente de tráfico',
  'Error loading campaigns': 'Error al cargar campañas',
  'Error loading landing pages': 'Error al cargar landings',
  'Error loading offers': 'Error al cargar ofertas',
  'Error loading settings': 'Error al cargar configuración',
  'Error loading traffic sources': 'Error al cargar fuentes de tráfico',
  'Error saving settings': 'Error al guardar configuración',
  'Error saving system settings': 'Error al guardar configuración del sistema',
  'Error testing webhook': 'Error al probar webhook',
  'Error updating': 'Error al actualizar',
  'Error updating campaign': 'Error al actualizar campaña',
  'Error updating landing page': 'Error al actualizar landing',
  'Error updating offer': 'Error al actualizar oferta',
  'Error updating profile': 'Error al actualizar perfil',
  'Error updating traffic source': 'Error al actualizar fuente de tráfico',
  'Error uploading landing page': 'Error al subir landing',
  'Error uploading offer': 'Error al subir oferta',
  'Errors': 'Errores',
  'Event': 'Evento',
  'Event name': 'Nombre del evento',
  'Events': 'Eventos',
  'Execution history': 'Historial de ejecuciones',
  'Execution history is empty': 'El historial de ejecuciones está vacío',
  'Execution settings': 'Configuración de ejecución',
  'Executions': 'Ejecuciones',
  'Explicit blocked fingerprints (comma-separated)': 'Huellas explícitas bloqueadas (separadas por comas)',
  'Export': 'Exportar',
  'Export CSV': 'Exportar CSV',
  'External provider': 'Proveedor externo',
  'External risk score': 'Puntuación de riesgo externa',
  'FX cache': 'Caché de divisas',
  'FX cache is empty.': 'El caché de divisas está vacío.',
  'FX rates unavailable — non-USD revenue is excluded from the totals.': 'Tipos de cambio no disponibles — los ingresos no-USD se excluyen de los totales.',
  'Failed': 'Fallido',
  'Failed to add IP': 'Error al agregar IP',
  'Failed to add domain': 'Error al agregar dominio',
  'Failed to change rule status': 'Error al cambiar estado de regla',
  'Failed to copy link': 'Error al copiar enlace',
  'Failed to create A/B test': 'Error al crear prueba A/B',
  'Failed to create automation rule': 'Error al crear regla de automatización',
  'Failed to create filter': 'Error al crear filtro',
  'Failed to create landing': 'Error al crear landing',
  'Failed to create offer': 'Error al crear oferta',
  'Failed to create rule': 'Error al crear regla',
  'Failed to create stream': 'Error al crear stream',
  'Failed to delete automation rule': 'Error al eliminar regla de automatización',
  'Failed to delete filter': 'Error al eliminar filtro',
  'Failed to delete rule': 'Error al eliminar regla',
  'Failed to delete stream': 'Error al eliminar stream',
  'Failed to delete test': 'Error al eliminar prueba',
  'Failed to load A/B tests': 'Error al cargar pruebas A/B',
  'Failed to load CAPI DLQ': 'Error al cargar CAPI DLQ',
  'Failed to load admin health': 'Error al cargar salud del admin',
  'Failed to load audit log': 'Error al cargar registro de auditoría',
  'Failed to load automation rules': 'Error al cargar reglas de automatización',
  'Failed to load blocked samples': 'Error al cargar muestras bloqueadas',
  'Failed to load campaign': 'Error al cargar campaña',
  'Failed to load connections': 'Error al cargar conexiones',
  'Failed to load data': 'Error al cargar datos',
  'Failed to load results': 'Error al cargar resultados',
  'Failed to load streams': 'Error al cargar streams',
  'Failed to load traffic rules': 'Error al cargar reglas de tráfico',
  'Failed to pause test': 'Error al pausar prueba',
  'Failed to remove IP': 'Error al eliminar IP',
  'Failed to save notification settings': 'Error al guardar configuración de notificaciones',
  'Failed to start OAuth': 'Error al iniciar OAuth',
  'Failed to start test': 'Error al iniciar prueba',
  'Failed to update activity': 'Error al actualizar actividad',
  'Failed to update automation rule': 'Error al actualizar regla de automatización',
  'Failed to update filter': 'Error al actualizar filtro',
  'Failed to update rule': 'Error al actualizar regla',
  'Failed to update stream': 'Error al actualizar stream',
  'Fallback': 'Respaldo',
  'False positives': 'Falsos positivos',
  'Fill in name and URL': 'Completa el nombre y la URL',
  'Fill in the details of your new ad campaign': 'Completa los detalles de tu nueva campaña publicitaria',
  'Fill in type and name': 'Completa el tipo y el nombre',
  'Filter created': 'Filtro creado',
  'Filter deleted': 'Filtro eliminado',
  'Filter description': 'Descripción del filtro',
  'Filter name': 'Nombre del filtro',
  'Filter type': 'Tipo de filtro',
  'Filter unique': 'Filtrar únicos',
  'Filter updated': 'Filtro actualizado',
  'Filters': 'Filtros',
  'Finance': 'Finanzas',
  'Fire Google Ads gtag on redirect': 'Disparar Google Ads gtag en la redirección',
  'For example: Product A ad': 'Por ejemplo: Anuncio del producto A',
  'For the current day': 'Para el día actual',
  'Forgot password?': '¿Olvidaste la contraseña?',
  'Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.': 'Reenvía conversiones servidor-a-servidor a redes publicitarias (FB CAPI, Google Ads, TikTok). Se dispara automáticamente en cada postback.',
  'Forwarder': 'Reenviador',
  'Forwarder ID': 'ID de reenviador',
  'Forwarder created': 'Reenviador creado',
  'Forwarder deleted': 'Reenviador eliminado',
  'Forwarder updated': 'Reenviador actualizado',
  'Fraud alerts': 'Alertas de fraude',
  'Fraud detected': 'Fraude detectado',
  'Fraud filters': 'Filtros antifraude',
  'Free forever': 'Gratis para siempre',
  'Fri': 'Vie',
  'Full name': 'Nombre completo',
  'Funnel': 'Embudo',
  'Gambling': 'Apuestas',
  'Generated at': 'Generado el',
  'Geo': 'Geo',
  'Geo table': 'Tabla geo',
  'Geographic data will appear after the first clicks with resolvable coordinates': 'Los datos geográficos aparecerán después de los primeros clics con coordenadas resolubles',
  'Geographic statistics': 'Estadísticas geográficas',
  'Get SMS for critical events': 'Recibe SMS para eventos críticos',
  'Get email notifications about important events': 'Recibe notificaciones por email sobre eventos importantes',
  'Google Ads tag': 'Etiqueta de Google Ads',
  'HTTPS active': 'HTTPS activo',
  'Heatmap': 'Mapa de calor',
  'Hide password': 'Ocultar contraseña',
  'History': 'Historial',
  'Home': 'Inicio',
  'Hourly activity': 'Actividad por hora',
  'IP': 'IP',
  'IP added to blacklist': 'IP agregada a la lista negra',
  'IP added to whitelist': 'IP agregada a la lista blanca',
  'IP address': 'Dirección IP',
  'IP blacklist': 'Lista negra de IPs',
  'IP lists': 'Listas de IPs',
  'IP removed from blacklist': 'IP eliminada de la lista negra',
  'IP removed from whitelist': 'IP eliminada de la lista blanca',
  'IP whitelist': 'Lista blanca de IPs',
  'Import ad statistics': 'Importar estadísticas publicitarias',
  'Import costs and conversions': 'Importar costos y conversiones',
  'Inactive': 'Inactivo',
  'Integration created': 'Integración creada',
  'Integration deleted': 'Integración eliminada',
  'Integration type': 'Tipo de integración',
  'Integration updated': 'Integración actualizada',
  'Integrations': 'Integraciones',
  'Interface preferences': 'Preferencias de interfaz',
  'Interval': 'Intervalo',
  'Interval between executions (min)': 'Intervalo entre ejecuciones (min)',
  'Invalid email or password': 'Email o contraseña inválidos',
  'Invite': 'Invitar',
  'Invite member': 'Invitar miembro',
  'Invite sent': 'Invitación enviada',
  'Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.': 'Invita compañeros con roles. El propietario ve todo; manager/admin pueden editar; viewer es solo lectura.',
  'Invited': 'Invitado',
  'Jane Doe': 'María García',
  'KPIs, sources and leads in one panel.': 'KPIs, fuentes y leads en un solo panel.',
  'Key (e.g. api_key)': 'Clave (ej. api_key)',
  'Key deleted': 'Clave eliminada',
  'Kyiv (UTC+2)': 'Kiev (UTC+2)',
  'Landing created': 'Landing creada',
  'Landing description': 'Descripción de la landing',
  'Landing name': 'Nombre de la landing',
  'Landing page created': 'Landing creada',
  'Landing page deleted': 'Landing eliminada',
  'Landing page description': 'Descripción de la landing',
  'Landing page test': 'Prueba de landing',
  'Landing page updated': 'Landing actualizada',
  'Landing page uploaded successfully': 'Landing subida con éxito',
  'Landing pages': 'Páginas de aterrizaje',
  'Landings': 'Landings',
  'Landings and offers': 'Landings y ofertas',
  'Language': 'Idioma',
  'Languages': 'Idiomas',
  'Last error': 'Último error',
  'Last execution': 'Última ejecución',
  'Last sent': 'Último envío',
  'Last sync': 'Última sincronización',
  'Lead': 'Lead',
  'Lead generation': 'Generación de leads',
  'Less': 'Menos',
  'Limit': 'Límite',
  'Link copied to clipboard!': '¡Enlace copiado al portapapeles!',
  'Load more': 'Cargar más',
  'Loading': 'Cargando',
  'Loading geographic data...': 'Cargando datos geográficos...',
  'Loading workspace': 'Cargando espacio de trabajo',
  'Loading your data…': 'Cargando tus datos…',
  'Loading...': 'Cargando...',
  'Loading…': 'Cargando…',
  'Log only': 'Solo registrar',
  'Manage': 'Gestionar',
  'Manage billing': 'Gestionar facturación',
  'Manage campaigns': 'Gestionar campañas',
  'Manage your basic account information': 'Gestiona la información básica de tu cuenta',
  'Mark as resolved': 'Marcar como resuelto',
  'Max clicks per minute': 'Clics máximos por minuto',
  'Maximum cost per click': 'Costo máximo por clic',
  'Maximum executions per day': 'Ejecuciones máximas por día',
  'Member had no 2FA configured': 'El miembro no tenía 2FA configurado',
  'Members': 'Miembros',
  'Method': 'Método',
  'Minimum CR (%)': 'CR mínimo (%)',
  'Minimum sample size': 'Tamaño mínimo de muestra',
  'Missing fields': 'Campos faltantes',
  'Mode': 'Modo',
  'Modify stream settings': 'Modificar configuración del stream',
  'Mon': 'Lun',
  'More': 'Más',
  'More details': 'Más detalles',
  'Moscow (UTC+3)': 'Moscú (UTC+3)',
  'Most recent traffic caught by this filter. Use it to spot false positives.': 'Tráfico más reciente capturado por este filtro. Úsalo para detectar falsos positivos.',
  'My account': 'Mi cuenta',
  'My landing': 'Mi landing',
  'My landing page': 'Mi landing',
  'My offer': 'Mi oferta',
  'My webhook': 'Mi webhook',
  'Name': 'Nombre',
  'Name is required': 'El nombre es obligatorio',
  'Network': 'Red',
  'New API key': 'Nueva clave API',
  'New forwarder': 'Nuevo reenviador',
  'New integration': 'Nueva integración',
  'New key': 'Nueva clave',
  'New landing page': 'Nueva landing',
  'New offer': 'Nueva oferta',
  'New password': 'Nueva contraseña',
  'New password must be at least 6 characters': 'La nueva contraseña debe tener al menos 6 caracteres',
  'New passwords do not match': 'Las nuevas contraseñas no coinciden',
  'New registrations are disabled. Contact your workspace admin for an invitation.': 'Las nuevas inscripciones están deshabilitadas. Contacta al admin de tu espacio para una invitación.',
  'New webhook': 'Nuevo webhook',
  'Next': 'Siguiente',
  'No': 'No',
  'No A/B tests': 'Sin pruebas A/B',
  'No API keys yet': 'Aún no hay claves API',
  'No CAPI events in window.': 'Sin eventos CAPI en la ventana.',
  'No DLQ entries match these filters.': 'Ninguna entrada DLQ coincide con estos filtros.',
  'No ROI data': 'Sin datos de ROI',
  'No active ad-cost connections.': 'No hay conexiones activas de costos publicitarios.',
  'No active filters': 'Sin filtros activos',
  'No audit entries match the current filters.': 'Ninguna entrada de auditoría coincide con los filtros actuales.',
  'No automation rules': 'Sin reglas de automatización',
  'No blocked samples yet': 'Aún no hay muestras bloqueadas',
  'No campaign data': 'Sin datos de campaña',
  'No campaigns': 'Sin campañas',
  'No city data': 'Sin datos de ciudad',
  'No clicks for this campaign yet': 'Aún no hay clics para esta campaña',
  'No connections yet. Connect FB or Google Ads to start importing cost.': 'Aún no hay conexiones. Conecta FB o Google Ads para empezar a importar costos.',
  'No country data': 'Sin datos de país',
  'No data': 'Sin datos',
  'No data for the selected period': 'Sin datos para el período seleccionado',
  'No data to display': 'Sin datos para mostrar',
  'No data to display on map': 'Sin datos para mostrar en el mapa',
  'No description': 'Sin descripción',
  'No device data': 'Sin datos de dispositivos',
  'No domains yet': 'Aún no hay dominios',
  'No events yet': 'Aún no hay eventos',
  'No forwarders yet': 'Aún no hay reenviadores',
  'No funnel data': 'Sin datos de embudo',
  'No geo data': 'Sin datos geográficos',
  'No heatmap data': 'Sin datos de mapa de calor',
  'No integrations': 'Sin integraciones',
  'No landing pages': 'Sin landings',
  'No landings': 'Sin landings',
  'No landings available': 'No hay landings disponibles',
  'No limit': 'Sin límite',
  'No members yet': 'Aún no hay miembros',
  'No offers': 'Sin ofertas',
  'No offers available': 'No hay ofertas disponibles',
  'No parameters added': 'No se agregaron parámetros',
  'No parameters yet': 'Aún no hay parámetros',
  'No postbacks yet': 'Aún no hay postbacks',
  'No shared workspaces': 'Sin espacios compartidos',
  'No streams': 'Sin streams',
  'No suspicious activity detected': 'No se detectó actividad sospechosa',
  'No traffic rules': 'Sin reglas de tráfico',
  'No traffic sources': 'Sin fuentes de tráfico',
  'No webhooks': 'Sin webhooks',
  'No webhooks yet': 'Aún no hay webhooks',
  'Notes': 'Notas',
  'Notification channels': 'Canales de notificación',
  'Notification preferences saved': 'Preferencias de notificación guardadas',
  'Notifications': 'Notificaciones',
  'Notify me about': 'Notificarme sobre',
  'Manage how and when you receive alerts': 'Gestiona cómo y cuándo recibes alertas',
  'Save preferences': 'Guardar preferencias',
  'Saving…': 'Guardando…',
  'Delivery channels': 'Canales de entrega',
  'Choose how to receive notifications': 'Elige cómo recibir notificaciones',
  'Receive alerts via email': 'Recibir alertas por email',
  'SMS notifications': 'Notificaciones por SMS',
  'Critical alerts via SMS': 'Alertas críticas por SMS',
  'In-app and browser push': 'Push en app y navegador',
  'POST JSON payloads to your endpoint': 'POST JSON a tu endpoint',
  'Alert categories': 'Categorías de alertas',
  'Choose which types of events trigger notifications': 'Elige qué tipos de eventos activan notificaciones',
  'Paused, resumed, daily cap reached': 'Pausada, reanudada, límite diario alcanzado',
  'Performance alerts': 'Alertas de rendimiento',
  'ROI drop, conversion rate change, EPC decline': 'Caída de ROI, cambio de tasa de conversión, descenso de EPC',
  'Suspicious clicks, bot traffic, IP blacklist hits': 'Clics sospechosos, tráfico bot, IPs en lista negra',
  'System alerts': 'Alertas del sistema',
  'Domain verification, TLS expiry, billing': 'Verificación de dominio, expiración TLS, facturación',
  'Failed to load notification settings': 'Error al cargar configuración de notificaciones',
  'CSV exported': 'CSV exportado',
  'Export campaigns to CSV': 'Exportar campañas a CSV',
  'Export offers to CSV': 'Exportar ofertas a CSV',
  'Number of clicks': 'Número de clics',
  'Number of conversions': 'Número de conversiones',
  'OAuth': 'OAuth',
  'OAuth error: ': 'Error OAuth: ',
  'Offer': 'Oferta',
  'Offer category': 'Categoría de oferta',
  'Offer created': 'Oferta creada',
  'Offer deleted': 'Oferta eliminada',
  'Offer description': 'Descripción de la oferta',
  'Offer details': 'Detalles de la oferta',
  'Offer name': 'Nombre de la oferta',
  'Offer payout': 'Payout de la oferta',
  'Offer test': 'Prueba de oferta',
  'Offer updated': 'Oferta actualizada',
  'Offer uploaded successfully': 'Oferta subida con éxito',
  'Offer with the same name already exists': 'Ya existe una oferta con el mismo nombre',
  'Offers': 'Ofertas',
  'Oldest': 'Más antiguo',
  'On approval': 'Tras aprobación',
  'On rejection': 'Tras rechazo',
  'On track': 'En curso',
  'Only currency code is updated; existing balances stay numeric and are not converted.': 'Solo se actualiza el código de moneda; los saldos existentes permanecen numéricos y no se convierten.',
  'Open menu': 'Abrir menú',
  'Open variant': 'Abrir variante',
  'Optional comma-separated list of ASN numbers (e.g. 16509 = AWS) you trust enough to let through.': 'Lista opcional de números ASN separados por comas (ej. 16509 = AWS) en los que confías lo suficiente para permitir paso.',
  'Order by': 'Ordenar por',
  'Other': 'Otro',
  'Owner': 'Propietario',
  'Page is not the source of truth': 'Esta página no es la fuente de verdad',
  'Page not found': 'Página no encontrada',
  'Page weight': 'Peso de la página',
  'Param': 'Parámetro',
  'Parameters': 'Parámetros',
  'Password': 'Contraseña',
  'Pause': 'Pausar',
  'Paused': 'En pausa',
  'Paused (no traffic)': 'Pausado (sin tráfico)',
  'Paused {n}': 'En pausa: {n}',
  'Pay-per-click': 'Pago por clic',
  'Pay-per-impression': 'Pago por impresión',
  'Pay-per-lead': 'Pago por lead',
  'Pay-per-sale': 'Pago por venta',
  'Peak': 'Pico',
  'Pending CAPI re-attempts.': 'Reintentos CAPI pendientes.',
  'Per-base exchange-rate snapshot freshness.': 'Frescura del snapshot de tipos de cambio por base.',
  'Per-page test settings': 'Configuración de prueba por página',
  'Permission denied': 'Permiso denegado',
  'Permissions': 'Permisos',
  'Personal info': 'Información personal',
  'Phone': 'Teléfono',
  'Pin': 'Fijar',
  'Pinned': 'Fijado',
  'Pixel ID': 'ID de pixel',
  'Plan name': 'Nombre del plan',
  'Platform': 'Plataforma',
  'Platform fee': 'Comisión de plataforma',
  'Postback delivery': 'Entrega de postbacks',
  'Postback fired': 'Postback disparado',
  'Precise tracking': 'Tracking preciso',
  'Preferences': 'Preferencias',
  'Previous': 'Anterior',
  'Primary tracking domain': 'Dominio principal de tracking',
  'Priority': 'Prioridad',
  'Profile': 'Perfil',
  'Profile information': 'Información del perfil',
  'Profile updated successfully': 'Perfil actualizado con éxito',
  'Profit': 'Ganancia',
  'Net positive': 'Ganancia neta',
  'Net loss': 'Pérdida neta',
  'Progress to minimum sample': 'Progreso al mínimo de muestra',
  'Provider': 'Proveedor',
  'Proxy / VPN / Tor block': 'Bloqueo proxy / VPN / Tor',
  'Public API': 'API pública',
  'Push notifications': 'Notificaciones push',
  'Quick actions': 'Acciones rápidas',
  'Quick start': 'Inicio rápido',
  'ROI by campaigns': 'ROI por campañas',
  'Readable reports': 'Reportes legibles',
  'Real-time overview of your campaigns and stats': 'Resumen en tiempo real de tus campañas y estadísticas',
  'Reason': 'Razón',
  'Reason for adding': 'Razón para agregar',
  'Receive SMS for critical events': 'Recibe SMS para eventos críticos',
  'Receive notifications by email': 'Recibe notificaciones por email',
  'Recent activity for this campaign': 'Actividad reciente para esta campaña',
  'Recent campaigns': 'Campañas recientes',
  'Recent clicks': 'Clics recientes',
  'Records of automatic rule executions will appear here': 'Aquí aparecerán los registros de ejecuciones automáticas',
  'Redirect': 'Redirección',
  'Redirect URL': 'URL de redirección',
  'Redirects': 'Redirecciones',
  'Refresh': 'Actualizar',
  'Refresh failed': 'Error al actualizar token',
  'Refresh token': 'Token de actualización',
  'Refresh token (optional)': 'Token de actualización (opcional)',
  'Refreshed': 'Actualizado',
  'Registration failed': 'Registro fallido',
  'Registration failed. Please try again.': 'Registro fallido. Por favor intenta de nuevo.',
  'Registration successful!': '¡Registro exitoso!',
  'Reject': 'Rechazar',
  'Remember this device': 'Recordar este dispositivo',
  'Replay': 'Reintentar',
  'Replay failed': 'Reintento fallido',
  'Replay failed:': 'Reintento fallido:',
  'Report exported': 'Reporte exportado',
  'Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.': 'Reportes y dashboards se normalizarán a esta moneda. Los tipos de cambio se actualizan cada hora.',
  'Reset': 'Restablecer',
  'Reset 2FA': 'Restablecer 2FA',
  'Resolved': 'Resuelto',
  'Retry attempts': 'Intentos de reintento',
  'Retry queue': 'Cola de reintentos',
  'Revenue': 'Ingresos',
  'Revoke access': 'Revocar acceso',
  'Revoke access?': '¿Revocar acceso?',
  'Risk score threshold (0-100)': 'Umbral de puntuación de riesgo (0-100)',
  'Risk score threshold (0.0 – 1.0)': 'Umbral de puntuación de riesgo (0.0 – 1.0)',
  'Role': 'Rol',
  'Routing record (CNAME)': 'Registro de enrutamiento (CNAME)',
  'Rule activated': 'Regla activada',
  'Rule deactivated': 'Regla desactivada',
  'Rule deleted': 'Regla eliminada',
  'Rule description': 'Descripción de la regla',
  'Rule name': 'Nombre de la regla',
  'Rule type': 'Tipo de regla',
  'Rule updated': 'Regla actualizada',
  'Rules': 'Reglas',
  'Running': 'Ejecutándose',
  'S2S postback callouts in the last window.': 'Llamadas postback S2S en la última ventana.',
  'S2S postback · bot shield': 'Postback S2S · escudo anti-bot',
  'S2S postbacks': 'Postbacks S2S',
  'Sale': 'Venta',
  'Sat': 'Sáb',
  'Save': 'Guardar',
  'Save changes': 'Guardar cambios',
  'Save domain settings': 'Guardar configuración de dominio',
  'Save failed': 'Error al guardar',
  'Save notification settings': 'Guardar configuración de notificaciones',
  'Save profile': 'Guardar perfil',
  'Save settings': 'Guardar configuración',
  'Saved': 'Guardado',
  'Scale your team': 'Escala tu equipo',
  'Scopes': 'Alcances',
  'Search': 'Buscar',
  'Search campaigns, streams…': 'Buscar campañas, streams…',
  'Search campaigns…': 'Buscar campañas…',
  'Search landing pages…': 'Buscar landings…',
  'Search offers…': 'Buscar ofertas…',
  'Search traffic sources…': 'Buscar fuentes de tráfico…',
  'Secret (optional)': 'Secreto (opcional)',
  'Security': 'Seguridad',
  'Security and access settings': 'Configuración de seguridad y acceso',
  'Security settings': 'Configuración de seguridad',
  'Select ZIP File': 'Seleccionar archivo ZIP',
  'Select ZIP file': 'Seleccionar archivo ZIP',
  'Select a campaign': 'Selecciona una campaña',
  'Select a campaign to manage traffic rules': 'Selecciona una campaña para gestionar reglas de tráfico',
  'Select a traffic source (optional)': 'Selecciona una fuente de tráfico (opcional)',
  'Select campaign': 'Seleccionar campaña',
  'Select category': 'Seleccionar categoría',
  'Select type': 'Seleccionar tipo',
  'Send test': 'Enviar prueba',
  'Sent': 'Enviado',
  'Separate tags with commas': 'Separa las etiquetas con comas',
  'Server-to-server postbacks': 'Postbacks servidor-a-servidor',
  'Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.': 'Configura IPQS_API_KEY o FRAUDSCORE_API_KEY en el entorno del backend.',
  'Set default': 'Establecer predeterminado',
  'Set up split testing to optimize conversions': 'Configura split testing para optimizar conversiones',
  'Settings': 'Ajustes',
  'Share': 'Compartir',
  'Share this link with the invitee:': 'Comparte este enlace con el invitado:',
  'Shared with me': 'Compartido conmigo',
  'Short campaign description': 'Descripción corta de la campaña',
  'Show all campaigns': 'Ver todas las campañas',
  'Show password': 'Mostrar contraseña',
  'Show recent log': 'Mostrar log reciente',
  'Showing latest 10 clicks': 'Mostrando los últimos 10 clics',
  'Sign in': 'Iniciar sesión',
  'Sign in failed': 'Fallo al iniciar sesión',
  'Sign in successfully!': '¡Sesión iniciada!',
  'Sign in to your xpnsr account': 'Inicia sesión en tu cuenta xpnsr',
  'Sign out': 'Cerrar sesión',
  'Sign up': 'Registrarse',
  'Signed in successfully!': '¡Sesión iniciada!',
  'Signed out': 'Sesión cerrada',
  'Significance': 'Significancia',
  'Signing in…': 'Iniciando sesión…',
  'Simple': 'Simple',
  'Since': 'Desde',
  'Since (ISO)': 'Desde (ISO)',
  'Skipped {n} (no access or not found)': 'Omitidas: {n} (sin acceso o no encontradas)',
  'Source macro': 'Macro de fuente',
  'Source template': 'Plantilla de fuente',
  'Sources': 'Fuentes',
  'Sources not found': 'Fuentes no encontradas',
  'Spend': 'Gasto',
  'Split test': 'Split test',
  'Statistics': 'Estadísticas',
  'Status': 'Estado',
  'Status breakdown': 'Desglose por estado',
  'Statuses': 'Estados',
  'Stopped': 'Detenido',
  'Stream action': 'Acción del stream',
  'Stream created': 'Stream creado',
  'Stream deleted': 'Stream eliminado',
  'Stream name': 'Nombre del stream',
  'Stream type': 'Tipo de stream',
  'Stream updated': 'Stream actualizado',
  'Streams': 'Streams',
  'Subscription': 'Suscripción',
  'Success': 'Éxito',
  'Success rate': 'Tasa de éxito',
  'Successful conversions': 'Conversiones exitosas',
  'Sun': 'Dom',
  'Suspicious activity': 'Actividad sospechosa',
  'Suspicious traffic detection': 'Detección de tráfico sospechoso',
  'Sweepstakes': 'Sweepstakes',
  'Sync campaigns and conversions': 'Sincronizar campañas y conversiones',
  'Sync complete': 'Sincronización completa',
  'Sync failed': 'Sincronización fallida',
  'Sync now': 'Sincronizar',
  'System': 'Sistema',
  'System health': 'Estado del sistema',
  // Nav labels added after the !99 coverage fill (parity !105/!108).
  'System status': 'Estatus del sistema',
  'S2S log': 'Registro S2S',
  'TLS fingerprints': 'Huellas TLS',
  'API docs': 'Documentación de API',
  'System settings saved': 'Configuración del sistema guardada',
  'TLS fingerprint (JA3 / JA4)': 'Huella TLS (JA3 / JA4)',
  'TLS provisioning failed': 'Aprovisionamiento TLS fallido',
  'TLS provisioning started': 'Aprovisionamiento TLS iniciado',
  'TLS validation records': 'Registros de validación TLS',
  'TXT verification record': 'Registro de verificación TXT',
  'Tags': 'Etiquetas',
  'Target': 'Objetivo',
  'Target URL': 'URL objetivo',
  'Target type': 'Tipo de objetivo',
  'Team': 'Equipo',
  'Telegram notifications': 'Notificaciones de Telegram',
  'Test': 'Prueba',
  'Test description': 'Descripción de la prueba',
  'Test error: {detail}': 'Error de prueba: {detail}',
  'Test event sent': 'Evento de prueba enviado',
  'Test failed': 'Prueba fallida',
  'Test name': 'Nombre de la prueba',
  'Test succeeded (HTTP {code})': 'Prueba exitosa (HTTP {code})',
  'Test type': 'Tipo de prueba',
  'Test variants': 'Variantes de prueba',
  'The system automatically tracks suspicious actions': 'El sistema rastrea automáticamente acciones sospechosas',
  'Threshold reached': 'Umbral alcanzado',
  'Thu': 'Jue',
  'Time': 'Hora',
  'Timeout (sec)': 'Tiempo de espera (seg)',
  'Timezone': 'Zona horaria',
  'Today': 'Hoy',
  'Token refreshed': 'Token actualizado',
  'Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.': 'Los tokens están cifrados en reposo. Usa los botones OAuth arriba para FB / Google, o ingresa tokens manualmente abajo.',
  'Total': 'Total',
  'Total active campaigns': 'Campañas activas en total',
  'Total clicks': 'Clics totales',
  'Total revenue': 'Ingresos totales',
  'Total spend': 'Gasto total',
  'Total weight': 'Peso total',
  'Tracker domains': 'Dominios del tracker',
  'Tracking ID': 'ID de tracking',
  'Tracking URL preview': 'Vista previa de URL de tracking',
  'Tracking domains': 'Dominios de tracking',
  'Tracking link': 'Enlace de tracking',
  'Tracking link copied!': '¡Enlace de tracking copiado!',
  'Tracking links will use': 'Los enlaces de tracking usarán',
  'Traffic': 'Tráfico',
  'Traffic distribution rules': 'Reglas de distribución de tráfico',
  'Traffic filters': 'Filtros de tráfico',
  'Traffic management': 'Gestión de tráfico',
  'Traffic paths': 'Rutas de tráfico',
  'Traffic rule created': 'Regla de tráfico creada',
  'Traffic rules': 'Reglas de tráfico',
  'Traffic source': 'Fuente de tráfico',
  'Traffic source created': 'Fuente de tráfico creada',
  'Traffic source deleted': 'Fuente de tráfico eliminada',
  'Traffic source description': 'Descripción de la fuente de tráfico',
  'Traffic source name': 'Nombre de la fuente de tráfico',
  'Traffic source updated': 'Fuente de tráfico actualizada',
  'Traffic sources': 'Fuentes de tráfico',
  'Traffic weight (%)': 'Peso del tráfico (%)',
  'Trigger conditions': 'Condiciones de disparo',
  'Try adjusting search criteria': 'Intenta ajustar los criterios de búsqueda',
  'Tue': 'Mar',
  'URL': 'URL',
  'URL (or pick below)': 'URL (o elige abajo)',
  'URL copied': 'URL copiada',
  'URL for receiving notifications in JSON format': 'URL para recibir notificaciones en formato JSON',
  'URL key': 'Clave URL',
  'UTM parameters': 'Parámetros UTM',
  'Unique': 'Único',
  'Unique clicks': 'Clics únicos',
  'Unique visitors': 'Visitantes únicos',
  'Unknown': 'Desconocido',
  'Until': 'Hasta',
  'Until (ISO)': 'Hasta (ISO)',
  'Update': 'Actualizar',
  'Update campaign details': 'Actualizar detalles de campaña',
  'Update traffic source settings': 'Actualizar configuración de fuente de tráfico',
  'Update your password to keep your account secure': 'Actualiza tu contraseña para mantener segura tu cuenta',
  'Updated': 'Actualizado',
  'Updates and technical information': 'Actualizaciones e información técnica',
  'Upgrade': 'Mejorar plan',
  'Upload': 'Subir',
  'Upload Landing Page': 'Subir landing',
  'Upload Offer': 'Subir oferta',
  'Upload Offer ZIP': 'Subir ZIP de oferta',
  'Upload ZIP': 'Subir ZIP',
  'Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.': 'Sube un archivo ZIP con páginas HTML, imágenes y otros recursos. Compatible con: _preview.png para vista previa, scripts PHP para procesamiento.',
  'Upload a ZIP file containing offer files': 'Sube un archivo ZIP con archivos de oferta',
  'Upload a ZIP file containing your landing page files (max 50MB)': 'Sube un archivo ZIP con los archivos de tu landing (máx 50MB)',
  'Uploading...': 'Subiendo...',
  'Upsell': 'Upsell',
  'Use API keys to call the public /v1 REST API. Pass the key as': 'Usa claves API para llamar a la REST API pública /v1. Pasa la clave como',
  'User': 'Usuario',
  'User Agent': 'User Agent',
  'User settings saved': 'Configuración de usuario guardada',
  'Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.': 'Usa la lista semilla (Python requests, Go net/http, curl, Chrome headless) más las anulaciones de tu espacio de trabajo.',
  'VKontakte integration': 'Integración VKontakte',
  'Value': 'Valor',
  'Variant name': 'Nombre de la variante',
  'Variant performance analysis': 'Análisis de rendimiento de variantes',
  'Variant {n}': 'Variante {n}',
  'Variants': 'Variantes',
  'Verification failed': 'Verificación fallida',
  'Verified': 'Verificado',
  'Verify': 'Verificar',
  'View blocked samples': 'Ver muestras bloqueadas',
  'View detailed statistics': 'Ver estadísticas detalladas',
  'Visitors': 'Visitantes',
  'Visits': 'Visitas',
  'Webhook URL': 'URL del webhook',
  'Webhook created': 'Webhook creado',
  'Webhook deleted': 'Webhook eliminado',
  'Webhook updated': 'Webhook actualizado',
  'Webhooks': 'Webhooks',
  'Wed': 'Mié',
  'Weight': 'Peso',
  'Weight (%)': 'Peso (%)',
  'Welcome back': 'Bienvenido de vuelta',
  'Welcome,': 'Bienvenido,',
  'Welcome, {name}.': 'Bienvenido, {name}.',
  'When on, /r/ returns a tiny HTML page that calls gtag("event","conversion", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.': 'Cuando está activado, /r/ devuelve una pequeña página HTML que llama a gtag("event","conversion", …) con tu etiqueta simple antes de redirigir. Úsalo si no configuras el sufijo Final URL del lado de Google Ads.',
  'Whitelist is empty': 'La lista blanca está vacía',
  'Window': 'Ventana',
  'Work email': 'Email de trabajo',
  'Workspace': 'Espacio de trabajo',
  'Workspace currency': 'Moneda del espacio de trabajo',
  'Workspace currency saved': 'Moneda del espacio guardada',
  'Workspace-scoped trail of privileged actions. Retained for 90 days.': 'Rastro de acciones privilegiadas dentro del workspace. Retenido 90 días.',
  'Yes': 'Sí',
  'You have no campaigns yet': 'Aún no tienes campañas',
  'Your latest campaigns': 'Tus últimas campañas',
  'ZIP File': 'Archivo ZIP',
  'ZIP File (max 100MB)': 'Archivo ZIP (máx 100MB)',
  'account': 'cuenta',
  'campaigns': 'campañas',
  'clicks/mo': 'clics/mes',
  'error': 'error',
  'fresh': 'fresco',
  'honest': 'honesto',
  'last used': 'último uso',
  'never used': 'nunca usado',
  'ok': 'ok',
  'or': 'o',
  'stale': 'obsoleto',
  'tag1, tag2, tag3': 'etiqueta1, etiqueta2, etiqueta3',
  'team members': 'miembros del equipo',
  '{n} clicks': '{n} clics',
  '{n} conversions': '{n} conversiones',
  '{n} min': '{n} min',
  '{n} unique': '{n} únicos',
  '{rate}% conversion': '{rate}% de conversión',
  // Wave 33 — granular RBAC matrix
  'Permission matrix': 'Matriz de permisos',
  'Permission matrix saved': 'Matriz de permisos guardada',
  'Failed to load permission matrix': 'Error al cargar la matriz de permisos',
  'Failed to save permission matrix': 'Error al guardar la matriz de permisos',
  'Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.': 'Sustituye el rol mínimo requerido para cada acción en este workspace. Solo se guardan las celdas que difieren del valor por defecto.',
  'overrides': 'anulaciones',
  'Read-only — only the workspace owner can edit the matrix.': 'Solo lectura — únicamente el dueño del workspace puede editar la matriz.',
  'Reset all to defaults': 'Restablecer todo a los valores por defecto',
  'Custom': 'Personalizado',
  'Reset to default': 'Restablecer al valor por defecto',
  'owner': 'dueño',
  'admin': 'admin',
  'manager': 'gerente',
  'viewer': 'visor',
  'Landings & offers': 'Landings y ofertas',
  'Reports': 'Reportes',
  'Audit': 'Auditoría',

  // Navigation hints (sidebar tooltips)
  'Toggle navigation hints': 'Activar/desactivar pistas de navegación',
  'Show hints': 'Mostrar pistas',
  'Hide hints': 'Ocultar pistas',

  // Sidebar nav group labels
  'Overview': 'Resumen',
  'Tools': 'Herramientas',
  'Resources': 'Recursos',
  'Pre-landings': 'Pre-landings',
  'Book demo': 'Reservar demo',
  'Overview of clicks, conversions and active campaigns': 'Pantalla principal: resumen de clics, conversiones y campañas activas',
  'Create ad campaigns and get tracking links': 'Crea campañas publicitarias y obtén enlaces de seguimiento',
  'Upload landing pages (ZIP) or set a URL for split-tests': 'Sube landing pages (ZIP) o indica una URL para split-tests',
  'Warm-up pages shown before the offer': 'Páginas intermedias antes de la oferta para calentar tráfico',
  'Connect Facebook, Google, TikTok ad accounts': 'Conecta cuentas publicitarias de Facebook, Google, TikTok',
  'Two-factor auth, sessions and password': 'Autenticación de dos factores, sesiones y contraseña',
  'Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms': 'Ofertas/embudos: carga, enrutamiento a partners por API (pesos, failover), formularios de lead',
  'Traffic sources with presets (Google Ads with tm & macros, etc.)': 'Fuentes de tráfico con presets (Google Ads con macros y tm, etc.)',
  'Manage flows and traffic distribution rules': 'Gestión de flujos y reglas de distribución de tráfico',
  'Split-test landings and offers with auto-distribution': 'Split-tests de landings y ofertas con distribución automática',
  'Block bots, fraud and suspicious clicks': 'Protección contra bots, fraude y clics sospechosos',
  'Detailed reports: charts, geo, devices, ROI': 'Informes detallados: gráficos, geo, dispositivos, ROI',
  'Full click log with IP, UserAgent, GEO and time': 'Registro completo de clics con IP, UserAgent, GEO y hora',
  'Auto-rules: pause campaigns on low ROI, etc.': 'Reglas automáticas: pausa de campañas con bajo ROI, etc.',
  'Partner CRMs (TrackBox, Custom API) for API lead injection + notifications': 'CRMs de partners (TrackBox, Custom API) para envío de leads por API + notificaciones',
  'Add your own domains for tracking links': 'Añade tus dominios para enlaces de seguimiento',
  'Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth': 'Conversiones online a Google/FB/TikTok (S2S). Google — modo simple, sin OAuth',
  'Keys to access the tracker REST API': 'Claves para acceder a la REST API del tracker',
  'Invite your team, assign roles and permissions': 'Invita a tu equipo, asigna roles y permisos',
  'Action log of all users for 90 days': 'Registro de acciones de todos los usuarios por 90 días',
  'Cookie consent banner for GDPR compliance': 'Banner de consentimiento de cookies para GDPR',
  'Ready-made templates and integrations': 'Plantillas e integraciones listas de la comunidad',
  'Swagger REST API docs (opens in new tab)': 'Documentación Swagger de la REST API (se abre en nueva pestaña)',
  'Failed conversion dispatches — can be retried': 'Errores de envío de conversiones — se puede reintentar',
  'Server, queue and database status': 'Estado de servidores, colas y bases de datos',
  'Plan, payment and usage limits': 'Plan tarifario, pago y límites',
  'Profile, language, timezone and notifications': 'Perfil, idioma, zona horaria y notificaciones',

  // De-russification wave: short/common keys only; long help paragraphs
  // intentionally fall back to English.
  'Registration': 'Registro',
  'Deposit': 'Depósito',
  'Trash': 'Basura',
  'Hide': 'Ocultar',
  'Show': 'Mostrar',
  'Ignore': 'Ignorar',
  'Import from source': 'Importar desde la fuente',
  'Postback token': 'Token de postback',
  'Require postback token': 'Exigir token de postback',
  'Network macros': 'Macros de la red',
  'Available macros': 'Macros disponibles',
  'Failed to copy': 'No se pudo copiar',
  'Hint': 'Sugerencia',
  'Cycle language': 'Cambiar idioma',
  'Switch to {lang}': 'Cambiar a {lang}',
  'Current language: {lang}': 'Idioma actual: {lang}',
  'Scroll to top': 'Volver arriba',
  'Something went wrong': 'Algo salió mal',
  'An unexpected error occurred.': 'Ocurrió un error inesperado.',
  'Reload page': 'Recargar página',
  'What is XPNSR Tracker': 'Qué es XPNSR Tracker',
  'Links & aliases': 'Enlaces y alias',
  'Redirect modes': 'Modos de redirección',
  'A/B tests': 'Pruebas A/B',
  'Glossary': 'Glosario',
  'Partners & lead forms': 'Partners y formularios de leads',
  'Google Ads & conversions': 'Google Ads y conversiones',
  'Affiliate networks': 'Redes de afiliados',
  'Reports (Report Builder)': 'Informes (Report Builder)',
  'Domain opened for indexing': 'Dominio abierto a la indexación',
  'Domain closed from indexing': 'Dominio cerrado a la indexación',
  'Index page set': 'Página index establecida',
  'Index page cleared': 'Página index quitada',
  'Server migration (admin only)': 'Cambio de servidor (solo admin)',
  'Current server IP:': 'IP actual del servidor:',
  'Custom API (any CRM)': 'Custom API (cualquier CRM)',
  'Username': 'Usuario',
  'Signup path': 'Ruta de registro',
  'Body format': 'Formato del cuerpo',
  'Headers': 'Cabeceras',
  'Body template (JSON)': 'Plantilla del cuerpo (JSON)',
  'Redirect field': 'Campo de redirección',
  'Success field (optional)': 'Campo de éxito (opcional)',
  'Success value (optional)': 'Valor de éxito (opcional)',
  'Telegram lead alerts': 'Alertas de leads en Telegram',
  '(sent on EVERY submit — even test/error)': '(se envía en CADA submit — incluso test/error)',
  'Affiliate routing (form offers)': 'Enrutamiento a partners (ofertas con formulario)',
  'My first campaign': 'Mi primera campaña',
  'CPA Network': 'Red CPA',
  'Main FB pixel': 'Píxel FB principal',
  'zapier integration': 'integración con zapier',
  'Bot token': 'Token del bot',
  'Chat ID': 'ID del chat',
  // --- Coverage fill (auto-added): remaining UI strings ---
  '(no label)': '(sin etiqueta)',
  '(no match)': '(sin coincidencias)',
  '(one "Key: value" per line, macros allowed)': '(un "Key: value" por línea, se permiten macros)',
  '(values are macros in curly braces)': '(los valores son macros entre llaves)',
  '+ Upload': '+ Subir',
  '180 days': '180 días',
  '2FA disabled': '2FA desactivada',
  '2FA enabled': '2FA activada',
  '2FA is currently enabled': 'La 2FA está activada actualmente',
  '302 redirect (default)': 'Redirección 302 (predeterminada)',
  '365 days': '365 días',
  'A campaign groups your traffic sources and tracking links under one name.': 'Una campaña agrupa tus fuentes de tráfico y enlaces de seguimiento bajo un solo nombre.',
  'A custom conversion type with its own reporting rules and status transitions.': 'Un tipo de conversión personalizado con sus propias reglas de reporte y transiciones de estado.',
  'A formula over base metrics rendered as a report column.': 'Una fórmula sobre métricas base que se muestra como columna de reporte.',
  'A/B testing': 'Pruebas A/B',
  'AI Optimizer': 'Optimizador IA',
  'AND (all)': 'AND (todos)',
  'AND: the click must pass every configured filter. OR: any single passing filter admits the click.': 'AND: el clic debe pasar todos los filtros configurados. OR: basta con que pase un solo filtro para admitir el clic.',
  'API URL (base)': 'URL de API (base)',
  'Accept button label': 'Texto del botón Aceptar',
  'Accepted': 'Aceptado',
  'Accepting invitation…': 'Aceptando invitación…',
  'Access denied': 'Acceso denegado',
  'Action on trigger': 'Acción al activarse',
  'Activate': 'Activar',
  'Activate 2FA': 'Activar 2FA',
  'Ad accounts': 'Cuentas publicitarias',
  'Add / remove tracking domains.': 'Agregar / eliminar dominios de seguimiento.',
  'Add a custom domain to serve tracking links from your own branded URL.': 'Agrega un dominio personalizado para servir los enlaces de seguimiento desde tu propia URL de marca.',
  'Add a forwarder to push conversions to ad networks automatically.': 'Agrega un forwarder para enviar conversiones a las redes publicitarias automáticamente.',
  'Add a manual cost, or connect an ad account to sync spend automatically.': 'Agrega un costo manual o conecta una cuenta publicitaria para sincronizar el gasto automáticamente.',
  'Add campaign…': 'Agregar campaña…',
  'Add cost': 'Agregar costo',
  'Add forwarder': 'Agregar forwarder',
  'Add from preset': 'Agregar desde preset',
  'Add interval': 'Agregar intervalo',
  'Add manual cost': 'Agregar costo manual',
  'Add new campaigns and their default streams.': 'Agregar nuevas campañas y sus streams predeterminados.',
  'Add partner route': 'Agregar ruta de partner',
  'Add range': 'Agregar rango',
  'Add status': 'Agregar estado',
  'Add the CNAME record shown on the Domains page, then click verify.': 'Agrega el registro CNAME que se muestra en la página Dominios y luego haz clic en verificar.',
  'Add value': 'Agregar valor',
  'Add vendor': 'Agregar proveedor',
  'Added to blacklist': 'Agregado a la lista negra',
  'Added to whitelist': 'Agregado a la lista blanca',
  'Adjust the period or campaign filter.': 'Ajusta el período o el filtro de campaña.',
  'Advanced': 'Avanzado',
  'Advanced notification preferences': 'Preferencias avanzadas de notificaciones',
  'Affiliate CRM — push leads via API': 'CRM de afiliados — envío de leads vía API',
  'Affiliate network': 'Red de afiliados',
  'Affiliate network created': 'Red de afiliados creada',
  'Affiliate network deleted': 'Red de afiliados eliminada',
  'Affiliate network name': 'Nombre de la red de afiliados',
  'Affiliate network postback': 'Postback de red de afiliados',
  'Affiliate network updated': 'Red de afiliados actualizada',
  'After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.': 'Después de agregarlo, configura el DNS de tu dominio (registro TXT para la verificación, registro CNAME o A para enrutar el tráfico) y luego presiona Verificar.',
  'Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.': 'Estado agregado de CAPI / postback / FX / sincronización de costos en los espacios de trabajo que administras.',
  'Alert if ROI drops below this %': 'Alertar si el ROI cae por debajo de este %',
  'Alert types': 'Tipos de alerta',
  'Algorithm': 'Algoritmo',
  'Alias': 'Alias',
  'All groups': 'Todos los grupos',
  'All offers': 'Todas las ofertas',
  'All rows': 'Todas las filas',
  'All statuses': 'Todos los estados',
  'All traffic': 'Todo el tráfico',
  'All values shown in': 'Todos los valores se muestran en',
  'Allowed ASNs (whitelist)': 'ASN permitidos (lista blanca)',
  'Allowed metrics': 'Métricas permitidas',
  'Allowed next statuses': 'Siguientes estados permitidos',
  'Already have an account? Sign in': '¿Ya tienes una cuenta? Inicia sesión',
  'Amount': 'Monto',
  'Anonymous': 'Anónimo',
  'Any': 'Cualquiera',
  'Any date': 'Cualquier fecha',
  'Any status': 'Cualquier estado',
  'Any type': 'Cualquier tipo',
  'Anyone with this link will lose access to the shared dashboard immediately.': 'Cualquier persona con este enlace perderá el acceso al panel compartido de inmediato.',
  'Applied {n} weight changes': 'Se aplicaron {n} cambios de peso',
  'Apply filters': 'Aplicar filtros',
  'Archive': 'Archivar',
  'Archived': 'Archivado',
  'Arithmetic over base metrics. Supported: + - * / ( ) and numbers.': 'Aritmética sobre métricas base. Se admiten: + - * / ( ) y números.',
  'At least 2 variants required': 'Se requieren al menos 2 variantes',
  'At least 6 characters': 'Al menos 6 caracteres',
  'Attempts': 'Intentos',
  'Attribution,': 'Atribución,',
  'Auto': 'Auto',
  'Auto pull-sync': 'Pull-sync automático',
  'Auto-refresh every 30s': 'Actualización automática cada 30s',
  'Automation rules': 'Reglas de automatización',
  'Available on enterprise plans. Hides the "Powered by xpnsr" footer.': 'Disponible en los planes enterprise. Oculta el pie de página "Powered by xpnsr".',
  'Back to sign-in': 'Volver al inicio de sesión',
  'Back to streams': 'Volver a streams',
  'Back to top': 'Volver arriba',
  'Backup codes (save now)': 'Códigos de respaldo (guárdalos ahora)',
  'Bangkok (UTC+7)': 'Bangkok (UTC+7)',
  'Banned': 'Baneado',
  'Banner copy': 'Texto del banner',
  'Banner status': 'Estado del banner',
  'Base metrics': 'Métricas base',
  'Berlin (UTC+1)': 'Berlín (UTC+1)',
  'Best cohort': 'Mejor cohorte',
  'Binary file — not editable': 'Archivo binario — no editable',
  'Bind to campaigns': 'Vincular a campañas',
  'Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.': 'Vincula tu propio dominio para enmascarar los enlaces de seguimiento. Apunta un registro A a tu servidor de tracking y verifica la propiedad mediante un registro TXT.',
  'Black': 'Negro',
  'Black / white lists': 'Listas negras / blancas',
  'Blacklist': 'Lista negra',
  'Blacklist is empty': 'La lista negra está vacía',
  'Blacklisted': 'En lista negra',
  'Blank referrer (JS)': 'Referrer en blanco (JS)',
  'Block Tor exit nodes': 'Bloquear nodos de salida de Tor',
  'Block VPNs (requires API key)': 'Bloquear VPNs (requiere clave de API)',
  'Block proxies (requires API key)': 'Bloquear proxies (requiere clave de API)',
  'Body': 'Cuerpo',
  'Body (JSON)': 'Cuerpo (JSON)',
  'Body copied to clipboard.': 'Cuerpo copiado al portapapeles.',
  'Body must be valid JSON.': 'El cuerpo debe ser JSON válido.',
  'Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.': 'Registra gasto en una campaña. Se suma al costo de la campaña que usan el ROI y los paneles.',
  'Bot': 'Bot',
  'Bot IP addresses': 'Direcciones IP de bots',
  'Bot User-Agent signatures': 'Firmas User-Agent de bots',
  'Bot lists': 'Listas de bots',
  'Bot lists saved': 'Listas de bots guardadas',
  'Bots': 'Bots',
  'Bots & spoofed crawlers': 'Bots y crawlers falsificados',
  'Bots and crawlers sent to the safe page vs humans to the offer': 'Bots y crawlers enviados a la página segura vs humanos a la oferta',
  'Branding': 'Branding',
  'Branding cleared': 'Branding restablecido',
  'Branding saved': 'Branding guardado',
  'Break down clicks and conversions by sub-ID parameters (sub1–sub15)': 'Desglosa clics y conversiones por parámetros sub-ID (sub1–sub15)',
  'Breakdown': 'Desglose',
  'Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.': 'Explora e instala plantillas aportadas por la comunidad para postbacks, macros, reglas antifraude y pre-landings. Los envíos se publican automáticamente — la comunidad se autorregula mediante la acción de eliminar.',
  'Browse integration configurations.': 'Ver configuraciones de integraciones.',
  'Browse postbacks and the CAPI dead-letter queue.': 'Ver postbacks y la cola de mensajes fallidos (DLQ) de CAPI.',
  'Browse the landing-page library.': 'Ver la biblioteca de páginas de aterrizaje.',
  'Browse the offer library.': 'Ver la biblioteca de ofertas.',
  'Browse the tracking-domain list.': 'Ver la lista de dominios de seguimiento.',
  'Browser': 'Navegador',
  'Bucket': 'Bucket',
  'Build traffic rules, rotate landings and split-test offers for any campaign.': 'Crea reglas de tráfico, rota landings y haz split-tests de ofertas para cualquier campaña.',
  'Built-in statuses': 'Estados integrados',
  'Bulk create': 'Crear en masa',
  'Bulk create Google Ads forwarders': 'Crear forwarders de Google Ads en masa',
  'Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.': 'Agrupa dominios verificados en un pool y rota los enlaces de seguimiento entre ellos. Saca un dominio baneado de la rotación con un clic, sin volver a publicar los anuncios.',
  'By browser': 'Por navegador',
  'By destination': 'Por destino',
  'By device': 'Por dispositivo',
  'By stream': 'Por stream',
  'By {author}': 'Por {author}',
  'CPS (per sale)': 'CPS (por venta)',
  'CPuC (per unique click)': 'CPuC (por clic único)',
  'CR %': 'CR %',
  'CR%': 'CR%',
  'CRM': 'CRM',
  'CRM response': 'Respuesta del CRM',
  'Cadence': 'Frecuencia',
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": "Fechas de calendario en las que el stream está activo (zona horaria del propietario). Deja el inicio o el fin vacío para un extremo abierto. 'No es' invierte el rango.",
  'California, Bavaria, Moscow Oblast': 'California, Baviera, Óblast de Moscú',
  'Campaign activated': 'Campaña activada',
  'Campaign archived': 'Campaña archivada',
  'Campaign cloned successfully!': '¡Campaña clonada con éxito!',
  'Campaign comparison': 'Comparación de campañas',
  'Campaign created': 'Campaña creada',
  'Campaign dashboard': 'Panel de campaña',
  'Campaign restored': 'Campaña restaurada',
  'Cannot delete: network is linked to offers': 'No se puede eliminar: la red está vinculada a ofertas',
  'Canonical status stored on each conversion. Auto-generated from the name if left blank.': 'Estado canónico almacenado en cada conversión. Se genera automáticamente a partir del nombre si se deja en blanco.',
  'Cap': 'Cap',
  'Cap timezone': 'Zona horaria del cap',
  'Card view': 'Vista de tarjetas',
  'Catalog': 'Catálogo',
  'Change campaign settings, target URL, status.': 'Cambiar ajustes de la campaña, URL de destino y estado.',
  'Change member role': 'Cambiar rol del miembro',
  'Change plan, update payment method.': 'Cambiar de plan, actualizar el método de pago.',
  'Change workspace currency, timezone, branding.': 'Cambiar la moneda, la zona horaria y el branding del espacio de trabajo.',
  'Chicago (UTC-6)': 'Chicago (UTC-6)',
  'Choose a ZIP file': 'Elegir un archivo ZIP',
  'Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).': 'Elige un preset y, si quieres, amplíalo con códigos de país ISO-3166 adicionales (separados por comas, p. ej. BR, MX, AR).',
  'Choose entry point': 'Elegir punto de entrada',
  'Clear': 'Limpiar',
  'Click API (server-to-server)': 'API de clics (server-to-server)',
  'Click ID forward parameter': 'Parámetro de reenvío del click ID',
  'Click a row to drill in': 'Haz clic en una fila para ver el detalle',
  'Click detail': 'Detalle del clic',
  'Click to activate': 'Haz clic para activar',
  'Click to pause': 'Haz clic para pausar',
  'Clicks log': 'Registro de clics',
  'Clicks per 24h': 'Clics por 24h',
  'Clicks per hour': 'Clics por hora',
  'Clipboard unavailable — copy the URL manually': 'Portapapeles no disponible — copia la URL manualmente',
  'Cloak rate': 'Tasa de cloaking',
  'Cloaked': 'Cloakeado',
  'Cloaked (iframe)': 'Cloakeado (iframe)',
  'Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.': 'El iframe cloakeado mantiene el dominio del tracker en la barra de direcciones — solo funciona con destinos que permiten framing.',
  'Cloaked only': 'Solo cloakeados',
  'Cloaked → safe page': 'Cloakeado → página segura',
  'Cloaking': 'Cloaking',
  'Cloaking — send bots to a safe page': 'Cloaking — envía los bots a una página segura',
  'Clone': 'Clonar',
  'Close navigation': 'Cerrar navegación',
  'Closed from search engines — click to open': 'Cerrado para motores de búsqueda — haz clic para abrir',
  'Code (slug)': 'Código (slug)',
  'Cohort': 'Cohorte',
  'Cohort retention': 'Retención de cohortes',
  'Collapse': 'Contraer',
  'Column key in reports. Auto-generated from the name if left blank.': 'Clave de la columna en los reportes. Se genera automáticamente a partir del nombre si se deja en blanco.',
  'Columns': 'Columnas',
  'Comma-separated email addresses.': 'Direcciones de correo separadas por comas.',
  'Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.': 'Lista separada por comas de IPs autorizadas a enviar postbacks. Deja vacío para permitir todas.',
  'Compare': 'Comparar',
  'Compare current to proposed weights. Apply persists the proposed column to the streams.': 'Compara los pesos actuales con los propuestos. Aplicar guarda la columna propuesta en los streams.',
  'Comparing…': 'Comparando…',
  'Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).': 'Compensa el costo por el tráfico perdido entre la fuente y el tracker: costo real = base / (1 − pérdida%/100).',
  'Compliance': 'Cumplimiento',
  'Configure': 'Configurar',
  'Configure UTM templates and conversion postbacks for every ad network you run.': 'Configura plantillas UTM y postbacks de conversión para cada red publicitaria que uses.',
  'Configure any partner CRM lead API': 'Configura la API de leads de cualquier CRM de partner',
  'Configure offers, payouts and target geos. Upload ZIPs or link external networks.': 'Configura ofertas, payouts y geos objetivo. Sube ZIPs o vincula redes externas.',
  'Configure postbacks, replay / discard CAPI DLQ entries.': 'Configurar postbacks, reenviar / descartar entradas de la DLQ de CAPI.',
  'Configure stream': 'Configurar stream',
  'Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.': 'Configura el banner de cookies GDPR / CCPA que se muestra en las páginas de aterrizaje de tu tracker. El banner detecta la región — los visitantes fuera de las regiones configuradas nunca lo ven.',
  'Confirm action': 'Confirmar acción',
  'Connect / disconnect ad accounts and webhooks.': 'Conectar / desconectar cuentas publicitarias y webhooks.',
  'Connect external services and webhooks': 'Conecta servicios externos y webhooks',
  'Connect external services and webhooks to automate workflows.': 'Conecta servicios externos y webhooks para automatizar flujos de trabajo.',
  'Connection restored': 'Conexión restablecida',
  'Connection types': 'Tipos de conexión',
  'Connections': 'Conexiones',
  'Consent banner': 'Banner de consentimiento',
  'Consent banner saved': 'Banner de consentimiento guardado',
  'Conv': 'Conv',
  'Conv.': 'Conv.',
  'Conversion date': 'Fecha de conversión',
  'Conversion forwarders that fire for this campaign': 'Forwarders de conversión que se disparan para esta campaña',
  'Conversion rate comparison': 'Comparación de tasas de conversión',
  'Conversion statuses': 'Estados de conversión',
  'Conversion tags (one per line)': 'Etiquetas de conversión (una por línea)',
  'Conversion type created': 'Tipo de conversión creado',
  'Conversion type deleted': 'Tipo de conversión eliminado',
  'Conversion type updated': 'Tipo de conversión actualizado',
  'Conversion types': 'Tipos de conversión',
  'Cookie (default)': 'Cookie (predeterminada)',
  'Cookieless mode (skip xpnsr_vid first-party cookie)': 'Modo sin cookies (omite la cookie first-party xpnsr_vid)',
  'Copied to clipboard.': 'Copiado al portapapeles.',
  'Copy blacklist': 'Copiar lista negra',
  'Copy failed': 'Error al copiar',
  'Copy link (/r/)': 'Copiar enlace (/r/)',
  'Copy link (/{alias}/)': 'Copiar enlace (/{alias}/)',
  'Copy list': 'Copiar lista',
  'Copy whitelist': 'Copiar lista blanca',
  'Cost': 'Costo',
  'Cost entries': 'Registros de costo',
  'Cost entry added': 'Registro de costo agregado',
  'Cost entry deleted': 'Registro de costo eliminado',
  'Cost value': 'Valor del costo',
  'Could not accept invitation': 'No se pudo aceptar la invitación',
  'Could not copy — please copy the link manually.': 'No se pudo copiar — copia el enlace manualmente.',
  'Could not create public link': 'No se pudo crear el enlace público',
  'Could not load branding': 'No se pudo cargar el branding',
  'Could not load marketplace templates.': 'No se pudieron cargar las plantillas del marketplace.',
  'Could not load template detail.': 'No se pudo cargar el detalle de la plantilla.',
  'Could not load the shared dashboard.': 'No se pudo cargar el panel compartido.',
  'Could not reset branding': 'No se pudo restablecer el branding',
  'Could not save branding': 'No se pudo guardar el branding',
  'Count conversions of this type toward the offer daily cap.': 'Contabilizar las conversiones de este tipo en el cap diario de la oferta.',
  'Country (ISO-2)': 'País (ISO-2)',
  'Counts against offer cap': 'Cuenta para el cap de la oferta',
  'Counts in conversions': 'Cuenta en conversiones',
  'Counts in revenue': 'Cuenta en ingresos',
  'Counts vs cap': 'Conteo vs cap',
  'Create / revoke API keys.': 'Crear / revocar claves de API.',
  'Create / update / delete automation rules.': 'Crear / actualizar / eliminar reglas de automatización.',
  'Create / update / delete fraud filters and IP lists.': 'Crear / actualizar / eliminar filtros de fraude y listas de IP.',
  'Create a campaign first': 'Primero crea una campaña',
  'Create affiliate network': 'Crear red de afiliados',
  'Create all': 'Crear todos',
  'Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.': 'Crea una instancia EC2 en AWS (Ubuntu, con los puertos 80 y 443 abiertos), conéctate por SSH y pega este comando completo. Al final imprime la IP del nuevo servidor.',
  'Create campaigns': 'Crear campañas',
  'Create conversion type': 'Crear tipo de conversión',
  'Create custom metric': 'Crear métrica personalizada',
  'Create key': 'Crear clave',
  'Create landing page': 'Crear página de aterrizaje',
  'Create link': 'Crear enlace',
  'Create metric': 'Crear métrica',
  'Create network': 'Crear red',
  'Create new landing page': 'Crear nueva página de aterrizaje',
  'Create new offer': 'Crear nueva oferta',
  'Create offer': 'Crear oferta',
  'Create one from a preset like TrackBox or Adcombo.': 'Crea una a partir de un preset como TrackBox o Adcombo.',
  'Create one like uCR = conversions / unique_clicks * 100.': 'Crea una como uCR = conversions / unique_clicks * 100.',
  'Create one to export campaign performance on demand.': 'Crea uno para exportar el rendimiento de las campañas bajo demanda.',
  'Create one to map partner statuses like FTD or second deposit.': 'Crea uno para mapear estados del partner como FTD o segundo depósito.',
  'Create one to receive recurring reports by email.': 'Crea uno para recibir reportes recurrentes por correo.',
  'Create pool': 'Crear pool',
  'Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.': 'Crea reglas para pausar, reanudar o ajustar campañas automáticamente según umbrales de rendimiento.',
  'Create streams to split traffic by geo, device, OS, or custom conditions.': 'Crea streams para dividir el tráfico por geo, dispositivo, sistema operativo o condiciones personalizadas.',
  'Create type': 'Crear tipo',
  'Create, edit, and delete offers.': 'Crear, editar y eliminar ofertas.',
  'Creating…': 'Creando…',
  'Custom bot IPs/CIDRs and UA signatures for the bot-detection filter': 'IPs/CIDRs personalizadas de bots y firmas UA para el filtro de detección de bots',
  'Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.': 'IPs/CIDRs personalizadas de bots y firmas User-Agent que usa el filtro antifraude de detección de bots.',
  'Custom conversion types: map network statuses, reporting flags and transition rules': 'Tipos de conversión personalizados: mapea estados de la red, flags de reporte y reglas de transición',
  'Custom domain': 'Dominio personalizado',
  'Custom metric created': 'Métrica personalizada creada',
  'Custom metric deleted': 'Métrica personalizada eliminada',
  'Custom metric updated': 'Métrica personalizada actualizada',
  'Custom metrics': 'Métricas personalizadas',
  'Custom range': 'Rango personalizado',
  'Customise the dashboard for your agency or sub-account': 'Personaliza el panel para tu agencia o subcuenta',
  'DSAR erasure completed': 'Borrado DSAR completado',
  'DSAR export ready': 'Exportación DSAR lista',
  'Daily': 'Diario',
  'Daily cap': 'Cap diario',
  'Dashboard hostname': 'Hostname del panel',
  'Data subject': 'Titular de los datos',
  'Data-subject access (Article 15) and erasure (Article 17) by identifier.': 'Acceso del titular de los datos (Artículo 15) y supresión (Artículo 17) por identificador.',
  'Data-subject export (Art. 15) and erasure (Art. 17) by identifier': 'Exportación de datos del titular (Art. 15) y supresión (Art. 17) por identificador',
  'Datacenter / Tor IPs': 'IPs de datacenter / Tor',
  'Date': 'Fecha',
  'Date range': 'Rango de fechas',
  'Day': 'Día',
  'Day of month (1-31)': 'Día del mes (1-31)',
  'Day of week': 'Día de la semana',
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Días de la semana y horas en que el stream está activo. La hora usa la zona horaria del propietario de la campaña. 'No es' invierte el horario: el stream acepta clics EXCEPTO en los horarios indicados.",
  'Decimals': 'Decimales',
  'Decision': 'Decisión',
  'Default offer URL': 'URL predeterminada de la oferta',
  'Defense': 'Defensa',
  'Define a reusable report and its grouping/metrics.': 'Define un reporte reutilizable y su agrupación/métricas.',
  'Define custom conversion types, map network statuses and control reporting semantics.': 'Define tipos de conversión personalizados, mapea los estados de la red y controla la semántica de los reportes.',
  'Define formula-based report columns over base metrics (CR, EPC, ROI variants).': 'Define columnas de reporte basadas en fórmulas sobre métricas base (CR, EPC, variantes de ROI).',
  'Delete A/B test': 'Eliminar test A/B',
  'Delete API key': 'Eliminar clave de API',
  'Delete affiliate network': 'Eliminar red de afiliados',
  'Delete automation rule': 'Eliminar regla de automatización',
  'Delete campaign': 'Eliminar campaña',
  'Delete campaigns': 'Eliminar campañas',
  'Delete connection': 'Eliminar conexión',
  'Delete conversion type': 'Eliminar tipo de conversión',
  'Delete cost entry': 'Eliminar registro de costo',
  'Delete custom metric': 'Eliminar métrica personalizada',
  'Delete domain': 'Eliminar dominio',
  'Delete domain pool': 'Eliminar pool de dominios',
  'Delete failed.': 'No se pudo eliminar.',
  'Delete file': 'Eliminar archivo',
  'Delete forwarder': 'Eliminar reenviador',
  'Delete integration': 'Eliminar integración',
  'Delete landing page': 'Eliminar página de aterrizaje',
  'Delete offer': 'Eliminar oferta',
  'Delete pre-landing': 'Eliminar pre-landing',
  'Delete report': 'Eliminar reporte',
  'Delete schedule': 'Eliminar programación',
  'Delete stream': 'Eliminar stream',
  'Delete this file?': '¿Eliminar este archivo?',
  'Delete traffic source': 'Eliminar fuente de tráfico',
  'Delete view': 'Eliminar vista',
  'Delete webhook': 'Eliminar webhook',
  'Delete {n} selected campaign(s)? This cannot be undone.': '¿Eliminar {n} campaña(s) seleccionada(s)? Esto no se puede deshacer.',
  'Denver (UTC-7)': 'Denver (UTC-7)',
  'Deselect all': 'Deseleccionar todo',
  'Desktop, Mobile, Tablet': 'Desktop, Mobile, Tablet',
  'Destination': 'Destino',
  'Device': 'Dispositivo',
  'Disable 2FA': 'Desactivar 2FA',
  'Disable 2FA — enter a current code': 'Desactivar 2FA — ingresa un código actual',
  'Disable auto-refresh': 'Desactivar actualización automática',
  'Disable failed': 'No se pudo desactivar',
  'Disabled': 'Desactivado',
  'Discard DLQ entry': 'Descartar entrada de la DLQ',
  'Discard unsaved changes?': '¿Descartar los cambios sin guardar?',
  'Dismissed': 'Descartado',
  'Distribution': 'Distribución',
  'Do not block by classification': 'No bloquear por clasificación',
  'Do nothing': 'No hacer nada',
  'Documentation': 'Documentación',
  'Domain marked healthy': 'Dominio marcado como saludable',
  'Domain not verified yet — check the DNS record.': 'El dominio aún no está verificado — revisa el registro DNS.',
  'Domain pool created': 'Pool de dominios creado',
  'Domain pool deleted': 'Pool de dominios eliminado',
  'Domain pools': 'Pools de dominios',
  'Domain pulled from rotation': 'Dominio retirado de la rotación',
  'Domain registered. Add the DNS record, then verify.': 'Dominio registrado. Agrega el registro DNS y luego verifica.',
  "Don't filter": 'No filtrar',
  'Done': 'Listo',
  'Double meta (hide referrer)': 'Doble meta (ocultar referrer)',
  'Download CSV / JSON report exports.': 'Descarga exportaciones de reportes en CSV / JSON.',
  'Drill-down by sub1–sub15: clicks, conversions, CR': 'Desglose por sub1–sub15: clics, conversiones, CR',
  'Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.': 'Simula clics a través de esta campaña para probar la lógica de flujos y los filtros — no se registra tráfico real.',
  'Dubai (UTC+4)': 'Dubái (UTC+4)',
  'EPC': 'EPC',
  'EPC (sensitive)': 'EPC (sensible)',
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.": 'Cada fila corresponde a los visitantes nuevos de un día. Las columnas siguen la tasa de conversión acumulada por desfase de días.',
  'Earnings per click': 'Ganancias por clic',
  'Edge server updated': 'Servidor edge actualizado',
  'Edit HTML, CSS, JS and other text files inside the uploaded archive': 'Edita HTML, CSS, JS y otros archivos de texto dentro del archivo comprimido subido',
  'Edit affiliate network': 'Editar red de afiliados',
  'Edit anti-fraud filters': 'Editar filtros antifraude',
  'Edit automation rules': 'Editar reglas de automatización',
  'Edit campaigns': 'Editar campañas',
  'Edit conversion type': 'Editar tipo de conversión',
  'Edit custom metric': 'Editar métrica personalizada',
  'Edit files': 'Editar archivos',
  'Edit integrations': 'Editar integraciones',
  'Edit landings': 'Editar landings',
  'Edit offers': 'Editar ofertas',
  'Edit permission matrix': 'Editar matriz de permisos',
  'Edit postbacks': 'Editar postbacks',
  'Edit pre-landing': 'Editar pre-landing',
  'Edit tracking domains': 'Editar dominios de tracking',
  'Edit workspace settings': 'Editar ajustes del espacio de trabajo',
  'Empty referrer': 'Referrer vacío',
  'Enable 2FA': 'Activar 2FA',
  'Enabled': 'Activado',
  'Enter a code from the app to confirm': 'Ingresa un código de la app para confirmar',
  'Enter a hostname': 'Ingresa un hostname',
  'Enter a valid amount': 'Ingresa un monto válido',
  'Enter a valid http(s) Safe page URL for cloaking': 'Ingresa una URL http(s) válida de la Safe page para cloaking',
  'Enter an offer URL': 'Ingresa una URL de oferta',
  'Enter at least one identifier': 'Ingresa al menos un identificador',
  'Enter bot token and chat id': 'Ingresa el token del bot y el chat id',
  'Enter the 6-digit code from your authenticator app, or one of your backup codes.': 'Ingresa el código de 6 dígitos de tu app de autenticación, o uno de tus códigos de respaldo.',
  'Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.': 'Ingresa el token del bot y el chat_id — se agregarán postbacks de Lead y Depósito con un mensaje listo (Campaña, Sub1..4, Fuente, Payout). Luego presiona Guardar.',
  'Enter the text to find': 'Ingresa el texto a buscar',
  'Epsilon (ε)': 'Épsilon (ε)',
  'Equalize weights': 'Igualar pesos',
  'Erase': 'Borrar',
  'Erase data': 'Borrar datos',
  'Erase subject data?': '¿Borrar los datos del titular?',
  'Erased': 'Borrado',
  'Erasure is a hard delete and cannot be undone. It requires an admin role.': 'El borrado es una eliminación definitiva y no se puede deshacer. Requiere un rol de administrador.',
  'Error archiving campaign': 'Error al archivar la campaña',
  'Error cloning campaign': 'Error al clonar la campaña',
  'Error creating affiliate network': 'Error al crear la red de afiliados',
  'Error creating conversion type': 'Error al crear el tipo de conversión',
  'Error creating cost entry': 'Error al crear el registro de costo',
  'Error creating custom metric': 'Error al crear la métrica personalizada',
  'Error creating report': 'Error al crear el reporte',
  'Error creating schedule': 'Error al crear la programación',
  'Error deleting affiliate network': 'Error al eliminar la red de afiliados',
  'Error deleting conversion type': 'Error al eliminar el tipo de conversión',
  'Error deleting cost entry': 'Error al eliminar el registro de costo',
  'Error deleting custom metric': 'Error al eliminar la métrica personalizada',
  'Error deleting file': 'Error al eliminar el archivo',
  'Error deleting report': 'Error al eliminar el reporte',
  'Error deleting schedule': 'Error al eliminar la programación',
  'Error loading affiliate networks': 'Error al cargar las redes de afiliados',
  'Error loading bot lists': 'Error al cargar las listas de bots',
  'Error loading conversion types': 'Error al cargar los tipos de conversión',
  'Error loading cost entries': 'Error al cargar los registros de costo',
  'Error loading custom metrics': 'Error al cargar las métricas personalizadas',
  'Error loading file': 'Error al cargar el archivo',
  'Error loading files': 'Error al cargar los archivos',
  'Error loading reports': 'Error al cargar los reportes',
  'Error loading scheduled reports': 'Error al cargar los reportes programados',
  'Error saving bot lists': 'Error al guardar las listas de bots',
  'Error saving file': 'Error al guardar el archivo',
  'Error updating affiliate network': 'Error al actualizar la red de afiliados',
  'Error updating conversion type': 'Error al actualizar el tipo de conversión',
  'Error updating custom metric': 'Error al actualizar la métrica personalizada',
  'Error uploading file': 'Error al subir el archivo',
  'Every day': 'Todos los días',
  'Every day, all day': 'Todos los días, todo el día',
  'Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.': 'Cada lead capturado por tus ofertas de formulario llega aquí — aceptados, rechazados y de prueba. Filtra, exporta a CSV y revende. Los estados se actualizan mediante postbacks y sincronización pull.',
  'Every submitted lead is stored here: filter, export (CSV) and resell': 'Cada lead enviado se guarda aquí: filtra, exporta (CSV) y revende',
  'Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.': 'IPs exactas, bloques CIDR (10.0.0.0/8) o máscaras (192.168.*). Útil para agregar tus propias IPs de prueba a la lista de permitidos o para bloquear un rango de datacenter.',
  'Exclude bots': 'Excluir bots',
  'Exclude proxy': 'Excluir proxy',
  'Expand': 'Expandir',
  'Expires': 'Expira',
  'Expires after (days)': 'Expira después de (días)',
  'Export JSON': 'Exportar JSON',
  'Export XLSX': 'Exportar XLSX',
  'Export data': 'Exportar datos',
  'Export flows': 'Exportar flujos',
  'Export reports': 'Exportar reportes',
  'Exported': 'Exportado',
  'Extra countries (ISO-3166 alpha-2)': 'Países adicionales (ISO-3166 alpha-2)',
  'FTD · Deposit (sale)': 'FTD · Depósito (venta)',
  'Failed to accept invite': 'No se pudo aceptar la invitación',
  'Failed to apply optimization': 'No se pudo aplicar la optimización',
  'Failed to clone stream': 'No se pudo clonar el stream',
  'Failed to compare': 'No se pudo comparar',
  'Failed to copy tracking link': 'No se pudo copiar el enlace de tracking',
  'Failed to create campaign': 'No se pudo crear la campaña',
  'Failed to create pool': 'No se pudo crear el pool',
  'Failed to delete key': 'No se pudo eliminar la clave',
  'Failed to equalize weights': 'No se pudieron igualar los pesos',
  'Failed to erase DSAR': 'No se pudo borrar la DSAR',
  'Failed to export DSAR': 'No se pudo exportar la DSAR',
  'Failed to export flows': 'No se pudieron exportar los flujos',
  'Failed to export list': 'No se pudo exportar la lista',
  'Failed to export report': 'No se pudo exportar el reporte',
  'Failed to import flows': 'No se pudieron importar los flujos',
  'Failed to insert flow': 'No se pudo insertar el flujo',
  'Failed to load': 'No se pudo cargar',
  'Failed to load campaigns': 'No se pudieron cargar las campañas',
  'Failed to load clicks log': 'No se pudo cargar el registro de clics',
  'Failed to load consent config': 'No se pudo cargar la configuración de consentimiento',
  'Failed to load conversions': 'No se pudieron cargar las conversiones',
  'Failed to load leads': 'No se pudieron cargar los leads',
  'Failed to load pre-landings': 'No se pudieron cargar las pre-landings',
  'Failed to load profile': 'No se pudo cargar el perfil',
  'Failed to load sub-ID report': 'No se pudo cargar el reporte de sub-ID',
  'Failed to preview optimization': 'No se pudo previsualizar la optimización',
  'Failed to register domain': 'No se pudo registrar el dominio',
  'Failed to remove': 'No se pudo quitar',
  'Failed to replace URLs': 'No se pudieron reemplazar las URLs',
  'Failed to revoke access': 'No se pudo revocar el acceso',
  'Failed to run report': 'No se pudo ejecutar el reporte',
  'Failed to save': 'No se pudo guardar',
  'Failed to update': 'No se pudo actualizar',
  'Failed to update campaign': 'No se pudo actualizar la campaña',
  'Failed to update list': 'No se pudo actualizar la lista',
  'Failed to update schedule': 'No se pudo actualizar la programación',
  'Failed to update status': 'No se pudo actualizar el estado',
  'Fallback offer': 'Oferta de respaldo',
  'Fallback robots.txt/sitemap.xml off': 'Fallback de robots.txt/sitemap.xml desactivado',
  'Fallback robots.txt/sitemap.xml on (only when your bundle has none)': 'Fallback de robots.txt/sitemap.xml activado (solo cuando tu paquete no incluye ninguno)',
  'Fallback robots/sitemap': 'Fallback de robots/sitemap',
  'Favourite': 'Favorito',
  'Favourite flows': 'Flujos favoritos',
  'Favourites': 'Favoritos',
  'Fetched': 'Obtenido',
  'File deleted': 'Archivo eliminado',
  'File editor': 'Editor de archivos',
  'File saved': 'Archivo guardado',
  'File uploaded': 'Archivo subido',
  'Files': 'Archivos',
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Filtra por tipo de conexión de red. 'hosting' (datacenter/nube) funciona de inmediato; otros valores como cellular o wifi requieren que el proxy edge envíe el encabezado X-Connection-Type.",
  'Filter junk traffic, block malicious IPs and review suspicious activity in one place.': 'Filtra el tráfico basura, bloquea IPs maliciosas y revisa la actividad sospechosa en un solo lugar.',
  'Filter relation': 'Relación de filtros',
  'Filter rule': 'Regla de filtro',
  'Find': 'Buscar',
  'Find and replace a substring in flow redirect URLs (never landing/offer URLs).': 'Busca y reemplaza una subcadena en las URLs de redirección de flujos (nunca en las URLs de landing/oferta).',
  'Fire on statuses': 'Disparar en estados',
  'First 25 simulated clicks and how each was routed.': 'Los primeros 25 clics simulados y cómo se enrutó cada uno.',
  'Flag clicks that arrive with no User-Agent header.': 'Marca los clics que llegan sin encabezado User-Agent.',
  'Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.': 'Rotación de flujos. Activado: los streams Normal rotan por peso y la posición se ignora. Desactivado: los streams se evalúan de arriba hacia abajo por posición y la primera coincidencia se lleva todo el tráfico. Los streams Catch siempre interceptan primero y nunca rotan por peso.',
  'Flow tools': 'Herramientas de flujos',
  'Form submit (POST)': 'Envío de formulario (POST)',
  'Format': 'Formato',
  'Formula': 'Fórmula',
  'Formula is required': 'La fórmula es obligatoria',
  'Formula-based report columns over base metrics (CR, EPC, ROI variants)': 'Columnas de reporte basadas en fórmulas sobre métricas base (CR, EPC, variantes de ROI)',
  'Forwarding — S2S postbacks': 'Reenvío — postbacks S2S',
  'Friday': 'Viernes',
  'From': 'Desde',
  'From (ISO-8601)': 'Desde (ISO-8601)',
  'GDPR / DSAR': 'GDPR / DSAR',
  'GDPR: pseudonymize visitor IPs (hash before storage)': 'GDPR: seudonimizar las IPs de los visitantes (hash antes de almacenar)',
  'Generate a key to call the public REST API.': 'Genera una clave para llamar a la API REST pública.',
  'GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.': 'Nombres de región / estado / óblast de GeoIP (p. ej. California, Bavaria). Se admiten máscaras, /regex/ y @empty.',
  'Go back': 'Volver',
  'Go to Workspace': 'Ir al espacio de trabajo',
  'Group': 'Grupo',
  'Group (optional)': 'Grupo (opcional)',
  'Group by': 'Agrupar por',
  'Group by:': 'Agrupar por:',
  'Group clicks and conversions by any dimension with full metrics.': 'Agrupa clics y conversiones por cualquier dimensión con métricas completas.',
  'Grouped by': 'Agrupado por',
  'Has label': 'Tiene etiqueta',
  'Headless click registration and the JS adapter for landing pages.': 'Registro de clics headless y el adaptador JS para páginas de aterrizaje.',
  'Healthy': 'Saludable',
  'Help': 'Ayuda',
  'Hide xpnsr branding': 'Ocultar la marca xpnsr',
  'Hosted pages and uploads': 'Páginas alojadas y archivos subidos',
  'Hostname': 'Hostname',
  'Hour': 'Hora',
  'Hour (0-23)': 'Hora (0-23)',
  'How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.': 'Cómo se identifica a los visitantes recurrentes para la detección de clics únicos: Cookie (predeterminado), IP, IP+UA o Parámetro — identifica por un parámetro GET (p. ej. external_id) para reconocer al mismo usuario aunque cambien la IP o las cookies.',
  'IP + User-Agent': 'IP + User-Agent',
  'IP addresses': 'Direcciones IP',
  'IP of your tracking server': 'IP de tu servidor de tracking',
  'IP version': 'Versión de IP',
  'IPs': 'IPs',
  'ISP / carrier': 'ISP / operador',
  'ISP / provider': 'ISP / proveedor',
  'Import flows': 'Importar flujos',
  'Imported': 'Importado',
  'In conversions': 'En conversiones',
  'In revenue': 'En ingresos',
  'Inbound URL copied': 'URL entrante copiada',
  'Inbound postback URL (paste in the network)': 'URL de postback entrante (pégala en la red)',
  'Include this type in the conversions column.': 'Incluir este tipo en la columna de conversiones.',
  'Include this type in the revenue column.': 'Incluir este tipo en la columna de ingresos.',
  'Index page (SEO, served at the root with 200):': 'Página de índice (SEO, servida en la raíz con 200):',
  'Indexable': 'Indexable',
  'Insert': 'Insertar',
  'Install': 'Instalar',
  'Install failed.': 'No se pudo instalar.',
  'Integration': 'Integración',
  'Internal notes': 'Notas internas',
  'Invalid 2FA code': 'Código 2FA inválido',
  'Invalid SSO session': 'Sesión SSO inválida',
  'Invitation accepted!': '¡Invitación aceptada!',
  'Invite members': 'Invitar miembros',
  'Invite teammates above to collaborate.': 'Invita a tus compañeros de equipo arriba para colaborar.',
  'Is': 'Es',
  'Is not': 'No es',
  'JS adapter snippet': 'Snippet del adaptador JS',
  'JS redirect (location.replace)': 'Redirección JS (location.replace)',
  'Key': 'Clave',
  'Key (e.g. price)': 'Clave (p. ej. price)',
  'Key metrics over time buckets. Toggle to attribute conversions to their arrival date.': 'Métricas clave por intervalos de tiempo. Alterna para atribuir las conversiones a su fecha de llegada.',
  'Keyboard shortcuts': 'Atajos de teclado',
  'Keyboard shortcuts (?)': 'Atajos de teclado (?)',
  'Keys': 'Claves',
  'Keyword exclude': 'Exclusión de palabras clave',
  'Keyword include': 'Inclusión de palabras clave',
  'Label (operator-only)': 'Etiqueta (solo operador)',
  'Label color': 'Color de etiqueta',
  'Landing click': 'Clic en landing',
  'Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.': 'Últimos 200 registros de consentimiento en este espacio de trabajo. Se usan como registro de auditoría para consultas de DSAR / reguladores.',
  'Last run': 'Última ejecución',
  'Last viewed': 'Visto por última vez',
  'Layout': 'Estructura',
  'Layout & retention': 'Estructura y retención',
  'Lead export failed': 'Falló la exportación de leads',
  'Lead storage': 'Almacenamiento de leads',
  'Leads': 'Leads',
  'Leads exported': 'Leads exportados',
  'Leave empty to count every conversion.': 'Deja vacío para contar todas las conversiones.',
  'Leave empty to fire on all campaigns': 'Deja vacío para disparar en todas las campañas',
  'Leave the period blank to record spend as of now.': 'Deja el período en blanco para registrar el gasto al momento actual.',
  'Linked forwarders': 'Reenviadores vinculados',
  'List and open campaigns and their stats.': 'Lista y abre campañas y sus estadísticas.',
  'List existing API keys (does not reveal the secret).': 'Lista las claves API existentes (no revela el secreto).',
  'Lists': 'Listas',
  'Live': 'En vivo',
  'Live KPIs and breakdowns across campaigns, geos, devices.': 'KPIs en vivo y desgloses por campañas, geos y dispositivos.',
  'Loading documentation...': 'Cargando documentación...',
  'Loading marketplace…': 'Cargando marketplace…',
  'Login page subtitle': 'Subtítulo de la página de inicio de sesión',
  'Logo URL': 'URL del logo',
  'London (UTC+0)': 'Londres (UTC+0)',
  'Lookback (days)': 'Lookback (días)',
  'Los Angeles (UTC-8)': 'Los Ángeles (UTC-8)',
  'Macros imported from the source — click Save': 'Macros importadas desde la fuente — haz clic en Guardar',
  'Make sure your tracking URLs include {key}=... parameter': 'Asegúrate de que tus URLs de tracking incluyan el parámetro {key}=...',
  'Manage API keys': 'Gestionar claves API',
  'Manage TLS fingerprint overrides': 'Gestionar overrides de fingerprint TLS',
  'Manage profile, preferences, notifications and system configuration.': 'Gestiona el perfil, las preferencias, las notificaciones y la configuración del sistema.',
  'Manage your offers and creatives': 'Gestiona tus ofertas y creativos',
  'Manager': 'Manager',
  'Manual': 'Manual',
  'Manual entry secret': 'Secreto de entrada manual',
  'Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.': 'Registra manualmente el gasto de campaña que la sincronización de la cuenta publicitaria no puede ver — tarifas fijas, medios offline, correcciones.',
  'Manually record campaign spend — flat fees, offline media, corrections': 'Registra manualmente el gasto de campaña — tarifas fijas, medios offline, correcciones',
  'Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.': 'Mapea los estados crudos de la red a los nuestros (separados por comas). Funciona con cualquier red y se aplica a todos los postbacks entrantes de esta campaña. Los parámetros inline en la URL tienen prioridad.',
  'Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.': 'Mapea el estado crudo que envía esta red a un bucket canónico. Se aplica a los postbacks entrantes cuando el mapa de estados de la campaña no coincide.',
  'Mark all read': 'Marcar todo como leído',
  'Mark read': 'Marcar como leído',
  'Marked values are reusable as report filters and copyable for ad networks.': 'Los valores marcados son reutilizables como filtros de reportes y se pueden copiar para las redes publicitarias.',
  'Marketplace': 'Marketplace',
  'Match if referrer/params contain a keyword': 'Coincide si el referrer/los parámetros contienen una palabra clave',
  'Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.': 'Compara el encabezado X-Requested-With para detectar webviews / navegadores in-app. Coincidencia por subcadena — p. ej. com.android apunta a webviews de Android; @empty apunta a clics sin encabezado.',
  'Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.': 'Coincide con el motor de búsqueda derivado de los parámetros se / se_referrer o del host del referrer — p. ej. google, bing, yandex.',
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": 'Coincide con el nombre de la organización del ISP / ASN del visitante (de la tabla offline de inteligencia de IP). Se admiten máscaras, /regex/ y @empty — p. ej. AMAZON*, *Comcast*.',
  'Matched': 'Coincidente',
  'Meta refresh': 'Meta refresh',
  'Metric': 'Métrica',
  'Metrics': 'Métricas',
  'Metrics over time buckets (hour/day/weekday/month) + conversion-date view': 'Métricas por intervalos de tiempo (hora/día/día de la semana/mes) + vista por fecha de conversión',
  'Min clicks per stream': 'Mín. de clics por stream',
  'Minimum ROI (%)': 'ROI mínimo (%)',
  'Missing SSO session token': 'Falta el token de sesión SSO',
  'Missing invite token': 'Falta el token de invitación',
  'Monday': 'Lunes',
  'Monthly': 'Mensual',
  'Moscow, New York': 'Moscú, Nueva York',
  'Moscow, New York, London': 'Moscú, Nueva York, Londres',
  'Most clicks': 'Más clics',
  'Most revenue': 'Más ingresos',
  'Multiple HTML pages detected. Select the main page visitors will land on.': 'Se detectaron varias páginas HTML. Selecciona la página principal a la que llegarán los visitantes.',
  'Mumbai (UTC+5:30)': 'Mumbai (UTC+5:30)',
  'Must be an https:// URL. Leave blank to fall back to the xpnsr logo.': 'Debe ser una URL https://. Déjalo en blanco para usar el logo de xpnsr.',
  'Name A→Z': 'Nombre A→Z',
  'Name Z→A': 'Nombre Z→A',
  'Name and target URL are required': 'El nombre y la URL de destino son obligatorios',
  'Name is required.': 'El nombre es obligatorio.',
  'Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.': 'Pares clave/valor con nombre que se inyectan en las URLs de landing/oferta/postback mediante la macro {offer_value:NAME}.',
  'Network (text label)': 'Red (etiqueta de texto)',
  'Network preset…': 'Preset de red…',
  'Network status (e.g. ftd)': 'Estado de la red (p. ej. ftd)',
  'Network status values': 'Valores de estado de la red',
  'New': 'Nuevo',
  'New York (UTC-5)': 'Nueva York (UTC-5)',
  'New pre-landing': 'Nueva pre-landing',
  'New public dashboard link': 'Nuevo enlace público del panel',
  'New report': 'Nuevo reporte',
  'New saved report': 'Nuevo reporte guardado',
  'New schedule': 'Nueva programación',
  'New scheduled report': 'Nuevo reporte programado',
  'Newest first': 'Más recientes primero',
  'No active streams to optimize.': 'No hay streams activos para optimizar.',
  'No affiliate networks yet': 'Aún no hay redes de afiliados',
  'No clicks match these filters.': 'Ningún clic coincide con estos filtros.',
  'No cohort data': 'Sin datos de cohortes',
  'No consent records yet.': 'Aún no hay registros de consentimiento.',
  'No conversions yet': 'Aún no hay conversiones',
  'No cost entries yet': 'Aún no hay registros de costos',
  'No custom conversion types yet': 'Aún no hay tipos de conversión personalizados',
  'No custom metrics yet': 'Aún no hay métricas personalizadas',
  'No data for this period': 'No hay datos para este período',
  'No data for this period.': 'No hay datos para este período.',
  'No data found for {key}': 'No se encontraron datos para {key}',
  'No data yet.': 'Aún no hay datos.',
  'No description provided.': 'No se proporcionó descripción.',
  'No favourite flows yet. Star a flow to reuse it here.': 'Aún no hay flujos favoritos. Marca un flujo con una estrella para reutilizarlo aquí.',
  'No internet connection': 'Sin conexión a internet',
  'No label': 'Sin etiqueta',
  'No leads yet': 'Aún no hay leads',
  'No list entries yet. Use the thumbs buttons on report rows.': 'Aún no hay entradas en la lista. Usa los botones de pulgar en las filas del reporte.',
  'No match': 'Sin coincidencia',
  'No notifications yet': 'Aún no hay notificaciones',
  'No offer values. Add a key like price, then use {offer_value:price} in URLs.': 'No hay valores de oferta. Agrega una clave como price y luego usa {offer_value:price} en las URLs.',
  'No partner routes — this is a plain redirect/upload offer.': 'No hay rutas de partner — esta es una oferta simple de redirección/carga.',
  'No performance data yet': 'Aún no hay datos de rendimiento',
  'No pre-landings yet. Create one to start chaining traffic.': 'Aún no hay pre-landings. Crea una para empezar a encadenar tráfico.',
  'No public links yet. Create one to share read-only stats with advertisers.': 'Aún no hay enlaces públicos. Crea uno para compartir estadísticas de solo lectura con los anunciantes.',
  'No recipients set': 'Sin destinatarios configurados',
  'No results.': 'Sin resultados.',
  'No saved reports yet': 'Aún no hay reportes guardados',
  'No scheduled reports yet': 'Aún no hay reportes programados',
  'No status mappings added': 'No se agregaron mapeos de estado',
  'No status values added': 'No se agregaron valores de estado',
  'No templates match these filters.': 'Ninguna plantilla coincide con estos filtros.',
  'No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.': 'No se necesita umbral. Esta regla se dispara cuando cualquier oferta usada por la campaña alcanza su límite diario y te notifica que el tráfico está rotando hacia la oferta de respaldo / las ofertas restantes. Configura el límite y la oferta de respaldo en cada oferta.',
  'No vendors disclosed.': 'No se divulgaron proveedores.',
  'No verified custom domains. Add one in Domains → Settings.': 'No hay dominios personalizados verificados. Agrega uno en Dominios → Ajustes.',
  'No-index': 'No-index',
  'None': 'Ninguno',
  'Normal': 'Normal',
  'Not accepted': 'No aceptado',
  'Not enough data for analysis': 'No hay suficientes datos para el análisis',
  'Note': 'Nota',
  'Notes (optional)': 'Notas (opcional)',
  'Nothing found': 'No se encontró nada',
  'Notification settings': 'Ajustes de notificaciones',
  'Notification settings saved': 'Ajustes de notificaciones guardados',
  'Notify only': 'Solo notificar',
  'Nutra': 'Nutra',
  'OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.': 'Subida de conversiones de clic basada en OAuth — requiere developer token, customer ID y un refresh token. Úsala solo si necesitas subidas del lado del servidor con gclid.',
  'OR (any)': 'OR (cualquiera)',
  'OS': 'SO',
  'Offer URL': 'URL de la oferta',
  'Offer parameters': 'Parámetros de la oferta',
  'Offer rotation on daily cap': 'Rotación de ofertas al alcanzar el límite diario',
  'Offer values': 'Valores de la oferta',
  'Oldest first': 'Más antiguos primero',
  'Onboarding complete!': '¡Onboarding completado!',
  'One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).': 'Una IP exacta o un bloque CIDR por línea (p. ej. 203.0.113.7 o 10.0.0.0/8).',
  'One moment…': 'Un momento…',
  'One per line: substring, mask (*) or /regex/.': 'Uno por línea: subcadena, máscara (*) o /regex/.',
  'One value per line (or comma-separated). Each simulated query samples one value from each list.': 'Un valor por línea (o separados por comas). Cada consulta simulada toma una muestra de un valor de cada lista.',
  'Only ZIP files are supported': 'Solo se admiten archivos ZIP',
  'Only bots': 'Solo bots',
  'Only match if referrer contains one of these': 'Coincidir solo si el referrer contiene uno de estos',
  'Only proxy': 'Solo proxy',
  'Only these conversion statuses are sent to the ad platform. Default: sale.': 'Solo estos estados de conversión se envían a la plataforma publicitaria. Por defecto: sale.',
  'Open Campaigns': 'Abrir Campañas',
  'Open Domains': 'Abrir Dominios',
  'Open Domains page': 'Abrir la página de Dominios',
  'Open command palette': 'Abrir la paleta de comandos',
  'Open for search engines — click to close': 'Abierto para los motores de búsqueda — haz clic para cerrar',
  'Open in clicks log': 'Abrir en el registro de clics',
  'Open landing pages': 'Abrir páginas de aterrizaje',
  'Open my tracking link': 'Abrir mi enlace de tracking',
  'Open target URL': 'Abrir URL de destino',
  'Open the analytics dashboard and saved reports.': 'Abre el panel de analítica y los reportes guardados.',
  'Operating systems': 'Sistemas operativos',
  'Operators host the static page; the tracker just routes clicks here first.': 'Los operadores alojan la página estática; el tracker solo enruta los clics aquí primero.',
  'Optimization': 'Optimización',
  'Optional': 'Opcional',
  'Optional. Datacenter IPs that match these ASNs / labels are not blocked.': 'Opcional. Las IPs de datacenter que coincidan con estos ASN / etiquetas no se bloquean.',
  'Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.': 'Llamadas HTTP salientes que se disparan cada vez que se recibe un postback de conversión. Admite macros como {click_id}, {payout} y todos los parámetros de campaña declarados arriba.',
  'Outbound postback the tracker calls to notify this network.': 'Postback saliente que el tracker llama para notificar a esta red.',
  'Override the default permission matrix for this workspace.': 'Anula la matriz de permisos por defecto para este espacio de trabajo.',
  'Overrides': 'Overrides',
  'POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.': 'POST /v1/click con una clave API (scope de escritura). Devuelve la decisión de enrutamiento sin redirección del navegador.',
  'Pages library': 'Biblioteca de páginas',
  'Parameter': 'Parámetro',
  'Parameter filters': 'Filtros de parámetros',
  'Parameter name, e.g. external_id': 'Nombre del parámetro, p. ej. external_id',
  'Parameter name, e.g. sub1': 'Nombre del parámetro, p. ej. sub1',
  'Parameters configured:': 'Parámetros configurados:',
  'Params': 'Parámetros',
  'Password changed successfully': 'Contraseña cambiada correctamente',
  'Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.': 'Pega las etiquetas AW-XXX/YYY, una por línea. Cada una crea un reenviador separado.',
  'Paste on a landing page to auto-append the click id and forward the visitor.': 'Pégalo en una página de aterrizaje para agregar automáticamente el click id y reenviar al visitante.',
  'Paste the "send_to" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.': 'Pega el valor "send_to" de tu snippet de conversión de Google Ads (p. ej. AW-123456789/AbCdEf). No se necesita OAuth. El tracker lo guarda y lo dispara mediante el sufijo de URL final o con gtag al redirigir.',
  'Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.': 'Pega la IP del Paso 1 y presiona Guardar. Todos los clientes reciben de inmediato la nueva IP para su registro A — no se necesita reiniciar.',
  'Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.': 'Pega estas URLs en tu red de afiliados (p. ej. TrackBox) para que notifique las conversiones a esta campaña. Pasa tu click_id en el parámetro de la red y volverá aquí.',
  'Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.': 'Pega esto como URL final (Google Ads) o enlace de tracking (Facebook). Reemplaza los placeholders {key} con macros reales de la red publicitaria según sea necesario.',
  'Pause campaign': 'Pausar campaña',
  'Payload': 'Payload',
  'Payout': 'Payout',
  'Pending': 'Pendiente',
  'Per-query trace': 'Traza por consulta',
  'Performance': 'Rendimiento',
  'Performance alert': 'Alerta de rendimiento',
  'Performance overview': 'Resumen de rendimiento',
  'Period': 'Período',
  'Period end': 'Fin del período',
  'Period start': 'Inicio del período',
  'Period:': 'Período:',
  'Permanently discard this dead-letter entry? This cannot be undone.': '¿Descartar permanentemente esta entrada dead-letter? Esto no se puede deshacer.',
  'Permanently remove a campaign and its history.': 'Elimina permanentemente una campaña y su historial.',
  'Pick a preset or configure a partner network from scratch.': 'Elige un preset o configura una red partner desde cero.',
  'Pick a report, cadence and recipients.': 'Elige un reporte, la frecuencia y los destinatarios.',
  'Pick landing page': 'Elegir página de aterrizaje',
  'Pick offer': 'Elegir oferta',
  'Pin JA3 / JA4 hashes per-workspace (overrides the seed list).': 'Fija hashes JA3 / JA4 por espacio de trabajo (anula la lista semilla).',
  'Placeholder': 'Placeholder',
  'Placeholder / default': 'Placeholder / valor por defecto',
  'Plans & usage': 'Planes y uso',
  'Please enter a name for the landing page': 'Ingresa un nombre para la página de aterrizaje',
  'Please fill in name and URL': 'Completa el nombre y la URL',
  'Please fill in name and select ZIP file': 'Completa el nombre y selecciona un archivo ZIP',
  'Please select a ZIP file': 'Selecciona un archivo ZIP',
  'Please sign in first, then open the invite link again.': 'Primero inicia sesión y luego vuelve a abrir el enlace de invitación.',
  'Please wait…': 'Espera, por favor…',
  'Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.': 'Apunta este hostname al tracker mediante DNS. Los visitantes que lleguen a él verán tu marca antes de iniciar sesión.',
  'Pool name': 'Nombre del pool',
  'Position': 'Posición',
  'Postback IP whitelist': 'Lista blanca de IPs para postbacks',
  'Postback URL': 'URL de postback',
  'Postback URL copied': 'URL de postback copiada',
  'Postback URL template': 'Plantilla de URL de postback',
  'Postback added from preset': 'Postback agregado desde el preset',
  'Postback copied': 'Postback copiado',
  'Postback macro': 'Macro de postback',
  'Pre-Landings': 'Pre-Landings',
  'Pre-landing created': 'Pre-landing creada',
  'Pre-landing deleted': 'Pre-landing eliminada',
  'Pre-landing updated': 'Pre-landing actualizada',
  'Pre-landing uploaded': 'Pre-landing subida',
  'Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.': 'Las pre-landings te dan una página de entrada más rápida y con mejor cumplimiento antes de enviar a los visitantes a la oferta. Puedes agregar una en cualquier momento.',
  'Preview': 'Vista previa',
  'Primary colour': 'Color primario',
  'Privacy policy URL': 'URL de la política de privacidad',
  'Products': 'Productos',
  'Promote / demote existing members.': 'Asciende / degrada a los miembros existentes.',
  'Proposed': 'Propuesto',
  'Proposed drift': 'Drift propuesto',
  'Proposed weights': 'Pesos propuestos',
  'Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.': 'Protege tu cuenta con un código TOTP de una app de autenticación. Los códigos de respaldo te permiten iniciar sesión si pierdes tu dispositivo.',
  'Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.': 'Proporciona al menos un identificador. Se verán afectados los clics y las conversiones coincidentes en todos tus espacios de trabajo accesibles.',
  'Proxy': 'Proxy',
  'Proxy / VPN': 'Proxy / VPN',
  'Proxy / VPN IPs': 'IPs de proxy / VPN',
  "Public link created — copy it now, it won't be shown again.": 'Enlace público creado — cópialo ahora, no se volverá a mostrar.',
  'Public link revoked.': 'Enlace público revocado.',
  'Public read-only links': 'Enlaces públicos de solo lectura',
  'Publish': 'Publicar',
  'Publishing…': 'Publicando…',
  'Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.': 'Extrae los estados de leads y los depósitos desde TrackBox (últimos 7 días) y actualiza los leads guardados. Configura primero la x-api-key de pull en la integración.',
  'Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.': 'Extrae los estados de leads desde OpenAFF por el número de días configurado en la integración y actualiza los leads guardados. Configura primero el token de la API de estados en la integración.',
  'Pull out of rotation': 'Sacar de la rotación',
  'Pull path': 'Ruta de pull',
  'Pull sync': 'Sincronización pull',
  'Pull sync (statuses/deposits)': 'Sincronización pull (estados/depósitos)',
  'Pull sync done': 'Sincronización pull completada',
  'Pull type': 'Tipo de pull',
  'Purpose (e.g. Analytics)': 'Propósito (p. ej. Analytics)',
  'Push notifications, webhook URL, alert categories': 'Notificaciones push, URL de webhook, categorías de alertas',
  'Queries': 'Consultas',
  'Quick start from preset': 'Inicio rápido desde preset',
  'Quick start from template': 'Inicio rápido desde plantilla',
  'Quiz / review / bonus pages that intercept the click before the final landing or offer.': 'Páginas de quiz / reseña / bono que interceptan el clic antes de la landing final o la oferta.',
  'ROI': 'ROI',
  'ROI %': 'ROI %',
  'ROI (sensitive)': 'ROI (sensible)',
  'ROI alert': 'Alerta de ROI',
  'Random seed (optional)': 'Semilla aleatoria (opcional)',
  'Raw status strings partner networks send that should map to this type (case-insensitive).': 'Cadenas de estado crudas que envían las redes partner y que deben mapearse a este tipo (sin distinguir mayúsculas y minúsculas).',
  'Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.': 'Estados crudos a tratar como TRASH (se registran pero se excluyen de los payouts). P. ej. trash, invalid.',
  'Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.': 'Estados crudos a tratar como DEPOSIT (tipo de conversión de primera clase). P. ej. dep, ftd, deposit.',
  'Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.': 'Estados crudos a tratar como REGISTRATION (tipo de conversión de primera clase). P. ej. reg, signup.',
  'Read filter list, blocked samples, audit feed.': 'Lee la lista de filtros, las muestras bloqueadas y el feed de auditoría.',
  'Read the rules engine and execution history.': 'Lee el motor de reglas y el historial de ejecución.',
  'Read the workspace audit feed.': 'Lee el feed de auditoría del espacio de trabajo.',
  'Read-only public view — generated by xpnsr-tracker.': 'Vista pública de solo lectura — generada por xpnsr-tracker.',
  'Read-only — only the workspace owner can edit the matrix': 'Solo lectura — solo el dueño del espacio de trabajo puede editar la matriz',
  'Real only': 'Solo reales',
  'Real → offer': 'Real → oferta',
  'Rebalance stream weights based on historical conversion rate using a multi-armed bandit.': 'Rebalancea los pesos de los streams según la tasa de conversión histórica usando un multi-armed bandit.',
  'Receiving conversions (incoming postback)': 'Recepción de conversiones (postback entrante)',
  'Recent decisions': 'Decisiones recientes',
  'Recipients': 'Destinatarios',
  'Record retention (days)': 'Retención de registros (días)',
  'Recurring reports emailed on a daily/weekly/monthly cadence': 'Reportes recurrentes enviados por correo con frecuencia diaria/semanal/mensual',
  'Recurring reports emailed to recipients on a daily/weekly/monthly cadence.': 'Reportes recurrentes enviados por correo a los destinatarios con frecuencia diaria/semanal/mensual.',
  'Redirect method': 'Método de redirección',
  'Redirect mode': 'Modo de redirección',
  'Referrer / Keyword filters': 'Filtros de referrer / palabra clave',
  'Referrer exclude': 'Excluir referrer',
  'Referrer include': 'Incluir referrer',
  'Region preset': 'Preset de región',
  'Region scope': 'Alcance de región',
  'Regions': 'Regiones',
  'Register a custom hostname so your tracking links resolve under your own brand.': 'Registra un hostname personalizado para que tus enlaces de tracking resuelvan bajo tu propia marca.',
  'Register hostname': 'Registrar hostname',
  'Reject button label': 'Etiqueta del botón de rechazar',
  'Rejected': 'Rechazado',
  'Remember the current filters, sort and layout under a name for one-click recall.': 'Guarda los filtros, el orden y el diseño actuales bajo un nombre para recuperarlos con un clic.',
  'Remove': 'Quitar',
  'Remove members': 'Quitar miembros',
  'Remove template': 'Eliminar plantilla',
  'Remove this template? This cannot be undone.': '¿Eliminar esta plantilla? Esto no se puede deshacer.',
  'Removed': 'Eliminado',
  'Replace': 'Reemplazar',
  'Replace URL': 'Reemplazar URL',
  'Replace with': 'Reemplazar con',
  'Report': 'Reporte',
  'Report deleted': 'Reporte eliminado',
  'Report queued': 'Reporte en cola',
  'Report saved': 'Reporte guardado',
  'Report type': 'Tipo de reporte',
  'Request': 'Solicitud',
  'Reset branding': 'Restablecer branding',
  'Reset to defaults': 'Restablecer valores por defecto',
  'Resetting…': 'Restableciendo…',
  'Response sample': 'Muestra de respuesta',
  'Restore': 'Restaurar',
  'Restore to rotation': 'Restaurar a la rotación',
  'Return on investment': 'Retorno de la inversión',
  'Reusable partner networks: postback template, offer params and inbound URL.': 'Redes partner reutilizables: plantilla de postback, parámetros de oferta y URL entrante.',
  'Reusable partner networks: postback, offer params, inbound URL': 'Redes partner reutilizables: postback, parámetros de oferta, URL entrante',
  'Reusable report definitions you can export to CSV or XLSX on demand.': 'Definiciones de reportes reutilizables que puedes exportar a CSV o XLSX bajo demanda.',
  'Reusable report definitions, exportable to CSV/XLSX on demand': 'Definiciones de reportes reutilizables, exportables a CSV/XLSX bajo demanda',
  'Rev.': 'Ing.',
  'RevShare (% of payout)': 'RevShare (% del payout)',
  'Revenue (sensitive)': 'Ingresos (sensible)',
  'Revenue comparison': 'Comparación de ingresos',
  'Revoke': 'Revocar',
  "Revoke a teammate's access.": 'Revoca el acceso de un compañero de equipo.',
  'Revoke failed': 'Error al revocar',
  'Revoke public link': 'Revocar enlace público',
  'Rolling-window limit over the last 24 hours. Empty = no limit.': 'Límite de ventana móvil sobre las últimas 24 horas. Vacío = sin límite.',
  'Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.': 'Límite de ventana deslizante: el stream deja de aceptar clics NUEVOS después de esta cantidad en la última hora; el tráfico pasa al siguiente stream. Vacío = sin límite.',
  'Round robin': 'Round robin',
  'Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.': 'Enruta por subparámetros de la URL. Una regla por línea: name=value1, value2 permite los valores listados; name!=value1, value2 los bloquea (un parámetro ausente pasa una regla de bloqueo). Una regla sin valores no agrega restricciones.',
  'Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.': 'Enruta esta oferta a uno o más partners con pesos (split/rotación). Los partners inactivos se omiten (p. ej. hasta que se acuerden los términos). El lead se asigna por peso; si es rechazado, pasa al siguiente partner.',
  'Routing': 'Enrutamiento',
  'Routing record (A record)': 'Registro de enrutamiento (registro A)',
  'Row-level drill-down into incoming clicks: country, device, stream, and variant.': 'Desglose a nivel de fila de los clics entrantes: país, dispositivo, stream y variante.',
  'Run a preview to see proposed weights.': 'Ejecuta una vista previa para ver los pesos propuestos.',
  'Run now': 'Ejecutar ahora',
  'Run pull sync': 'Ejecutar sincronización pull',
  'Run simulation': 'Ejecutar simulación',
  'Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.': 'Ejecuta una sincronización de los últimos 7 días. Úsala para verificar la respuesta antes de habilitar la sincronización pull automática.',
  'SEO crawler split off': 'Split SEO de crawlers desactivado',
  'SEO crawler split on: verified crawlers index the page, humans go to the funnel': 'Split SEO de crawlers activado: los crawlers verificados indexan la página, los humanos van al embudo',
  'SEO split (crawlers → index, humans → funnel)': 'Split SEO (crawlers → índice, humanos → embudo)',
  'SSO failed': 'Error de SSO',
  'SSO is not configured': 'SSO no está configurado',
  'SSO sign-in failed': 'Error al iniciar sesión con SSO',
  'Safe page URL': 'URL de la página segura',
  'Sample datasets': 'Conjuntos de datos de ejemplo',
  'Saturday': 'Sábado',
  'Save branding': 'Guardar branding',
  'Save current view': 'Guardar vista actual',
  'Save the campaign once to generate the token.': 'Guarda la campaña una vez para generar el token.',
  'Save view': 'Guardar vista',
  'Saved reports': 'Reportes guardados',
  'Saved views': 'Vistas guardadas',
  'Saving...': 'Guardando...',
  'Scan the QR code with your authenticator app': 'Escanea el código QR con tu app de autenticación',
  'Schedule': 'Programación',
  'Schedule created': 'Programación creada',
  'Schedule deleted': 'Programación eliminada',
  'Scheduled reports': 'Reportes programados',
  'Search by name, description, or slug. Filter by type or tag.': 'Busca por nombre, descripción o slug. Filtra por tipo o etiqueta.',
  'Search conversion types': 'Buscar tipos de conversión',
  'Search custom metrics': 'Buscar métricas personalizadas',
  'Search engines': 'Motores de búsqueda',
  'Search networks': 'Buscar redes',
  'Search presets': 'Buscar presets',
  'Search sections...': 'Buscar secciones...',
  'Search…': 'Buscar…',
  'Secondary colour': 'Color secundario',
  'See plan, invoices, payment method.': 'Consulta el plan, las facturas y el método de pago.',
  'Select a file from the sidebar to edit': 'Selecciona un archivo de la barra lateral para editarlo',
  'Select all': 'Seleccionar todo',
  'Select at least 2 campaigns': 'Selecciona al menos 2 campañas',
  'Select campaigns (2–10)': 'Selecciona campañas (2–10)',
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.": 'Cloaking autoalojado. Los bots, los moderadores de redes publicitarias, las IP de datacenter/proxy y los crawlers de búsqueda ven la página segura (white); los humanos genuinos van a la oferta real. La clasificación usa las verificaciones propias del tracker de bots / IP / DNS de crawlers — sin servicios de terceros.',
  'Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.': 'Envía un lead sintético al CRM e inspecciona la respuesta. Se usa un email/teléfono desechable a menos que lo sobrescribas abajo.',
  'Send invite links to new teammates.': 'Envía enlaces de invitación a nuevos miembros del equipo.',
  'Send test lead': 'Enviar lead de prueba',
  'Sending…': 'Enviando…',
  'Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.': 'Sirve un robots.txt / sitemap.xml generado en la raíz del dominio SOLO cuando tu paquete subido no incluye ninguno. Tus propios archivos SEO siempre tienen prioridad.',
  'Server error': 'Error del servidor',
  'Set another entry page first': 'Primero establece otra página de entrada',
  'Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.': 'Configura aquí un partner/CRM una vez y luego las ofertas lo referencian. TrackBox / Tigloo es el adaptador listo para usar; Custom API sirve para cualquier otro CRM. Los leads de los formularios de oferta se envían al partner seleccionado.',
  'Set up rules, notifications and triggered actions for your campaigns.': 'Configura reglas, notificaciones y acciones automatizadas para tus campañas.',
  'Set up your tracker': 'Configura tu tracker',
  'Setup failed': 'Error en la configuración',
  'Share a token-gated dashboard URL with advertisers without giving them an account.': 'Comparte una URL de panel protegida por token con anunciantes sin darles una cuenta.',
  'Shareable URL': 'URL para compartir',
  'Shared dashboard': 'Panel compartido',
  'Show 404': 'Mostrar 404',
  'Show shortcuts': 'Mostrar atajos',
  'Side-by-side metrics for multiple campaigns': 'Métricas lado a lado de varias campañas',
  'Side-by-side metrics for selected campaigns': 'Métricas lado a lado de las campañas seleccionadas',
  'Sign in with Google': 'Iniciar sesión con Google',
  'Sign in with Microsoft': 'Iniciar sesión con Microsoft',
  'Simulate': 'Simular',
  'Simulating…': 'Simulando…',
  'Simulation failed': 'Error en la simulación',
  'Singapore (UTC+8)': 'Singapur (UTC+8)',
  'Size': 'Tamaño',
  'Skip (use auto-detected)': 'Omitir (usar lo autodetectado)',
  'Skip for now': 'Omitir por ahora',
  'Skip if referrer contains one of these': 'Omitir si el referrer contiene uno de estos',
  'Skip if referrer/params contain a keyword': 'Omitir si el referrer/parámetros contienen una palabra clave',
  'Skip this step until you have a campaign — you can finish setup from the Campaigns page.': 'Omite este paso hasta que tengas una campaña — puedes terminar la configuración desde la página de Campañas.',
  'Skipped (below min_clicks_per_stream)': 'Omitido (por debajo de min_clicks_per_stream)',
  'Smoothed CR': 'CR suavizado',
  'Sort by': 'Ordenar por',
  'Source': 'Fuente',
  'Split testing': 'Split testing',
  'Split testing disabled': 'Split testing desactivado',
  'Split testing enabled': 'Split testing activado',
  'Split traffic across variants to find what converts best.': 'Divide el tráfico entre variantes para descubrir qué convierte mejor.',
  'Starred flows from any campaign. Insert a copy into this campaign.': 'Flujos destacados de cualquier campaña. Inserta una copia en esta campaña.',
  'Status mapping': 'Mapeo de estados',
  'Step 1. Provision a new server': 'Paso 1. Aprovisiona un nuevo servidor',
  'Step 2. Enter the new IP': 'Paso 2. Ingresa la nueva IP',
  'Step {step} of {total}': 'Paso {step} de {total}',
  'Step-by-step guide for every feature': 'Guía paso a paso de cada función',
  'Step-by-step user guide for every feature': 'Guía de usuario paso a paso de cada función',
  'Sticky (per-visitor)': 'Persistente (por visitante)',
  'Stored form leads: name/email/phone/geo/status, filter + CSV export for resale': 'Leads de formulario almacenados: nombre/email/teléfono/geo/estado, filtro + exportación a CSV para reventa',
  'Stream': 'Stream',
  'Stream ID': 'ID del stream',
  'Stream cloned': 'Stream clonado',
  'Stream configured': 'Stream configurado',
  'Streams changed': 'Streams modificados',
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": 'Los streams deciden a qué oferta llega cada visitante. Configura tu stream predeterminado y tendrás un enlace de tracking funcional.',
  'Sub-ID drill-down': 'Desglose por Sub-ID',
  'Sub-ID reports': 'Reportes de Sub-ID',
  'Submission failed.': 'Error al enviar.',
  'Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.': 'Los envíos se publican automáticamente. El slug se deriva del nombre; si coincide con una plantilla existente, se agrega un sufijo numérico.',
  'Submit a template': 'Enviar una plantilla',
  'Submit template': 'Enviar plantilla',
  'Submitted leads from your offer forms will appear here.': 'Los leads enviados desde tus formularios de oferta aparecerán aquí.',
  'Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.': 'Subcadenas, máscaras o /regex/ comparadas contra el User-Agent sin procesar — p. ej. *Chrome/12* apunta a Chrome 120+, HeadlessChrome detecta navegadores headless.',
  'Sunday': 'Domingo',
  'Switch to dark theme': 'Cambiar a tema oscuro',
  'Switch to light theme': 'Cambiar a tema claro',
  'Sydney (UTC+11)': 'Sídney (UTC+11)',
  'Synced': 'Sincronizado',
  'São Paulo (UTC-3)': 'São Paulo (UTC-3)',
  'Table view': 'Vista de tabla',
  'Tags (comma-separated)': 'Etiquetas (separadas por comas)',
  'Tags:': 'Etiquetas:',
  'Telegram postbacks added — press Save to apply': 'Postbacks de Telegram agregados — presiona Guardar para aplicar',
  'Template': 'Plantilla',
  'Template body copied to clipboard.': 'Cuerpo de la plantilla copiado al portapapeles.',
  'Template installed. Body shown in detail dialog.': 'Plantilla instalada. El cuerpo se muestra en el diálogo de detalles.',
  'Template marketplace': 'Marketplace de plantillas',
  'Template published as {slug}.': 'Plantilla publicada como {slug}.',
  'Template removed.': 'Plantilla eliminada.',
  'Test integration': 'Probar integración',
  'Test lead accepted': 'Lead de prueba aceptado',
  'Test lead not accepted': 'Lead de prueba no aceptado',
  'The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.': 'La página conforme que se muestra a bots/crawlers. Debe ser una URL http(s) absoluta. En modo SEO, esta es la página que indexan los crawlers de búsqueda verificados.',
  'The page you are looking for does not exist or has been moved.': 'La página que buscas no existe o fue movida.',
  'The token will only be shown once after creation — copy it immediately.': 'El token solo se mostrará una vez después de su creación — cópialo de inmediato.',
  'Third-party processors disclosed to the visitor (max 50).': 'Procesadores de terceros declarados al visitante (máx. 50).',
  'This campaign has no source with parameters': 'Esta campaña no tiene ninguna fuente con parámetros',
  'This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.': 'Este enlace no requiere autenticación. Cualquiera que lo tenga puede ver las métricas seleccionadas hasta que expire o sea revocado.',
  'This member will lose access to this workspace immediately.': 'Este miembro perderá el acceso a este espacio de trabajo de inmediato.',
  'This permanently deletes all matching clicks and conversions. This cannot be undone.': 'Esto elimina permanentemente todos los clics y conversiones que coincidan. Esto no se puede deshacer.',
  'This permanently deletes the conversion type. Existing conversions keep their stored status.': 'Esto elimina permanentemente el tipo de conversión. Las conversiones existentes conservan su estado almacenado.',
  'This permanently deletes the metric column from reports.': 'Esto elimina permanentemente la columna de la métrica de los reportes.',
  'This permanently deletes the network. Offers linked to it keep their other settings.': 'Esto elimina permanentemente la red. Las ofertas vinculadas a ella conservan sus demás ajustes.',
  'This permanently deletes the saved report definition.': 'Esto elimina permanentemente la definición del reporte guardado.',
  'This permanently deletes the scheduled report.': 'Esto elimina permanentemente el reporte programado.',
  'This removes the manual cost and reverses its contribution to the campaign spend.': 'Esto elimina el costo manual y revierte su contribución al gasto de la campaña.',
  'This shared link has expired or been revoked.': 'Este enlace compartido expiró o fue revocado.',
  'This shared link is not valid.': 'Este enlace compartido no es válido.',
  'This will permanently delete "{name}" and all associated clicks, conversions and postback events. This cannot be undone.': 'Esto eliminará permanentemente "{name}" y todos los clics, conversiones y eventos de postback asociados. Esto no se puede deshacer.',
  'This will permanently delete "{name}" and all its variants.': 'Esto eliminará permanentemente "{name}" y todas sus variantes.',
  'This will permanently delete "{name}" and remove it from all campaigns.': 'Esto eliminará permanentemente "{name}" y lo quitará de todas las campañas.',
  'This will permanently delete "{name}".': 'Esto eliminará permanentemente "{name}".',
  'This will permanently delete "{name}". Campaigns using this domain will fall back to the default domain.': 'Esto eliminará permanentemente "{name}". Las campañas que usan este dominio pasarán al dominio predeterminado.',
  'This will permanently delete "{name}". Campaigns using this source will lose their tracking parameters.': 'Esto eliminará permanentemente "{name}". Las campañas que usan esta fuente perderán sus parámetros de tracking.',
  'This will permanently delete pool "{name}".': 'Esto eliminará permanentemente el pool "{name}".',
  'This will permanently delete rule "{name}".': 'Esto eliminará permanentemente la regla "{name}".',
  'This will permanently delete stream "{name}".': 'Esto eliminará permanentemente el stream "{name}".',
  'This will permanently delete this ad account connection. Cost syncing will stop.': 'Esto eliminará permanentemente esta conexión de cuenta publicitaria. La sincronización de costos se detendrá.',
  'This will permanently delete this conversion forwarder.': 'Esto eliminará permanentemente este reenviador de conversiones.',
  'This will permanently delete webhook "{name}". Events will no longer be forwarded.': 'Esto eliminará permanentemente el webhook "{name}". Los eventos ya no se reenviarán.',
  'This will permanently revoke this API key. Any integrations using it will stop working.': 'Esto revocará permanentemente esta clave API. Cualquier integración que la use dejará de funcionar.',
  'This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.': 'Esto restablecerá todos los ajustes de branding a los valores predeterminados. Se eliminarán el logo, los colores y el dominio personalizado.',
  'This will reset two-factor authentication for this member. They will need to re-enrol.': 'Esto restablecerá la autenticación de dos factores para este miembro. Tendrá que configurarla de nuevo.',
  'Thursday': 'Jueves',
  'Time on landing': 'Tiempo en la landing',
  'Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.': 'Consejo: si reasignas la antigua Elastic IP al nuevo servidor en AWS, no hay que cambiar nada aquí — ni para los clientes.',
  'Title': 'Título',
  'Title, body, and button labels shown to the visitor.': 'Título, cuerpo y etiquetas de los botones que se muestran al visitante.',
  'To': 'Hasta',
  'To (ISO-8601)': 'Hasta (ISO-8601)',
  'Toggle navigation': 'Alternar navegación',
  'Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).': 'Verificación de token desactivada — los postbacks se aceptan por click_id sin token (elimina &token=… de la URL en tu red).',
  'Tokyo (UTC+9)': 'Tokio (UTC+9)',
  'Too many requests — please retry in a moment.': 'Demasiadas solicitudes — vuelve a intentarlo en un momento.',
  'Total leads': 'Total de leads',
  'Track click usage and switch plans. Billing renews monthly.': 'Controla el uso de clics y cambia de plan. La facturación se renueva mensualmente.',
  'TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.': 'Credenciales de la cuenta de TrackBox (dashboard → API Testing). Configúralas una vez por cuenta — las ofertas referenciarán este partner.',
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.": 'TrackBox: pasa tu click_id en el parámetro Affclickid del enlace de la oferta para que {affclickid} regrese a esta campaña. Método GET.',
  'Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.': 'Generic: pasa tu click_id en el enlace de la oferta para que regrese a esta campaña como {click_id}. Método GET.',
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.": 'Subid: pasa tu click_id en el parámetro subid del enlace de la oferta para que {subid} regrese a esta campaña. Método GET.',
  'Tracking domain': 'Dominio de tracking',
  'Tracking domains are managed on the Domains page — add and verify a custom domain there.': 'Los dominios de tracking se administran en la página de Dominios — agrega y verifica ahí un dominio personalizado.',
  'Tracking link copied to clipboard': 'Enlace de tracking copiado al portapapeles',
  'Traffic Simulation': 'Simulación de tráfico',
  'Traffic loss %': '% de pérdida de tráfico',
  'Traffic trends': 'Tendencias de tráfico',
  'Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.': 'Reglas de transición: a qué estados puede pasar una conversión de este tipo. Deja todo sin marcar para permitir cualquier transición.',
  'Treat empty User-Agent as bot': 'Tratar el User-Agent vacío como bot',
  'Trends': 'Tendencias',
  'Tuesday': 'Martes',
  'Tune the bandit before running a preview. Apply only writes weights to active streams.': 'Ajusta el bandit antes de ejecutar una vista previa. Aplicar solo escribe los pesos en los streams activos.',
  'Two-factor authentication': 'Autenticación de dos factores',
  'Two-factor code': 'Código de dos factores',
  'Type': 'Tipo',
  'Type a command or search…': 'Escribe un comando o busca…',
  'US, CA, GB': 'US, CA, GB',
  'US, CA, GB, RU': 'US, CA, GB, RU',
  'US, GB, DE': 'US, GB, DE',
  'US,RU,DE': 'US,RU,DE',
  'Ungrouped': 'Sin agrupar',
  'Uniqueness method': 'Método de unicidad',
  'Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.': 'Integración universal para cualquier CRM de partner. Describe su solicitud API de registro de leads — el tracker enviará ahí los datos del formulario y redirigirá usando el enlace de la respuesta.',
  'Unlimited': 'Ilimitado',
  'Update partner network settings': 'Actualizar ajustes de la red de partners',
  'Update reporting semantics and status transitions.': 'Actualiza la semántica de reportes y las transiciones de estado.',
  'Update the formula, format or decimals.': 'Actualiza la fórmula, el formato o los decimales.',
  'Upload a ZIP with your warm-up page. index.html is auto-detected.': 'Sube un ZIP con tu página de warm-up. index.html se detecta automáticamente.',
  'Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.': 'Sube un paquete de página de aterrizaje (.zip) o elige una plantilla de pre-landing alojada de la biblioteca.',
  'Upload failed': 'Error al subir',
  'Upload pre-landing (ZIP)': 'Subir pre-landing (ZIP)',
  'Upload, edit, and delete landings.': 'Sube, edita y elimina landings.',
  'Upload, organize and reuse landing pages across your campaigns.': 'Sube, organiza y reutiliza páginas de aterrizaje en todas tus campañas.',
  'Uploaded': 'Subido',
  'Uploading…': 'Subiendo…',
  'Use a negative amount to book a correction.': 'Usa un monto negativo para registrar una corrección.',
  'User agents': 'User-Agents',
  'Vendor list': 'Lista de proveedores',
  'Vendor name (e.g. Google Analytics)': 'Nombre del proveedor (p. ej. Google Analytics)',
  'Verified search crawlers': 'Crawlers de búsqueda verificados',
  'Verify now': 'Verificar ahora',
  'Verifying…': 'Verificando…',
  'Vertical': 'Vertical',
  'View': 'Ver',
  'View API keys': 'Ver claves API',
  'View anti-fraud': 'Ver antifraude',
  'View audit log': 'Ver registro de auditoría',
  'View automation rules': 'Ver reglas de automatización',
  'View billing': 'Ver facturación',
  'View campaigns': 'Ver campañas',
  'View integrations': 'Ver integraciones',
  'View landings': 'Ver landings',
  'View name': 'Nombre de la vista',
  'View offers': 'Ver ofertas',
  'View postbacks': 'Ver postbacks',
  'View reports': 'Ver reportes',
  'View saved': 'Ver guardados',
  'View tracking domains': 'Ver dominios de tracking',
  'Viewer': 'Visualizador',
  'Views': 'Vistas',
  'Visible metrics': 'Métricas visibles',
  'Visitor': 'Visitante',
  'Visitor ID': 'ID de visitante',
  'Visual identity': 'Identidad visual',
  'Wednesday': 'Miércoles',
  'Weekly': 'Semanal',
  'Weight floor (%)': 'Peso mínimo (%)',
  'Weighted': 'Ponderado',
  'Weights equalized': 'Pesos igualados',
  'Welcome to ACME Tracker — sign in to continue': 'Te damos la bienvenida a ACME Tracker — inicia sesión para continuar',
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.": 'Cuando está ACTIVADO, los postbacks entrantes deben llevar el token de esta campaña; de lo contrario se rechazan (401). Desactívalo si la red (p. ej. TrackBox) envía UN postback compartido para todas las campañas: elimina &token=… de esta URL y las conversiones se emparejarán por click_id.',
  'When disabled, the public widget responds with required:false so landing pages skip rendering entirely.': 'Cuando está desactivado, el widget público responde con required:false, así que las páginas de aterrizaje omiten el renderizado por completo.',
  'When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.': 'Cuando está activado, los crawlers de búsqueda verificados por DNS reciben la página índice (para posicionamiento) y los humanos se envían al embudo de la campaña vinculada. Requiere una página índice + una campaña vinculada a este dominio.',
  'When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.': 'Cuando se define, el tracker agrega automáticamente ?<param>=<click_id> a las URL de redirección. Déjalo vacío para desactivarlo. Usa {click_id} en la URL de destino para un control total.',
  'White': 'Blanco',
  'Whitelist': 'Lista blanca',
  'Whitelisted': 'En lista blanca',
  'Workflows': 'Flujos de trabajo',
  'Workspace default domain': 'Dominio predeterminado del espacio de trabajo',
  'X-Requested-With': 'X-Requested-With',
  'You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.': 'No tienes permiso para ver esta página. Contacta al administrador de tu espacio de trabajo si crees que se trata de un error.',
  'Your tracking link': 'Tu enlace de tracking',
  'ZIP file': 'Archivo ZIP',
  'analyst': 'analista',
  'box/goal id': 'id de box/goal',
  'buy, cheap, discount': 'comprar, barato, descuento',
  'campaign': 'campaña',
  'clear tag': 'quitar etiqueta',
  'clicks': 'clics',
  'connections': 'conexiones',
  'conv.': 'conv.',
  'cpa, nutra, en': 'cpa, nutra, en',
  'day': 'día',
  'days': 'días',
  'domains': 'dominios',
  'e.g. 185.45.12.1, 91.108.0.0': 'p. ej. 185.45.12.1, 91.108.0.0',
  'e.g. Facebook, Google, Tier 1': 'p. ej. Facebook, Google, Tier 1',
  'e.g. MaxBounty CPA': 'p. ej. MaxBounty CPA',
  'e.g. Q3 influencer flat fee': 'p. ej. Tarifa fija de influencer Q3',
  'e.g. Second deposit': 'p. ej. Segundo depósito',
  'e.g. Tier-1 by revenue': 'p. ej. Tier-1 por ingresos',
  'e.g. Unique CR': 'p. ej. CR único',
  'e.g. Weekly digest': 'p. ej. Resumen semanal',
  'e.g. Weekly performance': 'p. ej. Rendimiento semanal',
  'e.g. adcombo, cpa, status': 'p. ej. adcombo, cpa, status',
  'email / phone / name': 'email / teléfono / nombre',
  'fallback': 'fallback',
  'free, demo': 'gratis, demo',
  'group.<key>': 'group.<key>',
  'indexable': 'indexable',
  'installs': 'instalaciones',
  'last {n} days': 'últimos {n} días',
  'live': 'en vivo',
  'logo': 'logo',
  'max change': 'cambio máx.',
  'no': 'no',
  'no-index': 'no-index',
  'none': 'ninguno',
  'offer parameter(s)': 'parámetro(s) de oferta',
  'or continue with': 'o continúa con',
  'own': 'propio',
  'pages': 'páginas',
  'plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.': 'más cualquier campo del formulario y parámetros de la oferta. El campo redirect es una ruta dentro de la respuesta JSON (p. ej. data.url); si está vacío, se usa el primer enlace http(s) encontrado en la respuesta.',
  'redirect': 'redirect',
  'revoked': 'revocado',
  'rows': 'filas',
  'sec': 'seg',
  'statuses on schedule': 'estados según programación',
  'to close': 'para cerrar',
  'to navigate': 'para navegar',
  'to select': 'para seleccionar',
  'weight units': 'unidades de peso',
  'yes': 'sí',
  '{count} conversions': '{count} conversiones',
  '{count} forwarders created': '{count} reenviadores creados',
  '{key} breakdown': 'Desglose por {key}',
  '{n} selected': '{n} seleccionados',
  'Δ': 'Δ',
  '— no level —': '— sin nivel —',
  '— none (root opens the funnel) —': '— ninguno (la raíz abre el embudo) —',
  // A11y icon-button labels
  'Remove variant': 'Quitar variante',
  'Start test': 'Iniciar test',
  'Pause test': 'Pausar test',
  'View test results': 'Ver resultados del test',
  'Remove parameter': 'Quitar parámetro',
  'Remove status mapping': 'Quitar mapeo de estado',
  'Copy postback URL template': 'Copiar plantilla de URL de postback',
  'Copy inbound postback URL': 'Copiar URL de postback entrante',
  'Remove IP from blacklist': 'Quitar IP de la lista negra',
  'Remove IP from whitelist': 'Quitar IP de la lista blanca',
  'Copy curl command': 'Copiar comando curl',
  'Copy JS snippet': 'Copiar snippet JS',
  'Copy snippet': 'Copiar snippet',
  'Remove postback': 'Quitar postback',
  'Campaign actions': 'Acciones de la campaña',
  'Remove vendor': 'Quitar proveedor',
  'Remove campaign': 'Quitar campaña',
  'Remove value': 'Quitar valor',
  'Remove field': 'Quitar campo',
  'Copy webhook URL': 'Copiar URL del webhook',
  'Copy landing page URL': 'Copiar URL de la página de aterrizaje',
  'Open landing page': 'Abrir página de aterrizaje',
  'Remove partner route': 'Quitar ruta de partner',
  'Copy lead-form URL': 'Copiar URL del formulario de leads',
  'Copy offer URL': 'Copiar URL de la oferta',
  'Delete list entry': 'Eliminar entrada de la lista',
  'Copy secret': 'Copiar secreto',
  'Remove time range': 'Quitar rango de tiempo',
  'Remove date range': 'Quitar rango de fechas',
  'Pause stream': 'Pausar stream',
  'Resume stream': 'Reanudar stream',
  'Open redirect URL': 'Abrir URL de redirección',
  'Open offer URL': 'Abrir URL de la oferta',
  'Copy postback URL': 'Copiar URL de postback',
  'Delete rule': 'Eliminar regla',
  'Delete filter': 'Eliminar filtro',
  // i18n backfill: pre-existing untranslated keys in screens touched by the a11y pass
  'Delete traffic rule': 'Eliminar regla de tráfico',
  'This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.': 'Esto elimina la regla de tráfico de forma permanente. El tráfico pasará a las reglas restantes o al valor por defecto de la campaña.',
  'Delete fraud filter': 'Eliminar filtro antifraude',
  'This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.': 'Esto elimina el filtro antifraude de forma permanente. El tráfico que actualmente bloquea o puntúa dejará de ser evaluado por esta regla.',
  'Action (no page — hand off to the offer)': 'Action (sin página — entrega a la oferta)',
  'After click (at redirect)': 'Después del clic (en la redirección)',
  'Before click (at landing — enables offer macros)': 'Antes del clic (en la página de aterrizaje — habilita macros de la oferta)',
  'Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.': 'Coincide el operador móvil según el encabezado X-Carrier del edge. Se admiten máscaras, /regex/ y @empty — p. ej. Vodafone*, /^T-Mobile/.',
  'Mobile operator / carrier': 'Operador móvil',
  'Offer selection moment': 'Momento de selección de la oferta',
  'Preload (serve the page from the tracker domain)': 'Preload (servir la página desde el dominio del tracker)',
  'Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.': 'Preload obtiene la página en el servidor y la sirve bajo tu dominio del tracker; Action no muestra nada y deja que el stream elija una oferta.',
  'QR code': 'Código QR',
  'Redirect (send visitor to the URL)': 'Redirect (enviar al visitante a la URL)',
  'Remote rotator (fetch target)': 'Rotador remoto (obtiene el destino)',
  'Scan to open the tracking link on a device.': 'Escanea para abrir el enlace de tracking en un dispositivo.',
  'Transparent (server-side fetch)': 'Transparente (obtención en el servidor)',
  'When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.': 'Cuándo elegir la oferta para este stream. Después (por defecto): en el momento de la redirección. Antes: al servir la landing, para que las macros {offer_name} / {offer_value:*} se rendericen en la página de aterrizaje.',
  'Added to favourites': 'Añadido a favoritos',
  'Credentials and settings for this partner. Fields marked * are required.': 'Credenciales y ajustes de este socio. Los campos marcados con * son obligatorios.',
  'Key created': 'Clave creada',
  'Removed from favourites': 'Eliminado de favoritos',
  'Affiliate network archived': 'Red de afiliados archivada',
  'Archive affiliate network': 'Archivar red de afiliados',
  'Archive landing page': 'Archivar landing',
  'Archive offer': 'Archivar oferta',
  'Archive stream': 'Archivar stream',
  'Archive traffic source': 'Archivar fuente de tráfico',
  'Archived at': 'Archivado el',
  'Archived items are hidden from your lists. Restore them or delete them permanently.': 'Los elementos archivados se ocultan de tus listas. Restáuralos o elimínalos definitivamente.',
  'Delete permanently': 'Eliminar definitivamente',
  'Deleted permanently': 'Eliminado definitivamente',
  'Error loading archive': 'Error al cargar los elementos archivados',
  'Error restoring': 'Error al restaurar',
  'Landing page archived': 'Landing archivada',
  'No archived items': 'No hay elementos archivados',
  'Offer archived': 'Oferta archivada',
  'Restored': 'Restaurado',
  'Stream archived': 'Stream archivado',
  'This will move "{name}" to the archive. You can restore it or delete it permanently from the Archive page.': 'Esto moverá "{name}" al archivo. Puedes restaurarlo o eliminarlo definitivamente desde la página Archivo.',
  'This will permanently delete "{name}". This action cannot be undone.': 'Esto eliminará permanentemente "{name}". Esta acción no se puede deshacer.',
  'Traffic source archived': 'Fuente de tráfico archivada',
  'View archived': 'Ver archivados',
  // Backfill: post-!99 UI-wiring components (SystemStatus / CampaignMaintenance / TlsFingerprints / S2SLogs, etc.)
  'Start date is required': 'La fecha de inicio es obligatoria',
  'Enter a valid cost': 'Introduce un costo válido',
  'Updated {n} clicks': '{n} clics actualizados',
  'Failed to update costs': 'No se pudieron actualizar los costos',
  'Statistics deleted': 'Estadísticas eliminadas',
  'Failed to delete statistics': 'No se pudieron eliminar las estadísticas',
  'Maintenance & costs': 'Mantenimiento y costos',
  'Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.': 'Reescribe retroactivamente el costo de los clics, restablece las estadísticas u obtén un enlace de tracking alternativo.',
  'Update costs': 'Actualizar costos',
  'Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.': '(Re)escribe retroactivamente el costo por clic para los clics en un rango de tiempo. El modo Total reparte el monto entre los clics coincidentes; por clic lo aplica a cada uno.',
  'Start date': 'Fecha de inicio',
  'End date': 'Fecha de fin',
  'Total (spread across clicks)': 'Total (repartir entre clics)',
  'Per click': 'Por clic',
  'Only unique clicks': 'Solo clics únicos',
  'Skip bot clicks': 'Omitir clics de bots',
  'Clean statistics': 'Limpiar estadísticas',
  'Alternative link prefixes': 'Prefijos de enlace alternativos',
  'Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.': 'Cualquiera de estos prefijos de ruta enruta el mismo tracking id — rótalos entre las fuentes para esquivar las listas de bloqueo.',
  'Delete statistics': 'Eliminar estadísticas',
  'This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.': 'Esto elimina permanentemente todos los clics y conversiones de esta campaña. La configuración de la campaña se conserva. Esto no se puede deshacer.',
  'Error loading S2S log': 'Error al cargar el log S2S',
  'S2S postback log': 'Log de postbacks S2S',
  'Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.': 'Cada postback de conversión saliente disparado en tus campañas — filtra por campaña, estado o resultado.',
  'Any result': 'Cualquier resultado',
  'Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.': 'Los postbacks de conversión salientes aparecerán aquí cuando tus campañas empiecen a reenviar conversiones.',
  'Result': 'Resultado',
  'HTTP': 'HTTP',
  'Error loading system status': 'Error al cargar el estado del sistema',
  'Paste the Tor exit list first': 'Primero pega la lista de nodos de salida de Tor',
  'Tor exit list updated': 'Lista de nodos de salida de Tor actualizada',
  'Failed to update Tor exit list': 'No se pudo actualizar la lista de nodos de salida de Tor',
  'Process uptime, database size, data-processing queue and host metrics.': 'Tiempo de actividad del proceso, tamaño de la base de datos, cola de procesamiento de datos y métricas del host.',
  'Process': 'Proceso',
  'Uptime': 'Tiempo de actividad',
  'Started': 'Iniciado',
  'Python': 'Python',
  'Database': 'Base de datos',
  'Total documents': 'Total de documentos',
  'Data processing': 'Procesamiento de datos',
  'Analytics backend': 'Backend de analítica',
  'Ingest mode': 'Modo de ingesta',
  'Queue depth': 'Profundidad de la cola',
  'Click uniqueness': 'Unicidad de clics',
  'Redis ping': 'Ping de Redis',
  'Host': 'Host',
  'Load average': 'Carga promedio',
  'Disk used': 'Disco usado',
  'Disk free': 'Disco libre',
  'Cron': 'Cron',
  'Last cost sync': 'Última sincronización de costos',
  'FX rates': 'Tipos de cambio',
  'No FX rates cached.': 'No hay tipos de cambio en caché.',
  'Tor exit list': 'Lista de nodos de salida de Tor',
  'Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.': 'Pega un volcado de nodos de salida de Tor separados por saltos de línea (p. ej. de torbulkexitlist) para actualizar la lista de bloqueo en memoria.',
  'Replace list': 'Reemplazar lista',
  'Error loading fingerprints': 'Error al cargar las huellas',
  'Fingerprint updated': 'Huella actualizada',
  'Failed to update fingerprint': 'No se pudo actualizar la huella',
  'JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.': 'Overrides de huellas JA3 / JA4 — marca una huella como buena o mala para orientar la detección de bots.',
  'All classifications': 'Todas las clasificaciones',
  'All kinds': 'Todos los tipos',
  'No fingerprint overrides yet': 'Aún no hay overrides de huellas',
  'As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.': 'A medida que llega tráfico, las huellas JA3/JA4 aparecen aquí para que puedas marcar clientes conocidos como buenos o malos.',
  'Fingerprint': 'Huella',
  'Kind': 'Tipo',
  'Label': 'Etiqueta',
  'Hits': 'Hits',
  'Last seen': 'Visto por última vez',
  'Classification': 'Clasificación',
  // Platform back-office (operator console)
  'Platform admin': 'Admin de plataforma',
  'Operator': 'Operador',
  'Cross-tenant back-office: accounts, access and platform health.':
    'Back-office de la plataforma: cuentas, accesos y salud del sistema.',
  'Accounts': 'Cuentas',
  'New sign-ups': 'Registros nuevos',
  'Last 30 days': 'Últimos 30 días',
  'Clicks (24h)': 'Clics (24h)',
  'Clicks (30d)': 'Clics (30d)',
  'Conversions (30d)': 'Conversiones (30d)',
  'Platform state': 'Estado de la plataforma',
  'Self-signup': 'Auto-registro',
  'Open': 'Abierto',
  'Closed': 'Cerrado',
  'Controlled by the DISABLE_REGISTRATION variable on Railway.':
    'Controlado por la variable DISABLE_REGISTRATION en Railway.',
  'Root admins': 'Admins root',
  'From PLATFORM_ADMIN_EMAILS — manage the list on Railway.':
    'De PLATFORM_ADMIN_EMAILS — la lista se gestiona en Railway.',
  'Granted admins': 'Admins otorgados',
  'Every registered account. Block access or grant platform admin.':
    'Todas las cuentas registradas. Bloquea el acceso u otorga admin de plataforma.',
  'Search by email or name…': 'Buscar por email o nombre…',
  'Plan': 'Plan',
  'Last click': 'Último clic',
  'No accounts found': 'No se encontraron cuentas',
  'Root admin': 'Admin root',
  'Client': 'Cliente',
  'Managed on Railway': 'Se gestiona en Railway',
  'Grant platform admin': 'Otorgar admin de plataforma',
  'Grant platform admin?': '¿Otorgar admin de plataforma?',
  'Make admin': 'Hacer admin',
  'Revoke platform admin': 'Revocar admin de plataforma',
  'Revoke platform admin?': '¿Revocar admin de plataforma?',
  'Revoke admin': 'Revocar admin',
  'Block account': 'Bloquear cuenta',
  'Block this account?': '¿Bloquear esta cuenta?',
  'The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.':
    'El usuario pierde el acceso de inmediato — todas las sesiones se rechazan hasta que lo desbloquees. Sus campañas y enlaces de tracking siguen recibiendo tráfico.',
  'Reason (optional)': 'Motivo (opcional)',
  'Visible to admins only': 'Visible solo para admins',
  'Unblock': 'Desbloquear',
  'Unblock account': 'Desbloquear cuenta',
  'Unblock this account?': '¿Desbloquear esta cuenta?',
  'The user will be able to sign in again immediately.':
    'El usuario podrá iniciar sesión de nuevo de inmediato.',
  'This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.':
    'Este usuario obtiene acceso de operador: el back-office de la plataforma, todas las cuentas y la configuración. La concesión queda en el registro de auditoría.',
  'The user keeps their account but loses operator access.':
    'El usuario conserva su cuenta pero pierde el acceso de operador.',
  'Account blocked': 'Cuenta bloqueada',
  'Account unblocked': 'Cuenta desbloqueada',
  'Platform admin granted': 'Admin de plataforma otorgado',
  'Platform admin revoked': 'Admin de plataforma revocado',
  'Failed to load platform overview': 'No se pudo cargar el resumen de la plataforma',
  'Failed to load users': 'No se pudieron cargar los usuarios',
  '{count} accounts': '{count} cuentas',
  'Page {page} of {total}': 'Página {page} de {total}',
  'Change plan': 'Cambiar plan',
  'Plan updated': 'Plan actualizado',
  'Sets the edition directly (status "active", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.':
    'Establece la edición directamente (estado «active», sin prueba) — para cuentas manuales o de cortesía. Las cuentas con una suscripción activa de Stripe cambian de plan a través de Stripe.',
  'Account deleted': 'Cuenta eliminada',
  'Delete account': 'Eliminar cuenta',
  'Delete this account permanently?': '¿Eliminar esta cuenta de forma permanente?',
  'This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.':
    'Se borran la cuenta y TODOS sus datos: campañas, clics, conversiones, ofertas, landings, dominios, informes. No se puede deshacer.',
  // Signup email verification
  'We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.':
    'Enviamos un enlace de confirmación a {email}. Ábrelo para activar tu cuenta — el enlace es válido por 24 horas.',
  "Check your spam folder if it doesn't arrive within a minute.":
    'Si no llega en un minuto, revisa la carpeta de spam.',
  'Resend the email': 'Reenviar el correo',
  'Sent — check your inbox': 'Enviado — revisa tu bandeja',
  'Could not resend the email — try again.': 'No se pudo reenviar el correo — inténtalo de nuevo.',
  'Back to sign in': 'Volver a iniciar sesión',
  'Confirming your email…': 'Confirmando tu correo…',
  'This takes a second.': 'Esto toma un segundo.',
  'Email confirmed — welcome aboard!': '¡Correo confirmado — bienvenido a bordo!',
  'Taking you to your dashboard…': 'Llevándote a tu panel…',
  'Verification failed — the link may have expired.':
    'La verificación falló — puede que el enlace haya caducado.',
  'The verification link is incomplete — open the link from the email again.':
    'El enlace de verificación está incompleto — abre de nuevo el enlace del correo.',
  // Settings, Ops, platform admin, white pages, campaign params (completed 2026-10-11)
  "Inbound postback URL template": "Plantilla de URL de postback entrante",
  "Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.": "URL entrante que la red de afiliados llama cuando informa un lead, una venta, un rechazo u otro estado. Cópiela en el panel del partner; XPNSR no llama a esta URL como postback saliente de la campaña.",
  "Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.": "Configuración entrante del partner: parámetros de click ID de la oferta, mapeo de estados y la URL de postback para pegar en el panel del partner. No envía leads a un CRM ni es un reenvío S2S de la campaña.",
  "Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.": "Elija una plantilla de postback entrante o configure el acuerdo con el partner desde cero. Para enviar leads del formulario a un CRM, cree una Integración y vincúlela a la oferta.",
  "Use 8–128 characters; long passphrases are recommended": "Use de 8 a 128 caracteres; se recomiendan frases de contraseña largas",
  "Users": "Usuarios",
  "This source postback is already added": "Este postback de la fuente ya está añadido",
  "Source postback added — check its placeholders (REPLACE, XXXX…) and press Save": "Postback de la fuente añadido: revise sus marcadores (REPLACE, XXXX…) y pulse Guardar",
  "Google Ads deposit postback added + click-time gtag kept off — press Save to apply": "Postback de depósito de Google Ads añadido y gtag al clic desactivado: pulse Guardar para aplicar",
  "Parameters have unsaved changes — clicks keep using the saved set until you save.": "Los parámetros tienen cambios sin guardar: los clics siguen usando el conjunto guardado hasta que guarde.",
  "The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.": "Nombre del parámetro en la URL de seguimiento: solo letras, dígitos y _ (sin espacios). Los espacios se convierten en _ para que el enlace nunca muestre %20.",
  "Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.": "Valor que se escribe en el enlace de seguimiento para esta clave: una macro de la red publicitaria como {campaignid} o un valor fijo como MCLV. Un valor fijo también se guarda en los clics que llegan sin la clave; una macro entre llaves no. Déjelo vacío para claves que el anuncio define por cuenta, como tm y tml.",
  "Sub slot": "Slot sub",
  "Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.": "Opcional: el valor también se guarda como sub1…sub30 o en un campo con nombre (external_id, creative_id…). Asigne lo mismo al mismo slot en todas las campañas (p. ej., team -> sub8) y una sola columna del informe y la macro {sub_id_8} cubrirán a todos los compradores; external_id alimenta {external_id} en el postback de la fuente.",
  "Macro: filled by the ad network, not stored on clicks without this key": "Macro: la rellena la red publicitaria; no se guarda en clics sin esta clave",
  "Google Ads conversion keys": "Claves de conversión de Google Ads",
  "= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.": "= etiqueta de envío de formulario de lead: configure esta conversión como Principal. Se envía desde el navegador del visitante tras un lead correcto.",
  "= Purchase / deposit label — set this conversion as Secondary. Sent by the \"Deposit → Purchase\" S2S rule; do not add an S2S rule for lead.": "= etiqueta de compra / depósito: configure esta conversión como Secundaria. La envía la regla S2S \"Depósito → Compra\"; no añada una regla S2S para el lead.",
  "Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.": "Ponga ambas en el sufijo de URL final de cada cuenta de Google Ads (tml=AW-…/lead-label&tm=AW-…/purchase-label) y deje vacío aquí su valor por defecto.",
  "Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.": "Las claves distinguen mayúsculas y minúsculas. Cualquier clave (a, b, s, c…) se guarda en el clic, funciona como macro {key} y puede elegirse como agrupación en Informes y en informes Sub-ID, junto a sub1…sub30. Asígnela a un slot sub para alinearla entre campañas.",
  "Use lowercase keys — the tracker does not read:": "Use claves en minúsculas; el tracker no lee:",
  "The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.": "El enlace de seguimiento listo para copiar de esta campaña. Cambie el dominio por cualquier dominio verificado del espacio de trabajo para usar varios dominios en una campaña; la red publicitaria rellena los marcadores al hacer clic.",
  "Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.": "Las claves sin valor por defecto (tm, tml, a…) no se incluyen en el enlace: páselas en el anuncio, p. ej., en el sufijo de URL final de Google Ads.",
  "Fire Google Ads gtag on redirect (click-time conversion)": "Enviar gtag de Google Ads en la redirección (conversión al clic)",
  "Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.": "Conversión heredada al clic: se envía en /r/ antes de cualquier registro o depósito. Manténgala desactivada para optimizar por leads o depósitos. Los leads reales se envían automáticamente desde las landings alojadas tras una respuesta correcta de /api/lead.",
  "Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.": "Manténgalo DESACTIVADO para optimizar por conversiones reales. Los leads se envían online desde la landing alojada solo después de que /api/lead tenga éxito; los depósitos pueden reenviarse abajo por S2S con el postback de venta del bróker. Activarlo hace que Google optimice por clics y puede duplicar conversiones.",
  "Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.": "Secreto que autentica los postbacks entrantes de esta campaña. Péguelo como &token=… en las URL de postback que entrega a la red. Manténgalo en privado: cualquiera que lo tenga puede registrar conversiones.",
  "Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.": "Traduce los estados que envía una red a nuestras categorías. Prioridad: parámetro en la URL > mapa de esta campaña > plantilla de la red de afiliados > tipos personalizados > valores por defecto.",
  "Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.": "Llamadas salientes que avisan a otro sistema (su fuente de tráfico, otro tracker, Telegram) cuando llega una conversión. Para CAPI de plataformas publicitarias (Facebook/Google/TikTok) use Reenvíos de conversiones: datos personales con hash y reintentos.",
  "Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.": "Solo saliente: estas llamadas HTTP avisan a otro sistema después de que XPNSR registra una conversión. Las plantillas de redes de afiliados y las URL entrantes van en la página Redes de afiliados y se pegan en el panel del partner; no son reglas de reenvío.",
  "Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.": "Venta también se activa con depósitos (ftd, dep, deposit) y Lead con registros (reg, signup), los llame como los llame el bróker.",
  "Source postback": "Postback de la fuente",
  "Google Ads conversions": "Conversiones de Google Ads",
  "Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.": "Añade solo el postback S2S de depósito/Compra. Se activa con el postback de venta del bróker y asocia el clic de Google por {gclid}. El ID de cuenta y la etiqueta de depósito vienen de la etiqueta {tm} por clic (AW-<account>/<deposit-label>) en el sufijo de URL final del anuncio.",
  "Deposit → Purchase (with payout value) — fires on sale": "Depósito → Compra (con valor del pago): se activa con la venta",
  "Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.": "El S2S de lead no se añade a propósito: la landing alojada ya envía la conversión Lead online con gtag en el navegador después de que el CRM acepta /api/lead. Una regla S2S de lead podría contar el mismo lead dos veces.",
  "Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use \"Import from source\" to add them to a campaign.": "Los parámetros de seguimiento (campaignid, adgroupid, keyword, tm, tml, sub1–3) se declaran una vez en la fuente de tráfico Google Ads; use \"Importar desde la fuente\" para añadirlos a una campaña.",
  "For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep \"Fire Google Ads gtag on redirect\" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.": "Para leads online, pase tml=AW-<account>/<lead-label> en el sufijo de URL final de cada cuenta publicitaria. Mantenga DESACTIVADO \"Enviar gtag de Google Ads en la redirección\": el tracker inserta un gtag de lead aparte en las landings alojadas y lo envía solo tras un envío de lead correcto. Configure Lead como Principal si puja por leads; mantenga Compra como secundaria hasta verificar los depósitos y luego ajuste los objetivos a su estrategia de puja.",
  "White pages (hosted, same-origin)": "White pages (alojadas, mismo origen)",
  "selected — rotated per request": "seleccionadas: rotan en cada solicitud",
  "No white pages yet. Upload some under White pages, then pick them here.": "Aún no hay white pages. Súbalas en White pages y elíjalas aquí.",
  "Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.": "Opcional: la opción más robusta para Google/Facebook. Se sirve desde el dominio de su campaña (/wp/…), así la URL final se queda en el dominio. Seleccione varias para rotar una al azar en cada solicitud y no reutilizar la misma white en cientos de anuncios. Gestión en White pages.",
  "Safe page URL (external)": "URL de la página segura (externa)",
  "External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.": "Página segura externa: el tracker la sirve como proxy desde el mismo origen (sin etiquetas de identidad). Se usa si no hay white page seleccionada. Debe ser una URL http(s) absoluta. Este método ya supera por sí solo la revisión de Google; una white page alojada es solo una alternativa aún más robusta servida por completo en su dominio.",
  "UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.": "Los bots detectados por User-Agent y los que se hacen pasar por un rastreador de buscador (verificación DNS fallida) reciben la página segura.",
  "DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.": "Los rastreadores de buscadores verificados por DNS (Googlebot/Bingbot/…) reciben la página segura. Desactívelo para que indexen la oferta real.",
  "Visitors from datacenter or Tor-exit IPs get the safe page.": "Los visitantes con IP de centro de datos o de salida Tor reciben la página segura.",
  "Visitors behind a proxy/VPN get the safe page.": "Los visitantes detrás de un proxy/VPN reciben la página segura.",
  "Select a white page or enter a valid http(s) Safe page URL for cloaking": "Elija una white page o introduzca una URL http(s) válida de página segura para el cloaking",
  "Error": "Error",
  "Failed to load documentation.": "No se pudo cargar la documentación.",
  "Topic ID (optional)": "ID del tema (opcional)",
  "Chat ID is required": "Se requiere el Chat ID",
  "Test message delivered": "Mensaje de prueba entregado",
  "Send failed": "Error al enviar",
  "Backup started — the result will arrive in the monitoring topic.": "Copia de seguridad iniciada: el resultado llegará al tema de monitoreo.",
  "Production readiness": "Preparación para producción",
  "Ready": "Listo",
  "Attention required": "Requiere atención",
  "Secret-free checks for runtime configuration and isolation controls.": "Comprobaciones de configuración y aislamiento sin exponer secretos.",
  "Environment": "Entorno",
  "production": "producción",
  "development": "desarrollo",
  "Rate limiter": "Limitador de solicitudes",
  "Access token TTL": "Vigencia del token de acceso",
  "Backend root": "Backend como root",
  "Blocking checks": "Comprobaciones bloqueantes",
  "Telegram alerts": "Alertas de Telegram",
  "Configured": "Configurado",
  "Not configured": "Sin configurar",
  "Deploy + server-error notifications for the operator.": "Avisos de despliegue y errores del servidor para el operador.",
  "Topic": "Tema",
  "Leave the token empty to keep the saved one.": "Deje el token vacío para conservar el guardado.",
  "Save & send test": "Guardar y enviar prueba",
  "Nightly DB backups": "Copias nocturnas de la base de datos",
  "A full copy of the database every night, kept on the persistent volume.": "Una copia completa de la base de datos cada noche, guardada en el volumen persistente.",
  "Daily at": "Cada día a las",
  "Copies kept": "Copias conservadas",
  "Stored": "Almacenado",
  "Latest": "Última",
  "No backups yet": "Aún no hay copias",
  "Run backup now": "Hacer copia ahora",
  "Failed to load integrity status": "No se pudo cargar el estado de integridad",
  "Traffic suspended": "Tráfico suspendido",
  "Traffic resumed": "Tráfico reanudado",
  "Data integrity": "Integridad de datos",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Los índices únicos obligatorios protegen la atribución de clics, las conversiones y la idempotencia de la facturación.",
  "All mandatory indexes are present and unique.": "Todos los índices obligatorios existen y son únicos.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "No ignore esta advertencia. Revise los registros de inicio del backend antes de cambiar índices.",
  "Missing": "Falta",
  "Not unique": "No único",
  "Resume campaign traffic": "Reanudar el tráfico de campañas",
  "Resume traffic": "Reanudar tráfico",
  "Suspend campaign traffic": "Suspender el tráfico de campañas",
  "Suspend traffic": "Suspender tráfico",
  "Suspend all campaign traffic for this account?": "¿Suspender todo el tráfico de campañas de esta cuenta?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "Los enlaces de seguimiento públicos devolverán la respuesta de campaña inactiva. La configuración de las campañas no cambia y el tráfico puede reanudarse al instante.",
  "Resume campaign traffic for this account?": "¿Reanudar el tráfico de campañas de esta cuenta?",
  "Existing active campaigns and tracking links will start serving again.": "Las campañas activas y los enlaces de seguimiento volverán a funcionar.",
  "Password changed — other devices have been signed out": "Contraseña cambiada: se cerró la sesión en los demás dispositivos",
  "Sign out of every device, including this one? You will need to sign in again.": "¿Cerrar sesión en todos los dispositivos, incluido este? Tendrá que volver a iniciar sesión.",
  "All sessions signed out": "Se cerraron todas las sesiones",
  "Error signing out sessions": "Error al cerrar las sesiones",
  "Changing your password also signs out every other device.": "Cambiar la contraseña también cierra la sesión en todos los demás dispositivos.",
  "Active sessions": "Sesiones activas",
  "Lost a laptop, or think someone else has your password? End every session at once.": "¿Perdió un portátil o cree que alguien más tiene su contraseña? Cierre todas las sesiones a la vez.",
  "This signs out every device, including this one. Signing back in takes one password.": "Se cerrará la sesión en todos los dispositivos, incluido este. Para volver a entrar basta la contraseña.",
  "Sign out everywhere": "Cerrar sesión en todas partes",
  "Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign": "Desglose clics y conversiones por sub1–sub30 o por cualquier parámetro declarado en una campaña",
  "Error loading white pages": "Error al cargar las white pages",
  "Please enter a name for the white page": "Introduzca un nombre para la white page",
  "White page uploaded successfully": "White page subida correctamente",
  "Error uploading white page": "Error al subir la white page",
  "White page deleted": "White page eliminada",
  "Error deleting white page": "Error al eliminar la white page",
  "White pages": "White pages",
  "Static pages for bots & ad review": "Páginas estáticas para bots y revisión de anuncios",
  "Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.": "Páginas estáticas conformes que se muestran a bots y revisores de anuncios, desde el mismo origen en el dominio de su campaña.",
  "Upload white page": "Subir white page",
  "Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.": "Suba un ZIP estático (index.html + recursos). No se permite PHP. Máx. 50 MB.",
  "My white page": "Mi white page",
  "What this white page is for": "Para qué sirve esta white page",
  "Static files only (.html/.css/.js/images). No .php.": "Solo archivos estáticos (.html/.css/.js/imágenes). Sin .php.",
  "These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.": "Estas páginas se alojan aquí y se sirven desde el mismo origen en /wp/<slug>/ en cualquiera de sus dominios verificados. Elija una en la configuración de Cloaking de una campaña: los bots y los revisores de Google/Facebook ven esta página y los usuarios reales, la oferta.",
  "Search white pages…": "Buscar white pages…",
  "No white pages": "No hay white pages",
  "Upload a static white page to use for campaign cloaking": "Suba una white page estática para usarla en el cloaking de campañas",
  "Same-origin path": "Ruta en el mismo origen",
  "Pages": "Páginas",
  "Copy path": "Copiar ruta",
  "Delete white page": "Eliminar white page",
  "This permanently deletes \"{name}\" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).": "Esto elimina de forma permanente \"{name}\" y sus archivos. Las campañas que aún la usen pasarán a su URL de página segura (o a la oferta si no hay ninguna).",
  "Multiple HTML pages detected. Select the main page bots will land on.": "Se detectaron varias páginas HTML. Elija la página principal a la que llegarán los bots.",
};

// Brazilian Portuguese (pt) — same coverage focus as Spanish.
const pt = {
  'Bot model': 'Modelo de bots',
  // C5/A2/C4 UI screens + doc TOC labels (member access, click traces, bot model)
  'Member access': 'Acesso de membros',
  'Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.': 'Defina o que cada membro da equipe pode ver e editar — por entidade, e quais métricas de relatórios pode ler. Proprietários e administradores nunca são restringidos.',
  'Member': 'Membro',
  'Choose a member…': 'Escolha um membro…',
  'Failed to load members': 'Não foi possível carregar os membros',
  'Retry': 'Tentar novamente',
  'No team members yet': 'Ainda não há membros na equipe',
  'Invite teammates from the Workspace page, then configure their access here.': 'Convide colegas na página Workspace e depois configure o acesso deles aqui.',
  'Pick a member to configure': 'Escolha um membro para configurar',
  'Their entity access and allowed report metrics will show up here.': 'O acesso a entidades e as métricas de relatórios permitidas aparecerão aqui.',
  'Failed to load member access': 'Não foi possível carregar o acesso do membro',
  'Owners and admins have full, unrestricted access': 'Proprietários e administradores têm acesso completo e irrestrito',
  'You can still save these rules, but they stay inert unless the role changes to manager or viewer.': 'Você ainda pode salvar estas regras, mas elas permanecem inativas até que o papel mude para manager ou viewer.',
  'Entity access': 'Acesso a entidades',
  'Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.': 'Completo é o padrão: sem restrição. Somente leitura bloqueia edições. Aos selecionados limita o membro aos IDs listados. Criados e selecionados adiciona tudo o que o membro criou por conta própria.',
  'Entity': 'Entidade',
  'Access mode': 'Modo de acesso',
  'Allowed IDs': 'IDs permitidos',
  'Full': 'Completo',
  'Read-only': 'Somente leitura',
  'To selected': 'Aos selecionados',
  'Created and selected': 'Criados e selecionados',
  'IDs, comma or space separated': 'IDs separados por vírgula ou espaço',
  'IDs of the specific items this member may access': 'IDs dos itens específicos que este membro pode acessar',
  'No IDs yet — the member will only see items they created themselves.': 'Ainda não há IDs — o membro verá apenas os itens que ele mesmo criou.',
  'No IDs yet — the member will not see any items of this type.': 'Ainda não há IDs — o membro não verá nenhum item deste tipo.',
  'All items': 'Todos os itens',
  'Allowed report metrics': 'Métricas de relatórios permitidas',
  'Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.': 'Ative ou desative as métricas que este membro pode ver em relatórios e painéis. Se nenhuma estiver selecionada, não há restrição.',
  'All metrics (no restriction)': 'Todas as métricas (sem restrição)',
  'metrics allowed': 'métricas permitidas',
  'Clear (allow all)': 'Limpar (permitir todas)',
  'Save access': 'Salvar acesso',
  'Member access saved': 'Acesso do membro salvo',
  'Failed to save member access': 'Não foi possível salvar o acesso do membro',
  'Click traces': 'Rastreamentos de cliques',
  'Diagnostics': 'Diagnóstico',
  'Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.': 'Cliques reais amostrados com a decisão de roteamento completa de cada um — quais streams foram avaliados e por que o vencedor correspondeu.',
  'Pick a campaign above to inspect where its real clicks were routed and why.': 'Escolha uma campanha acima para ver para onde os cliques reais foram roteados e por quê.',
  'Live-click tracing': 'Rastreamento de cliques ao vivo',
  'Enable live-click tracing': 'Ativar o rastreamento de cliques ao vivo',
  'Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.': 'Desativado por padrão. Quando ativado, uma parcela amostrada dos cliques reais registra seu rastreamento completo de roteamento. Seguro para a privacidade: nenhum endereço IP ou user agent é armazenado, e os rastreamentos expiram automaticamente.',
  'Sample rate (%)': 'Taxa de amostragem (%)',
  'Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.': 'Parcela de cliques a rastrear, de 0 a 100%. Exemplo: 10% rastreia aproximadamente um em cada dez cliques.',
  'Sample rate must be between 0 and 100': 'A taxa de amostragem deve estar entre 0 e 100',
  'Trace settings saved': 'Configurações de rastreamento salvas',
  'Error loading click traces': 'Erro ao carregar os rastreamentos de cliques',
  'Could not load traces': 'Não foi possível carregar os rastreamentos',
  'Something went wrong while loading click traces for this campaign.': 'Algo deu errado ao carregar os rastreamentos de cliques desta campanha.',
  'No traces yet': 'Ainda não há rastreamentos',
  'Enable tracing above; traces of sampled real clicks will appear here.': 'Ative o rastreamento acima; os rastreamentos de cliques reais amostrados aparecerão aqui.',
  'Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.': 'O rastreamento está ativado — os rastreamentos de cliques reais amostrados aparecerão aqui conforme o tráfego chegar. Se nada aparecer, verifique a taxa de amostragem.',
  'Flags': 'Indicadores',
  'Show routing trace': 'Mostrar o rastreamento de roteamento',
  'Hide routing trace': 'Ocultar o rastreamento de roteamento',
  'Per-stream verdicts': 'Veredictos por stream',
  'No per-stream verdicts were recorded for this click.': 'Nenhum veredicto por stream foi registrado para este clique.',
  'Not matched': 'Sem correspondência',
  'Filters evaluated': 'Filtros avaliados',
  'Relation': 'Relação',
  'Page': 'Página',
  'entries': 'registros',
  'just now': 'agora mesmo',
  '{n}m ago': 'há {n} min',
  '{n}h ago': 'há {n} h',
  'ML bot model': 'Modelo ML de bots',
  'Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.': 'Classificador de bots com supervisão fraca: treine-o com cliques recentes, inspecione métricas e pontue payloads ad hoc. Somente em modo sombra — nunca afeta o roteamento ao vivo.',
  'Admin access required': 'Requer acesso de administrador',
  'The ML bot-model panel is only available to workspace admins.': 'O painel do modelo ML de bots está disponível apenas para administradores do workspace.',
  'Error loading bot-model status': 'Erro ao carregar o status do modelo de bots',
  'Model status': 'Status do modelo',
  'Trained': 'Treinado',
  'Not trained': 'Não treinado',
  'Inference': 'Inferência',
  'Degenerate': 'Degenerado',
  'Trained on a single class or too few samples — metrics are not meaningful.': 'Treinado com uma única classe ou poucas amostras — as métricas não são significativas.',
  'Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.': 'A inferência vem desativada por padrão e é apenas em modo sombra — mesmo ativada, as pontuações são apenas gravadas nos cliques para análise e nunca afetam o roteamento.',
  'Accuracy': 'Acurácia',
  'Positive rate': 'Taxa de positivos',
  'Log loss': 'Log loss',
  'AUC': 'AUC',
  'Training samples': 'Amostras de treinamento',
  'Trained at': 'Treinado em',
  'No bot model trained yet. Train one on recent clicks below.': 'Ainda não há modelo de bots treinado. Treine um com os cliques recentes abaixo.',
  'Train model': 'Treinar modelo',
  'Training…': 'Treinando…',
  'Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.': 'O treinamento usa até 5.000 cliques recentes, rotula-os fracamente com as heurísticas de bots existentes (user agent, unicidade, pontuação de comportamento) e ajusta um pequeno modelo de regressão logística. Retreinar substitui o modelo salvo.',
  'Model trained on {n} clicks — accuracy {acc}': 'Modelo treinado com {n} cliques — acurácia {acc}',
  'Model trained on {n} clicks': 'Modelo treinado com {n} cliques',
  'No click data to train on yet.': 'Ainda não há dados de cliques para treinar.',
  'Training finished': 'Treinamento concluído',
  'Training failed': 'Falha ao treinar o modelo',
  'Score a sample': 'Pontuar uma amostra',
  'Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.': 'Ferramenta de desenvolvedor: cole um payload JSON no formato de clique e rode-o pelo modelo treinado. Nada é salvo e o tráfego ao vivo não é afetado.',
  'Click payload (JSON)': 'Payload do clique (JSON)',
  'Score': 'Pontuar',
  'Scoring…': 'Pontuando…',
  'Reset example': 'Restaurar exemplo',
  'Invalid JSON — check the payload and try again.': 'JSON inválido — verifique o payload e tente novamente.',
  'Payload must be a JSON object.': 'O payload deve ser um objeto JSON.',
  'No trained model — train one first.': 'Não há modelo treinado — treine um primeiro.',
  'Scoring failed': 'Falha ao pontuar',
  'Likely bot': 'Provável bot',
  'Likely human': 'Provável humano',
  'Threshold 0.5 — scores above are flagged as bots.': 'Limiar 0.5 — pontuações acima são marcadas como bots.',
  'Heuristic weak label': 'Rótulo fraco heurístico',
  'Human': 'Humano',
  'Feature': 'Atributo',
  '{n} min ago': 'há {n} min',
  '{n} h ago': 'há {n} h',
  '{n} d ago': 'há {n} d',
  'Archive & restore': 'Arquivar e restaurar',
  'Access control': 'Controle de acesso',

  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Rótulo de texto livre da rede, apenas para notas e filtros — não afeta nada. Para um vínculo real use o campo Rede de afiliados ou o bloco Affiliate routing abaixo.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Rede de parceiros reutilizável da seção Affiliate networks: modelo de postback, parâmetros de oferta e relatórios por rede. Opcional.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "Para onde vai o clique numa oferta de redirecionamento simples. Macros funcionam: {click_id}, {country_code}, {gclid} e mais. Para ofertas com formulário (lead para CRM) a URL pode ser qualquer uma.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Máximo de conversões por oferta por dia. Ao atingir o limite, o tráfego vai para a oferta reserva (Fallback). Vazio = sem limite.",
  "Time zone in which the daily cap is counted and the counter resets.": "Fuso horário em que o limite diário é contado e o contador é zerado.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Oferta reserva: o tráfego vai para cá quando a oferta principal atinge o limite diário.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "O parceiro/CRM para onde o lead é enviado. Configure uma vez na seção Integrations (TrackBox ou Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "O Box/Goal ID da oferta no parceiro — qual produto/box recebe o lead. O parceiro fornece o valor (ex. 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Proporção de leads para este parceiro quando há vários (split/rotação). Ex. 70 e 30 = 70% e 30%.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Desligado = o parceiro é ignorado temporariamente (ex. até acertar o lançamento); os ajustes são mantidos.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Endpoint de formulário específico para SOMENTE esta oferta. Normalmente NÃO é necessário — use o /api/lead compartilhado (ver docs). Só para vincular um formulário a uma oferta específica.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Notificação no Telegram a CADA envio do formulário (aceito/rejeitado/teste). Separado do postback de Telegram na campanha (esse dispara numa conversão confirmada). Bot token do @BotFather; o Chat ID do grupo começa com -100…",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "URL padrão quando nenhum fluxo corresponde. O roteamento normalmente é definido pelos Streams — este campo é uma rede de segurança.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "A plataforma de anúncios (Google Ads, Facebook…). Define o conjunto de macros/subs anexados ao link de tracking para passar dados do clique.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Como o custo é contado: CPC — por clique, CPM — por 1000 impressões, CPA — por conversão. Afeta Custo / ROI / CPC / CPA nos relatórios.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "O nome do parâmetro GET que o tracker usa para anexar o click_id à URL da oferta (ex. click_id → ?click_id=…). Necessário para o parceiro devolver esse click_id no postback. Os snippets de formulário leem click_id e clickid.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "Não definir o cookie xpnsr_vid (para redes que proíbem cookies). A unicidade passa a ser por IP+User Agent, e o click_id é passado via URL — o campo Click ID forward parameter acima.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "Fazer hash do IP antes de salvar (para GDPR). O GEO é resolvido ANTES do hash, então o targeting por país/cidade não é afetado.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Como redirecionar: 302 — redirecionamento rápido normal; Meta refresh / JS — quando a rede não segue 302 ou precisa de gtag; Cloaked (iframe) — esconder a URL da oferta na barra de endereço.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — fluxo comum com filtros; Catch — captura o tráfego que não coincidiu com nenhum Normal; Default — fluxo de último recurso quando nada coincide.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Prioridade de verificação. Quanto menor o número, mais cedo o fluxo é verificado. O tráfego vai para o primeiro que corresponde.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "Quando vários fluxos têm o mesmo tipo — a divisão de tráfego entre eles (split). Ex. 70 e 30 = 70% e 30%.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Máximo de cliques para este fluxo. Ao atingir, o fluxo para de receber tráfego. Vazio = sem limite.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — enviar para o landing/oferta do fluxo; Action — resposta especial (ex. 404 / resposta vazia para antifraude); Split test — divisão entre variantes.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Filtrar por unicidade da visita: apenas únicas / apenas repetidas / não filtrar.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Como tratar os bots (detectados por User-Agent): não filtrar / apenas bots / excluir bots. Útil para um fluxo antifraude.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Filtro de proxy/VPN (datacenter/Tor): não filtrar / apenas proxy / excluir proxy.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Permitir apenas IPv4 ou apenas IPv6, ou não filtrar.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Dias da semana e horas em que o fluxo está ativo. O horário é no fuso do dono da campanha.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Um preset de plataforma pronto (Google Ads, Facebook…) — preenche o nome, os macros/subs padrão e o postback S2S desta fonte.",
  // Traffic-source template catalog picker
  'Search templates…': 'Buscar modelos…',
  'All categories': 'Todas as categorias',
  'Templates in catalog': 'Modelos no catálogo',
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "Opcional. Um postback de saída PARA a rede de anúncios na conversão — para a plataforma otimizar campanhas do lado dela (ex. Facebook CAPI clássico).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Parâmetros que a plataforma passa no clique (sub1…subN, gclid, tm, etc.). Viram macros, aparecem nos relatórios e são adicionados ao link de tracking.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — adaptador tipado para a API deles. Custom API — para qualquer outra CRM: você configura a requisição (URL, cabeçalhos, corpo, de onde ler o redirect).",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "A chave secreta Push/Registration do parceiro. Pegue no painel do parceiro (seção API / API Testing) ou com seu gerente de afiliados.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Seu Affiliate ID no parceiro. Fornecido pelo parceiro.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Campaign ID no parceiro. Normalmente 1, salvo indicação em contrário.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "Status crus da rede a tratar como LEAD (registro). Separados por vírgula. Ex. new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "Status crus a tratar como VENDA/depósito. Ex. ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Status de rejeição/ruim. Ex. bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Esses status são descartados silenciosamente — não são registrados como conversões. Ex. spam, junk, test.",
  '(empty UA)': '(UA vazio)',
  '14 days': '14 dias',
  '2FA reset failed': 'Falha ao redefinir 2FA',
  '2FA reset — member can re-enrol': '2FA redefinido — o membro pode se reinscrever',
  '30 days': '30 dias',
  '7 days': '7 dias',
  '90 days': '90 dias',
  'A/B Testing': 'Testes A/B',
  'A/B Tests': 'Testes A/B',
  'A/B test created': 'Teste A/B criado',
  'A/B test deleted': 'Teste A/B excluído',
  'A/B test paused': 'Teste A/B pausado',
  'A/B test results': 'Resultados do teste A/B',
  'A/B test started': 'Teste A/B iniciado',
  'API keys': 'Chaves de API',
  'ASN block': 'Bloqueio por ASN',
  'ASN name substrings': 'Subcadeias do nome ASN',
  'ASN numbers': 'Números ASN',
  'Accept only unique': 'Aceitar apenas únicos',
  'Access revoked': 'Acesso revogado',
  'Access token': 'Token de acesso',
  'Access tracker': 'Acessar tracker',
  'Account': 'Conta',
  'Account ID': 'ID da conta',
  'Action': 'Ação',
  'Action failed': 'Ação falhou',
  'Action type': 'Tipo de ação',
  'Actions': 'Ações',
  'Activated {n}': 'Ativadas: {n}',
  'Active': 'Ativa',
  'Active campaigns': 'Campanhas ativas',
  'Active connections, last sync time, and recent errors.': 'Conexões ativas, última sincronização e erros recentes.',
  'Active filters': 'Filtros ativos',
  'Activity heatmap': 'Mapa de calor de atividade',
  'Activity marked as resolved': 'Atividade marcada como resolvida',
  'Actor': 'Ator',
  'Actor ID': 'ID do ator',
  'Ad account connected via OAuth': 'Conta de anúncios conectada via OAuth',
  'Ad cost sync': 'Sincronização de custos de anúncios',
  'Ad-Account Connections': 'Conexões de contas de anúncio',
  'Add': 'Adicionar',
  'Add IP to blacklist': 'Adicionar IP à lista negra',
  'Add IP to whitelist': 'Adicionar IP à lista branca',
  'Add a landing page for use in campaigns and A/B tests': 'Adicione uma landing page para usar em campanhas e testes A/B',
  'Add a new ad campaign': 'Adicionar uma nova campanha',
  'Add a new landing to the library': 'Adicionar nova landing à biblioteca',
  'Add a new offer to monetize traffic': 'Adicionar nova oferta para monetizar tráfego',
  'Add an offer to use in campaigns': 'Adicionar uma oferta para usar em campanhas',
  'Add domain': 'Adicionar domínio',
  'Add integration': 'Adicionar integração',
  'Add landing': 'Adicionar landing',
  'Add landing page': 'Adicionar landing page',
  'Add landings to use in traffic rules': 'Adicionar landings para usar em regras de tráfego',
  'Add offer': 'Adicionar oferta',
  'Add offers to monetize traffic': 'Adicionar ofertas para monetizar tráfego',
  'Add parameter': 'Adicionar parâmetro',
  'Add postback': 'Adicionar postback',
  'Add tag': 'Adicionar tag',
  'Add variant': 'Adicionar variante',
  'Add webhook': 'Adicionar webhook',
  'Additional domains': 'Domínios adicionais',
  'Additional information': 'Informações adicionais',
  'Admin': 'Administrador',
  'Admin reset 2FA': 'Admin redefiniu 2FA',
  'Admin tools': 'Ferramentas de administrador',
  'After completing payment, your subscription will be activated automatically.': 'Após concluir o pagamento, sua assinatura será ativada automaticamente.',
  'Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.': 'Agressivo: bloqueia qualquer clique cujo JA3/JA4 esteja ausente ou não classificado. Marque primeiro os hashes de proxy corporativo via Substituições do espaço de trabalho.',
  'Alert': 'Alerta',
  'Alert sent': 'Alerta enviado',
  'Alerts': 'Alertas',
  'All': 'Todos',
  'All campaigns': 'Todas as campanhas',
  'All clear': 'Tudo certo',
  'All clicks': 'Todos os cliques',
  'All conversions': 'Todas as conversões',
  'All countries': 'Todos os países',
  'All devices': 'Todos os dispositivos',
  'All sources': 'Todas as fontes',
  'All status': 'Todos os status',
  'All systems normal': 'Todos os sistemas normais',
  'All time': 'Todo o tempo',
  'All types': 'Todos os tipos',
  'Allow custom domains for tracking links and pre-landings.': 'Permitir domínios personalizados para links de tracking e pre-landings.',
  'Allowed ASN numbers': 'Números ASN permitidos',
  'Allowed countries (ISO codes)': 'Países permitidos (códigos ISO)',
  'Already have an account?': 'Já tem uma conta?',
  'Always block these JA3 / JA4 hashes regardless of classification.': 'Sempre bloquear estes hashes JA3 / JA4 independentemente da classificação.',
  'An admin will be notified — keep your authenticator app handy in case the issue is on your end.': 'Um administrador será notificado — mantenha seu app autenticador à mão caso o problema seja do seu lado.',
  'Analytics': 'Análises',
  'Analytics view': 'Visualização de analytics',
  'Anti-fraud': 'Antifraude',
  'Anti-fraud filters and detection rules will appear here': 'Filtros antifraude e regras de detecção aparecerão aqui',
  'Anti-fraud rules engine': 'Motor de regras antifraude',
  'Anti-fraud system': 'Sistema antifraude',
  'Any role except Owner': 'Qualquer cargo exceto Proprietário',
  'Approve': 'Aprovar',
  'Are you sure?': 'Tem certeza?',
  'Are you sure? This action cannot be undone.': 'Tem certeza? Esta ação não pode ser desfeita.',
  'Audit export failed': 'Falha na exportação do log',
  'Audit log': 'Log de auditoria',
  'Audit log exported': 'Log de auditoria exportado',
  'Authentication': 'Autenticação',
  'Auto-pause': 'Pausa automática',
  'Auto-pause when fraud rate exceeds': 'Pausar automaticamente quando a taxa de fraude exceder',
  'Auto-redirect': 'Redirecionamento automático',
  'Auto-renews monthly. Cancel anytime.': 'Renova-se automaticamente todo mês. Cancele quando quiser.',
  'Automate': 'Automatizar',
  'Automated decisions': 'Decisões automáticas',
  'Automation': 'Automação',
  'Automation rule created': 'Regra de automação criada',
  'Automation rule deleted': 'Regra de automação excluída',
  'Automation rule failed': 'Regra de automação falhou',
  'Automation rule updated': 'Regra de automação atualizada',
  'Available': 'Disponível',
  'Average CR': 'CR média',
  'Average CR (%)': 'CR média (%)',
  'Average ROI': 'ROI médio',
  'Average revenue per conversion': 'Receita média por conversão',
  'Avg time on landing': 'Tempo médio na landing',
  'Back': 'Voltar',
  'Back to landings': 'Voltar para landings',
  'Back to login': 'Voltar ao login',
  'Back to offers': 'Voltar para ofertas',
  'Backup codes': 'Códigos de backup',
  'Bad classification list': 'Lista de classificação ruim',
  'Bad fingerprint': 'Huella maliciosa',
  'Banking-grade security': 'Segurança nível bancário',
  'Base': 'Base',
  'Basic information': 'Informações básicas',
  'Be careful with these powerful tools': 'Cuidado com estas ferramentas poderosas',
  'Best practices': 'Melhores práticas',
  'Beta': 'Beta',
  'Billing': 'Faturamento',
  'Block': 'Bloquear',
  'Block by classification': 'Bloquear por classificação',
  'Block classification': 'Classificação a bloquear',
  'Block fingerprints classified as bad': 'Bloquear fingerprints classificados como ruins',
  'Block known fraud': 'Bloquear fraude conhecida',
  'Block selected': 'Bloquear selecionados',
  'Block tor': 'Bloquear Tor',
  'Block unknown fingerprints': 'Bloquear fingerprints desconhecidos',
  'Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.': 'Bloquear quando a pontuação de risco combinada TLS+UA+IP exceder este limiar. Padrão 0.7.',
  'Block when the provider returns a score >= this threshold (default 85).': 'Bloquear quando o provedor retornar uma pontuação >= este limiar (padrão 85).',
  'Blocked': 'Bloqueado',
  'Blocked IPs': 'IPs bloqueados',
  'Blocked countries (ISO codes)': 'Países bloqueados (códigos ISO)',
  'Blocked samples': 'Amostras bloqueadas',
  'Blocked samples: {name}': 'Amostras bloqueadas: {name}',
  'Blocked: {n} times': 'Bloqueado: {n} vezes',
  'Book Demo': 'Agendar demo',
  'Bot detection': 'Detecção de bots',
  'Bots filtered': 'Bots filtrados',
  'Browser breakdown': 'Distribuição por navegador',
  'Browser notifications': 'Notificações do navegador',
  'Browsers': 'Navegadores',
  'Budget alert': 'Alerta de orçamento',
  'Budget percentage for alert': 'Porcentagem do orçamento para alerta',
  'Bulk delete failed': 'Falha na exclusão em massa',
  'Bulk update failed': 'Falha na atualização em massa',
  'By city': 'Por cidade',
  'By country': 'Por país',
  'CAPI DLQ': 'CAPI DLQ',
  'CAPI dead-letter queue': 'Fila de mensagens mortas CAPI',
  'CAPI delivery': 'Entrega CAPI',
  'CAPI replay succeeded': 'Replay CAPI bem-sucedido',
  'CPA (per action)': 'CPA (por ação)',
  'CPC (per click)': 'CPC (por clique)',
  'CPM (per impression)': 'CPM (por impressão)',
  'CR': 'CR',
  'CR% by day': 'CR% por dia',
  'Campaign': 'Campanha',
  'Campaign alerts': 'Alertas de campanha',
  'Campaign created successfully!': 'Campanha criada com sucesso!',
  'Campaign deleted successfully!': 'Campanha excluída com sucesso!',
  'Campaign info': 'Informações da campanha',
  'Campaign management': 'Gestão de campanhas',
  'Campaign name': 'Nome da campanha',
  'Campaign not found': 'Campanha não encontrada',
  'Campaign parameters': 'Parâmetros da campanha',
  'Campaign paused': 'Campanha pausada',
  'Campaign saved': 'Campanha salva',
  'Campaign start, pause, completion': 'Início, pausa e conclusão de campanha',
  'Campaign started': 'Campanha iniciada',
  'Campaign stats': 'Estatísticas da campanha',
  'Campaign streams': 'Streams da campanha',
  'Campaign updated successfully!': 'Campanha atualizada com sucesso!',
  'Campaign:': 'Campanha:',
  'Campaigns': 'Campanhas',
  'Campaigns not found': 'Campanhas não encontradas',
  'Cancel': 'Cancelar',
  'Cannot delete: source is in use by campaigns': 'Não é possível excluir: a fonte está em uso por campanhas',
  'Case-insensitive substring match against the ASN label.': 'Correspondência de subcadeia sem distinção de maiúsculas contra o rótulo ASN.',
  'Catch': 'Capturar',
  'Category': 'Categoria',
  'Change': 'Alterar',
  'Change automation rule settings': 'Alterar configurações da regra de automação',
  'Change offer parameters': 'Alterar parâmetros da oferta',
  'Change password': 'Alterar senha',
  'Changes in CR, ROI, cost': 'Alterações em CR, ROI, custo',
  'Check TLS': 'Verificar TLS',
  'Cities': 'Cidades',
  'Click': 'Clique',
  'Click frequency': 'Frequência de cliques',
  'Click limit': 'Limite de cliques',
  'Click map': 'Mapa de cliques',
  'Click-to-conversion pipeline with status breakdown': 'Pipeline clique-a-conversão com análise por status',
  'Clicks': 'Cliques',
  'Clicks and conversions': 'Cliques e conversões',
  'Clicks by country': 'Cliques por país',
  'Clicks this month': 'Cliques este mês',
  // Billing — tiered editions (launch)
  'Plans & billing': 'Planos e cobrança',
  'Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.': 'Cinco edições: cada plano inclui o tracker completo — escolha o tamanho da equipe, a escala de domínios e o nível de automação. Os cliques nunca são limitados.',
  'Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.': 'A cobrança ainda não está ativada neste servidor — todos os recursos estão abertos. Os planos abaixo mostram o que valerá quando os pagamentos entrarem no ar.',
  'Trial': 'Teste',
  'day(s) left': 'dia(s) restante(s)',
  'choose a plan to keep your traffic flowing without interruption.': 'escolha um plano para manter seu tráfego sem interrupção.',
  'Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.': 'Sua assinatura está inativa: o processamento de cliques e a criação de entidades estão pausados. Escolha um plano para retomar imediatamente.',
  'Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.': 'O último pagamento falhou — o tracker continua funcionando enquanto o Stripe tenta novamente. Atualize seu cartão em Gerenciar cobrança.',
  'cancels at period end': 'cancela no fim do período',
  'unlimited': 'ilimitado',
  'months': 'meses',
  'month': 'mês',
  'billed every': 'cobrado a cada',
  'user(s)': 'usuário(s)',
  'domain(s)': 'domínio(s)',
  'Choose plan': 'Escolher plano',
  'Full tracker core': 'Núcleo completo do tracker',
  'Unlimited clicks': 'Cliques ilimitados',
  'Landing page editor': 'Editor de landing pages',
  'Online support': 'Suporte on-line',
  'Click API + API keys': 'Click API + chaves de API',
  'Facebook CAPI': 'Facebook CAPI',
  'All 8 CAPI providers': 'Todos os 8 provedores CAPI',
  'Report by conversion date': 'Relatório por data de conversão',
  'White label branding': 'Marca white label',
  'Personal manager': 'Gerente pessoal',
  'Priority support': 'Suporte prioritário',
  'Onboarding call': 'Chamada de onboarding',
  'trialing': 'em teste',
  'active': 'ativa',
  'past_due': 'pagamento vencido',
  'expired': 'expirada',
  'canceled': 'cancelada',
  'exempt': 'isenta',
  'Clicks today': 'Cliques hoje',
  'Close': 'Fechar',
  'Coming in upcoming releases': 'Em breve em próximas versões',
  'Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).': 'Números AS separados por vírgulas (ex. 16509 = AWS, 24940 = Hetzner).',
  'Commonly used features': 'Recursos mais usados',
  'Completed': 'Concluído',
  'Conditions (leave empty for any value)': 'Condições (deixe vazio para qualquer valor)',
  'Confidence interval': 'Intervalo de confiança',
  'Confidence level (%)': 'Nível de confiança (%)',
  'Configuration (key-value)': 'Configuração (chave-valor)',
  'Configure a traffic source for UTM tags and conversion postbacks': 'Configure uma fonte de tráfego para tags UTM e postbacks de conversão',
  'Configure a webhook to receive notifications': 'Configure um webhook para receber notificações',
  'Configure automatic actions based on conditions': 'Configure ações automáticas baseadas em condições',
  'Configure automatic filters to block suspicious traffic': 'Configure filtros automáticos para bloquear tráfego suspeito',
  'Configure conditions and actions for traffic distribution': 'Configure condições e ações para distribuição de tráfego',
  'Configure connection to an external service': 'Configure a conexão com um serviço externo',
  'Configure domains for campaign tracking': 'Configure domínios para tracking de campanhas',
  'Configure how you receive notifications': 'Configure como recebe notificações',
  'Configure stream for traffic distribution by conditions': 'Configure stream para distribuição de tráfego por condições',
  'Confirm': 'Confirmar',
  'Confirm new password': 'Confirmar nova senha',
  'Confirm password': 'Confirmar senha',
  'Confirmed': 'Confirmado',
  'Connect': 'Conectar',
  'Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.': 'Conecte contas FB / Google Ads para que os dados de custo sejam importados automaticamente para as campanhas.',
  'Connect ad account': 'Conectar conta de anúncios',
  'Connect external services to automate workflows': 'Conecte serviços externos para automatizar workflows',
  'Connect with Facebook': 'Conectar com Facebook',
  'Connect with Google Ads': 'Conectar com Google Ads',
  'Connected': 'Conectado',
  'Connection created': 'Conexão criada',
  'Connection deleted': 'Conexão excluída',
  'Control': 'Controle',
  'Conversion': 'Conversão',
  'Conversion API': 'API de conversão',
  'Conversion API dispatches in the last window.': 'Envios da Conversion API na última janela.',
  'Conversion ID': 'ID de conversão',
  'Conversion forwarders': 'Encaminhadores de conversão',
  'Conversion funnel': 'Funil de conversão',
  'Conversion percentage': 'Porcentagem de conversão',
  'Conversion rate': 'Taxa de conversão',
  'Conversion tag': 'Tag de conversão',
  'Conversion tag is required': 'Tag de conversão é obrigatória',
  'Conversions': 'Conversões',
  'Conversions that exhausted the retry budget.': 'Conversões que esgotaram o orçamento de reenvio.',
  'Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.': 'Conversões que esgotaram o orçamento de tentativas. Replay tenta o encaminhador novamente; descartar remove a entrada permanentemente.',
  'Copied': 'Copiado',
  'Copy': 'Copiar',
  'Copy link': 'Copiar link',
  'Copy tracking link': 'Copiar link de tracking',
  'Copy value': 'Copiar valor',
  'Copy your key now — it will not be shown again': 'Copie sua chave agora — ela não será mostrada novamente',
  'Cost model': 'Modelo de custo',
  'Could not save currency': 'Não foi possível salvar a moeda',
  'Countries': 'Países',
  'Countries (ISO codes)': 'Países (códigos ISO)',
  'Countries (ISO codes, e.g. US, RU)': 'Países (códigos ISO, ex. US, RU)',
  'Countries (comma-separated ISO codes, e.g. US,RU,DE)': 'Países (códigos ISO separados por vírgulas, ex. US,RU,DE)',
  'Country': 'País',
  'Country block': 'Bloqueio por país',
  'Create': 'Criar',
  'Create A/B test': 'Criar teste A/B',
  'Create a new xpnsr.tech account': 'Criar uma nova conta xpnsr.tech',
  'Create a new xpnsr.tech account.': 'Criar uma nova conta xpnsr.tech.',
  'Create account': 'Criar conta',
  'Create automation rule': 'Criar regra de automação',
  'Create campaign': 'Criar campanha',
  'Create filter': 'Criar filtro',
  'Create filters for automatic fraud protection': 'Criar filtros para proteção antifraude automática',
  'Create fraud filter': 'Criar filtro antifraude',
  'Create landing pages for use in campaigns': 'Criar landings para usar em campanhas',
  'Create new account': 'Criar nova conta',
  'Create new campaign': 'Criar nova campanha',
  'Create offers to monetize your traffic': 'Criar ofertas para monetizar seu tráfego',
  'Create rule': 'Criar regra',
  'Create rules to automatically manage campaigns': 'Criar regras para gerenciar campanhas automaticamente',
  'Create rules to distribute traffic by conditions': 'Criar regras para distribuir tráfego por condições',
  'Create source': 'Criar fonte',
  'Create sources to integrate with ad networks': 'Criar fontes para integrar com redes de anúncios',
  'Create split tests to optimize conversions': 'Criar split tests para otimizar conversões',
  'Create stream': 'Criar stream',
  'Create streams to distribute traffic by conditions': 'Criar streams para distribuir tráfego por condições',
  'Create test': 'Criar teste',
  'Create traffic rule': 'Criar regra de tráfego',
  'Create traffic source': 'Criar fonte de tráfego',
  'Create webhooks to send events to external systems': 'Criar webhooks para enviar eventos a sistemas externos',
  'Create your first campaign': 'Crie sua primeira campanha',
  'Create your first campaign to start tracking traffic': 'Crie sua primeira campanha para começar a trackear tráfego',
  'Create, edit and track your ad campaigns in real time': 'Crie, edite e trackeie suas campanhas de anúncios em tempo real',
  'Created': 'Criado',
  'Creating account…': 'Criando conta…',
  'Crypto': 'Cripto',
  'Currency': 'Moeda',
  'Current': 'Atual',
  'Current password': 'Senha atual',
  'Current plan': 'Plano atual',
  'Custom API integration': 'Integração API personalizada',
  'Custom domains': 'Domínios personalizados',
  'Customize the look and behavior of the app': 'Personalize a aparência e o comportamento do app',
  'DLQ entry discarded': 'Entrada DLQ descartada',
  'Daily limit': 'Limite diário',
  'Dashboard': 'Painel',
  'Dashboard refresh rate (sec)': 'Taxa de atualização do dashboard (seg)',
  'Data visualization for fast decisions.': 'Visualização de dados para decisões rápidas.',
  'Datacenter / hosting block': 'Bloqueio por datacenter / hospedagem',
  'Date format': 'Formato de data',
  'Dating': 'Dating',
  'Day-of-week x hour-of-day breakdown': 'Análise por dia da semana e hora',
  'Dead-letter queue': 'Fila dead-letter',
  'Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.': 'Declare os parâmetros de URL que você passa através de redes de anúncios. Cada linha vira uma macro como {key} disponível em postbacks e payloads CAPI.',
  'Default': 'Padrão',
  'Default domain updated': 'Domínio padrão atualizado',
  'Delete': 'Excluir',
  'Delete failed': 'Falha ao excluir',
  'Delete forwarder?': 'Excluir encaminhador?',
  'Delete integration?': 'Excluir integração?',
  'Delete this A/B test?': 'Excluir este teste A/B?',
  'Delete this connection?': 'Excluir esta conexão?',
  'Delete this domain?': 'Excluir este domínio?',
  'Delete this key?': 'Excluir esta chave?',
  'Delete this landing page?': 'Excluir esta landing?',
  'Delete this offer?': 'Excluir esta oferta?',
  'Delete this stream?': 'Excluir este stream?',
  'Delete webhook?': 'Excluir webhook?',
  'Deleted': 'Excluído',
  'Deleted {n}': 'Excluídas: {n}',
  'Description': 'Descrição',
  'Description (optional)': 'Descrição (opcional)',
  'Details': 'Detalhes',
  'Device breakdown': 'Distribuição por dispositivo',
  'Device type': 'Tipo de dispositivo',
  'Devices': 'Dispositivos',
  'Devices table': 'Tabela de dispositivos',
  'Discard': 'Descartar',
  'Discard failed': 'Falha ao descartar',
  'Disconnected': 'Desconectado',
  'Dismiss': 'Dispensar',
  'Display currency': 'Moeda a exibir',
  'Display name': 'Nome de exibição',
  'Docs': 'Docs',
  'Domain added': 'Domínio adicionado',
  'Domain deleted': 'Domínio excluído',
  'Domain verified': 'Domínio verificado',
  'Domains': 'Domínios',
  'Download': 'Baixar',
  'Draft': 'Rascunho',
  'Drag & drop or click to select': 'Arraste e solte ou clique para selecionar',
  'Due now': 'Pendentes agora',
  'Edit': 'Editar',
  'Edit automation rule': 'Editar regra de automação',
  'Edit campaign': 'Editar campanha',
  'Edit existing campaigns': 'Editar campanhas existentes',
  'Edit filter': 'Editar filtro',
  'Edit forwarder': 'Editar encaminhador',
  'Edit integration': 'Editar integração',
  'Edit landing page': 'Editar landing',
  'Edit landing page settings': 'Editar configurações da landing',
  'Edit offer': 'Editar oferta',
  'Edit rule': 'Editar regra',
  'Edit stream': 'Editar stream',
  'Edit traffic source': 'Editar fonte de tráfego',
  'Edit webhook': 'Editar webhook',
  'Email': 'E-mail',
  'Email notifications': 'Notificações por email',
  'Enable HTTPS': 'Habilitar HTTPS',
  'Enter current password': 'Digite a senha atual',
  'Enter new password': 'Digite a nova senha',
  'Enter parameter name:': 'Digite o nome do parâmetro:',
  'Enter your credentials to continue.': 'Digite suas credenciais para continuar.',
  'Enter your email': 'Digite seu email',
  'Enter your full name': 'Digite seu nome completo',
  'Error changing password': 'Erro ao alterar senha',
  'Error creating': 'Erro ao criar',
  'Error creating campaign': 'Erro ao criar campanha',
  'Error creating landing page': 'Erro ao criar landing',
  'Error creating offer': 'Erro ao criar oferta',
  'Error creating traffic source': 'Erro ao criar fonte de tráfego',
  'Error creating webhook': 'Erro ao criar webhook',
  'Error deleting': 'Erro ao excluir',
  'Error deleting campaign': 'Erro ao excluir campanha',
  'Error deleting landing page': 'Erro ao excluir landing',
  'Error deleting offer': 'Erro ao excluir oferta',
  'Error deleting traffic source': 'Erro ao excluir fonte de tráfego',
  'Error loading campaigns': 'Erro ao carregar campanhas',
  'Error loading landing pages': 'Erro ao carregar landings',
  'Error loading offers': 'Erro ao carregar ofertas',
  'Error loading settings': 'Erro ao carregar configurações',
  'Error loading traffic sources': 'Erro ao carregar fontes de tráfego',
  'Error saving settings': 'Erro ao salvar configurações',
  'Error saving system settings': 'Erro ao salvar configurações do sistema',
  'Error testing webhook': 'Erro ao testar webhook',
  'Error updating': 'Erro ao atualizar',
  'Error updating campaign': 'Erro ao atualizar campanha',
  'Error updating landing page': 'Erro ao atualizar landing',
  'Error updating offer': 'Erro ao atualizar oferta',
  'Error updating profile': 'Erro ao atualizar perfil',
  'Error updating traffic source': 'Erro ao atualizar fonte de tráfego',
  'Error uploading landing page': 'Erro ao enviar landing',
  'Error uploading offer': 'Erro ao enviar oferta',
  'Errors': 'Erros',
  'Event': 'Evento',
  'Event name': 'Nome do evento',
  'Events': 'Eventos',
  'Execution history': 'Histórico de execuções',
  'Execution history is empty': 'Histórico de execuções está vazio',
  'Execution settings': 'Configurações de execução',
  'Executions': 'Execuções',
  'Explicit blocked fingerprints (comma-separated)': 'Fingerprints bloqueados explicitamente (separados por vírgula)',
  'Export': 'Exportar',
  'Export CSV': 'Exportar CSV',
  'External provider': 'Provedor externo',
  'External risk score': 'Pontuação de risco externa',
  'FX cache': 'Cache de câmbio',
  'FX cache is empty.': 'O cache de câmbio está vazio.',
  'FX rates unavailable — non-USD revenue is excluded from the totals.': 'Taxas de câmbio indisponíveis — receita não-USD é excluída dos totais.',
  'Failed': 'Falhou',
  'Failed to add IP': 'Falha ao adicionar IP',
  'Failed to add domain': 'Falha ao adicionar domínio',
  'Failed to change rule status': 'Falha ao alterar status da regra',
  'Failed to copy link': 'Falha ao copiar link',
  'Failed to create A/B test': 'Falha ao criar teste A/B',
  'Failed to create automation rule': 'Falha ao criar regra de automação',
  'Failed to create filter': 'Falha ao criar filtro',
  'Failed to create landing': 'Falha ao criar landing',
  'Failed to create offer': 'Falha ao criar oferta',
  'Failed to create rule': 'Falha ao criar regra',
  'Failed to create stream': 'Falha ao criar stream',
  'Failed to delete automation rule': 'Falha ao excluir regra de automação',
  'Failed to delete filter': 'Falha ao excluir filtro',
  'Failed to delete rule': 'Falha ao excluir regra',
  'Failed to delete stream': 'Falha ao excluir stream',
  'Failed to delete test': 'Falha ao excluir teste',
  'Failed to load A/B tests': 'Falha ao carregar testes A/B',
  'Failed to load CAPI DLQ': 'Falha ao carregar CAPI DLQ',
  'Failed to load admin health': 'Falha ao carregar saúde do admin',
  'Failed to load audit log': 'Falha ao carregar log de auditoria',
  'Failed to load automation rules': 'Falha ao carregar regras de automação',
  'Failed to load blocked samples': 'Falha ao carregar amostras bloqueadas',
  'Failed to load campaign': 'Falha ao carregar campanha',
  'Failed to load connections': 'Falha ao carregar conexões',
  'Failed to load data': 'Falha ao carregar dados',
  'Failed to load results': 'Falha ao carregar resultados',
  'Failed to load streams': 'Falha ao carregar streams',
  'Failed to load traffic rules': 'Falha ao carregar regras de tráfego',
  'Failed to pause test': 'Falha ao pausar teste',
  'Failed to remove IP': 'Falha ao remover IP',
  'Failed to save notification settings': 'Falha ao salvar configurações de notificação',
  'Failed to start OAuth': 'Falha ao iniciar OAuth',
  'Failed to start test': 'Falha ao iniciar teste',
  'Failed to update activity': 'Falha ao atualizar atividade',
  'Failed to update automation rule': 'Falha ao atualizar regra de automação',
  'Failed to update filter': 'Falha ao atualizar filtro',
  'Failed to update rule': 'Falha ao atualizar regra',
  'Failed to update stream': 'Falha ao atualizar stream',
  'Fallback': 'Fallback',
  'False positives': 'Falsos positivos',
  'Fill in name and URL': 'Preencha nome e URL',
  'Fill in the details of your new ad campaign': 'Preencha os detalhes da sua nova campanha de anúncios',
  'Fill in type and name': 'Preencha tipo e nome',
  'Filter created': 'Filtro criado',
  'Filter deleted': 'Filtro excluído',
  'Filter description': 'Descrição do filtro',
  'Filter name': 'Nome do filtro',
  'Filter type': 'Tipo de filtro',
  'Filter unique': 'Filtrar únicos',
  'Filter updated': 'Filtro atualizado',
  'Filters': 'Filtros',
  'Finance': 'Finanças',
  'Fire Google Ads gtag on redirect': 'Disparar Google Ads gtag no redirecionamento',
  'For example: Product A ad': 'Por exemplo: Anúncio do produto A',
  'For the current day': 'Para o dia atual',
  'Forgot password?': 'Esqueceu a senha?',
  'Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.': 'Encaminhe conversões servidor-a-servidor para redes de anúncios (FB CAPI, Google Ads, TikTok). Dispara automaticamente em cada postback.',
  'Forwarder': 'Encaminhador',
  'Forwarder ID': 'ID do encaminhador',
  'Forwarder created': 'Encaminhador criado',
  'Forwarder deleted': 'Encaminhador excluído',
  'Forwarder updated': 'Encaminhador atualizado',
  'Fraud alerts': 'Alertas de fraude',
  'Fraud detected': 'Fraude detectada',
  'Fraud filters': 'Filtros antifraude',
  'Free forever': 'Grátis para sempre',
  'Fri': 'Sex',
  'Full name': 'Nome completo',
  'Funnel': 'Funil',
  'Gambling': 'Apostas',
  'Generated at': 'Gerado em',
  'Geo': 'Geo',
  'Geo table': 'Tabela geo',
  'Geographic data will appear after the first clicks with resolvable coordinates': 'Dados geográficos aparecerão após os primeiros cliques com coordenadas resolvíveis',
  'Geographic statistics': 'Estatísticas geográficas',
  'Get SMS for critical events': 'Receba SMS para eventos críticos',
  'Get email notifications about important events': 'Receba notificações por email sobre eventos importantes',
  'Google Ads tag': 'Tag do Google Ads',
  'HTTPS active': 'HTTPS ativo',
  'Heatmap': 'Mapa de calor',
  'Hide password': 'Ocultar senha',
  'History': 'Histórico',
  'Home': 'Início',
  'Hourly activity': 'Atividade por hora',
  'IP': 'IP',
  'IP added to blacklist': 'IP adicionado à lista negra',
  'IP added to whitelist': 'IP adicionado à lista branca',
  'IP address': 'Endereço IP',
  'IP blacklist': 'Lista negra de IPs',
  'IP lists': 'Listas de IPs',
  'IP removed from blacklist': 'IP removido da lista negra',
  'IP removed from whitelist': 'IP removido da lista branca',
  'IP whitelist': 'Lista branca de IPs',
  'Import ad statistics': 'Importar estatísticas de anúncios',
  'Import costs and conversions': 'Importar custos e conversões',
  'Inactive': 'Inativo',
  'Integration created': 'Integração criada',
  'Integration deleted': 'Integração excluída',
  'Integration type': 'Tipo de integração',
  'Integration updated': 'Integração atualizada',
  'Integrations': 'Integrações',
  'Interface preferences': 'Preferências de interface',
  'Interval': 'Intervalo',
  'Interval between executions (min)': 'Intervalo entre execuções (min)',
  'Invalid email or password': 'Email ou senha inválidos',
  'Invite': 'Convidar',
  'Invite member': 'Convidar membro',
  'Invite sent': 'Convite enviado',
  'Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.': 'Convide colegas com cargos. Proprietário vê tudo; manager/admin podem editar; viewer é somente leitura.',
  'Invited': 'Convidado',
  'Jane Doe': 'Maria Silva',
  'KPIs, sources and leads in one panel.': 'KPIs, fontes e leads em um único painel.',
  'Key (e.g. api_key)': 'Chave (ex. api_key)',
  'Key deleted': 'Chave excluída',
  'Kyiv (UTC+2)': 'Kiev (UTC+2)',
  'Landing created': 'Landing criada',
  'Landing description': 'Descrição da landing',
  'Landing name': 'Nome da landing',
  'Landing page created': 'Landing criada',
  'Landing page deleted': 'Landing excluída',
  'Landing page description': 'Descrição da landing',
  'Landing page test': 'Teste de landing',
  'Landing page updated': 'Landing atualizada',
  'Landing page uploaded successfully': 'Landing enviada com sucesso',
  'Landing pages': 'Páginas de destino',
  'Landings': 'Landings',
  'Landings and offers': 'Landings e ofertas',
  'Language': 'Idioma',
  'Languages': 'Idiomas',
  'Last error': 'Último erro',
  'Last execution': 'Última execução',
  'Last sent': 'Último envio',
  'Last sync': 'Última sincronização',
  'Lead': 'Lead',
  'Lead generation': 'Geração de leads',
  'Less': 'Menos',
  'Limit': 'Limite',
  'Link copied to clipboard!': 'Link copiado para a área de transferência!',
  'Load more': 'Carregar mais',
  'Loading': 'Carregando',
  'Loading geographic data...': 'Carregando dados geográficos...',
  'Loading workspace': 'Carregando workspace',
  'Loading your data…': 'Carregando seus dados…',
  'Loading...': 'Carregando...',
  'Loading…': 'Carregando…',
  'Log only': 'Apenas registrar',
  'Manage': 'Gerenciar',
  'Manage billing': 'Gerenciar faturamento',
  'Manage campaigns': 'Gerenciar campanhas',
  'Manage your basic account information': 'Gerencie as informações básicas da sua conta',
  'Mark as resolved': 'Marcar como resolvido',
  'Max clicks per minute': 'Máximo de cliques por minuto',
  'Maximum cost per click': 'Custo máximo por clique',
  'Maximum executions per day': 'Máximo de execuções por dia',
  'Member had no 2FA configured': 'O membro não tinha 2FA configurado',
  'Members': 'Membros',
  'Method': 'Método',
  'Minimum CR (%)': 'CR mínima (%)',
  'Minimum sample size': 'Tamanho mínimo da amostra',
  'Missing fields': 'Campos ausentes',
  'Mode': 'Modo',
  'Modify stream settings': 'Modificar configurações do stream',
  'Mon': 'Seg',
  'More': 'Mais',
  'More details': 'Mais detalhes',
  'Moscow (UTC+3)': 'Moscou (UTC+3)',
  'Most recent traffic caught by this filter. Use it to spot false positives.': 'Tráfego mais recente capturado por este filtro. Use para detectar falsos positivos.',
  'My account': 'Minha conta',
  'My landing': 'Minha landing',
  'My landing page': 'Minha landing',
  'My offer': 'Minha oferta',
  'My webhook': 'Meu webhook',
  'Name': 'Nome',
  'Name is required': 'O nome é obrigatório',
  'Network': 'Rede',
  'New API key': 'Nova chave API',
  'New forwarder': 'Novo encaminhador',
  'New integration': 'Nova integração',
  'New key': 'Nova chave',
  'New landing page': 'Nova landing',
  'New offer': 'Nova oferta',
  'New password': 'Nova senha',
  'New password must be at least 6 characters': 'A nova senha deve ter pelo menos 6 caracteres',
  'New passwords do not match': 'As novas senhas não coincidem',
  'New registrations are disabled. Contact your workspace admin for an invitation.': 'Novos registros estão desabilitados. Contate o admin do seu workspace para um convite.',
  'New webhook': 'Novo webhook',
  'Next': 'Próximo',
  'No': 'Não',
  'No A/B tests': 'Sem testes A/B',
  'No API keys yet': 'Ainda não há chaves API',
  'No CAPI events in window.': 'Sem eventos CAPI na janela.',
  'No DLQ entries match these filters.': 'Nenhuma entrada DLQ corresponde a estes filtros.',
  'No ROI data': 'Sem dados de ROI',
  'No active ad-cost connections.': 'Nenhuma conexão ativa de custo de anúncios.',
  'No active filters': 'Sem filtros ativos',
  'No audit entries match the current filters.': 'Nenhuma entrada de auditoria corresponde aos filtros atuais.',
  'No automation rules': 'Sem regras de automação',
  'No blocked samples yet': 'Ainda não há amostras bloqueadas',
  'No campaign data': 'Sem dados de campanha',
  'No campaigns': 'Sem campanhas',
  'No city data': 'Sem dados de cidade',
  'No clicks for this campaign yet': 'Ainda não há cliques para esta campanha',
  'No connections yet. Connect FB or Google Ads to start importing cost.': 'Ainda não há conexões. Conecte FB ou Google Ads para começar a importar custos.',
  'No country data': 'Sem dados de país',
  'No data': 'Sem dados',
  'No data for the selected period': 'Sem dados para o período selecionado',
  'No data to display': 'Sem dados para exibir',
  'No data to display on map': 'Sem dados para exibir no mapa',
  'No description': 'Sem descrição',
  'No device data': 'Sem dados de dispositivos',
  'No domains yet': 'Ainda não há domínios',
  'No events yet': 'Ainda não há eventos',
  'No forwarders yet': 'Ainda não há encaminhadores',
  'No funnel data': 'Sem dados de funil',
  'No geo data': 'Sem dados geográficos',
  'No heatmap data': 'Sem dados de mapa de calor',
  'No integrations': 'Sem integrações',
  'No landing pages': 'Sem landings',
  'No landings': 'Sem landings',
  'No landings available': 'Nenhuma landing disponível',
  'No limit': 'Sem limite',
  'No members yet': 'Ainda não há membros',
  'No offers': 'Sem ofertas',
  'No offers available': 'Nenhuma oferta disponível',
  'No parameters added': 'Nenhum parâmetro adicionado',
  'No parameters yet': 'Ainda não há parâmetros',
  'No postbacks yet': 'Ainda não há postbacks',
  'No shared workspaces': 'Sem workspaces compartilhados',
  'No streams': 'Sem streams',
  'No suspicious activity detected': 'Nenhuma atividade suspeita detectada',
  'No traffic rules': 'Sem regras de tráfego',
  'No traffic sources': 'Sem fontes de tráfego',
  'No webhooks': 'Sem webhooks',
  'No webhooks yet': 'Ainda não há webhooks',
  'Notes': 'Notas',
  'Notification channels': 'Canais de notificação',
  'Notification preferences saved': 'Preferências de notificação salvas',
  'Notifications': 'Notificações',
  'Notify me about': 'Me notificar sobre',
  'Manage how and when you receive alerts': 'Gerencie como e quando receber alertas',
  'Save preferences': 'Salvar preferências',
  'Saving…': 'Salvando…',
  'Delivery channels': 'Canais de entrega',
  'Choose how to receive notifications': 'Escolha como receber notificações',
  'Receive alerts via email': 'Receber alertas por email',
  'SMS notifications': 'Notificações por SMS',
  'Critical alerts via SMS': 'Alertas críticos por SMS',
  'In-app and browser push': 'Push no app e navegador',
  'POST JSON payloads to your endpoint': 'POST JSON para seu endpoint',
  'Alert categories': 'Categorias de alertas',
  'Choose which types of events trigger notifications': 'Escolha quais tipos de eventos ativam notificações',
  'Paused, resumed, daily cap reached': 'Pausada, retomada, limite diário atingido',
  'Performance alerts': 'Alertas de performance',
  'ROI drop, conversion rate change, EPC decline': 'Queda de ROI, mudança na taxa de conversão, declínio de EPC',
  'Suspicious clicks, bot traffic, IP blacklist hits': 'Cliques suspeitos, tráfego bot, IPs em lista negra',
  'System alerts': 'Alertas do sistema',
  'Domain verification, TLS expiry, billing': 'Verificação de domínio, expiração TLS, cobrança',
  'Failed to load notification settings': 'Erro ao carregar configurações de notificação',
  'CSV exported': 'CSV exportado',
  'Export campaigns to CSV': 'Exportar campanhas para CSV',
  'Export offers to CSV': 'Exportar ofertas para CSV',
  'Number of clicks': 'Número de cliques',
  'Number of conversions': 'Número de conversões',
  'OAuth': 'OAuth',
  'OAuth error: ': 'Erro OAuth: ',
  'Offer': 'Oferta',
  'Offer category': 'Categoria da oferta',
  'Offer created': 'Oferta criada',
  'Offer deleted': 'Oferta excluída',
  'Offer description': 'Descrição da oferta',
  'Offer details': 'Detalhes da oferta',
  'Offer name': 'Nome da oferta',
  'Offer payout': 'Payout da oferta',
  'Offer test': 'Teste de oferta',
  'Offer updated': 'Oferta atualizada',
  'Offer uploaded successfully': 'Oferta enviada com sucesso',
  'Offer with the same name already exists': 'Já existe uma oferta com o mesmo nome',
  'Offers': 'Ofertas',
  'Oldest': 'Mais antigo',
  'On approval': 'Após aprovação',
  'On rejection': 'Após rejeição',
  'On track': 'No caminho',
  'Only currency code is updated; existing balances stay numeric and are not converted.': 'Apenas o código da moeda é atualizado; saldos existentes permanecem numéricos e não são convertidos.',
  'Open menu': 'Abrir menu',
  'Open variant': 'Abrir variante',
  'Optional comma-separated list of ASN numbers (e.g. 16509 = AWS) you trust enough to let through.': 'Lista opcional de números ASN separados por vírgulas (ex. 16509 = AWS) em que você confia o suficiente para deixar passar.',
  'Order by': 'Ordenar por',
  'Other': 'Outro',
  'Owner': 'Proprietário',
  'Page is not the source of truth': 'Esta página não é a fonte da verdade',
  'Page not found': 'Página não encontrada',
  'Page weight': 'Peso da página',
  'Param': 'Parâmetro',
  'Parameters': 'Parâmetros',
  'Password': 'Senha',
  'Pause': 'Pausar',
  'Paused': 'Pausada',
  'Paused (no traffic)': 'Pausado (sem tráfego)',
  'Paused {n}': 'Pausadas: {n}',
  'Pay-per-click': 'Pagamento por clique',
  'Pay-per-impression': 'Pagamento por impressão',
  'Pay-per-lead': 'Pagamento por lead',
  'Pay-per-sale': 'Pagamento por venda',
  'Peak': 'Pico',
  'Pending CAPI re-attempts.': 'Reenvios CAPI pendentes.',
  'Per-base exchange-rate snapshot freshness.': 'Frescor dos snapshots de câmbio por base.',
  'Per-page test settings': 'Configurações de teste por página',
  'Permission denied': 'Permissão negada',
  'Permissions': 'Permissões',
  'Personal info': 'Informações pessoais',
  'Phone': 'Telefone',
  'Pin': 'Fixar',
  'Pinned': 'Fixado',
  'Pixel ID': 'ID do pixel',
  'Plan name': 'Nome do plano',
  'Platform': 'Plataforma',
  'Platform fee': 'Taxa da plataforma',
  'Postback delivery': 'Entrega de postbacks',
  'Postback fired': 'Postback disparado',
  'Precise tracking': 'Tracking preciso',
  'Preferences': 'Preferências',
  'Previous': 'Anterior',
  'Primary tracking domain': 'Domínio principal de tracking',
  'Priority': 'Prioridade',
  'Profile': 'Perfil',
  'Profile information': 'Informações do perfil',
  'Profile updated successfully': 'Perfil atualizado com sucesso',
  'Profit': 'Lucro',
  'Net positive': 'Lucro líquido',
  'Net loss': 'Prejuízo líquido',
  'Progress to minimum sample': 'Progresso até o mínimo da amostra',
  'Provider': 'Provedor',
  'Proxy / VPN / Tor block': 'Bloqueio proxy / VPN / Tor',
  'Public API': 'API pública',
  'Push notifications': 'Notificações push',
  'Quick actions': 'Ações rápidas',
  'Quick start': 'Início rápido',
  'ROI by campaigns': 'ROI por campanhas',
  'Readable reports': 'Relatórios legíveis',
  'Real-time overview of your campaigns and stats': 'Visão em tempo real das suas campanhas e estatísticas',
  'Reason': 'Motivo',
  'Reason for adding': 'Motivo para adicionar',
  'Receive SMS for critical events': 'Receba SMS para eventos críticos',
  'Receive notifications by email': 'Receba notificações por email',
  'Recent activity for this campaign': 'Atividade recente para esta campanha',
  'Recent campaigns': 'Campanhas recentes',
  'Recent clicks': 'Cliques recentes',
  'Records of automatic rule executions will appear here': 'Registros de execuções automáticas aparecerão aqui',
  'Redirect': 'Redirecionar',
  'Redirect URL': 'URL de redirecionamento',
  'Redirects': 'Redirecionamentos',
  'Refresh': 'Atualizar',
  'Refresh failed': 'Falha ao atualizar token',
  'Refresh token': 'Refresh token',
  'Refresh token (optional)': 'Refresh token (opcional)',
  'Refreshed': 'Atualizado',
  'Registration failed': 'Registro falhou',
  'Registration failed. Please try again.': 'Registro falhou. Por favor tente novamente.',
  'Registration successful!': 'Registro bem-sucedido!',
  'Reject': 'Rejeitar',
  'Remember this device': 'Lembrar este dispositivo',
  'Replay': 'Reenviar',
  'Replay failed': 'Reenvio falhou',
  'Replay failed:': 'Reenvio falhou:',
  'Report exported': 'Relatório exportado',
  'Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.': 'Relatórios e dashboards serão normalizados para esta moeda. Taxas de câmbio são atualizadas a cada hora.',
  'Reset': 'Redefinir',
  'Reset 2FA': 'Redefinir 2FA',
  'Resolved': 'Resolvido',
  'Retry attempts': 'Tentativas de reenvio',
  'Retry queue': 'Fila de reenvio',
  'Revenue': 'Receita',
  'Revoke access': 'Revogar acesso',
  'Revoke access?': 'Revogar acesso?',
  'Risk score threshold (0-100)': 'Limiar de pontuação de risco (0-100)',
  'Risk score threshold (0.0 – 1.0)': 'Limiar de pontuação de risco (0.0 – 1.0)',
  'Role': 'Cargo',
  'Routing record (CNAME)': 'Registro de roteamento (CNAME)',
  'Rule activated': 'Regra ativada',
  'Rule deactivated': 'Regra desativada',
  'Rule deleted': 'Regra excluída',
  'Rule description': 'Descrição da regra',
  'Rule name': 'Nome da regra',
  'Rule type': 'Tipo de regra',
  'Rule updated': 'Regra atualizada',
  'Rules': 'Regras',
  'Running': 'Executando',
  'S2S postback callouts in the last window.': 'Chamadas postback S2S na última janela.',
  'S2S postback · bot shield': 'Postback S2S · escudo anti-bot',
  'S2S postbacks': 'Postbacks S2S',
  'Sale': 'Venda',
  'Sat': 'Sáb',
  'Save': 'Salvar',
  'Save changes': 'Salvar alterações',
  'Save domain settings': 'Salvar configurações de domínio',
  'Save failed': 'Falha ao salvar',
  'Save notification settings': 'Salvar configurações de notificação',
  'Save profile': 'Salvar perfil',
  'Save settings': 'Salvar configurações',
  'Saved': 'Salvo',
  'Scale your team': 'Expanda seu time',
  'Scopes': 'Escopos',
  'Search': 'Buscar',
  'Search campaigns, streams…': 'Buscar campanhas, streams…',
  'Search campaigns…': 'Buscar campanhas…',
  'Search landing pages…': 'Buscar landings…',
  'Search offers…': 'Buscar ofertas…',
  'Search traffic sources…': 'Buscar fontes de tráfego…',
  'Secret (optional)': 'Segredo (opcional)',
  'Security': 'Segurança',
  'Security and access settings': 'Configurações de segurança e acesso',
  'Security settings': 'Configurações de segurança',
  'Select ZIP File': 'Selecionar arquivo ZIP',
  'Select ZIP file': 'Selecionar arquivo ZIP',
  'Select a campaign': 'Selecione uma campanha',
  'Select a campaign to manage traffic rules': 'Selecione uma campanha para gerenciar regras de tráfego',
  'Select a traffic source (optional)': 'Selecione uma fonte de tráfego (opcional)',
  'Select campaign': 'Selecionar campanha',
  'Select category': 'Selecionar categoria',
  'Select type': 'Selecionar tipo',
  'Send test': 'Enviar teste',
  'Sent': 'Enviado',
  'Separate tags with commas': 'Separe tags com vírgulas',
  'Server-to-server postbacks': 'Postbacks servidor-a-servidor',
  'Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.': 'Configure IPQS_API_KEY ou FRAUDSCORE_API_KEY no ambiente do backend.',
  'Set default': 'Definir como padrão',
  'Set up split testing to optimize conversions': 'Configure split testing para otimizar conversões',
  'Settings': 'Configurações',
  'Share': 'Compartilhar',
  'Share this link with the invitee:': 'Compartilhe este link com o convidado:',
  'Shared with me': 'Compartilhado comigo',
  'Short campaign description': 'Descrição curta da campanha',
  'Show all campaigns': 'Mostrar todas as campanhas',
  'Show password': 'Mostrar senha',
  'Show recent log': 'Mostrar log recente',
  'Showing latest 10 clicks': 'Mostrando os últimos 10 cliques',
  'Sign in': 'Entrar',
  'Sign in failed': 'Falha no login',
  'Sign in successfully!': 'Login realizado!',
  'Sign in to your xpnsr account': 'Entre na sua conta xpnsr',
  'Sign out': 'Sair',
  'Sign up': 'Cadastrar',
  'Signed in successfully!': 'Login realizado!',
  'Signed out': 'Sessão encerrada',
  'Significance': 'Significância',
  'Signing in…': 'Entrando…',
  'Simple': 'Simples',
  'Since': 'Desde',
  'Since (ISO)': 'Desde (ISO)',
  'Skipped {n} (no access or not found)': 'Ignoradas: {n} (sem acesso ou não encontradas)',
  'Source macro': 'Macro da fonte',
  'Source template': 'Template da fonte',
  'Sources': 'Fontes',
  'Sources not found': 'Fontes não encontradas',
  'Spend': 'Gasto',
  'Split test': 'Split test',
  'Statistics': 'Estatísticas',
  'Status': 'Status',
  'Status breakdown': 'Análise por status',
  'Statuses': 'Status',
  'Stopped': 'Parado',
  'Stream action': 'Ação do stream',
  'Stream created': 'Stream criado',
  'Stream deleted': 'Stream excluído',
  'Stream name': 'Nome do stream',
  'Stream type': 'Tipo de stream',
  'Stream updated': 'Stream atualizado',
  'Streams': 'Streams',
  'Subscription': 'Assinatura',
  'Success': 'Sucesso',
  'Success rate': 'Taxa de sucesso',
  'Successful conversions': 'Conversões bem-sucedidas',
  'Sun': 'Dom',
  'Suspicious activity': 'Atividade suspeita',
  'Suspicious traffic detection': 'Detecção de tráfego suspeito',
  'Sweepstakes': 'Sweepstakes',
  'Sync campaigns and conversions': 'Sincronizar campanhas e conversões',
  'Sync complete': 'Sincronização completa',
  'Sync failed': 'Sincronização falhou',
  'Sync now': 'Sincronizar',
  'System': 'Sistema',
  'System health': 'Saúde do sistema',
  // Nav labels added after the !99 coverage fill (parity !105/!108).
  'System status': 'Status do sistema',
  'S2S log': 'Log S2S',
  'TLS fingerprints': 'Impressões digitais TLS',
  'API docs': 'Documentação da API',
  'System settings saved': 'Configurações do sistema salvas',
  'TLS fingerprint (JA3 / JA4)': 'Fingerprint TLS (JA3 / JA4)',
  'TLS provisioning failed': 'Provisionamento TLS falhou',
  'TLS provisioning started': 'Provisionamento TLS iniciado',
  'TLS validation records': 'Registros de validação TLS',
  'TXT verification record': 'Registro de verificação TXT',
  'Tags': 'Tags',
  'Target': 'Alvo',
  'Target URL': 'URL alvo',
  'Target type': 'Tipo de alvo',
  'Team': 'Time',
  'Telegram notifications': 'Notificações do Telegram',
  'Test': 'Teste',
  'Test description': 'Descrição do teste',
  'Test error: {detail}': 'Erro de teste: {detail}',
  'Test event sent': 'Evento de teste enviado',
  'Test failed': 'Teste falhou',
  'Test name': 'Nome do teste',
  'Test succeeded (HTTP {code})': 'Teste bem-sucedido (HTTP {code})',
  'Test type': 'Tipo de teste',
  'Test variants': 'Variantes de teste',
  'The system automatically tracks suspicious actions': 'O sistema rastreia automaticamente ações suspeitas',
  'Threshold reached': 'Limiar atingido',
  'Thu': 'Qui',
  'Time': 'Hora',
  'Timeout (sec)': 'Timeout (seg)',
  'Timezone': 'Fuso horário',
  'Today': 'Hoje',
  'Token refreshed': 'Token atualizado',
  'Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.': 'Tokens são criptografados em repouso. Use os botões OAuth acima para FB / Google, ou digite tokens manualmente abaixo.',
  'Total': 'Total',
  'Total active campaigns': 'Total de campanhas ativas',
  'Total clicks': 'Total de cliques',
  'Total revenue': 'Receita total',
  'Total spend': 'Gasto total',
  'Total weight': 'Peso total',
  'Tracker domains': 'Domínios do tracker',
  'Tracking ID': 'ID de tracking',
  'Tracking URL preview': 'Prévia da URL de tracking',
  'Tracking domains': 'Domínios de tracking',
  'Tracking link': 'Link de tracking',
  'Tracking link copied!': 'Link de tracking copiado!',
  'Tracking links will use': 'Links de tracking usarão',
  'Traffic': 'Tráfego',
  'Traffic distribution rules': 'Regras de distribuição de tráfego',
  'Traffic filters': 'Filtros de tráfego',
  'Traffic management': 'Gestão de tráfego',
  'Traffic paths': 'Rotas de tráfego',
  'Traffic rule created': 'Regra de tráfego criada',
  'Traffic rules': 'Regras de tráfego',
  'Traffic source': 'Fonte de tráfego',
  'Traffic source created': 'Fonte de tráfego criada',
  'Traffic source deleted': 'Fonte de tráfego excluída',
  'Traffic source description': 'Descrição da fonte de tráfego',
  'Traffic source name': 'Nome da fonte de tráfego',
  'Traffic source updated': 'Fonte de tráfego atualizada',
  'Traffic sources': 'Fontes de tráfego',
  'Traffic weight (%)': 'Peso do tráfego (%)',
  'Trigger conditions': 'Condições de gatilho',
  'Try adjusting search criteria': 'Tente ajustar os critérios de busca',
  'Tue': 'Ter',
  'URL': 'URL',
  'URL (or pick below)': 'URL (ou escolha abaixo)',
  'URL copied': 'URL copiada',
  'URL for receiving notifications in JSON format': 'URL para receber notificações em formato JSON',
  'URL key': 'Chave URL',
  'UTM parameters': 'Parâmetros UTM',
  'Unique': 'Único',
  'Unique clicks': 'Cliques únicos',
  'Unique visitors': 'Visitantes únicos',
  'Unknown': 'Desconhecido',
  'Until': 'Até',
  'Until (ISO)': 'Até (ISO)',
  'Update': 'Atualizar',
  'Update campaign details': 'Atualizar detalhes da campanha',
  'Update traffic source settings': 'Atualizar configurações da fonte de tráfego',
  'Update your password to keep your account secure': 'Atualize sua senha para manter sua conta segura',
  'Updated': 'Atualizado',
  'Updates and technical information': 'Atualizações e informações técnicas',
  'Upgrade': 'Fazer upgrade',
  'Upload': 'Enviar',
  'Upload Landing Page': 'Enviar landing',
  'Upload Offer': 'Enviar oferta',
  'Upload Offer ZIP': 'Enviar ZIP da oferta',
  'Upload ZIP': 'Enviar ZIP',
  'Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.': 'Envie um arquivo ZIP com páginas HTML, imagens e outros recursos. Suporta: _preview.png para prévia, scripts PHP para processamento.',
  'Upload a ZIP file containing offer files': 'Envie um arquivo ZIP com arquivos da oferta',
  'Upload a ZIP file containing your landing page files (max 50MB)': 'Envie um arquivo ZIP com os arquivos da sua landing (máx 50MB)',
  'Uploading...': 'Enviando...',
  'Upsell': 'Upsell',
  'Use API keys to call the public /v1 REST API. Pass the key as': 'Use chaves API para chamar a REST API pública /v1. Passe a chave como',
  'User': 'Usuário',
  'User Agent': 'User Agent',
  'User settings saved': 'Configurações de usuário salvas',
  'Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.': 'Usa a lista semente (Python requests, Go net/http, curl, Chrome headless) mais suas substituições do workspace.',
  'VKontakte integration': 'Integração VKontakte',
  'Value': 'Valor',
  'Variant name': 'Nome da variante',
  'Variant performance analysis': 'Análise de desempenho de variantes',
  'Variant {n}': 'Variante {n}',
  'Variants': 'Variantes',
  'Verification failed': 'Verificação falhou',
  'Verified': 'Verificado',
  'Verify': 'Verificar',
  'View blocked samples': 'Ver amostras bloqueadas',
  'View detailed statistics': 'Ver estatísticas detalhadas',
  'Visitors': 'Visitantes',
  'Visits': 'Visitas',
  'Webhook URL': 'URL do webhook',
  'Webhook created': 'Webhook criado',
  'Webhook deleted': 'Webhook excluído',
  'Webhook updated': 'Webhook atualizado',
  'Webhooks': 'Webhooks',
  'Wed': 'Qua',
  'Weight': 'Peso',
  'Weight (%)': 'Peso (%)',
  'Welcome back': 'Bem-vindo de volta',
  'Welcome,': 'Bem-vindo,',
  'Welcome, {name}.': 'Bem-vindo, {name}.',
  'When on, /r/ returns a tiny HTML page that calls gtag("event","conversion", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.': 'Quando ativo, /r/ retorna uma pequena página HTML que chama gtag("event","conversion", …) com sua tag simples antes de redirecionar. Use isso se você não configurar o sufixo Final URL do lado do Google Ads.',
  'Whitelist is empty': 'Lista branca está vazia',
  'Window': 'Janela',
  'Work email': 'Email de trabalho',
  'Workspace': 'Workspace',
  'Workspace currency': 'Moeda do workspace',
  'Workspace currency saved': 'Moeda do workspace salva',
  'Workspace-scoped trail of privileged actions. Retained for 90 days.': 'Trilha de ações privilegiadas no workspace. Retida por 90 dias.',
  'Yes': 'Sim',
  'You have no campaigns yet': 'Você ainda não tem campanhas',
  'Your latest campaigns': 'Suas campanhas mais recentes',
  'ZIP File': 'Arquivo ZIP',
  'ZIP File (max 100MB)': 'Arquivo ZIP (máx 100MB)',
  'account': 'conta',
  'campaigns': 'campanhas',
  'clicks/mo': 'cliques/mês',
  'error': 'erro',
  'fresh': 'atualizado',
  'honest': 'honesto',
  'last used': 'último uso',
  'never used': 'nunca usado',
  'ok': 'ok',
  'or': 'ou',
  'stale': 'desatualizado',
  'tag1, tag2, tag3': 'tag1, tag2, tag3',
  'team members': 'membros do time',
  '{n} clicks': '{n} cliques',
  '{n} conversions': '{n} conversões',
  '{n} min': '{n} min',
  '{n} unique': '{n} únicos',
  '{rate}% conversion': '{rate}% de conversão',
  // Wave 33 — granular RBAC matrix
  'Permission matrix': 'Matriz de permissões',
  'Permission matrix saved': 'Matriz de permissões salva',
  'Failed to load permission matrix': 'Falha ao carregar a matriz de permissões',
  'Failed to save permission matrix': 'Falha ao salvar a matriz de permissões',
  'Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.': 'Substitua o papel mínimo exigido para cada ação neste workspace. Apenas as células diferentes do padrão são salvas.',
  'overrides': 'substituições',
  'Read-only — only the workspace owner can edit the matrix.': 'Somente leitura — apenas o dono do workspace pode editar a matriz.',
  'Reset all to defaults': 'Redefinir tudo para o padrão',
  'Custom': 'Personalizado',
  'Reset to default': 'Redefinir ao padrão',
  'owner': 'dono',
  'admin': 'admin',
  'manager': 'gerente',
  'viewer': 'visualizador',
  'Landings & offers': 'Landings e ofertas',
  'Reports': 'Relatórios',
  'Audit': 'Auditoria',

  // Navigation hints (sidebar tooltips)
  'Toggle navigation hints': 'Ativar/desativar dicas de navegação',
  'Show hints': 'Mostrar dicas',
  'Hide hints': 'Ocultar dicas',

  // Sidebar nav group labels
  'Overview': 'Visão geral',
  'Tools': 'Ferramentas',
  'Resources': 'Recursos',
  'Pre-landings': 'Pre-landings',
  'Book demo': 'Agendar demo',
  'Overview of clicks, conversions and active campaigns': 'Tela principal: resumo de cliques, conversões e campanhas ativas',
  'Create ad campaigns and get tracking links': 'Crie campanhas publicitárias e obtenha links de rastreamento',
  'Upload landing pages (ZIP) or set a URL for split-tests': 'Envie landing pages (ZIP) ou informe uma URL para split-tests',
  'Warm-up pages shown before the offer': 'Páginas intermediárias antes da oferta para aquecer o tráfego',
  'Connect Facebook, Google, TikTok ad accounts': 'Conecte contas de anúncios do Facebook, Google, TikTok',
  'Two-factor auth, sessions and password': 'Autenticação de dois fatores, sessões e senha',
  'Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms': 'Ofertas/funis: upload, roteamento para parceiros via API (pesos, failover), formulários de lead',
  'Traffic sources with presets (Google Ads with tm & macros, etc.)': 'Fontes de tráfego com presets (Google Ads com macros e tm, etc.)',
  'Manage flows and traffic distribution rules': 'Gerenciamento de fluxos e regras de distribuição de tráfego',
  'Split-test landings and offers with auto-distribution': 'Split-tests de landings e ofertas com distribuição automática',
  'Block bots, fraud and suspicious clicks': 'Proteção contra bots, fraude e cliques suspeitos',
  'Detailed reports: charts, geo, devices, ROI': 'Relatórios detalhados: gráficos, geo, dispositivos, ROI',
  'Full click log with IP, UserAgent, GEO and time': 'Log completo de cliques com IP, UserAgent, GEO e horário',
  'Auto-rules: pause campaigns on low ROI, etc.': 'Regras automáticas: pausar campanhas com ROI baixo, etc.',
  'Partner CRMs (TrackBox, Custom API) for API lead injection + notifications': 'CRMs de parceiros (TrackBox, Custom API) para envio de leads por API + notificações',
  'Add your own domains for tracking links': 'Adicione seus domínios para links de rastreamento',
  'Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth': 'Conversões online para Google/FB/TikTok (S2S). Google — modo simple, sem OAuth',
  'Keys to access the tracker REST API': 'Chaves para acessar a REST API do tracker',
  'Invite your team, assign roles and permissions': 'Convide sua equipe, atribua funções e permissões',
  'Action log of all users for 90 days': 'Registro de ações de todos os usuários por 90 dias',
  'Cookie consent banner for GDPR compliance': 'Banner de consentimento de cookies para GDPR',
  'Ready-made templates and integrations': 'Templates e integrações prontas da comunidade',
  'Swagger REST API docs (opens in new tab)': 'Documentação Swagger da REST API (abre em nova aba)',
  'Failed conversion dispatches — can be retried': 'Erros de envio de conversões — pode ser reenviado',
  'Server, queue and database status': 'Estado dos servidores, filas e bancos de dados',
  'Plan, payment and usage limits': 'Plano tarifário, pagamento e limites',
  'Profile, language, timezone and notifications': 'Perfil, idioma, fuso horário e notificações',

  // De-russification wave: short/common keys only; long help paragraphs
  // intentionally fall back to English.
  'Registration': 'Registro',
  'Deposit': 'Depósito',
  'Trash': 'Lixo',
  'Hide': 'Ocultar',
  'Show': 'Mostrar',
  'Ignore': 'Ignorar',
  'Import from source': 'Importar da fonte',
  'Postback token': 'Token de postback',
  'Require postback token': 'Exigir token de postback',
  'Network macros': 'Macros da rede',
  'Available macros': 'Macros disponíveis',
  'Failed to copy': 'Falha ao copiar',
  'Hint': 'Dica',
  'Cycle language': 'Alternar idioma',
  'Switch to {lang}': 'Mudar para {lang}',
  'Current language: {lang}': 'Idioma atual: {lang}',
  'Scroll to top': 'Voltar ao topo',
  'Something went wrong': 'Algo deu errado',
  'An unexpected error occurred.': 'Ocorreu um erro inesperado.',
  'Reload page': 'Recarregar página',
  'What is XPNSR Tracker': 'O que é o XPNSR Tracker',
  'Links & aliases': 'Links e aliases',
  'Redirect modes': 'Modos de redirecionamento',
  'A/B tests': 'Testes A/B',
  'Glossary': 'Glossário',
  'Partners & lead forms': 'Parceiros e formulários de leads',
  'Google Ads & conversions': 'Google Ads e conversões',
  'Affiliate networks': 'Redes de afiliados',
  'Reports (Report Builder)': 'Relatórios (Report Builder)',
  'Domain opened for indexing': 'Domínio aberto para indexação',
  'Domain closed from indexing': 'Domínio fechado para indexação',
  'Index page set': 'Página index definida',
  'Index page cleared': 'Página index removida',
  'Server migration (admin only)': 'Troca de servidor (somente admin)',
  'Current server IP:': 'IP atual do servidor:',
  'Indexable': 'Indexável',
  'Custom API (any CRM)': 'Custom API (qualquer CRM)',
  'Username': 'Usuário',
  'Signup path': 'Caminho de cadastro',
  'Body format': 'Formato do corpo',
  'Headers': 'Cabeçalhos',
  'Body template (JSON)': 'Modelo do corpo (JSON)',
  'Redirect field': 'Campo de redirecionamento',
  'Success field (optional)': 'Campo de sucesso (opcional)',
  'Success value (optional)': 'Valor de sucesso (opcional)',
  'Telegram lead alerts': 'Alertas de leads no Telegram',
  '(sent on EVERY submit — even test/error)': '(enviado em CADA submit — até teste/erro)',
  'Affiliate routing (form offers)': 'Roteamento para parceiros (ofertas com formulário)',
  'My first campaign': 'Minha primeira campanha',
  'CPA Network': 'Rede CPA',
  'Main FB pixel': 'Pixel FB principal',
  'zapier integration': 'integração com zapier',
  'Bot token': 'Token do bot',
  'Chat ID': 'ID do chat',
  // --- Coverage fill (auto-added): remaining UI strings ---
  '(no label)': '(sem rótulo)',
  '(no match)': '(sem correspondência)',
  '(one "Key: value" per line, macros allowed)': '(um "Key: value" por linha, macros permitidas)',
  '(values are macros in curly braces)': '(os valores são macros entre chaves)',
  '+ Upload': '+ Upload',
  '180 days': '180 dias',
  '2FA disabled': '2FA desativada',
  '2FA enabled': '2FA ativada',
  '2FA is currently enabled': 'A 2FA está ativada no momento',
  '302 redirect (default)': 'Redirecionamento 302 (padrão)',
  '365 days': '365 dias',
  'A campaign groups your traffic sources and tracking links under one name.': 'Uma campanha agrupa suas fontes de tráfego e links de rastreamento sob um único nome.',
  'A custom conversion type with its own reporting rules and status transitions.': 'Um tipo de conversão personalizado com regras de relatório e transições de status próprias.',
  'A formula over base metrics rendered as a report column.': 'Uma fórmula sobre métricas base exibida como coluna de relatório.',
  'A/B testing': 'Teste A/B',
  'AI Optimizer': 'Otimizador de IA',
  'AND (all)': 'AND (todos)',
  'AND: the click must pass every configured filter. OR: any single passing filter admits the click.': 'AND: o clique deve passar por todos os filtros configurados. OR: basta um único filtro aprovado para admitir o clique.',
  'API URL (base)': 'URL da API (base)',
  'Accept button label': 'Rótulo do botão de aceitar',
  'Accepted': 'Aceito',
  'Accepting invitation…': 'Aceitando convite…',
  'Access denied': 'Acesso negado',
  'Action on trigger': 'Ação ao disparar',
  'Activate': 'Ativar',
  'Activate 2FA': 'Ativar 2FA',
  'Ad accounts': 'Contas de anúncios',
  'Add / remove tracking domains.': 'Adicionar / remover domínios de rastreamento.',
  'Add a custom domain to serve tracking links from your own branded URL.': 'Adicione um domínio personalizado para servir links de rastreamento a partir de uma URL com a sua marca.',
  'Add a forwarder to push conversions to ad networks automatically.': 'Adicione um forwarder para enviar conversões às redes de anúncios automaticamente.',
  'Add a manual cost, or connect an ad account to sync spend automatically.': 'Adicione um custo manual ou conecte uma conta de anúncios para sincronizar o gasto automaticamente.',
  'Add campaign…': 'Adicionar campanha…',
  'Add cost': 'Adicionar custo',
  'Add forwarder': 'Adicionar forwarder',
  'Add from preset': 'Adicionar a partir de preset',
  'Add interval': 'Adicionar intervalo',
  'Add manual cost': 'Adicionar custo manual',
  'Add new campaigns and their default streams.': 'Adicionar novas campanhas e seus streams padrão.',
  'Add partner route': 'Adicionar rota de parceiro',
  'Add range': 'Adicionar faixa',
  'Add status': 'Adicionar status',
  'Add the CNAME record shown on the Domains page, then click verify.': 'Adicione o registro CNAME exibido na página Domínios e depois clique em verificar.',
  'Add value': 'Adicionar valor',
  'Add vendor': 'Adicionar fornecedor',
  'Added to blacklist': 'Adicionado à blacklist',
  'Added to whitelist': 'Adicionado à whitelist',
  'Adjust the period or campaign filter.': 'Ajuste o período ou o filtro de campanha.',
  'Advanced': 'Avançado',
  'Advanced notification preferences': 'Preferências avançadas de notificação',
  'Affiliate CRM — push leads via API': 'CRM de afiliados — envio de leads via API',
  'Affiliate network': 'Rede de afiliados',
  'Affiliate network created': 'Rede de afiliados criada',
  'Affiliate network deleted': 'Rede de afiliados excluída',
  'Affiliate network name': 'Nome da rede de afiliados',
  'Affiliate network postback': 'Postback da rede de afiliados',
  'Affiliate network updated': 'Rede de afiliados atualizada',
  'After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.': 'Após adicionar, configure o DNS do seu domínio (registro TXT para verificação, registro CNAME ou A para rotear o tráfego) e depois pressione Verificar.',
  'Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.': 'Estado agregado de CAPI / postback / FX / sincronização de custos nos workspaces que você administra.',
  'Alert if ROI drops below this %': 'Alertar se o ROI cair abaixo deste %',
  'Alert types': 'Tipos de alerta',
  'Algorithm': 'Algoritmo',
  'Alias': 'Alias',
  'All groups': 'Todos os grupos',
  'All offers': 'Todas as ofertas',
  'All rows': 'Todas as linhas',
  'All statuses': 'Todos os status',
  'All traffic': 'Todo o tráfego',
  'All values shown in': 'Todos os valores exibidos em',
  'Allowed ASNs (whitelist)': 'ASNs permitidos (whitelist)',
  'Allowed metrics': 'Métricas permitidas',
  'Allowed next statuses': 'Próximos status permitidos',
  'Already have an account? Sign in': 'Já tem uma conta? Entrar',
  'Amount': 'Valor',
  'Anonymous': 'Anônimo',
  'Any': 'Qualquer',
  'Any date': 'Qualquer data',
  'Any status': 'Qualquer status',
  'Any type': 'Qualquer tipo',
  'Anyone with this link will lose access to the shared dashboard immediately.': 'Qualquer pessoa com este link perderá o acesso ao painel compartilhado imediatamente.',
  'Applied {n} weight changes': '{n} alterações de peso aplicadas',
  'Apply filters': 'Aplicar filtros',
  'Archive': 'Arquivar',
  'Archived': 'Arquivada',
  'Arithmetic over base metrics. Supported: + - * / ( ) and numbers.': 'Aritmética sobre métricas base. Suportado: + - * / ( ) e números.',
  'At least 2 variants required': 'São necessárias pelo menos 2 variantes',
  'At least 6 characters': 'Pelo menos 6 caracteres',
  'Attempts': 'Tentativas',
  'Attribution,': 'Atribuição,',
  'Auto': 'Auto',
  'Auto pull-sync': 'Sincronização automática (pull)',
  'Auto-refresh every 30s': 'Atualização automática a cada 30s',
  'Automation rules': 'Regras de automação',
  'Available on enterprise plans. Hides the "Powered by xpnsr" footer.': 'Disponível nos planos enterprise. Oculta o rodapé "Powered by xpnsr".',
  'Back to sign-in': 'Voltar ao login',
  'Back to streams': 'Voltar aos streams',
  'Back to top': 'Voltar ao topo',
  'Backup codes (save now)': 'Códigos de backup (salve agora)',
  'Bangkok (UTC+7)': 'Bangkok (UTC+7)',
  'Banned': 'Banido',
  'Banner copy': 'Texto do banner',
  'Banner status': 'Status do banner',
  'Base metrics': 'Métricas base',
  'Berlin (UTC+1)': 'Berlim (UTC+1)',
  'Best cohort': 'Melhor coorte',
  'Binary file — not editable': 'Arquivo binário — não editável',
  'Bind to campaigns': 'Vincular a campanhas',
  'Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.': 'Vincule seu próprio domínio para mascarar os links de rastreamento. Aponte um registro A para o seu servidor de rastreamento e verifique a propriedade via registro TXT.',
  'Black': 'Black',
  'Black / white lists': 'Blacklists / whitelists',
  'Blacklist': 'Blacklist',
  'Blacklist is empty': 'A blacklist está vazia',
  'Blacklisted': 'Na blacklist',
  'Blank referrer (JS)': 'Referrer em branco (JS)',
  'Block Tor exit nodes': 'Bloquear nós de saída do Tor',
  'Block VPNs (requires API key)': 'Bloquear VPNs (requer chave de API)',
  'Block proxies (requires API key)': 'Bloquear proxies (requer chave de API)',
  'Body': 'Corpo',
  'Body (JSON)': 'Corpo (JSON)',
  'Body copied to clipboard.': 'Corpo copiado para a área de transferência.',
  'Body must be valid JSON.': 'O corpo deve ser um JSON válido.',
  'Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.': 'Registre gasto em uma campanha. Ele é incorporado ao custo da campanha usado pelo ROI e pelos painéis.',
  'Bot': 'Bot',
  'Bot IP addresses': 'Endereços IP de bots',
  'Bot User-Agent signatures': 'Assinaturas de User-Agent de bots',
  'Bot lists': 'Listas de bots',
  'Bot lists saved': 'Listas de bots salvas',
  'Bots': 'Bots',
  'Bots & spoofed crawlers': 'Bots e crawlers falsificados',
  'Bots and crawlers sent to the safe page vs humans to the offer': 'Bots e crawlers enviados para a página segura vs humanos para a oferta',
  'Branding': 'Branding',
  'Branding cleared': 'Branding redefinido',
  'Branding saved': 'Branding salvo',
  'Break down clicks and conversions by sub-ID parameters (sub1–sub15)': 'Detalhe cliques e conversões por parâmetros de sub-ID (sub1–sub15)',
  'Breakdown': 'Detalhamento',
  'Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.': 'Navegue e instale templates da comunidade para postbacks, macros, regras antifraude e pre-landings. Os envios são publicados automaticamente — a própria comunidade se modera por meio da ação de excluir.',
  'Browse integration configurations.': 'Visualizar configurações de integrações.',
  'Browse postbacks and the CAPI dead-letter queue.': 'Visualizar postbacks e a fila dead-letter do CAPI.',
  'Browse the landing-page library.': 'Visualizar a biblioteca de páginas de destino.',
  'Browse the offer library.': 'Visualizar a biblioteca de ofertas.',
  'Browse the tracking-domain list.': 'Visualizar a lista de domínios de rastreamento.',
  'Browser': 'Navegador',
  'Bucket': 'Bucket',
  'Build traffic rules, rotate landings and split-test offers for any campaign.': 'Crie regras de tráfego, rotacione landings e faça split test de ofertas em qualquer campanha.',
  'Built-in statuses': 'Status nativos',
  'Bulk create': 'Criar em massa',
  'Bulk create Google Ads forwarders': 'Criar forwarders do Google Ads em massa',
  'Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.': 'Agrupe domínios verificados em um pool e rotacione os links de rastreamento entre eles. Remova um domínio banido da rotação com um clique, sem republicar os anúncios.',
  'By browser': 'Por navegador',
  'By destination': 'Por destino',
  'By device': 'Por dispositivo',
  'By stream': 'Por stream',
  'By {author}': 'Por {author}',
  'CPS (per sale)': 'CPS (por venda)',
  'CPuC (per unique click)': 'CPuC (por clique único)',
  'CR %': 'CR %',
  'CR%': 'CR%',
  'CRM': 'CRM',
  'CRM response': 'Resposta do CRM',
  'Cadence': 'Periodicidade',
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": "Datas de calendário em que o stream fica ativo (fuso horário do proprietário). Deixe o início ou o fim vazio para manter um lado em aberto. 'Não é' inverte o intervalo.",
  'California, Bavaria, Moscow Oblast': 'Califórnia, Baviera, Oblast de Moscou',
  'Campaign activated': 'Campanha ativada',
  'Campaign archived': 'Campanha arquivada',
  'Campaign cloned successfully!': 'Campanha clonada com sucesso!',
  'Campaign comparison': 'Comparação de campanhas',
  'Campaign created': 'Campanha criada',
  'Campaign dashboard': 'Painel da campanha',
  'Campaign restored': 'Campanha restaurada',
  'Cannot delete: network is linked to offers': 'Não é possível excluir: a rede está vinculada a ofertas',
  'Canonical status stored on each conversion. Auto-generated from the name if left blank.': 'Status canônico armazenado em cada conversão. Gerado automaticamente a partir do nome se deixado em branco.',
  'Cap': 'Cap',
  'Cap timezone': 'Fuso horário do cap',
  'Card view': 'Visualização em cartões',
  'Catalog': 'Catálogo',
  'Change campaign settings, target URL, status.': 'Alterar configurações da campanha, URL de destino, status.',
  'Change member role': 'Alterar função do membro',
  'Change plan, update payment method.': 'Alterar plano, atualizar forma de pagamento.',
  'Change workspace currency, timezone, branding.': 'Alterar moeda, fuso horário e branding do workspace.',
  'Chicago (UTC-6)': 'Chicago (UTC-6)',
  'Choose a ZIP file': 'Escolha um arquivo ZIP',
  'Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).': 'Escolha um preset e, opcionalmente, estenda-o com códigos de país ISO-3166 adicionais (separados por vírgula, ex.: BR, MX, AR).',
  'Choose entry point': 'Escolher ponto de entrada',
  'Clear': 'Limpar',
  'Click API (server-to-server)': 'API de cliques (server-to-server)',
  'Click ID forward parameter': 'Parâmetro de encaminhamento do click ID',
  'Click a row to drill in': 'Clique em uma linha para detalhar',
  'Click detail': 'Detalhes do clique',
  'Click to activate': 'Clique para ativar',
  'Click to pause': 'Clique para pausar',
  'Clicks log': 'Log de cliques',
  'Clicks per 24h': 'Cliques por 24h',
  'Clicks per hour': 'Cliques por hora',
  'Clipboard unavailable — copy the URL manually': 'Área de transferência indisponível — copie a URL manualmente',
  'Cloak rate': 'Taxa de cloaking',
  'Cloaked': 'Com cloaking',
  'Cloaked (iframe)': 'Com cloaking (iframe)',
  'Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.': 'O iframe com cloaking mantém o domínio do tracker na barra de endereço — só funciona com destinos que permitem exibição em iframe.',
  'Cloaked only': 'Somente com cloaking',
  'Cloaked → safe page': 'Com cloaking → página segura',
  'Cloaking': 'Cloaking',
  'Cloaking — send bots to a safe page': 'Cloaking — envie bots para uma página segura',
  'Clone': 'Clonar',
  'Close navigation': 'Fechar navegação',
  'Closed from search engines — click to open': 'Fechado para mecanismos de busca — clique para abrir',
  'Code (slug)': 'Código (slug)',
  'Cohort': 'Coorte',
  'Cohort retention': 'Retenção por coorte',
  'Collapse': 'Recolher',
  'Column key in reports. Auto-generated from the name if left blank.': 'Chave da coluna nos relatórios. Gerada automaticamente a partir do nome se deixada em branco.',
  'Columns': 'Colunas',
  'Comma-separated email addresses.': 'Endereços de e-mail separados por vírgula.',
  'Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.': 'Lista de IPs autorizados a enviar postbacks, separados por vírgula. Deixe vazio para permitir todos.',
  'Compare': 'Comparar',
  'Compare current to proposed weights. Apply persists the proposed column to the streams.': 'Compare os pesos atuais com os propostos. Aplicar grava a coluna proposta nos streams.',
  'Comparing…': 'Comparando…',
  'Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).': 'Compensa o custo do tráfego perdido entre a fonte e o tracker: custo real = base / (1 − perda%/100).',
  'Compliance': 'Conformidade',
  'Configure': 'Configurar',
  'Configure UTM templates and conversion postbacks for every ad network you run.': 'Configure templates de UTM e postbacks de conversão para cada rede de anúncios que você usa.',
  'Configure any partner CRM lead API': 'Configure a API de leads de qualquer CRM parceiro',
  'Configure offers, payouts and target geos. Upload ZIPs or link external networks.': 'Configure ofertas, payouts e geos-alvo. Envie ZIPs ou vincule redes externas.',
  'Configure postbacks, replay / discard CAPI DLQ entries.': 'Configurar postbacks, reprocessar / descartar entradas da DLQ do CAPI.',
  'Configure stream': 'Configurar stream',
  'Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.': 'Configure o banner de cookies GDPR / CCPA exibido nas páginas de destino do seu tracker. O banner é sensível à região — visitantes fora das regiões configuradas nunca o veem.',
  'Confirm action': 'Confirmar ação',
  'Connect / disconnect ad accounts and webhooks.': 'Conectar / desconectar contas de anúncios e webhooks.',
  'Connect external services and webhooks': 'Conecte serviços externos e webhooks',
  'Connect external services and webhooks to automate workflows.': 'Conecte serviços externos e webhooks para automatizar fluxos de trabalho.',
  'Connection restored': 'Conexão restaurada',
  'Connection types': 'Tipos de conexão',
  'Connections': 'Conexões',
  'Consent banner': 'Banner de consentimento',
  'Consent banner saved': 'Banner de consentimento salvo',
  'Conv': 'Conv',
  'Conv.': 'Conv.',
  'Conversion date': 'Data da conversão',
  'Conversion forwarders that fire for this campaign': 'Forwarders de conversão que disparam para esta campanha',
  'Conversion rate comparison': 'Comparação de taxa de conversão',
  'Conversion statuses': 'Status de conversão',
  'Conversion tags (one per line)': 'Tags de conversão (uma por linha)',
  'Conversion type created': 'Tipo de conversão criado',
  'Conversion type deleted': 'Tipo de conversão excluído',
  'Conversion type updated': 'Tipo de conversão atualizado',
  'Conversion types': 'Tipos de conversão',
  'Cookie (default)': 'Cookie (padrão)',
  'Cookieless mode (skip xpnsr_vid first-party cookie)': 'Modo sem cookies (ignora o cookie primário xpnsr_vid)',
  'Copied to clipboard.': 'Copiado para a área de transferência.',
  'Copy blacklist': 'Copiar blacklist',
  'Copy failed': 'Falha ao copiar',
  'Copy link (/r/)': 'Copiar link (/r/)',
  'Copy link (/{alias}/)': 'Copiar link (/{alias}/)',
  'Copy list': 'Copiar lista',
  'Copy whitelist': 'Copiar whitelist',
  'Cost': 'Custo',
  'Cost entries': 'Lançamentos de custo',
  'Cost entry added': 'Lançamento de custo adicionado',
  'Cost entry deleted': 'Lançamento de custo excluído',
  'Cost value': 'Valor do custo',
  'Could not accept invitation': 'Não foi possível aceitar o convite',
  'Could not copy — please copy the link manually.': 'Não foi possível copiar — copie o link manualmente.',
  'Could not create public link': 'Não foi possível criar o link público',
  'Could not load branding': 'Não foi possível carregar o branding',
  'Could not load marketplace templates.': 'Não foi possível carregar os templates do marketplace.',
  'Could not load template detail.': 'Não foi possível carregar os detalhes do template.',
  'Could not load the shared dashboard.': 'Não foi possível carregar o painel compartilhado.',
  'Could not reset branding': 'Não foi possível redefinir o branding',
  'Could not save branding': 'Não foi possível salvar o branding',
  'Count conversions of this type toward the offer daily cap.': 'Contar conversões deste tipo no cap diário da oferta.',
  'Country (ISO-2)': 'País (ISO-2)',
  'Counts against offer cap': 'Conta no cap da oferta',
  'Counts in conversions': 'Conta nas conversões',
  'Counts in revenue': 'Conta na receita',
  'Counts vs cap': 'Contagem vs cap',
  'Create / revoke API keys.': 'Criar / revogar chaves de API.',
  'Create / update / delete automation rules.': 'Criar / atualizar / excluir regras de automação.',
  'Create / update / delete fraud filters and IP lists.': 'Criar / atualizar / excluir filtros antifraude e listas de IP.',
  'Create a campaign first': 'Crie uma campanha primeiro',
  'Create affiliate network': 'Criar rede de afiliados',
  'Create all': 'Criar todos',
  'Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.': 'Crie uma instância EC2 na AWS (Ubuntu, com as portas 80 e 443 abertas), conecte-se a ela via SSH e cole este comando inteiro. Ele exibe o IP do novo servidor no final.',
  'Create campaigns': 'Criar campanhas',
  'Create conversion type': 'Criar tipo de conversão',
  'Create custom metric': 'Criar métrica personalizada',
  'Create key': 'Criar chave',
  'Create landing page': 'Criar página de destino',
  'Create link': 'Criar link',
  'Create metric': 'Criar métrica',
  'Create network': 'Criar rede',
  'Create new landing page': 'Criar nova página de destino',
  'Create new offer': 'Criar nova oferta',
  'Create offer': 'Criar oferta',
  'Create one from a preset like TrackBox or Adcombo.': 'Crie uma a partir de um preset como TrackBox ou Adcombo.',
  'Create one like uCR = conversions / unique_clicks * 100.': 'Crie uma como uCR = conversions / unique_clicks * 100.',
  'Create one to export campaign performance on demand.': 'Crie uma para exportar o desempenho das campanhas sob demanda.',
  'Create one to map partner statuses like FTD or second deposit.': 'Crie um para mapear status de parceiros como FTD ou segundo depósito.',
  'Create one to receive recurring reports by email.': 'Crie um para receber relatórios recorrentes por e-mail.',
  'Create pool': 'Criar pool',
  'Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.': 'Crie regras para pausar, retomar ou ajustar campanhas automaticamente com base em limites de desempenho.',
  'Create streams to split traffic by geo, device, OS, or custom conditions.': 'Crie streams para dividir o tráfego por geo, dispositivo, SO ou condições personalizadas.',
  'Create type': 'Criar tipo',
  'Create, edit, and delete offers.': 'Criar, editar e excluir ofertas.',
  'Creating…': 'Criando…',
  'Custom bot IPs/CIDRs and UA signatures for the bot-detection filter': 'IPs/CIDRs de bots e assinaturas de UA personalizados para o filtro de detecção de bots',
  'Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.': 'IPs/CIDRs de bots e assinaturas de User-Agent personalizados usados pelo filtro antifraude de detecção de bots.',
  'Custom conversion types: map network statuses, reporting flags and transition rules': 'Tipos de conversão personalizados: mapeie status das redes, flags de relatório e regras de transição',
  'Custom domain': 'Domínio personalizado',
  'Custom metric created': 'Métrica personalizada criada',
  'Custom metric deleted': 'Métrica personalizada excluída',
  'Custom metric updated': 'Métrica personalizada atualizada',
  'Custom metrics': 'Métricas personalizadas',
  'Custom range': 'Período personalizado',
  'Customise the dashboard for your agency or sub-account': 'Personalize o painel para sua agência ou subconta',
  'DSAR erasure completed': 'Exclusão de dados DSAR concluída',
  'DSAR export ready': 'Exportação DSAR pronta',
  'Daily': 'Diário',
  'Daily cap': 'Limite diário',
  'Dashboard hostname': 'Hostname do painel',
  'Data subject': 'Titular dos dados',
  'Data-subject access (Article 15) and erasure (Article 17) by identifier.': 'Acesso do titular dos dados (Artigo 15) e apagamento (Artigo 17) por identificador.',
  'Data-subject export (Art. 15) and erasure (Art. 17) by identifier': 'Exportação (Art. 15) e apagamento (Art. 17) de dados do titular por identificador',
  'Datacenter / Tor IPs': 'IPs de datacenter / Tor',
  'Date': 'Data',
  'Date range': 'Intervalo de datas',
  'Day': 'Dia',
  'Day of month (1-31)': 'Dia do mês (1-31)',
  'Day of week': 'Dia da semana',
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Dias da semana e horários em que o stream está ativo. O horário segue o fuso horário do proprietário da campanha. 'Não é' inverte a programação: o stream aceita cliques EXCETO nos horários listados.",
  'Decimals': 'Casas decimais',
  'Decision': 'Decisão',
  'Default offer URL': 'URL padrão da oferta',
  'Defense': 'Defesa',
  'Define a reusable report and its grouping/metrics.': 'Defina um relatório reutilizável e seu agrupamento/métricas.',
  'Define custom conversion types, map network statuses and control reporting semantics.': 'Defina tipos de conversão personalizados, mapeie status das redes e controle a semântica dos relatórios.',
  'Define formula-based report columns over base metrics (CR, EPC, ROI variants).': 'Defina colunas de relatório baseadas em fórmula sobre métricas base (variantes de CR, EPC, ROI).',
  'Delete A/B test': 'Excluir teste A/B',
  'Delete API key': 'Excluir chave de API',
  'Delete affiliate network': 'Excluir rede de afiliados',
  'Delete automation rule': 'Excluir regra de automação',
  'Delete campaign': 'Excluir campanha',
  'Delete campaigns': 'Excluir campanhas',
  'Delete connection': 'Excluir conexão',
  'Delete conversion type': 'Excluir tipo de conversão',
  'Delete cost entry': 'Excluir lançamento de custo',
  'Delete custom metric': 'Excluir métrica personalizada',
  'Delete domain': 'Excluir domínio',
  'Delete domain pool': 'Excluir pool de domínios',
  'Delete failed.': 'Falha ao excluir.',
  'Delete file': 'Excluir arquivo',
  'Delete forwarder': 'Excluir encaminhador',
  'Delete integration': 'Excluir integração',
  'Delete landing page': 'Excluir página de destino',
  'Delete offer': 'Excluir oferta',
  'Delete pre-landing': 'Excluir pre-landing',
  'Delete report': 'Excluir relatório',
  'Delete schedule': 'Excluir agendamento',
  'Delete stream': 'Excluir stream',
  'Delete this file?': 'Excluir este arquivo?',
  'Delete traffic source': 'Excluir fonte de tráfego',
  'Delete view': 'Excluir visualização',
  'Delete webhook': 'Excluir webhook',
  'Delete {n} selected campaign(s)? This cannot be undone.': 'Excluir {n} campanha(s) selecionada(s)? Esta ação não pode ser desfeita.',
  'Denver (UTC-7)': 'Denver (UTC-7)',
  'Deselect all': 'Desmarcar tudo',
  'Desktop, Mobile, Tablet': 'Desktop, Mobile, Tablet',
  'Destination': 'Destino',
  'Device': 'Dispositivo',
  'Disable 2FA': 'Desativar 2FA',
  'Disable 2FA — enter a current code': 'Desativar 2FA — insira um código atual',
  'Disable auto-refresh': 'Desativar atualização automática',
  'Disable failed': 'Falha ao desativar',
  'Disabled': 'Desativado',
  'Discard DLQ entry': 'Descartar entrada da DLQ',
  'Discard unsaved changes?': 'Descartar alterações não salvas?',
  'Dismissed': 'Dispensado',
  'Distribution': 'Distribuição',
  'Do not block by classification': 'Não bloquear por classificação',
  'Do nothing': 'Não fazer nada',
  'Documentation': 'Documentação',
  'Domain marked healthy': 'Domínio marcado como saudável',
  'Domain not verified yet — check the DNS record.': 'Domínio ainda não verificado — verifique o registro DNS.',
  'Domain pool created': 'Pool de domínios criado',
  'Domain pool deleted': 'Pool de domínios excluído',
  'Domain pools': 'Pools de domínios',
  'Domain pulled from rotation': 'Domínio retirado da rotação',
  'Domain registered. Add the DNS record, then verify.': 'Domínio registrado. Adicione o registro DNS e depois verifique.',
  "Don't filter": 'Não filtrar',
  'Done': 'Concluído',
  'Double meta (hide referrer)': 'Meta duplo (ocultar referrer)',
  'Download CSV / JSON report exports.': 'Baixar exportações de relatórios em CSV / JSON.',
  'Drill-down by sub1–sub15: clicks, conversions, CR': 'Detalhamento por sub1–sub15: cliques, conversões, CR',
  'Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.': 'Simule cliques nesta campanha para testar a lógica do fluxo e os filtros — nenhum tráfego real é registrado.',
  'Dubai (UTC+4)': 'Dubai (UTC+4)',
  'EPC': 'EPC',
  'EPC (sensitive)': 'EPC (sensível)',
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.": 'Cada linha corresponde aos visitantes de primeira vez de um dia. As colunas acompanham a taxa de conversão acumulada por defasagem de dias.',
  'Earnings per click': 'Ganhos por clique',
  'Edge server updated': 'Servidor edge atualizado',
  'Edit HTML, CSS, JS and other text files inside the uploaded archive': 'Edite HTML, CSS, JS e outros arquivos de texto dentro do arquivo compactado enviado',
  'Edit affiliate network': 'Editar rede de afiliados',
  'Edit anti-fraud filters': 'Editar filtros antifraude',
  'Edit automation rules': 'Editar regras de automação',
  'Edit campaigns': 'Editar campanhas',
  'Edit conversion type': 'Editar tipo de conversão',
  'Edit custom metric': 'Editar métrica personalizada',
  'Edit files': 'Editar arquivos',
  'Edit integrations': 'Editar integrações',
  'Edit landings': 'Editar landings',
  'Edit offers': 'Editar ofertas',
  'Edit permission matrix': 'Editar matriz de permissões',
  'Edit postbacks': 'Editar postbacks',
  'Edit pre-landing': 'Editar pre-landing',
  'Edit tracking domains': 'Editar domínios de rastreamento',
  'Edit workspace settings': 'Editar configurações do workspace',
  'Empty referrer': 'Referrer vazio',
  'Enable 2FA': 'Ativar 2FA',
  'Enabled': 'Ativado',
  'Enter a code from the app to confirm': 'Insira um código do aplicativo para confirmar',
  'Enter a hostname': 'Insira um hostname',
  'Enter a valid amount': 'Insira um valor válido',
  'Enter a valid http(s) Safe page URL for cloaking': 'Insira uma URL http(s) válida de Safe page para cloaking',
  'Enter an offer URL': 'Insira a URL da oferta',
  'Enter at least one identifier': 'Insira pelo menos um identificador',
  'Enter bot token and chat id': 'Insira o token do bot e o chat id',
  'Enter the 6-digit code from your authenticator app, or one of your backup codes.': 'Insira o código de 6 dígitos do seu aplicativo autenticador ou um dos seus códigos de backup.',
  'Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.': 'Insira o token do bot e o chat_id — serão adicionados postbacks de Lead e Depósito com uma mensagem pronta (Campanha, Sub1..4, Fonte, Payout). Depois, pressione Salvar.',
  'Enter the text to find': 'Insira o texto a localizar',
  'Epsilon (ε)': 'Épsilon (ε)',
  'Equalize weights': 'Igualar pesos',
  'Erase': 'Apagar',
  'Erase data': 'Apagar dados',
  'Erase subject data?': 'Apagar dados do titular?',
  'Erased': 'Apagado',
  'Erasure is a hard delete and cannot be undone. It requires an admin role.': 'O apagamento é uma exclusão definitiva e não pode ser desfeito. Exige função de administrador.',
  'Error archiving campaign': 'Erro ao arquivar campanha',
  'Error cloning campaign': 'Erro ao clonar campanha',
  'Error creating affiliate network': 'Erro ao criar rede de afiliados',
  'Error creating conversion type': 'Erro ao criar tipo de conversão',
  'Error creating cost entry': 'Erro ao criar lançamento de custo',
  'Error creating custom metric': 'Erro ao criar métrica personalizada',
  'Error creating report': 'Erro ao criar relatório',
  'Error creating schedule': 'Erro ao criar agendamento',
  'Error deleting affiliate network': 'Erro ao excluir rede de afiliados',
  'Error deleting conversion type': 'Erro ao excluir tipo de conversão',
  'Error deleting cost entry': 'Erro ao excluir lançamento de custo',
  'Error deleting custom metric': 'Erro ao excluir métrica personalizada',
  'Error deleting file': 'Erro ao excluir arquivo',
  'Error deleting report': 'Erro ao excluir relatório',
  'Error deleting schedule': 'Erro ao excluir agendamento',
  'Error loading affiliate networks': 'Erro ao carregar redes de afiliados',
  'Error loading bot lists': 'Erro ao carregar listas de bots',
  'Error loading conversion types': 'Erro ao carregar tipos de conversão',
  'Error loading cost entries': 'Erro ao carregar lançamentos de custo',
  'Error loading custom metrics': 'Erro ao carregar métricas personalizadas',
  'Error loading file': 'Erro ao carregar arquivo',
  'Error loading files': 'Erro ao carregar arquivos',
  'Error loading reports': 'Erro ao carregar relatórios',
  'Error loading scheduled reports': 'Erro ao carregar relatórios agendados',
  'Error saving bot lists': 'Erro ao salvar listas de bots',
  'Error saving file': 'Erro ao salvar arquivo',
  'Error updating affiliate network': 'Erro ao atualizar rede de afiliados',
  'Error updating conversion type': 'Erro ao atualizar tipo de conversão',
  'Error updating custom metric': 'Erro ao atualizar métrica personalizada',
  'Error uploading file': 'Erro ao enviar arquivo',
  'Every day': 'Todos os dias',
  'Every day, all day': 'Todos os dias, o dia todo',
  'Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.': 'Todo lead capturado pelas suas ofertas de formulário chega aqui — aceitos, rejeitados e de teste. Filtre, exporte para CSV e revenda. Os status são atualizados por postbacks e pela sincronização pull.',
  'Every submitted lead is stored here: filter, export (CSV) and resell': 'Todo lead enviado fica armazenado aqui: filtre, exporte (CSV) e revenda',
  'Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.': 'IPs exatos, blocos CIDR (10.0.0.0/8) ou máscaras (192.168.*). Útil para adicionar seus próprios IPs de teste à lista de permissões ou bloquear uma faixa de datacenter.',
  'Exclude bots': 'Excluir bots',
  'Exclude proxy': 'Excluir proxy',
  'Expand': 'Expandir',
  'Expires': 'Expira',
  'Expires after (days)': 'Expira após (dias)',
  'Export JSON': 'Exportar JSON',
  'Export XLSX': 'Exportar XLSX',
  'Export data': 'Exportar dados',
  'Export flows': 'Exportar fluxos',
  'Export reports': 'Exportar relatórios',
  'Exported': 'Exportado',
  'Extra countries (ISO-3166 alpha-2)': 'Países adicionais (ISO-3166 alpha-2)',
  'FTD · Deposit (sale)': 'FTD · Depósito (venda)',
  'Failed to accept invite': 'Falha ao aceitar convite',
  'Failed to apply optimization': 'Falha ao aplicar otimização',
  'Failed to clone stream': 'Falha ao clonar stream',
  'Failed to compare': 'Falha ao comparar',
  'Failed to copy tracking link': 'Falha ao copiar link de rastreamento',
  'Failed to create campaign': 'Falha ao criar campanha',
  'Failed to create pool': 'Falha ao criar pool',
  'Failed to delete key': 'Falha ao excluir chave',
  'Failed to equalize weights': 'Falha ao igualar pesos',
  'Failed to erase DSAR': 'Falha ao apagar DSAR',
  'Failed to export DSAR': 'Falha ao exportar DSAR',
  'Failed to export flows': 'Falha ao exportar fluxos',
  'Failed to export list': 'Falha ao exportar lista',
  'Failed to export report': 'Falha ao exportar relatório',
  'Failed to import flows': 'Falha ao importar fluxos',
  'Failed to insert flow': 'Falha ao inserir fluxo',
  'Failed to load': 'Falha ao carregar',
  'Failed to load campaigns': 'Falha ao carregar campanhas',
  'Failed to load clicks log': 'Falha ao carregar log de cliques',
  'Failed to load consent config': 'Falha ao carregar configuração de consentimento',
  'Failed to load conversions': 'Falha ao carregar conversões',
  'Failed to load leads': 'Falha ao carregar leads',
  'Failed to load pre-landings': 'Falha ao carregar pre-landings',
  'Failed to load profile': 'Falha ao carregar perfil',
  'Failed to load sub-ID report': 'Falha ao carregar relatório de sub-ID',
  'Failed to preview optimization': 'Falha ao pré-visualizar otimização',
  'Failed to register domain': 'Falha ao registrar domínio',
  'Failed to remove': 'Falha ao remover',
  'Failed to replace URLs': 'Falha ao substituir URLs',
  'Failed to revoke access': 'Falha ao revogar acesso',
  'Failed to run report': 'Falha ao executar relatório',
  'Failed to save': 'Falha ao salvar',
  'Failed to update': 'Falha ao atualizar',
  'Failed to update campaign': 'Falha ao atualizar campanha',
  'Failed to update list': 'Falha ao atualizar lista',
  'Failed to update schedule': 'Falha ao atualizar agendamento',
  'Failed to update status': 'Falha ao atualizar status',
  'Fallback offer': 'Oferta de fallback',
  'Fallback robots.txt/sitemap.xml off': 'Fallback de robots.txt/sitemap.xml desativado',
  'Fallback robots.txt/sitemap.xml on (only when your bundle has none)': 'Fallback de robots.txt/sitemap.xml ativado (apenas quando seu pacote não contém nenhum)',
  'Fallback robots/sitemap': 'Fallback de robots/sitemap',
  'Favourite': 'Favorito',
  'Favourite flows': 'Fluxos favoritos',
  'Favourites': 'Favoritos',
  'Fetched': 'Obtido',
  'File deleted': 'Arquivo excluído',
  'File editor': 'Editor de arquivos',
  'File saved': 'Arquivo salvo',
  'File uploaded': 'Arquivo enviado',
  'Files': 'Arquivos',
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Filtre por tipo de conexão de rede. 'hosting' (datacenter/nuvem) funciona por padrão; outros valores, como cellular ou wifi, exigem que o proxy edge envie o cabeçalho X-Connection-Type.",
  'Filter junk traffic, block malicious IPs and review suspicious activity in one place.': 'Filtre tráfego lixo, bloqueie IPs maliciosos e analise atividades suspeitas em um só lugar.',
  'Filter relation': 'Relação do filtro',
  'Filter rule': 'Regra de filtro',
  'Find': 'Localizar',
  'Find and replace a substring in flow redirect URLs (never landing/offer URLs).': 'Localize e substitua uma substring nas URLs de redirecionamento de fluxo (nunca em URLs de landing/oferta).',
  'Fire on statuses': 'Disparar nos status',
  'First 25 simulated clicks and how each was routed.': 'Os 25 primeiros cliques simulados e como cada um foi roteado.',
  'Flag clicks that arrive with no User-Agent header.': 'Sinalizar cliques que chegam sem o cabeçalho User-Agent.',
  'Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.': 'Rotação de fluxo. Ativado: streams normais rotacionam por peso e a posição é ignorada. Desativado: os streams são verificados de cima para baixo por posição e o primeiro que corresponder recebe todo o tráfego. Streams Catch sempre interceptam primeiro e nunca rotacionam por peso.',
  'Flow tools': 'Ferramentas de fluxo',
  'Form submit (POST)': 'Envio de formulário (POST)',
  'Format': 'Formato',
  'Formula': 'Fórmula',
  'Formula is required': 'A fórmula é obrigatória',
  'Formula-based report columns over base metrics (CR, EPC, ROI variants)': 'Colunas de relatório baseadas em fórmula sobre métricas base (variantes de CR, EPC, ROI)',
  'Forwarding — S2S postbacks': 'Encaminhamento — postbacks S2S',
  'Friday': 'Sexta-feira',
  'From': 'De',
  'From (ISO-8601)': 'De (ISO-8601)',
  'GDPR / DSAR': 'GDPR / DSAR',
  'GDPR: pseudonymize visitor IPs (hash before storage)': 'GDPR: pseudonimizar IPs de visitantes (hash antes do armazenamento)',
  'Generate a key to call the public REST API.': 'Gere uma chave para chamar a API REST pública.',
  'GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.': 'Nomes de região / estado / oblast do GeoIP (ex.: California, Bavaria). Máscaras, /regex/ e @empty são suportados.',
  'Go back': 'Voltar',
  'Go to Workspace': 'Ir para o Workspace',
  'Group': 'Grupo',
  'Group (optional)': 'Grupo (opcional)',
  'Group by': 'Agrupar por',
  'Group by:': 'Agrupar por:',
  'Group clicks and conversions by any dimension with full metrics.': 'Agrupe cliques e conversões por qualquer dimensão com métricas completas.',
  'Grouped by': 'Agrupado por',
  'Has label': 'Com rótulo',
  'Headless click registration and the JS adapter for landing pages.': 'Registro de cliques headless e o adaptador JS para páginas de destino.',
  'Healthy': 'Saudável',
  'Help': 'Ajuda',
  'Hide xpnsr branding': 'Ocultar a marca xpnsr',
  'Hosted pages and uploads': 'Páginas hospedadas e uploads',
  'Hostname': 'Hostname',
  'Hour': 'Hora',
  'Hour (0-23)': 'Hora (0-23)',
  'How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.': 'Como visitantes recorrentes são identificados para a detecção de cliques únicos: Cookie (padrão), IP, IP+UA ou Parâmetro — identificação por um parâmetro GET (ex.: external_id) para que o mesmo usuário seja reconhecido mesmo com mudanças de IP/cookie.',
  'IP + User-Agent': 'IP + User-Agent',
  'IP addresses': 'Endereços IP',
  'IP of your tracking server': 'IP do seu servidor de rastreamento',
  'IP version': 'Versão de IP',
  'IPs': 'IPs',
  'ISP / carrier': 'ISP / operadora',
  'ISP / provider': 'ISP / provedor',
  'Import flows': 'Importar fluxos',
  'Imported': 'Importado',
  'In conversions': 'Em conversões',
  'In revenue': 'Em receita',
  'Inbound URL copied': 'URL de entrada copiada',
  'Inbound postback URL (paste in the network)': 'URL de postback de entrada (cole na rede)',
  'Include this type in the conversions column.': 'Incluir este tipo na coluna de conversões.',
  'Include this type in the revenue column.': 'Incluir este tipo na coluna de receita.',
  'Index page (SEO, served at the root with 200):': 'Página de índice (SEO, servida na raiz com 200):',
  'Insert': 'Inserir',
  'Install': 'Instalar',
  'Install failed.': 'Falha ao instalar.',
  'Integration': 'Integração',
  'Internal notes': 'Notas internas',
  'Invalid 2FA code': 'Código 2FA inválido',
  'Invalid SSO session': 'Sessão SSO inválida',
  'Invitation accepted!': 'Convite aceito!',
  'Invite members': 'Convidar membros',
  'Invite teammates above to collaborate.': 'Convide colegas de equipe acima para colaborar.',
  'Is': 'É',
  'Is not': 'Não é',
  'JS adapter snippet': 'Snippet do adaptador JS',
  'JS redirect (location.replace)': 'Redirecionamento JS (location.replace)',
  'Key': 'Chave',
  'Key (e.g. price)': 'Chave (ex.: price)',
  'Key metrics over time buckets. Toggle to attribute conversions to their arrival date.': 'Métricas-chave por períodos de tempo. Alterne para atribuir as conversões à data de chegada.',
  'Keyboard shortcuts': 'Atalhos de teclado',
  'Keyboard shortcuts (?)': 'Atalhos de teclado (?)',
  'Keys': 'Chaves',
  'Keyword exclude': 'Exclusão de palavra-chave',
  'Keyword include': 'Inclusão de palavra-chave',
  'Label (operator-only)': 'Rótulo (somente operador)',
  'Label color': 'Cor do rótulo',
  'Landing click': 'Clique na landing',
  'Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.': 'Últimos 200 registros de consentimento neste workspace. Usados como trilha de auditoria para DSAR / consultas de reguladores.',
  'Last run': 'Última execução',
  'Last viewed': 'Última visualização',
  'Layout': 'Layout',
  'Layout & retention': 'Layout e retenção',
  'Lead export failed': 'Falha ao exportar leads',
  'Lead storage': 'Armazenamento de leads',
  'Leads': 'Leads',
  'Leads exported': 'Leads exportados',
  'Leave empty to count every conversion.': 'Deixe vazio para contar todas as conversões.',
  'Leave empty to fire on all campaigns': 'Deixe vazio para disparar em todas as campanhas',
  'Leave the period blank to record spend as of now.': 'Deixe o período em branco para registrar o gasto no momento atual.',
  'Linked forwarders': 'Encaminhadores vinculados',
  'List and open campaigns and their stats.': 'Listar e abrir campanhas e suas estatísticas.',
  'List existing API keys (does not reveal the secret).': 'Listar as chaves de API existentes (não revela o segredo).',
  'Lists': 'Listas',
  'Live': 'Ao vivo',
  'Live KPIs and breakdowns across campaigns, geos, devices.': 'KPIs ao vivo e detalhamentos por campanhas, geos e dispositivos.',
  'Loading documentation...': 'Carregando documentação...',
  'Loading marketplace…': 'Carregando marketplace…',
  'Login page subtitle': 'Subtítulo da página de login',
  'Logo URL': 'URL do logo',
  'London (UTC+0)': 'Londres (UTC+0)',
  'Lookback (days)': 'Lookback (dias)',
  'Los Angeles (UTC-8)': 'Los Angeles (UTC-8)',
  'Macros imported from the source — click Save': 'Macros importadas da fonte — clique em Salvar',
  'Make sure your tracking URLs include {key}=... parameter': 'Certifique-se de que suas URLs de rastreamento incluam o parâmetro {key}=...',
  'Manage API keys': 'Gerenciar chaves de API',
  'Manage TLS fingerprint overrides': 'Gerenciar substituições de fingerprint TLS',
  'Manage profile, preferences, notifications and system configuration.': 'Gerencie perfil, preferências, notificações e configurações do sistema.',
  'Manage your offers and creatives': 'Gerencie suas ofertas e criativos',
  'Manager': 'Gerente',
  'Manual': 'Manual',
  'Manual entry secret': 'Segredo para entrada manual',
  'Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.': 'Registre manualmente gastos de campanha que a sincronização da conta de anúncios não enxerga — taxas fixas, mídia offline, correções.',
  'Manually record campaign spend — flat fees, offline media, corrections': 'Registre manualmente gastos de campanha — taxas fixas, mídia offline, correções',
  'Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.': 'Mapeie os status brutos da rede para os nossos (separados por vírgula). Funciona com qualquer rede e se aplica a todos os postbacks de entrada desta campanha. Parâmetros inline na URL têm prioridade.',
  'Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.': 'Mapeie o status bruto que esta rede envia para um bucket canônico. Aplicado aos postbacks de entrada quando o mapa de status da campanha não corresponde.',
  'Mark all read': 'Marcar todas como lidas',
  'Mark read': 'Marcar como lida',
  'Marked values are reusable as report filters and copyable for ad networks.': 'Os valores marcados podem ser reutilizados como filtros de relatório e copiados para redes de anúncios.',
  'Marketplace': 'Marketplace',
  'Match if referrer/params contain a keyword': 'Corresponde se o referrer/parâmetros contiverem uma palavra-chave',
  'Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.': 'Compara o cabeçalho X-Requested-With para detectar webview / navegador in-app. Correspondência por substring — ex.: com.android atinge webviews Android; @empty atinge cliques sem o cabeçalho.',
  'Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.': 'Compara o mecanismo de busca derivado dos parâmetros se / se_referrer ou do host do referrer — ex.: google, bing, yandex.',
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": 'Compara o nome da organização do ISP / ASN do visitante (da tabela offline de IP-intel). Suporta máscaras, /regex/ e @empty — ex.: AMAZON*, *Comcast*.',
  'Matched': 'Com correspondência',
  'Meta refresh': 'Meta refresh',
  'Metric': 'Métrica',
  'Metrics': 'Métricas',
  'Metrics over time buckets (hour/day/weekday/month) + conversion-date view': 'Métricas por intervalos de tempo (hora/dia/dia da semana/mês) + visão por data de conversão',
  'Min clicks per stream': 'Mín. de cliques por stream',
  'Minimum ROI (%)': 'ROI mínimo (%)',
  'Missing SSO session token': 'Token de sessão SSO ausente',
  'Missing invite token': 'Token de convite ausente',
  'Monday': 'Segunda-feira',
  'Monthly': 'Mensal',
  'Moscow, New York': 'Moscou, Nova York',
  'Moscow, New York, London': 'Moscou, Nova York, Londres',
  'Most clicks': 'Mais cliques',
  'Most revenue': 'Mais receita',
  'Multiple HTML pages detected. Select the main page visitors will land on.': 'Várias páginas HTML detectadas. Selecione a página principal em que os visitantes vão chegar.',
  'Mumbai (UTC+5:30)': 'Mumbai (UTC+5:30)',
  'Must be an https:// URL. Leave blank to fall back to the xpnsr logo.': 'Deve ser uma URL https://. Deixe em branco para usar o logo do xpnsr.',
  'Name A→Z': 'Nome A→Z',
  'Name Z→A': 'Nome Z→A',
  'Name and target URL are required': 'Nome e URL de destino são obrigatórios',
  'Name is required.': 'O nome é obrigatório.',
  'Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.': 'Pares chave/valor nomeados injetados nas URLs de landing/oferta/postback via macro {offer_value:NAME}.',
  'Network (text label)': 'Rede (rótulo de texto)',
  'Network preset…': 'Preset de rede…',
  'Network status (e.g. ftd)': 'Status da rede (ex.: ftd)',
  'Network status values': 'Valores de status da rede',
  'New': 'Novo',
  'New York (UTC-5)': 'Nova York (UTC-5)',
  'New pre-landing': 'Nova pre-landing',
  'New public dashboard link': 'Novo link público de painel',
  'New report': 'Novo relatório',
  'New saved report': 'Novo relatório salvo',
  'New schedule': 'Novo agendamento',
  'New scheduled report': 'Novo relatório agendado',
  'Newest first': 'Mais recentes primeiro',
  'No active streams to optimize.': 'Nenhum stream ativo para otimizar.',
  'No affiliate networks yet': 'Nenhuma rede de afiliados ainda',
  'No clicks match these filters.': 'Nenhum clique corresponde a esses filtros.',
  'No cohort data': 'Sem dados de coorte',
  'No consent records yet.': 'Nenhum registro de consentimento ainda.',
  'No conversions yet': 'Nenhuma conversão ainda',
  'No cost entries yet': 'Nenhum lançamento de custo ainda',
  'No custom conversion types yet': 'Nenhum tipo de conversão personalizado ainda',
  'No custom metrics yet': 'Nenhuma métrica personalizada ainda',
  'No data for this period': 'Sem dados para este período',
  'No data for this period.': 'Sem dados para este período.',
  'No data found for {key}': 'Nenhum dado encontrado para {key}',
  'No data yet.': 'Sem dados ainda.',
  'No description provided.': 'Nenhuma descrição fornecida.',
  'No favourite flows yet. Star a flow to reuse it here.': 'Nenhum fluxo favorito ainda. Marque um fluxo com estrela para reutilizá-lo aqui.',
  'No internet connection': 'Sem conexão com a internet',
  'No label': 'Sem rótulo',
  'No leads yet': 'Nenhum lead ainda',
  'No list entries yet. Use the thumbs buttons on report rows.': 'Nenhuma entrada na lista ainda. Use os botões de polegar nas linhas dos relatórios.',
  'No match': 'Sem correspondência',
  'No notifications yet': 'Nenhuma notificação ainda',
  'No offer values. Add a key like price, then use {offer_value:price} in URLs.': 'Nenhum valor de oferta. Adicione uma chave como price e depois use {offer_value:price} nas URLs.',
  'No partner routes — this is a plain redirect/upload offer.': 'Sem rotas de parceiro — esta é uma oferta simples de redirecionamento/upload.',
  'No performance data yet': 'Nenhum dado de desempenho ainda',
  'No pre-landings yet. Create one to start chaining traffic.': 'Nenhuma pre-landing ainda. Crie uma para começar a encadear o tráfego.',
  'No public links yet. Create one to share read-only stats with advertisers.': 'Nenhum link público ainda. Crie um para compartilhar estatísticas somente leitura com anunciantes.',
  'No recipients set': 'Nenhum destinatário definido',
  'No results.': 'Nenhum resultado.',
  'No saved reports yet': 'Nenhum relatório salvo ainda',
  'No scheduled reports yet': 'Nenhum relatório agendado ainda',
  'No status mappings added': 'Nenhum mapeamento de status adicionado',
  'No status values added': 'Nenhum valor de status adicionado',
  'No templates match these filters.': 'Nenhum template corresponde a esses filtros.',
  'No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.': 'Nenhum limite é necessário. Esta regra dispara quando qualquer oferta usada pela campanha atinge o cap diário e avisa que o tráfego está rotacionando para a oferta de fallback / ofertas restantes. Defina o cap e a oferta de fallback em cada oferta.',
  'No vendors disclosed.': 'Nenhum fornecedor divulgado.',
  'No verified custom domains. Add one in Domains → Settings.': 'Nenhum domínio personalizado verificado. Adicione um em Domínios → Configurações.',
  'No-index': 'No-index',
  'None': 'Nenhum',
  'Normal': 'Normal',
  'Not accepted': 'Não aceito',
  'Not enough data for analysis': 'Dados insuficientes para análise',
  'Note': 'Observação',
  'Notes (optional)': 'Observações (opcional)',
  'Nothing found': 'Nada encontrado',
  'Notification settings': 'Configurações de notificação',
  'Notification settings saved': 'Configurações de notificação salvas',
  'Notify only': 'Apenas notificar',
  'Nutra': 'Nutra',
  'OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.': 'Click Conversions Upload baseado em OAuth — requer token de desenvolvedor, ID do cliente e um refresh token. Use apenas se você precisar de uploads server-side com gclid.',
  'OR (any)': 'OU (qualquer)',
  'OS': 'SO',
  'Offer URL': 'URL da oferta',
  'Offer parameters': 'Parâmetros da oferta',
  'Offer rotation on daily cap': 'Rotação de ofertas no cap diário',
  'Offer values': 'Valores da oferta',
  'Oldest first': 'Mais antigos primeiro',
  'Onboarding complete!': 'Onboarding concluído!',
  'One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).': 'Um IP exato ou bloco CIDR por linha (ex.: 203.0.113.7 ou 10.0.0.0/8).',
  'One moment…': 'Um momento…',
  'One per line: substring, mask (*) or /regex/.': 'Um por linha: substring, máscara (*) ou /regex/.',
  'One value per line (or comma-separated). Each simulated query samples one value from each list.': 'Um valor por linha (ou separados por vírgula). Cada consulta simulada sorteia um valor de cada lista.',
  'Only ZIP files are supported': 'Apenas arquivos ZIP são suportados',
  'Only bots': 'Apenas bots',
  'Only match if referrer contains one of these': 'Só corresponde se o referrer contiver um destes',
  'Only proxy': 'Apenas proxy',
  'Only these conversion statuses are sent to the ad platform. Default: sale.': 'Apenas estes status de conversão são enviados para a plataforma de anúncios. Padrão: sale.',
  'Open Campaigns': 'Abrir Campanhas',
  'Open Domains': 'Abrir Domínios',
  'Open Domains page': 'Abrir página de Domínios',
  'Open command palette': 'Abrir paleta de comandos',
  'Open for search engines — click to close': 'Aberto para mecanismos de busca — clique para fechar',
  'Open in clicks log': 'Abrir no log de cliques',
  'Open landing pages': 'Abrir páginas de destino',
  'Open my tracking link': 'Abrir meu link de rastreamento',
  'Open target URL': 'Abrir URL de destino',
  'Open the analytics dashboard and saved reports.': 'Abra o painel de análises e os relatórios salvos.',
  'Operating systems': 'Sistemas operacionais',
  'Operators host the static page; the tracker just routes clicks here first.': 'Os operadores hospedam a página estática; o tracker apenas roteia os cliques por aqui primeiro.',
  'Optimization': 'Otimização',
  'Optional': 'Opcional',
  'Optional. Datacenter IPs that match these ASNs / labels are not blocked.': 'Opcional. IPs de datacenter que correspondam a esses ASNs / rótulos não são bloqueados.',
  'Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.': 'Chamadas HTTP de saída disparadas sempre que um postback de conversão é recebido. Suporta macros como {click_id}, {payout} e todos os parâmetros de campanha declarados acima.',
  'Outbound postback the tracker calls to notify this network.': 'Postback de saída que o tracker chama para notificar esta rede.',
  'Override the default permission matrix for this workspace.': 'Substitua a matriz de permissões padrão deste workspace.',
  'Overrides': 'Substituições',
  'POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.': 'POST /v1/click com uma chave de API (escopo write). Retorna a decisão de roteamento sem redirecionamento no navegador.',
  'Pages library': 'Biblioteca de páginas',
  'Parameter': 'Parâmetro',
  'Parameter filters': 'Filtros de parâmetro',
  'Parameter name, e.g. external_id': 'Nome do parâmetro, ex.: external_id',
  'Parameter name, e.g. sub1': 'Nome do parâmetro, ex.: sub1',
  'Parameters configured:': 'Parâmetros configurados:',
  'Params': 'Parâmetros',
  'Password changed successfully': 'Senha alterada com sucesso',
  'Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.': 'Cole tags AW-XXX/YYY, uma por linha. Cada uma cria um encaminhador separado.',
  'Paste on a landing page to auto-append the click id and forward the visitor.': 'Cole em uma página de destino para anexar automaticamente o click id e encaminhar o visitante.',
  'Paste the "send_to" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.': 'Cole o valor "send_to" do seu snippet de conversão do Google Ads (ex.: AW-123456789/AbCdEf). Não precisa de OAuth. O tracker o armazena e o dispara via sufixo de URL final ou gtag no redirecionamento.',
  'Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.': 'Cole o IP da Etapa 1 e pressione Salvar. Todos os clientes recebem imediatamente o novo IP para o registro A deles — sem necessidade de reiniciar.',
  'Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.': 'Cole estas URLs na sua rede de afiliados (ex.: TrackBox) para que ela notifique esta campanha sobre as conversões. Passe seu click_id no parâmetro da rede e ele volta para cá.',
  'Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.': 'Cole isto como URL final (Google Ads) ou link de rastreamento (Facebook). Substitua os placeholders {key} por macros reais da rede de anúncios conforme necessário.',
  'Pause campaign': 'Pausar campanha',
  'Payload': 'Payload',
  'Payout': 'Payout',
  'Pending': 'Pendente',
  'Per-query trace': 'Trace por consulta',
  'Performance': 'Desempenho',
  'Performance alert': 'Alerta de desempenho',
  'Performance overview': 'Visão geral de desempenho',
  'Period': 'Período',
  'Period end': 'Fim do período',
  'Period start': 'Início do período',
  'Period:': 'Período:',
  'Permanently discard this dead-letter entry? This cannot be undone.': 'Descartar permanentemente esta entrada da dead-letter? Isso não pode ser desfeito.',
  'Permanently remove a campaign and its history.': 'Remova permanentemente uma campanha e seu histórico.',
  'Pick a preset or configure a partner network from scratch.': 'Escolha um preset ou configure uma rede parceira do zero.',
  'Pick a report, cadence and recipients.': 'Escolha um relatório, a periodicidade e os destinatários.',
  'Pick landing page': 'Escolher página de destino',
  'Pick offer': 'Escolher oferta',
  'Pin JA3 / JA4 hashes per-workspace (overrides the seed list).': 'Fixe hashes JA3 / JA4 por workspace (substitui a lista padrão).',
  'Placeholder': 'Placeholder',
  'Placeholder / default': 'Placeholder / padrão',
  'Plans & usage': 'Planos e uso',
  'Please enter a name for the landing page': 'Informe um nome para a página de destino',
  'Please fill in name and URL': 'Preencha o nome e a URL',
  'Please fill in name and select ZIP file': 'Preencha o nome e selecione um arquivo ZIP',
  'Please select a ZIP file': 'Selecione um arquivo ZIP',
  'Please sign in first, then open the invite link again.': 'Faça login primeiro e depois abra o link de convite novamente.',
  'Please wait…': 'Aguarde…',
  'Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.': 'Aponte este hostname para o tracker via DNS. Os visitantes que o acessarem verão sua marca antes de fazer login.',
  'Pool name': 'Nome do pool',
  'Position': 'Posição',
  'Postback IP whitelist': 'Whitelist de IPs de postback',
  'Postback URL': 'URL de postback',
  'Postback URL copied': 'URL de postback copiada',
  'Postback URL template': 'Template de URL de postback',
  'Postback added from preset': 'Postback adicionado a partir do preset',
  'Postback copied': 'Postback copiado',
  'Postback macro': 'Macro de postback',
  'Pre-Landings': 'Pre-Landings',
  'Pre-landing created': 'Pre-landing criada',
  'Pre-landing deleted': 'Pre-landing excluída',
  'Pre-landing updated': 'Pre-landing atualizada',
  'Pre-landing uploaded': 'Pre-landing enviada',
  'Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.': 'As pre-landings oferecem uma página de entrada mais rápida e mais adequada às políticas antes de enviar os visitantes para a oferta. Você pode adicionar uma a qualquer momento.',
  'Preview': 'Pré-visualizar',
  'Primary colour': 'Cor primária',
  'Privacy policy URL': 'URL da política de privacidade',
  'Products': 'Produtos',
  'Promote / demote existing members.': 'Promova / rebaixe membros existentes.',
  'Proposed': 'Proposto',
  'Proposed drift': 'Desvio proposto',
  'Proposed weights': 'Pesos propostos',
  'Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.': 'Proteja sua conta com um código TOTP de um app autenticador. Códigos de backup permitem fazer login caso você perca o dispositivo.',
  'Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.': 'Forneça pelo menos um identificador. Os cliques e conversões correspondentes em todos os workspaces acessíveis a você serão afetados.',
  'Proxy': 'Proxy',
  'Proxy / VPN': 'Proxy / VPN',
  'Proxy / VPN IPs': 'IPs de proxy / VPN',
  "Public link created — copy it now, it won't be shown again.": 'Link público criado — copie agora, ele não será mostrado novamente.',
  'Public link revoked.': 'Link público revogado.',
  'Public read-only links': 'Links públicos somente leitura',
  'Publish': 'Publicar',
  'Publishing…': 'Publicando…',
  'Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.': 'Puxa status de leads e depósitos do TrackBox (últimos 7 dias) e atualiza os leads armazenados. Defina primeiro a x-api-key de Pull na integração.',
  'Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.': 'Puxa status de leads do OpenAFF pelo número de dias definido na integração e atualiza os leads armazenados. Defina primeiro o token da API de status na integração.',
  'Pull out of rotation': 'Tirar da rotação',
  'Pull path': 'Caminho do pull',
  'Pull sync': 'Sincronização pull',
  'Pull sync (statuses/deposits)': 'Sincronização pull (status/depósitos)',
  'Pull sync done': 'Sincronização pull concluída',
  'Pull type': 'Tipo de pull',
  'Purpose (e.g. Analytics)': 'Finalidade (ex.: Analytics)',
  'Push notifications, webhook URL, alert categories': 'Notificações push, URL de webhook, categorias de alerta',
  'Queries': 'Consultas',
  'Quick start from preset': 'Início rápido a partir de preset',
  'Quick start from template': 'Início rápido a partir de template',
  'Quiz / review / bonus pages that intercept the click before the final landing or offer.': 'Páginas de quiz / review / bônus que interceptam o clique antes da landing final ou da oferta.',
  'ROI': 'ROI',
  'ROI %': 'ROI %',
  'ROI (sensitive)': 'ROI (sensível)',
  'ROI alert': 'Alerta de ROI',
  'Random seed (optional)': 'Seed aleatória (opcional)',
  'Raw status strings partner networks send that should map to this type (case-insensitive).': 'Strings de status bruto que as redes parceiras enviam e que devem ser mapeadas para este tipo (sem diferenciar maiúsculas de minúsculas).',
  'Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.': 'Status brutos a tratar como TRASH (registrados, mas excluídos dos payouts). Ex.: trash, invalid.',
  'Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.': 'Status brutos a tratar como DEPOSIT (tipo de conversão de primeira classe). Ex.: dep, ftd, deposit.',
  'Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.': 'Status brutos a tratar como REGISTRATION (tipo de conversão de primeira classe). Ex.: reg, signup.',
  'Read filter list, blocked samples, audit feed.': 'Ler a lista de filtros, amostras bloqueadas e o feed de auditoria.',
  'Read the rules engine and execution history.': 'Ler o mecanismo de regras e o histórico de execuções.',
  'Read the workspace audit feed.': 'Ler o feed de auditoria do workspace.',
  'Read-only public view — generated by xpnsr-tracker.': 'Visualização pública somente leitura — gerada por xpnsr-tracker.',
  'Read-only — only the workspace owner can edit the matrix': 'Somente leitura — apenas o dono do workspace pode editar a matriz',
  'Real only': 'Apenas reais',
  'Real → offer': 'Real → oferta',
  'Rebalance stream weights based on historical conversion rate using a multi-armed bandit.': 'Rebalanceie os pesos dos streams com base na taxa de conversão histórica usando um multi-armed bandit.',
  'Receiving conversions (incoming postback)': 'Recebimento de conversões (postback de entrada)',
  'Recent decisions': 'Decisões recentes',
  'Recipients': 'Destinatários',
  'Record retention (days)': 'Retenção de registros (dias)',
  'Recurring reports emailed on a daily/weekly/monthly cadence': 'Relatórios recorrentes enviados por e-mail com frequência diária/semanal/mensal',
  'Recurring reports emailed to recipients on a daily/weekly/monthly cadence.': 'Relatórios recorrentes enviados por e-mail aos destinatários com frequência diária/semanal/mensal.',
  'Redirect method': 'Método de redirecionamento',
  'Redirect mode': 'Modo de redirecionamento',
  'Referrer / Keyword filters': 'Filtros de referrer / palavra-chave',
  'Referrer exclude': 'Excluir referrer',
  'Referrer include': 'Incluir referrer',
  'Region preset': 'Preset de região',
  'Region scope': 'Escopo de região',
  'Regions': 'Regiões',
  'Register a custom hostname so your tracking links resolve under your own brand.': 'Registre um hostname personalizado para que seus links de rastreamento resolvam sob a sua própria marca.',
  'Register hostname': 'Registrar hostname',
  'Reject button label': 'Rótulo do botão de rejeitar',
  'Rejected': 'Rejeitado',
  'Remember the current filters, sort and layout under a name for one-click recall.': 'Salve os filtros, a ordenação e o layout atuais com um nome para recuperá-los com um clique.',
  'Remove': 'Remover',
  'Remove members': 'Remover membros',
  'Remove template': 'Remover template',
  'Remove this template? This cannot be undone.': 'Remover este template? Isso não pode ser desfeito.',
  'Removed': 'Removido',
  'Replace': 'Substituir',
  'Replace URL': 'Substituir URL',
  'Replace with': 'Substituir por',
  'Report': 'Relatório',
  'Report deleted': 'Relatório excluído',
  'Report queued': 'Relatório na fila',
  'Report saved': 'Relatório salvo',
  'Report type': 'Tipo de relatório',
  'Request': 'Requisição',
  'Reset branding': 'Redefinir branding',
  'Reset to defaults': 'Restaurar padrões',
  'Resetting…': 'Redefinindo…',
  'Response sample': 'Amostra de resposta',
  'Restore': 'Restaurar',
  'Restore to rotation': 'Restaurar à rotação',
  'Return on investment': 'Retorno sobre o investimento',
  'Reusable partner networks: postback template, offer params and inbound URL.': 'Redes parceiras reutilizáveis: template de postback, parâmetros de oferta e URL de entrada.',
  'Reusable partner networks: postback, offer params, inbound URL': 'Redes parceiras reutilizáveis: postback, parâmetros de oferta, URL de entrada',
  'Reusable report definitions you can export to CSV or XLSX on demand.': 'Definições de relatório reutilizáveis que você pode exportar para CSV ou XLSX sob demanda.',
  'Reusable report definitions, exportable to CSV/XLSX on demand': 'Definições de relatório reutilizáveis, exportáveis para CSV/XLSX sob demanda',
  'Rev.': 'Rec.',
  'RevShare (% of payout)': 'RevShare (% do payout)',
  'Revenue (sensitive)': 'Receita (sensível)',
  'Revenue comparison': 'Comparação de receita',
  'Revoke': 'Revogar',
  "Revoke a teammate's access.": 'Revogue o acesso de um membro da equipe.',
  'Revoke failed': 'Falha ao revogar',
  'Revoke public link': 'Revogar link público',
  'Rolling-window limit over the last 24 hours. Empty = no limit.': 'Limite em janela móvel nas últimas 24 horas. Vazio = sem limite.',
  'Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.': 'Limite em janela móvel: o stream para de aceitar NOVOS cliques após essa quantidade na última hora, e o tráfego passa para o próximo stream. Vazio = sem limite.',
  'Round robin': 'Round robin',
  'Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.': 'Roteie por subparâmetros da URL. Uma regra por linha: name=value1, value2 permite os valores listados; name!=value1, value2 os bloqueia (um parâmetro ausente passa na regra de bloqueio). Uma regra sem valores não adiciona restrição.',
  'Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.': 'Roteie esta oferta para um ou mais parceiros com pesos (split/rotação). Parceiros inativos são ignorados (ex.: até que os termos sejam acordados). O lead segue pelo peso; em caso de rejeição, passa para o próximo parceiro.',
  'Routing': 'Roteamento',
  'Routing record (A record)': 'Registro de roteamento (registro A)',
  'Row-level drill-down into incoming clicks: country, device, stream, and variant.': 'Detalhamento em nível de linha dos cliques recebidos: país, dispositivo, stream e variante.',
  'Run a preview to see proposed weights.': 'Execute uma prévia para ver os pesos propostos.',
  'Run now': 'Executar agora',
  'Run pull sync': 'Executar sincronização pull',
  'Run simulation': 'Executar simulação',
  'Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.': 'Executa uma sincronização com janela móvel de 7 dias. Use isto para verificar a resposta antes de ativar a sincronização pull automática.',
  'SEO crawler split off': 'Split de crawler SEO desativado',
  'SEO crawler split on: verified crawlers index the page, humans go to the funnel': 'Split de crawler SEO ativado: crawlers verificados indexam a página, humanos vão para o funil',
  'SEO split (crawlers → index, humans → funnel)': 'Split SEO (crawlers → índice, humanos → funil)',
  'SSO failed': 'Falha no SSO',
  'SSO is not configured': 'O SSO não está configurado',
  'SSO sign-in failed': 'Falha no login com SSO',
  'Safe page URL': 'URL da página segura',
  'Sample datasets': 'Conjuntos de dados de exemplo',
  'Saturday': 'Sábado',
  'Save branding': 'Salvar branding',
  'Save current view': 'Salvar visualização atual',
  'Save the campaign once to generate the token.': 'Salve a campanha uma vez para gerar o token.',
  'Save view': 'Salvar visualização',
  'Saved reports': 'Relatórios salvos',
  'Saved views': 'Visualizações salvas',
  'Saving...': 'Salvando...',
  'Scan the QR code with your authenticator app': 'Escaneie o QR code com seu aplicativo autenticador',
  'Schedule': 'Agendamento',
  'Schedule created': 'Agendamento criado',
  'Schedule deleted': 'Agendamento excluído',
  'Scheduled reports': 'Relatórios agendados',
  'Search by name, description, or slug. Filter by type or tag.': 'Busque por nome, descrição ou slug. Filtre por tipo ou tag.',
  'Search conversion types': 'Buscar tipos de conversão',
  'Search custom metrics': 'Buscar métricas personalizadas',
  'Search engines': 'Mecanismos de busca',
  'Search networks': 'Buscar redes',
  'Search presets': 'Buscar predefinições',
  'Search sections...': 'Buscar seções...',
  'Search…': 'Buscar…',
  'Secondary colour': 'Cor secundária',
  'See plan, invoices, payment method.': 'Veja plano, faturas e forma de pagamento.',
  'Select a file from the sidebar to edit': 'Selecione um arquivo na barra lateral para editar',
  'Select all': 'Selecionar tudo',
  'Select at least 2 campaigns': 'Selecione pelo menos 2 campanhas',
  'Select campaigns (2–10)': 'Selecione campanhas (2–10)',
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.": 'Cloaking auto-hospedado. Bots, moderadores de redes de anúncios, IPs de datacenter/proxy e crawlers de busca veem a página segura (white page); humanos reais vão para a oferta verdadeira. A classificação usa as verificações próprias do tracker de bot / IP / DNS de crawler — sem serviço de terceiros.',
  'Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.': 'Envie um lead sintético ao CRM e inspecione a resposta. Um email/telefone descartável é usado, a menos que você defina outro abaixo.',
  'Send invite links to new teammates.': 'Envie links de convite para novos membros da equipe.',
  'Send test lead': 'Enviar lead de teste',
  'Sending…': 'Enviando…',
  'Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.': 'Servir um robots.txt / sitemap.xml gerado na raiz do domínio APENAS quando o pacote enviado não tiver nenhum. Seus próprios arquivos de SEO sempre têm prioridade.',
  'Server error': 'Erro no servidor',
  'Set another entry page first': 'Defina outra página de entrada primeiro',
  'Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.': 'Configure um parceiro/CRM aqui uma vez e as ofertas passarão a referenciá-lo. TrackBox / Tigloo é o adaptador pronto; API personalizada serve para qualquer outro CRM. Os leads dos formulários de oferta são enviados ao parceiro selecionado.',
  'Set up rules, notifications and triggered actions for your campaigns.': 'Configure regras, notificações e ações acionadas para suas campanhas.',
  'Set up your tracker': 'Configure seu tracker',
  'Setup failed': 'Falha na configuração',
  'Share a token-gated dashboard URL with advertisers without giving them an account.': 'Compartilhe com anunciantes uma URL de painel protegida por token, sem dar a eles uma conta.',
  'Shareable URL': 'URL compartilhável',
  'Shared dashboard': 'Painel compartilhado',
  'Show 404': 'Mostrar 404',
  'Show shortcuts': 'Mostrar atalhos',
  'Side-by-side metrics for multiple campaigns': 'Métricas lado a lado de várias campanhas',
  'Side-by-side metrics for selected campaigns': 'Métricas lado a lado das campanhas selecionadas',
  'Sign in with Google': 'Entrar com Google',
  'Sign in with Microsoft': 'Entrar com Microsoft',
  'Simulate': 'Simular',
  'Simulating…': 'Simulando…',
  'Simulation failed': 'Falha na simulação',
  'Singapore (UTC+8)': 'Singapura (UTC+8)',
  'Size': 'Tamanho',
  'Skip (use auto-detected)': 'Pular (usar o detectado automaticamente)',
  'Skip for now': 'Pular por enquanto',
  'Skip if referrer contains one of these': 'Ignorar se o referrer contiver um destes',
  'Skip if referrer/params contain a keyword': 'Ignorar se o referrer/parâmetros contiverem uma palavra-chave',
  'Skip this step until you have a campaign — you can finish setup from the Campaigns page.': 'Pule esta etapa até ter uma campanha — você pode concluir a configuração na página Campanhas.',
  'Skipped (below min_clicks_per_stream)': 'Ignorado (abaixo de min_clicks_per_stream)',
  'Smoothed CR': 'CR suavizado',
  'Sort by': 'Ordenar por',
  'Source': 'Fonte',
  'Split testing': 'Teste A/B',
  'Split testing disabled': 'Teste A/B desativado',
  'Split testing enabled': 'Teste A/B ativado',
  'Split traffic across variants to find what converts best.': 'Divida o tráfego entre variantes para descobrir o que converte melhor.',
  'Starred flows from any campaign. Insert a copy into this campaign.': 'Fluxos favoritados de qualquer campanha. Insira uma cópia nesta campanha.',
  'Status mapping': 'Mapeamento de status',
  'Step 1. Provision a new server': 'Etapa 1. Provisione um novo servidor',
  'Step 2. Enter the new IP': 'Etapa 2. Informe o novo IP',
  'Step {step} of {total}': 'Etapa {step} de {total}',
  'Step-by-step guide for every feature': 'Guia passo a passo de cada recurso',
  'Step-by-step user guide for every feature': 'Guia do usuário passo a passo de cada recurso',
  'Sticky (per-visitor)': 'Sticky (por visitante)',
  'Stored form leads: name/email/phone/geo/status, filter + CSV export for resale': 'Leads de formulário armazenados: nome/email/telefone/geo/status, filtro + exportação CSV para revenda',
  'Stream': 'Stream',
  'Stream ID': 'ID do stream',
  'Stream cloned': 'Stream clonado',
  'Stream configured': 'Stream configurado',
  'Streams changed': 'Streams alterados',
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": 'Os streams decidem em qual oferta cada visitante chega. Configure seu stream padrão e você terá um link de rastreamento funcionando.',
  'Sub-ID drill-down': 'Detalhamento por Sub-ID',
  'Sub-ID reports': 'Relatórios de Sub-ID',
  'Submission failed.': 'Falha no envio.',
  'Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.': 'Os envios são publicados automaticamente. O slug deriva do nome; se colidir com um template existente, um sufixo numérico é adicionado.',
  'Submit a template': 'Enviar um template',
  'Submit template': 'Enviar template',
  'Submitted leads from your offer forms will appear here.': 'Os leads enviados pelos formulários das suas ofertas aparecerão aqui.',
  'Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.': 'Substrings, máscaras ou /regex/ comparadas ao User-Agent bruto — ex.: *Chrome/12* abrange Chrome 120+, HeadlessChrome captura navegadores headless.',
  'Sunday': 'Domingo',
  'Switch to dark theme': 'Mudar para o tema escuro',
  'Switch to light theme': 'Mudar para o tema claro',
  'Sydney (UTC+11)': 'Sydney (UTC+11)',
  'Synced': 'Sincronizado',
  'São Paulo (UTC-3)': 'São Paulo (UTC-3)',
  'Table view': 'Visualização em tabela',
  'Tags (comma-separated)': 'Tags (separadas por vírgula)',
  'Tags:': 'Tags:',
  'Telegram postbacks added — press Save to apply': 'Postbacks do Telegram adicionados — pressione Salvar para aplicar',
  'Template': 'Template',
  'Template body copied to clipboard.': 'Corpo do template copiado para a área de transferência.',
  'Template installed. Body shown in detail dialog.': 'Template instalado. O corpo é exibido no diálogo de detalhes.',
  'Template marketplace': 'Marketplace de templates',
  'Template published as {slug}.': 'Template publicado como {slug}.',
  'Template removed.': 'Template removido.',
  'Test integration': 'Testar integração',
  'Test lead accepted': 'Lead de teste aceito',
  'Test lead not accepted': 'Lead de teste não aceito',
  'The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.': 'A página em conformidade exibida a bots/crawlers. Deve ser uma URL http(s) absoluta. No modo SEO, esta é a página que os crawlers de busca verificados indexam.',
  'The page you are looking for does not exist or has been moved.': 'A página que você procura não existe ou foi movida.',
  'The token will only be shown once after creation — copy it immediately.': 'O token será exibido apenas uma vez após a criação — copie-o imediatamente.',
  'Third-party processors disclosed to the visitor (max 50).': 'Processadores de terceiros divulgados ao visitante (máx. 50).',
  'This campaign has no source with parameters': 'Esta campanha não tem fonte com parâmetros',
  'This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.': 'Este link não requer autenticação. Qualquer pessoa com ele pode ver as métricas selecionadas até que expire ou seja revogado.',
  'This member will lose access to this workspace immediately.': 'Este membro perderá o acesso a este workspace imediatamente.',
  'This permanently deletes all matching clicks and conversions. This cannot be undone.': 'Isso exclui permanentemente todos os cliques e conversões correspondentes. Esta ação não pode ser desfeita.',
  'This permanently deletes the conversion type. Existing conversions keep their stored status.': 'Isso exclui permanentemente o tipo de conversão. As conversões existentes mantêm o status armazenado.',
  'This permanently deletes the metric column from reports.': 'Isso exclui permanentemente a coluna da métrica dos relatórios.',
  'This permanently deletes the network. Offers linked to it keep their other settings.': 'Isso exclui permanentemente a rede. As ofertas vinculadas a ela mantêm as demais configurações.',
  'This permanently deletes the saved report definition.': 'Isso exclui permanentemente a definição do relatório salvo.',
  'This permanently deletes the scheduled report.': 'Isso exclui permanentemente o relatório agendado.',
  'This removes the manual cost and reverses its contribution to the campaign spend.': 'Isso remove o custo manual e reverte sua contribuição para o gasto da campanha.',
  'This shared link has expired or been revoked.': 'Este link compartilhado expirou ou foi revogado.',
  'This shared link is not valid.': 'Este link compartilhado não é válido.',
  'This will permanently delete "{name}" and all associated clicks, conversions and postback events. This cannot be undone.': 'Isso excluirá permanentemente "{name}" e todos os cliques, conversões e eventos de postback associados. Esta ação não pode ser desfeita.',
  'This will permanently delete "{name}" and all its variants.': 'Isso excluirá permanentemente "{name}" e todas as suas variantes.',
  'This will permanently delete "{name}" and remove it from all campaigns.': 'Isso excluirá permanentemente "{name}" e o removerá de todas as campanhas.',
  'This will permanently delete "{name}".': 'Isso excluirá permanentemente "{name}".',
  'This will permanently delete "{name}". Campaigns using this domain will fall back to the default domain.': 'Isso excluirá permanentemente "{name}". As campanhas que usam este domínio voltarão a usar o domínio padrão.',
  'This will permanently delete "{name}". Campaigns using this source will lose their tracking parameters.': 'Isso excluirá permanentemente "{name}". As campanhas que usam esta fonte perderão seus parâmetros de rastreamento.',
  'This will permanently delete pool "{name}".': 'Isso excluirá permanentemente o pool "{name}".',
  'This will permanently delete rule "{name}".': 'Isso excluirá permanentemente a regra "{name}".',
  'This will permanently delete stream "{name}".': 'Isso excluirá permanentemente o stream "{name}".',
  'This will permanently delete this ad account connection. Cost syncing will stop.': 'Isso excluirá permanentemente esta conexão de conta de anúncios. A sincronização de custos será interrompida.',
  'This will permanently delete this conversion forwarder.': 'Isso excluirá permanentemente este encaminhador de conversões.',
  'This will permanently delete webhook "{name}". Events will no longer be forwarded.': 'Isso excluirá permanentemente o webhook "{name}". Os eventos não serão mais encaminhados.',
  'This will permanently revoke this API key. Any integrations using it will stop working.': 'Isso revogará permanentemente esta chave de API. Quaisquer integrações que a utilizem deixarão de funcionar.',
  'This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.': 'Isso redefinirá todas as configurações de branding para o padrão. Logo, cores e domínio personalizado serão removidos.',
  'This will reset two-factor authentication for this member. They will need to re-enrol.': 'Isso redefinirá a autenticação de dois fatores deste membro. Ele precisará configurá-la novamente.',
  'Thursday': 'Quinta-feira',
  'Time on landing': 'Tempo na landing',
  'Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.': 'Dica: se você reatribuir o Elastic IP antigo ao novo servidor na AWS, nada precisa mudar aqui — nem para os clientes.',
  'Title': 'Título',
  'Title, body, and button labels shown to the visitor.': 'Título, corpo e rótulos dos botões exibidos ao visitante.',
  'To': 'Até',
  'To (ISO-8601)': 'Até (ISO-8601)',
  'Toggle navigation': 'Alternar navegação',
  'Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).': 'Verificação de token desativada — os postbacks são aceitos pelo click_id sem token (remova &token=… da URL na sua rede).',
  'Tokyo (UTC+9)': 'Tóquio (UTC+9)',
  'Too many requests — please retry in a moment.': 'Muitas requisições — tente novamente em instantes.',
  'Total leads': 'Total de leads',
  'Track click usage and switch plans. Billing renews monthly.': 'Acompanhe o uso de cliques e troque de plano. A cobrança é renovada mensalmente.',
  'TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.': 'Credenciais da conta TrackBox (dashboard → API Testing). Configure uma vez por conta — as ofertas referenciarão este parceiro.',
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.": 'TrackBox: passe seu click_id no parâmetro Affclickid do link da oferta para que {affclickid} retorne a esta campanha. Método GET.',
  'Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.': 'Generic: passe seu click_id no link da oferta para que retorne a esta campanha como {click_id}. Método GET.',
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.": 'Subid: passe seu click_id no parâmetro subid do link da oferta para que {subid} retorne a esta campanha. Método GET.',
  'Tracking domain': 'Domínio de rastreamento',
  'Tracking domains are managed on the Domains page — add and verify a custom domain there.': 'Os domínios de rastreamento são gerenciados na página Domínios — adicione e verifique um domínio personalizado lá.',
  'Tracking link copied to clipboard': 'Link de rastreamento copiado para a área de transferência',
  'Traffic Simulation': 'Simulação de tráfego',
  'Traffic loss %': '% de perda de tráfego',
  'Traffic trends': 'Tendências de tráfego',
  'Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.': 'Regras de transição: para quais status uma conversão deste tipo pode mudar. Deixe tudo desmarcado para permitir qualquer transição.',
  'Treat empty User-Agent as bot': 'Tratar User-Agent vazio como bot',
  'Trends': 'Tendências',
  'Tuesday': 'Terça-feira',
  'Tune the bandit before running a preview. Apply only writes weights to active streams.': 'Ajuste o bandit antes de executar uma prévia. Aplicar grava pesos apenas nos streams ativos.',
  'Two-factor authentication': 'Autenticação de dois fatores',
  'Two-factor code': 'Código de dois fatores',
  'Type': 'Tipo',
  'Type a command or search…': 'Digite um comando ou busque…',
  'US, CA, GB': 'US, CA, GB',
  'US, CA, GB, RU': 'US, CA, GB, RU',
  'US, GB, DE': 'US, GB, DE',
  'US,RU,DE': 'US,RU,DE',
  'Ungrouped': 'Sem grupo',
  'Uniqueness method': 'Método de unicidade',
  'Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.': 'Integração universal para qualquer CRM parceiro. Descreva a requisição da API de registro de leads — o tracker enviará os dados do formulário para lá e redirecionará usando o link da resposta.',
  'Unlimited': 'Ilimitado',
  'Update partner network settings': 'Atualizar configurações da rede parceira',
  'Update reporting semantics and status transitions.': 'Atualize a semântica de relatórios e as transições de status.',
  'Update the formula, format or decimals.': 'Atualize a fórmula, o formato ou as casas decimais.',
  'Upload a ZIP with your warm-up page. index.html is auto-detected.': 'Faça upload de um ZIP com sua página de aquecimento. O index.html é detectado automaticamente.',
  'Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.': 'Faça upload de um pacote de página de destino (.zip) ou escolha um template de pre-landing hospedado da biblioteca.',
  'Upload failed': 'Falha no upload',
  'Upload pre-landing (ZIP)': 'Fazer upload de pre-landing (ZIP)',
  'Upload, edit, and delete landings.': 'Faça upload, edite e exclua landings.',
  'Upload, organize and reuse landing pages across your campaigns.': 'Faça upload, organize e reutilize páginas de destino em suas campanhas.',
  'Uploaded': 'Enviado',
  'Uploading…': 'Fazendo upload…',
  'Use a negative amount to book a correction.': 'Use um valor negativo para lançar uma correção.',
  'User agents': 'User-Agents',
  'Vendor list': 'Lista de fornecedores',
  'Vendor name (e.g. Google Analytics)': 'Nome do fornecedor (ex.: Google Analytics)',
  'Verified search crawlers': 'Crawlers de busca verificados',
  'Verify now': 'Verificar agora',
  'Verifying…': 'Verificando…',
  'Vertical': 'Vertical',
  'View': 'Visualizar',
  'View API keys': 'Ver chaves de API',
  'View anti-fraud': 'Ver antifraude',
  'View audit log': 'Ver log de auditoria',
  'View automation rules': 'Ver regras de automação',
  'View billing': 'Ver faturamento',
  'View campaigns': 'Ver campanhas',
  'View integrations': 'Ver integrações',
  'View landings': 'Ver landings',
  'View name': 'Nome da visualização',
  'View offers': 'Ver ofertas',
  'View postbacks': 'Ver postbacks',
  'View reports': 'Ver relatórios',
  'View saved': 'Ver salvos',
  'View tracking domains': 'Ver domínios de rastreamento',
  'Viewer': 'Visualizador',
  'Views': 'Visualizações',
  'Visible metrics': 'Métricas visíveis',
  'Visitor': 'Visitante',
  'Visitor ID': 'ID do visitante',
  'Visual identity': 'Identidade visual',
  'Wednesday': 'Quarta-feira',
  'Weekly': 'Semanal',
  'Weight floor (%)': 'Peso mínimo (%)',
  'Weighted': 'Ponderado',
  'Weights equalized': 'Pesos igualados',
  'Welcome to ACME Tracker — sign in to continue': 'Bem-vindo ao ACME Tracker — faça login para continuar',
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.": 'Quando ATIVADO, os postbacks recebidos precisam trazer o token desta campanha; caso contrário, são rejeitados (401). DESATIVE se a rede (ex.: TrackBox) envia UM postback compartilhado para todas as campanhas: remova &token=… desta URL e as conversões serão correspondidas pelo click_id.',
  'When disabled, the public widget responds with required:false so landing pages skip rendering entirely.': 'Quando desativado, o widget público responde com required:false e as páginas de destino pulam totalmente a renderização.',
  'When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.': 'Quando ativado, crawlers de busca verificados por DNS recebem a página de índice (para ranqueamento) e humanos são enviados ao funil da campanha vinculada. Requer uma página de índice + uma campanha vinculada a este domínio.',
  'When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.': 'Quando definido, o tracker acrescenta automaticamente ?<param>=<click_id> às URLs de redirecionamento. Deixe vazio para desativar. Use {click_id} na URL de destino para controle total.',
  'White': 'Branco',
  'Whitelist': 'Whitelist',
  'Whitelisted': 'Na whitelist',
  'Workflows': 'Fluxos de trabalho',
  'Workspace default domain': 'Domínio padrão do workspace',
  'X-Requested-With': 'X-Requested-With',
  'You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.': 'Você não tem permissão para ver esta página. Contate o administrador do seu workspace se você acredita que isso é um engano.',
  'Your tracking link': 'Seu link de rastreamento',
  'ZIP file': 'Arquivo ZIP',
  'analyst': 'analista',
  'box/goal id': 'id do box/goal',
  'buy, cheap, discount': 'comprar, barato, desconto',
  'campaign': 'campanha',
  'clear tag': 'limpar tag',
  'clicks': 'cliques',
  'connections': 'conexões',
  'conv.': 'conv.',
  'cpa, nutra, en': 'cpa, nutra, en',
  'day': 'dia',
  'days': 'dias',
  'domains': 'domínios',
  'e.g. 185.45.12.1, 91.108.0.0': 'ex.: 185.45.12.1, 91.108.0.0',
  'e.g. Facebook, Google, Tier 1': 'ex.: Facebook, Google, Tier 1',
  'e.g. MaxBounty CPA': 'ex.: MaxBounty CPA',
  'e.g. Q3 influencer flat fee': 'ex.: Valor fixo de influenciador no Q3',
  'e.g. Second deposit': 'ex.: Segundo depósito',
  'e.g. Tier-1 by revenue': 'ex.: Tier-1 por receita',
  'e.g. Unique CR': 'ex.: CR único',
  'e.g. Weekly digest': 'ex.: Resumo semanal',
  'e.g. Weekly performance': 'ex.: Desempenho semanal',
  'e.g. adcombo, cpa, status': 'ex.: adcombo, cpa, status',
  'email / phone / name': 'email / telefone / nome',
  'fallback': 'fallback',
  'free, demo': 'grátis, demo',
  'group.<key>': 'group.<key>',
  'indexable': 'indexável',
  'installs': 'instalações',
  'last {n} days': 'últimos {n} dias',
  'live': 'ao vivo',
  'logo': 'logo',
  'max change': 'variação máx.',
  'no': 'não',
  'no-index': 'no-index',
  'none': 'nenhum',
  'offer parameter(s)': 'parâmetro(s) da oferta',
  'or continue with': 'ou continue com',
  'own': 'próprio',
  'pages': 'páginas',
  'plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.': 'mais quaisquer campos de formulário e parâmetros da oferta. O campo de redirecionamento é um caminho na resposta JSON (ex.: data.url); se vazio, o primeiro link http(s) encontrado na resposta é usado.',
  'redirect': 'redirecionamento',
  'revoked': 'revogado',
  'rows': 'linhas',
  'sec': 'seg',
  'statuses on schedule': 'status conforme o cronograma',
  'to close': 'para fechar',
  'to navigate': 'para navegar',
  'to select': 'para selecionar',
  'weight units': 'unidades de peso',
  'yes': 'sim',
  '{count} conversions': '{count} conversões',
  '{count} forwarders created': '{count} encaminhadores criados',
  '{key} breakdown': 'Detalhamento por {key}',
  '{n} selected': '{n} selecionados',
  'Δ': 'Δ',
  '— no level —': '— sem nível —',
  '— none (root opens the funnel) —': '— nenhum (a raiz abre o funil) —',
  // A11y icon-button labels
  'Remove variant': 'Remover variante',
  'Start test': 'Iniciar teste',
  'Pause test': 'Pausar teste',
  'View test results': 'Ver resultados do teste',
  'Remove parameter': 'Remover parâmetro',
  'Remove status mapping': 'Remover mapeamento de status',
  'Copy postback URL template': 'Copiar template de URL de postback',
  'Copy inbound postback URL': 'Copiar URL de postback de entrada',
  'Remove IP from blacklist': 'Remover IP da blacklist',
  'Remove IP from whitelist': 'Remover IP da whitelist',
  'Copy curl command': 'Copiar comando curl',
  'Copy JS snippet': 'Copiar snippet JS',
  'Copy snippet': 'Copiar snippet',
  'Remove postback': 'Remover postback',
  'Campaign actions': 'Ações da campanha',
  'Remove vendor': 'Remover fornecedor',
  'Remove campaign': 'Remover campanha',
  'Remove value': 'Remover valor',
  'Remove field': 'Remover campo',
  'Copy webhook URL': 'Copiar URL do webhook',
  'Copy landing page URL': 'Copiar URL da página de destino',
  'Open landing page': 'Abrir página de destino',
  'Remove partner route': 'Remover rota de parceiro',
  'Copy lead-form URL': 'Copiar URL do formulário de leads',
  'Copy offer URL': 'Copiar URL da oferta',
  'Delete list entry': 'Excluir entrada da lista',
  'Copy secret': 'Copiar segredo',
  'Remove time range': 'Remover intervalo de tempo',
  'Remove date range': 'Remover intervalo de datas',
  'Pause stream': 'Pausar stream',
  'Resume stream': 'Retomar stream',
  'Open redirect URL': 'Abrir URL de redirecionamento',
  'Open offer URL': 'Abrir URL da oferta',
  'Copy postback URL': 'Copiar URL de postback',
  'Delete rule': 'Excluir regra',
  'Delete filter': 'Excluir filtro',
  // i18n backfill: pre-existing untranslated keys in screens touched by the a11y pass
  'Delete traffic rule': 'Excluir regra de tráfego',
  'This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.': 'Isso exclui a regra de tráfego permanentemente. O tráfego passará para as regras restantes ou para o padrão da campanha.',
  'Delete fraud filter': 'Excluir filtro antifraude',
  'This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.': 'Isso exclui o filtro antifraude permanentemente. O tráfego que ele atualmente bloqueia ou pontua não será mais avaliado por esta regra.',
  'Action (no page — hand off to the offer)': 'Action (sem página — entrega à oferta)',
  'After click (at redirect)': 'Depois do clique (no redirecionamento)',
  'Before click (at landing — enables offer macros)': 'Antes do clique (na página de destino — habilita macros da oferta)',
  'Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.': 'Corresponde a operadora móvel pelo cabeçalho X-Carrier do edge. Máscaras, /regex/ e @empty são suportados — ex.: Vodafone*, /^T-Mobile/.',
  'Mobile operator / carrier': 'Operadora móvel',
  'Offer selection moment': 'Momento de seleção da oferta',
  'Preload (serve the page from the tracker domain)': 'Preload (servir a página do domínio do tracker)',
  'Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.': 'Preload busca a página no servidor e a serve sob o seu domínio do tracker; Action não mostra nada e deixa o stream escolher uma oferta.',
  'QR code': 'Código QR',
  'Redirect (send visitor to the URL)': 'Redirect (enviar o visitante para a URL)',
  'Remote rotator (fetch target)': 'Rotador remoto (busca o destino)',
  'Scan to open the tracking link on a device.': 'Escaneie para abrir o link de tracking em um dispositivo.',
  'Transparent (server-side fetch)': 'Transparente (busca no servidor)',
  'When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.': 'Quando escolher a oferta para este stream. Depois (padrão): no momento do redirecionamento. Antes: ao servir a landing, para que as macros {offer_name} / {offer_value:*} sejam renderizadas na página de destino.',
  'Added to favourites': 'Adicionado aos favoritos',
  'Credentials and settings for this partner. Fields marked * are required.': 'Credenciais e configurações deste parceiro. Os campos marcados com * são obrigatórios.',
  'Key created': 'Chave criada',
  'Removed from favourites': 'Removido dos favoritos',
  'Affiliate network archived': 'Rede de afiliados arquivada',
  'Archive affiliate network': 'Arquivar rede de afiliados',
  'Archive landing page': 'Arquivar landing',
  'Archive offer': 'Arquivar oferta',
  'Archive stream': 'Arquivar stream',
  'Archive traffic source': 'Arquivar fonte de tráfego',
  'Archived at': 'Arquivado em',
  'Archived items are hidden from your lists. Restore them or delete them permanently.': 'Os itens arquivados ficam ocultos das suas listas. Restaure-os ou exclua-os permanentemente.',
  'Delete permanently': 'Excluir permanentemente',
  'Deleted permanently': 'Excluído permanentemente',
  'Error loading archive': 'Erro ao carregar os itens arquivados',
  'Error restoring': 'Erro ao restaurar',
  'Landing page archived': 'Landing arquivada',
  'No archived items': 'Nenhum item arquivado',
  'Offer archived': 'Oferta arquivada',
  'Restored': 'Restaurado',
  'Stream archived': 'Stream arquivado',
  'This will move "{name}" to the archive. You can restore it or delete it permanently from the Archive page.': 'Isso moverá "{name}" para o arquivo. Você pode restaurá-lo ou excluí-lo permanentemente na página Arquivo.',
  'This will permanently delete "{name}". This action cannot be undone.': 'Isso excluirá permanentemente "{name}". Esta ação não pode ser desfeita.',
  'Traffic source archived': 'Fonte de tráfego arquivada',
  'View archived': 'Ver arquivados',
  // Backfill: post-!99 UI-wiring components (SystemStatus / CampaignMaintenance / TlsFingerprints / S2SLogs, etc.)
  'Start date is required': 'A data de início é obrigatória',
  'Enter a valid cost': 'Insira um custo válido',
  'Updated {n} clicks': '{n} cliques atualizados',
  'Failed to update costs': 'Falha ao atualizar os custos',
  'Statistics deleted': 'Estatísticas excluídas',
  'Failed to delete statistics': 'Falha ao excluir as estatísticas',
  'Maintenance & costs': 'Manutenção e custos',
  'Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.': 'Reescreva retroativamente o custo dos cliques, redefina as estatísticas ou obtenha um link de tracking alternativo.',
  'Update costs': 'Atualizar custos',
  'Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.': '(Re)escreva retroativamente o custo por clique para os cliques em um intervalo de tempo. O modo Total distribui o valor entre os cliques correspondentes; por clique aplica-o a cada um.',
  'Start date': 'Data de início',
  'End date': 'Data de fim',
  'Total (spread across clicks)': 'Total (distribuir entre cliques)',
  'Per click': 'Por clique',
  'Only unique clicks': 'Apenas cliques únicos',
  'Skip bot clicks': 'Ignorar cliques de bots',
  'Clean statistics': 'Limpar estatísticas',
  'Alternative link prefixes': 'Prefixos de link alternativos',
  'Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.': 'Qualquer um destes prefixos de caminho roteia o mesmo tracking id — rotacione-os entre as fontes para escapar das listas de bloqueio.',
  'Delete statistics': 'Excluir estatísticas',
  'This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.': 'Isso exclui permanentemente todos os cliques e conversões desta campanha. A configuração da campanha é mantida. Esta ação não pode ser desfeita.',
  'Error loading S2S log': 'Erro ao carregar o log S2S',
  'S2S postback log': 'Log de postbacks S2S',
  'Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.': 'Cada postback de conversão de saída disparado nas suas campanhas — filtre por campanha, status ou resultado.',
  'Any result': 'Qualquer resultado',
  'Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.': 'Os postbacks de conversão de saída aparecerão aqui assim que suas campanhas começarem a encaminhar conversões.',
  'Result': 'Resultado',
  'HTTP': 'HTTP',
  'Error loading system status': 'Erro ao carregar o estado do sistema',
  'Paste the Tor exit list first': 'Primeiro cole a lista de nós de saída do Tor',
  'Tor exit list updated': 'Lista de nós de saída do Tor atualizada',
  'Failed to update Tor exit list': 'Falha ao atualizar a lista de nós de saída do Tor',
  'Process uptime, database size, data-processing queue and host metrics.': 'Tempo de atividade do processo, tamanho do banco de dados, fila de processamento de dados e métricas do host.',
  'Process': 'Processo',
  'Uptime': 'Tempo de atividade',
  'Started': 'Iniciado',
  'Python': 'Python',
  'Database': 'Banco de dados',
  'Total documents': 'Total de documentos',
  'Data processing': 'Processamento de dados',
  'Analytics backend': 'Backend de análises',
  'Ingest mode': 'Modo de ingestão',
  'Queue depth': 'Profundidade da fila',
  'Click uniqueness': 'Unicidade de cliques',
  'Redis ping': 'Ping do Redis',
  'Host': 'Host',
  'Load average': 'Carga média',
  'Disk used': 'Disco usado',
  'Disk free': 'Disco livre',
  'Cron': 'Cron',
  'Last cost sync': 'Última sincronização de custos',
  'FX rates': 'Taxas de câmbio',
  'No FX rates cached.': 'Nenhuma taxa de câmbio em cache.',
  'Tor exit list': 'Lista de nós de saída do Tor',
  'Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.': 'Cole um dump de nós de saída do Tor separados por quebras de linha (ex. do torbulkexitlist) para atualizar a lista de bloqueio em memória.',
  'Replace list': 'Substituir lista',
  'Error loading fingerprints': 'Erro ao carregar os fingerprints',
  'Fingerprint updated': 'Fingerprint atualizado',
  'Failed to update fingerprint': 'Falha ao atualizar o fingerprint',
  'JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.': 'Substituições de fingerprints JA3 / JA4 — marque um fingerprint como bom ou ruim para orientar a detecção de bots.',
  'All classifications': 'Todas as classificações',
  'All kinds': 'Todos os tipos',
  'No fingerprint overrides yet': 'Ainda não há substituições de fingerprints',
  'As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.': 'Conforme o tráfego chega, os fingerprints JA3/JA4 aparecem aqui para que você possa marcar clientes conhecidos como bons ou ruins.',
  'Fingerprint': 'Fingerprint',
  'Kind': 'Tipo',
  'Label': 'Rótulo',
  'Hits': 'Hits',
  'Last seen': 'Visto pela última vez',
  'Classification': 'Classificação',
  // Platform back-office (operator console)
  'Platform admin': 'Admin da plataforma',
  'Operator': 'Operador',
  'Cross-tenant back-office: accounts, access and platform health.':
    'Back-office da plataforma: contas, acessos e saúde do sistema.',
  'Accounts': 'Contas',
  'New sign-ups': 'Novos cadastros',
  'Last 30 days': 'Últimos 30 dias',
  'Clicks (24h)': 'Cliques (24h)',
  'Clicks (30d)': 'Cliques (30d)',
  'Conversions (30d)': 'Conversões (30d)',
  'Platform state': 'Estado da plataforma',
  'Self-signup': 'Autocadastro',
  'Open': 'Aberto',
  'Closed': 'Fechado',
  'Controlled by the DISABLE_REGISTRATION variable on Railway.':
    'Controlado pela variável DISABLE_REGISTRATION no Railway.',
  'Root admins': 'Admins root',
  'From PLATFORM_ADMIN_EMAILS — manage the list on Railway.':
    'De PLATFORM_ADMIN_EMAILS — a lista é gerenciada no Railway.',
  'Granted admins': 'Admins concedidos',
  'Every registered account. Block access or grant platform admin.':
    'Todas as contas registradas. Bloqueie o acesso ou conceda admin da plataforma.',
  'Search by email or name…': 'Buscar por email ou nome…',
  'Plan': 'Plano',
  'Last click': 'Último clique',
  'No accounts found': 'Nenhuma conta encontrada',
  'Root admin': 'Admin root',
  'Client': 'Cliente',
  'Managed on Railway': 'Gerenciado no Railway',
  'Grant platform admin': 'Conceder admin da plataforma',
  'Grant platform admin?': 'Conceder admin da plataforma?',
  'Make admin': 'Tornar admin',
  'Revoke platform admin': 'Revogar admin da plataforma',
  'Revoke platform admin?': 'Revogar admin da plataforma?',
  'Revoke admin': 'Revogar admin',
  'Block account': 'Bloquear conta',
  'Block this account?': 'Bloquear esta conta?',
  'The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.':
    'O usuário perde o acesso imediatamente — todas as sessões são rejeitadas até você desbloqueá-lo. As campanhas e links de tracking continuam recebendo tráfego.',
  'Reason (optional)': 'Motivo (opcional)',
  'Visible to admins only': 'Visível apenas para admins',
  'Unblock': 'Desbloquear',
  'Unblock account': 'Desbloquear conta',
  'Unblock this account?': 'Desbloquear esta conta?',
  'The user will be able to sign in again immediately.':
    'O usuário poderá entrar novamente de imediato.',
  'This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.':
    'Este usuário recebe acesso de operador: o back-office da plataforma, todas as contas e as configurações. A concessão fica no log de auditoria.',
  'The user keeps their account but loses operator access.':
    'O usuário mantém a conta, mas perde o acesso de operador.',
  'Account blocked': 'Conta bloqueada',
  'Account unblocked': 'Conta desbloqueada',
  'Platform admin granted': 'Admin da plataforma concedido',
  'Platform admin revoked': 'Admin da plataforma revogado',
  'Failed to load platform overview': 'Falha ao carregar o resumo da plataforma',
  'Failed to load users': 'Falha ao carregar os usuários',
  '{count} accounts': '{count} contas',
  'Page {page} of {total}': 'Página {page} de {total}',
  'Apply': 'Aplicar',
  'Change plan': 'Alterar plano',
  'Plan updated': 'Plano atualizado',
  'Sets the edition directly (status "active", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.':
    'Define a edição diretamente (status «active», sem trial) — para contas manuais ou de cortesia. Contas com assinatura ativa no Stripe mudam de plano pelo Stripe.',
  'Account deleted': 'Conta excluída',
  'Delete account': 'Excluir conta',
  'Delete this account permanently?': 'Excluir esta conta permanentemente?',
  'This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.':
    'A conta e TODOS os seus dados serão apagados — campanhas, cliques, conversões, ofertas, landings, domínios, relatórios. Não é possível desfazer.',
  // Signup email verification
  'We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.':
    'Enviamos um link de confirmação para {email}. Abra-o para ativar sua conta — o link vale por 24 horas.',
  "Check your spam folder if it doesn't arrive within a minute.":
    'Se não chegar em um minuto, verifique a pasta de spam.',
  'Resend the email': 'Reenviar o e-mail',
  'Sent — check your inbox': 'Enviado — verifique sua caixa de entrada',
  'Could not resend the email — try again.': 'Não foi possível reenviar o e-mail — tente novamente.',
  'Back to sign in': 'Voltar ao login',
  'Confirming your email…': 'Confirmando seu e-mail…',
  'This takes a second.': 'Isso leva um segundo.',
  'Email confirmed — welcome aboard!': 'E-mail confirmado — bem-vindo a bordo!',
  'Taking you to your dashboard…': 'Levando você ao seu painel…',
  'Verification failed — the link may have expired.':
    'Falha na verificação — o link pode ter expirado.',
  'The verification link is incomplete — open the link from the email again.':
    'O link de verificação está incompleto — abra novamente o link do e-mail.',
  // Settings, Ops, platform admin, white pages, campaign params (completed 2026-10-11)
  "Inbound postback URL template": "Modelo de URL de postback de entrada",
  "Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.": "URL de entrada que a rede de afiliados chama ao informar um lead, uma venda, uma rejeição ou outro status. Copie-a no painel do parceiro; o XPNSR não chama essa URL como postback de saída da campanha.",
  "Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.": "Configuração de entrada do parceiro: parâmetros de click ID da oferta, mapeamento de status e a URL de postback para colar no painel do parceiro. Não envia leads para um CRM nem é encaminhamento S2S da campanha.",
  "Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.": "Escolha um modelo de postback de entrada ou configure o acordo com o parceiro do zero. Para enviar leads do formulário a um CRM, crie uma Integração e vincule-a à oferta.",
  "Use 8–128 characters; long passphrases are recommended": "Use de 8 a 128 caracteres; frases-senha longas são recomendadas",
  "Users": "Usuários",
  "This source postback is already added": "Este postback da fonte já foi adicionado",
  "Source postback added — check its placeholders (REPLACE, XXXX…) and press Save": "Postback da fonte adicionado — confira os marcadores (REPLACE, XXXX…) e clique em Salvar",
  "Google Ads deposit postback added + click-time gtag kept off — press Save to apply": "Postback de depósito do Google Ads adicionado e gtag no clique mantido desligado — clique em Salvar para aplicar",
  "Parameters have unsaved changes — clicks keep using the saved set until you save.": "Os parâmetros têm alterações não salvas — os cliques continuam usando o conjunto salvo até você salvar.",
  "The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.": "Nome do parâmetro no link de rastreamento: apenas letras, dígitos e _ (sem espaços). Espaços são convertidos em _ para que o link nunca mostre %20.",
  "Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.": "Valor escrito no link de rastreamento para esta chave: uma macro da rede de anúncios como {campaignid} ou um valor fixo como MCLV. Um valor fixo também é salvo nos cliques que chegam sem a chave; uma macro entre chaves não. Deixe vazio para chaves que o anúncio define por conta, como tm e tml.",
  "Sub slot": "Slot sub",
  "Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.": "Opcional: o valor também é salvo como sub1…sub30 ou em um campo nomeado (external_id, creative_id…). Mapeie a mesma coisa para o mesmo slot em todas as campanhas (ex.: team -> sub8) e uma coluna do relatório e a macro {sub_id_8} cobrem todos os compradores; external_id alimenta {external_id} no postback da fonte.",
  "Macro: filled by the ad network, not stored on clicks without this key": "Macro: preenchida pela rede de anúncios; não é salva em cliques sem esta chave",
  "Google Ads conversion keys": "Chaves de conversão do Google Ads",
  "= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.": "= rótulo de envio de formulário de lead — defina esta conversão como Principal. É disparada pelo navegador do visitante após um lead bem-sucedido.",
  "= Purchase / deposit label — set this conversion as Secondary. Sent by the \"Deposit → Purchase\" S2S rule; do not add an S2S rule for lead.": "= rótulo de compra / depósito — defina esta conversão como Secundária. É enviada pela regra S2S \"Depósito → Compra\"; não adicione regra S2S para lead.",
  "Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.": "Coloque as duas no sufixo de URL final de cada conta do Google Ads (tml=AW-…/lead-label&tm=AW-…/purchase-label) e deixe o valor padrão vazio aqui.",
  "Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.": "As chaves diferenciam maiúsculas e minúsculas. Qualquer chave (a, b, s, c…) é salva no clique, funciona como macro {key} e pode ser escolhida como agrupamento em Relatórios e relatórios Sub-ID, ao lado de sub1…sub30. Mapeie-a para um slot sub para alinhá-la entre campanhas.",
  "Use lowercase keys — the tracker does not read:": "Use chaves em minúsculas — o tracker não lê:",
  "The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.": "O link de rastreamento pronto para copiar desta campanha. Troque o domínio por qualquer domínio verificado do workspace para usar vários domínios em uma campanha; a rede de anúncios preenche os marcadores no momento do clique.",
  "Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.": "Chaves sem valor padrão (tm, tml, a…) ficam fora do link: passe-as no anúncio, ex.: no sufixo de URL final do Google Ads.",
  "Fire Google Ads gtag on redirect (click-time conversion)": "Disparar gtag do Google Ads no redirecionamento (conversão no clique)",
  "Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.": "Conversão legada no clique: dispara em /r/ antes de qualquer cadastro ou depósito. Mantenha desativada para otimizar por leads/depósitos. Leads reais são enviados automaticamente pelas landings hospedadas após uma resposta bem-sucedida de /api/lead.",
  "Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.": "Mantenha DESLIGADO para otimizar por conversões reais. Leads disparam online pela landing hospedada somente após /api/lead ter sucesso; depósitos podem ser encaminhados abaixo por S2S no postback de venda do broker. Ativar faz o Google otimizar por cliques e pode duplicar conversões.",
  "Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.": "Segredo que autentica os postbacks de entrada desta campanha. Cole-o como &token=… nas URLs de postback que você passa à rede. Mantenha-o privado; quem o tiver pode registrar conversões.",
  "Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.": "Traduz os status enviados por uma rede para as nossas categorias. Prioridade: parâmetro na URL > mapa desta campanha > modelo da rede de afiliados > tipos personalizados > padrões internos.",
  "Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.": "Chamadas de saída que avisam outro sistema (sua fonte de tráfego, outro tracker, Telegram) quando chega uma conversão. Para CAPI de plataformas de anúncios (Facebook/Google/TikTok) use Encaminhadores de conversão — dados pessoais com hash e novas tentativas.",
  "Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.": "Somente saída: estas chamadas HTTP avisam outro sistema depois que o XPNSR registra uma conversão. Modelos de redes de afiliados e URLs de entrada ficam na página Redes de afiliados e devem ser colados no painel do parceiro — não são regras de encaminhamento.",
  "Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.": "Venda também dispara para depósitos (ftd, dep, deposit) e Lead para cadastros (reg, signup), seja qual for o nome usado pelo broker.",
  "Source postback": "Postback da fonte",
  "Google Ads conversions": "Conversões do Google Ads",
  "Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.": "Adiciona apenas o postback S2S de depósito/Compra. Dispara no postback de venda do broker e associa o clique do Google por {gclid}. O ID da conta e o rótulo de depósito vêm da tag {tm} por clique (AW-<account>/<deposit-label>) no sufixo de URL final do anúncio.",
  "Deposit → Purchase (with payout value) — fires on sale": "Depósito → Compra (com valor do pagamento) — dispara na venda",
  "Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.": "O S2S de lead não é adicionado de propósito: a landing hospedada já envia a conversão Lead online via gtag no navegador depois que o CRM aceita /api/lead. Uma regra S2S de lead poderia contar o mesmo lead duas vezes.",
  "Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use \"Import from source\" to add them to a campaign.": "Os parâmetros de rastreamento (campaignid, adgroupid, keyword, tm, tml, sub1–3) são declarados uma vez na fonte de tráfego Google Ads — use \"Importar da fonte\" para adicioná-los a uma campanha.",
  "For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep \"Fire Google Ads gtag on redirect\" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.": "Para leads online, passe tml=AW-<account>/<lead-label> no sufixo de URL final de cada conta de anúncios. Mantenha DESLIGADO \"Disparar gtag do Google Ads no redirecionamento\": o tracker insere um gtag de lead separado nas landings hospedadas e o dispara somente após um envio de lead bem-sucedido. Configure Lead como Principal ao dar lances por leads; mantenha Compra como secundária até verificar os depósitos e depois ajuste as metas à sua estratégia de lances.",
  "White pages (hosted, same-origin)": "White pages (hospedadas, mesma origem)",
  "selected — rotated per request": "selecionadas — rotacionadas a cada requisição",
  "No white pages yet. Upload some under White pages, then pick them here.": "Ainda não há white pages. Envie-as em White pages e escolha-as aqui.",
  "Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.": "Opcional — a opção mais robusta para Google/Facebook: servida pelo domínio da sua campanha (/wp/…), então a URL final fica no domínio. Selecione várias para rotacionar uma aleatória a cada requisição, assim a mesma white não é reutilizada em centenas de anúncios. Gerencie em White pages.",
  "Safe page URL (external)": "URL da página segura (externa)",
  "External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.": "Página segura externa — o tracker a serve como proxy na mesma origem (tags de identidade removidas). Usada quando nenhuma white page está selecionada. Deve ser uma URL http(s) absoluta. Este método já passa sozinho pela revisão do Google; uma white page hospedada é apenas uma alternativa ainda mais robusta servida totalmente no seu domínio.",
  "UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.": "Bots detectados pelo User-Agent e os que fingem ser um rastreador de busca (verificação de DNS falhou) recebem a página segura.",
  "DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.": "Rastreadores de busca verificados por DNS (Googlebot/Bingbot/…) recebem a página segura. Desative para deixá-los indexar a oferta real.",
  "Visitors from datacenter or Tor-exit IPs get the safe page.": "Visitantes com IP de datacenter ou de saída Tor recebem a página segura.",
  "Visitors behind a proxy/VPN get the safe page.": "Visitantes atrás de proxy/VPN recebem a página segura.",
  "Select a white page or enter a valid http(s) Safe page URL for cloaking": "Escolha uma white page ou informe uma URL http(s) válida de página segura para o cloaking",
  "Error": "Erro",
  "Failed to load documentation.": "Não foi possível carregar a documentação.",
  "Topic ID (optional)": "ID do tópico (opcional)",
  "Chat ID is required": "O Chat ID é obrigatório",
  "Test message delivered": "Mensagem de teste entregue",
  "Send failed": "Falha no envio",
  "Backup started — the result will arrive in the monitoring topic.": "Backup iniciado — o resultado chegará no tópico de monitoramento.",
  "Production readiness": "Prontidão para produção",
  "Ready": "Pronto",
  "Attention required": "Atenção necessária",
  "Secret-free checks for runtime configuration and isolation controls.": "Verificações de configuração e isolamento sem expor segredos.",
  "Environment": "Ambiente",
  "production": "produção",
  "development": "desenvolvimento",
  "Rate limiter": "Limitador de requisições",
  "Access token TTL": "Validade do token de acesso",
  "Backend root": "Backend como root",
  "Blocking checks": "Verificações bloqueantes",
  "Telegram alerts": "Alertas do Telegram",
  "Configured": "Configurado",
  "Not configured": "Não configurado",
  "Deploy + server-error notifications for the operator.": "Avisos de deploy e erros do servidor para o operador.",
  "Topic": "Tópico",
  "Leave the token empty to keep the saved one.": "Deixe o token vazio para manter o salvo.",
  "Save & send test": "Salvar e enviar teste",
  "Nightly DB backups": "Backups noturnos do banco de dados",
  "A full copy of the database every night, kept on the persistent volume.": "Uma cópia completa do banco de dados toda noite, guardada no volume persistente.",
  "Daily at": "Diariamente às",
  "Copies kept": "Cópias mantidas",
  "Stored": "Armazenado",
  "Latest": "Mais recente",
  "No backups yet": "Ainda não há backups",
  "Run backup now": "Fazer backup agora",
  "Failed to load integrity status": "Não foi possível carregar o status de integridade",
  "Traffic suspended": "Tráfego suspenso",
  "Traffic resumed": "Tráfego retomado",
  "Data integrity": "Integridade dos dados",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Índices únicos obrigatórios protegem a atribuição de cliques, as conversões e a idempotência do faturamento.",
  "All mandatory indexes are present and unique.": "Todos os índices obrigatórios existem e são únicos.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "Não ignore este aviso. Revise os logs de inicialização do backend antes de alterar índices.",
  "Missing": "Ausente",
  "Not unique": "Não único",
  "Resume campaign traffic": "Retomar o tráfego das campanhas",
  "Resume traffic": "Retomar tráfego",
  "Suspend campaign traffic": "Suspender o tráfego das campanhas",
  "Suspend traffic": "Suspender tráfego",
  "Suspend all campaign traffic for this account?": "Suspender todo o tráfego das campanhas desta conta?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "Os links de rastreamento públicos retornarão a resposta de campanha inativa. As configurações das campanhas não mudam e o tráfego pode ser retomado na hora.",
  "Resume campaign traffic for this account?": "Retomar o tráfego das campanhas desta conta?",
  "Existing active campaigns and tracking links will start serving again.": "As campanhas ativas e os links de rastreamento voltarão a funcionar.",
  "Password changed — other devices have been signed out": "Senha alterada — os outros dispositivos foram desconectados",
  "Sign out of every device, including this one? You will need to sign in again.": "Sair de todos os dispositivos, incluindo este? Você precisará entrar novamente.",
  "All sessions signed out": "Todas as sessões foram encerradas",
  "Error signing out sessions": "Erro ao encerrar as sessões",
  "Changing your password also signs out every other device.": "Alterar a senha também desconecta todos os outros dispositivos.",
  "Active sessions": "Sessões ativas",
  "Lost a laptop, or think someone else has your password? End every session at once.": "Perdeu um notebook ou acha que alguém tem sua senha? Encerre todas as sessões de uma vez.",
  "This signs out every device, including this one. Signing back in takes one password.": "Isso desconecta todos os dispositivos, incluindo este. Para entrar de novo basta a senha.",
  "Sign out everywhere": "Sair de todos os lugares",
  "Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign": "Detalhe cliques e conversões por sub1–sub30 ou por qualquer parâmetro declarado em uma campanha",
  "Error loading white pages": "Erro ao carregar as white pages",
  "Please enter a name for the white page": "Informe um nome para a white page",
  "White page uploaded successfully": "White page enviada com sucesso",
  "Error uploading white page": "Erro ao enviar a white page",
  "White page deleted": "White page excluída",
  "Error deleting white page": "Erro ao excluir a white page",
  "White pages": "White pages",
  "Static pages for bots & ad review": "Páginas estáticas para bots e revisão de anúncios",
  "Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.": "Páginas estáticas em conformidade servidas a bots e revisores de anúncios — na mesma origem, no domínio da sua campanha.",
  "Upload white page": "Enviar white page",
  "Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.": "Envie um ZIP estático (index.html + recursos). PHP não é permitido. Máx. 50 MB.",
  "My white page": "Minha white page",
  "What this white page is for": "Para que serve esta white page",
  "Static files only (.html/.css/.js/images). No .php.": "Somente arquivos estáticos (.html/.css/.js/imagens). Sem .php.",
  "These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.": "Estas páginas ficam hospedadas aqui e são servidas na mesma origem em /wp/<slug>/ em qualquer um dos seus domínios verificados. Escolha uma nas configurações de Cloaking de uma campanha — bots e revisores do Google/Facebook veem esta página, usuários reais veem a oferta.",
  "Search white pages…": "Buscar white pages…",
  "No white pages": "Nenhuma white page",
  "Upload a static white page to use for campaign cloaking": "Envie uma white page estática para usar no cloaking das campanhas",
  "Same-origin path": "Caminho na mesma origem",
  "Pages": "Páginas",
  "Copy path": "Copiar caminho",
  "Delete white page": "Excluir white page",
  "This permanently deletes \"{name}\" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).": "Isso exclui permanentemente \"{name}\" e seus arquivos. Campanhas que ainda apontam para ela passarão a usar a URL da página segura (ou a oferta, se não houver).",
  "Multiple HTML pages detected. Select the main page bots will land on.": "Várias páginas HTML detectadas. Escolha a página principal em que os bots vão chegar.",
};

//: Locale registry — keys are the codes the picker writes to localStorage,
//: values are the per-locale translation maps. Keep this aligned with
//: ``LOCALE_LABELS`` below.
const TRANSLATION_MAPS = {
  ru: { ...CONVERSION_IMPORT.ru, ...TLS_TOOLS.ru, ...EDIT_DIALOGS.ru, ...SAVED_REPORT_VIEW.ru, ...POOL_LINKS.ru, ...PLAN_LIMITS.ru, ...AUTOMATION_HISTORY.ru, ...CLICK_WARNINGS.ru, ...BUNDLE_ACTIONS.ru, ...OFFER_FORM.ru, ...STREAM_FORM.ru, ...CAMPAIGN_FORM.ru, ...MENU_GROUPS.ru, ...PER_EVENT_POSTBACKS.ru, ...AI_OPTIMIZER_SAFE.ru, ...PROTECTION_WARNINGS.ru, ...SETTINGS_PLACES.ru, ...CONVERSION_STATUSES.ru, ...METRIC_NAMES.ru, ...QUICK_SETUP.ru, ...ERROR_TEXTS.ru, ...CLICK_ISSUES.ru, ...PRESET_HINTS.ru, ...DOWNGRADE_IMPACT.ru, ...NOTIFICATION_CHANNELS.ru, ...TRIAL_BANNER.ru, ...LIVE_TRACE_AUTO.ru, ...DOMAIN_CHECK.ru, ...POSTBACK_JOURNAL.ru, ...CONVERSION_CHECK.ru, ...FIRST_DAY.ru, ...TRIAL_FUNNEL.ru, ...ru, ...BILLING_FLOW.ru, ...WORKSPACE_EXTRA.ru, ...SELF_HOSTED.ru, ...SELF_HOSTED_GUIDE.ru, ...UX_EXTRA.ru, ...INSTANCE_LICENCE.ru, ...DESIGN_EXTRA.ru, ...ERROR_REPORTS.ru, ...CLOAKING_TOOLS.ru, ...INTEGRATION_CATALOGUE.ru, ...BILLING_STOP.ru },
  es: { ...CONVERSION_IMPORT.es, ...TLS_TOOLS.es, ...EDIT_DIALOGS.es, ...SAVED_REPORT_VIEW.es, ...POOL_LINKS.es, ...PLAN_LIMITS.es, ...AUTOMATION_HISTORY.es, ...CLICK_WARNINGS.es, ...BUNDLE_ACTIONS.es, ...OFFER_FORM.es, ...STREAM_FORM.es, ...CAMPAIGN_FORM.es, ...MENU_GROUPS.es, ...PER_EVENT_POSTBACKS.es, ...AI_OPTIMIZER_SAFE.es, ...PROTECTION_WARNINGS.es, ...SETTINGS_PLACES.es, ...CONVERSION_STATUSES.es, ...METRIC_NAMES.es, ...QUICK_SETUP.es, ...ERROR_TEXTS.es, ...CLICK_ISSUES.es, ...PRESET_HINTS.es, ...DOWNGRADE_IMPACT.es, ...NOTIFICATION_CHANNELS.es, ...TRIAL_BANNER.es, ...LIVE_TRACE_AUTO.es, ...DOMAIN_CHECK.es, ...POSTBACK_JOURNAL.es, ...CONVERSION_CHECK.es, ...FIRST_DAY.es, ...TRIAL_FUNNEL.es, ...es, ...BILLING_FLOW.es, ...WORKSPACE_EXTRA.es, ...SELF_HOSTED.es, ...SELF_HOSTED_GUIDE.es, ...UX_EXTRA.es, ...INSTANCE_LICENCE.es, ...DESIGN_EXTRA.es, ...ERROR_REPORTS.es, ...CLOAKING_TOOLS.es, ...INTEGRATION_CATALOGUE.es, ...BILLING_STOP.es },
  pt: { ...CONVERSION_IMPORT.pt, ...TLS_TOOLS.pt, ...EDIT_DIALOGS.pt, ...SAVED_REPORT_VIEW.pt, ...POOL_LINKS.pt, ...PLAN_LIMITS.pt, ...AUTOMATION_HISTORY.pt, ...CLICK_WARNINGS.pt, ...BUNDLE_ACTIONS.pt, ...OFFER_FORM.pt, ...STREAM_FORM.pt, ...CAMPAIGN_FORM.pt, ...MENU_GROUPS.pt, ...PER_EVENT_POSTBACKS.pt, ...AI_OPTIMIZER_SAFE.pt, ...PROTECTION_WARNINGS.pt, ...SETTINGS_PLACES.pt, ...CONVERSION_STATUSES.pt, ...METRIC_NAMES.pt, ...QUICK_SETUP.pt, ...ERROR_TEXTS.pt, ...CLICK_ISSUES.pt, ...PRESET_HINTS.pt, ...DOWNGRADE_IMPACT.pt, ...NOTIFICATION_CHANNELS.pt, ...TRIAL_BANNER.pt, ...LIVE_TRACE_AUTO.pt, ...DOMAIN_CHECK.pt, ...POSTBACK_JOURNAL.pt, ...CONVERSION_CHECK.pt, ...FIRST_DAY.pt, ...TRIAL_FUNNEL.pt, ...pt, ...BILLING_FLOW.pt, ...WORKSPACE_EXTRA.pt, ...SELF_HOSTED.pt, ...SELF_HOSTED_GUIDE.pt, ...UX_EXTRA.pt, ...INSTANCE_LICENCE.pt, ...DESIGN_EXTRA.pt, ...ERROR_REPORTS.pt, ...CLOAKING_TOOLS.pt, ...INTEGRATION_CATALOGUE.pt, ...BILLING_STOP.pt },
  // One file per language in ./locales (keys are the English source).
  de: { ...CONVERSION_IMPORT.de, ...TLS_TOOLS.de, ...EDIT_DIALOGS.de, ...SAVED_REPORT_VIEW.de, ...POOL_LINKS.de, ...PLAN_LIMITS.de, ...AUTOMATION_HISTORY.de, ...CLICK_WARNINGS.de, ...BUNDLE_ACTIONS.de, ...OFFER_FORM.de, ...STREAM_FORM.de, ...CAMPAIGN_FORM.de, ...MENU_GROUPS.de, ...PER_EVENT_POSTBACKS.de, ...AI_OPTIMIZER_SAFE.de, ...PROTECTION_WARNINGS.de, ...SETTINGS_PLACES.de, ...CONVERSION_STATUSES.de, ...METRIC_NAMES.de, ...QUICK_SETUP.de, ...ERROR_TEXTS.de, ...CLICK_ISSUES.de, ...PRESET_HINTS.de, ...DOWNGRADE_IMPACT.de, ...NOTIFICATION_CHANNELS.de, ...TRIAL_BANNER.de, ...LIVE_TRACE_AUTO.de, ...DOMAIN_CHECK.de, ...POSTBACK_JOURNAL.de, ...CONVERSION_CHECK.de, ...FIRST_DAY.de, ...TRIAL_FUNNEL.de, ...DE, ...INTEGRATION_CATALOGUE.de, ...BILLING_STOP.de },
  fr: { ...CONVERSION_IMPORT.fr, ...TLS_TOOLS.fr, ...EDIT_DIALOGS.fr, ...SAVED_REPORT_VIEW.fr, ...POOL_LINKS.fr, ...PLAN_LIMITS.fr, ...AUTOMATION_HISTORY.fr, ...CLICK_WARNINGS.fr, ...BUNDLE_ACTIONS.fr, ...OFFER_FORM.fr, ...STREAM_FORM.fr, ...CAMPAIGN_FORM.fr, ...MENU_GROUPS.fr, ...PER_EVENT_POSTBACKS.fr, ...AI_OPTIMIZER_SAFE.fr, ...PROTECTION_WARNINGS.fr, ...SETTINGS_PLACES.fr, ...CONVERSION_STATUSES.fr, ...METRIC_NAMES.fr, ...QUICK_SETUP.fr, ...ERROR_TEXTS.fr, ...CLICK_ISSUES.fr, ...PRESET_HINTS.fr, ...DOWNGRADE_IMPACT.fr, ...NOTIFICATION_CHANNELS.fr, ...TRIAL_BANNER.fr, ...LIVE_TRACE_AUTO.fr, ...DOMAIN_CHECK.fr, ...POSTBACK_JOURNAL.fr, ...CONVERSION_CHECK.fr, ...FIRST_DAY.fr, ...TRIAL_FUNNEL.fr, ...FR, ...INTEGRATION_CATALOGUE.fr, ...BILLING_STOP.fr },
  it: { ...CONVERSION_IMPORT.it, ...TLS_TOOLS.it, ...EDIT_DIALOGS.it, ...SAVED_REPORT_VIEW.it, ...POOL_LINKS.it, ...PLAN_LIMITS.it, ...AUTOMATION_HISTORY.it, ...CLICK_WARNINGS.it, ...BUNDLE_ACTIONS.it, ...OFFER_FORM.it, ...STREAM_FORM.it, ...CAMPAIGN_FORM.it, ...MENU_GROUPS.it, ...PER_EVENT_POSTBACKS.it, ...AI_OPTIMIZER_SAFE.it, ...PROTECTION_WARNINGS.it, ...SETTINGS_PLACES.it, ...CONVERSION_STATUSES.it, ...METRIC_NAMES.it, ...QUICK_SETUP.it, ...ERROR_TEXTS.it, ...CLICK_ISSUES.it, ...PRESET_HINTS.it, ...DOWNGRADE_IMPACT.it, ...NOTIFICATION_CHANNELS.it, ...TRIAL_BANNER.it, ...LIVE_TRACE_AUTO.it, ...DOMAIN_CHECK.it, ...POSTBACK_JOURNAL.it, ...CONVERSION_CHECK.it, ...FIRST_DAY.it, ...TRIAL_FUNNEL.it, ...IT, ...INTEGRATION_CATALOGUE.it, ...BILLING_STOP.it },
  pl: { ...CONVERSION_IMPORT.pl, ...TLS_TOOLS.pl, ...EDIT_DIALOGS.pl, ...SAVED_REPORT_VIEW.pl, ...POOL_LINKS.pl, ...PLAN_LIMITS.pl, ...AUTOMATION_HISTORY.pl, ...CLICK_WARNINGS.pl, ...BUNDLE_ACTIONS.pl, ...OFFER_FORM.pl, ...STREAM_FORM.pl, ...CAMPAIGN_FORM.pl, ...MENU_GROUPS.pl, ...PER_EVENT_POSTBACKS.pl, ...AI_OPTIMIZER_SAFE.pl, ...PROTECTION_WARNINGS.pl, ...SETTINGS_PLACES.pl, ...CONVERSION_STATUSES.pl, ...METRIC_NAMES.pl, ...QUICK_SETUP.pl, ...ERROR_TEXTS.pl, ...CLICK_ISSUES.pl, ...PRESET_HINTS.pl, ...DOWNGRADE_IMPACT.pl, ...NOTIFICATION_CHANNELS.pl, ...TRIAL_BANNER.pl, ...LIVE_TRACE_AUTO.pl, ...DOMAIN_CHECK.pl, ...POSTBACK_JOURNAL.pl, ...CONVERSION_CHECK.pl, ...FIRST_DAY.pl, ...TRIAL_FUNNEL.pl, ...PL, ...INTEGRATION_CATALOGUE.pl, ...BILLING_STOP.pl },
  tr: { ...CONVERSION_IMPORT.tr, ...TLS_TOOLS.tr, ...EDIT_DIALOGS.tr, ...SAVED_REPORT_VIEW.tr, ...POOL_LINKS.tr, ...PLAN_LIMITS.tr, ...AUTOMATION_HISTORY.tr, ...CLICK_WARNINGS.tr, ...BUNDLE_ACTIONS.tr, ...OFFER_FORM.tr, ...STREAM_FORM.tr, ...CAMPAIGN_FORM.tr, ...MENU_GROUPS.tr, ...PER_EVENT_POSTBACKS.tr, ...AI_OPTIMIZER_SAFE.tr, ...PROTECTION_WARNINGS.tr, ...SETTINGS_PLACES.tr, ...CONVERSION_STATUSES.tr, ...METRIC_NAMES.tr, ...QUICK_SETUP.tr, ...ERROR_TEXTS.tr, ...CLICK_ISSUES.tr, ...PRESET_HINTS.tr, ...DOWNGRADE_IMPACT.tr, ...NOTIFICATION_CHANNELS.tr, ...TRIAL_BANNER.tr, ...LIVE_TRACE_AUTO.tr, ...DOMAIN_CHECK.tr, ...POSTBACK_JOURNAL.tr, ...CONVERSION_CHECK.tr, ...FIRST_DAY.tr, ...TRIAL_FUNNEL.tr, ...TR, ...INTEGRATION_CATALOGUE.tr, ...BILLING_STOP.tr },
  uk: { ...CONVERSION_IMPORT.uk, ...TLS_TOOLS.uk, ...EDIT_DIALOGS.uk, ...SAVED_REPORT_VIEW.uk, ...POOL_LINKS.uk, ...PLAN_LIMITS.uk, ...AUTOMATION_HISTORY.uk, ...CLICK_WARNINGS.uk, ...BUNDLE_ACTIONS.uk, ...OFFER_FORM.uk, ...STREAM_FORM.uk, ...CAMPAIGN_FORM.uk, ...MENU_GROUPS.uk, ...PER_EVENT_POSTBACKS.uk, ...AI_OPTIMIZER_SAFE.uk, ...PROTECTION_WARNINGS.uk, ...SETTINGS_PLACES.uk, ...CONVERSION_STATUSES.uk, ...METRIC_NAMES.uk, ...QUICK_SETUP.uk, ...ERROR_TEXTS.uk, ...CLICK_ISSUES.uk, ...PRESET_HINTS.uk, ...DOWNGRADE_IMPACT.uk, ...NOTIFICATION_CHANNELS.uk, ...TRIAL_BANNER.uk, ...LIVE_TRACE_AUTO.uk, ...DOMAIN_CHECK.uk, ...POSTBACK_JOURNAL.uk, ...CONVERSION_CHECK.uk, ...FIRST_DAY.uk, ...TRIAL_FUNNEL.uk, ...UK, ...INTEGRATION_CATALOGUE.uk, ...BILLING_STOP.uk },
};

// Exported for the translation coverage test.
export { TRANSLATION_MAPS };

//: Display labels for the language picker. Native names so a Spanish
//: speaker recognises their own option without thinking.
export const LOCALE_LABELS = {
  en: 'English',
  ru: 'Русский',
  es: 'Español',
  pt: 'Português',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  pl: 'Polski',
  tr: 'Türkçe',
  uk: 'Українська',
};

//: Stable order so the picker doesn't reshuffle on a Map iteration whim.
export const LOCALE_ORDER = ['en', 'ru', 'es', 'pt', 'de', 'fr', 'it', 'pl', 'tr', 'uk'];

//: First visit: the first browser language the app has, otherwise English.
function browserLocale() {
  if (typeof navigator === 'undefined') return 'en';
  const wanted = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  for (const tag of wanted) {
    const code = String(tag || '').toLowerCase().split('-')[0];
    if (LOCALE_ORDER.includes(code)) return code;
  }
  return 'en';
}

const LocaleContext = React.createContext({
  locale: 'en',
  setLocale: () => {},
  t: (s) => s,
});

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = React.useState(() => {
    if (typeof window === 'undefined') return 'en';
    return localStorage.getItem('locale') || browserLocale();
  });

  const setLocale = React.useCallback((next) => {
    setLocaleState(next);
    try { localStorage.setItem('locale', next); } catch {}
    if (typeof document !== 'undefined') {
      document.documentElement.lang = next;
    }
  }, []);

  React.useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = locale;
    }
  }, [locale]);

  const t = React.useCallback(
    (key, vars) => {
      const map = TRANSLATION_MAPS[locale];
      let out = brandText(map && map[key] ? map[key] : key);
      if (vars) {
        for (const [k, v] of Object.entries(vars)) {
          out = out.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
        }
      }
      return out;
    },
    [locale]
  );

  return (
    <LocaleContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useT() {
  return React.useContext(LocaleContext);
}
